'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var React = _interopDefault(require('react'));
var functions = require('@keytrade/functions');
var PropTypes = _interopDefault(require('prop-types'));
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : String(i);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var IcnPDF = function IcnPDF(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M13.586 4a1.5 1.5 0 0 1 .95.34l.11.1 3.915 3.914a1.5 1.5 0 0 1 .432.912l.007.149V12.5a.5.5 0 0 1-.992.09L18 12.5V10h-3.5a1.5 1.5 0 0 1-1.493-1.356L13 8.5V5H6.5a.5.5 0 0 0-.492.41L6 5.5v13a.5.5 0 0 0 .41.492L6.5 19h2a.5.5 0 0 1 .09.992L8.5 20h-2a1.5 1.5 0 0 1-1.493-1.356L5 18.5v-13a1.5 1.5 0 0 1 1.356-1.493L6.5 4h7.086zm-2.583 10a2 2 0 0 1 .149 3.995l-.15.005H11v1.5a.5.5 0 0 1-.992.09L10 19.5v-5a.5.5 0 0 1 .5-.5h.503zm3.497 0a2.5 2.5 0 0 1 2.5 2.5v1a2.5 2.5 0 0 1-2.5 2.5.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5zm6 0a.5.5 0 0 1 .09.992L20.5 15h-1a.5.5 0 0 0-.492.41L19 15.5V17h1a.5.5 0 0 1 .09.992L20 18h-1v1.5a.5.5 0 0 1-.992.09L18 19.5v-4a1.5 1.5 0 0 1 1.356-1.493L19.5 14h1zM15 15.086v3.827l.052-.018c.513-.203.887-.68.941-1.25L16 17.5v-1a1.5 1.5 0 0 0-.948-1.395L15 15.086zM11.003 15H11v2h.003a1 1 0 0 0 .116-1.993L11.003 15zM14 5.207V8.5a.5.5 0 0 0 .41.492L14.5 9h3.293L14 5.207z"
  }));
};
var IcnPDFLight = function IcnPDFLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M13.586 4a1.5 1.5 0 0 1 .95.34l.11.1 3.915 3.914a1.5 1.5 0 0 1 .432.912l.007.149V12.5a.5.5 0 0 1-.992.09L18 12.5V10h-3.5a1.5 1.5 0 0 1-1.493-1.356L13 8.5V5H6.5a.5.5 0 0 0-.492.41L6 5.5v13a.5.5 0 0 0 .41.492L6.5 19h2a.5.5 0 0 1 .09.992L8.5 20h-2a1.5 1.5 0 0 1-1.493-1.356L5 18.5v-13a1.5 1.5 0 0 1 1.356-1.493L6.5 4h7.086zm-2.583 10a2 2 0 0 1 .149 3.995l-.15.005H11v1.5a.5.5 0 0 1-.992.09L10 19.5v-5a.5.5 0 0 1 .5-.5h.503zm3.497 0a2.5 2.5 0 0 1 2.5 2.5v1a2.5 2.5 0 0 1-2.5 2.5.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5zm6 0a.5.5 0 0 1 .09.992L20.5 15h-1a.5.5 0 0 0-.492.41L19 15.5V17h1a.5.5 0 0 1 .09.992L20 18h-1v1.5a.5.5 0 0 1-.992.09L18 19.5v-4a1.5 1.5 0 0 1 1.356-1.493L19.5 14h1zM15 15.086v3.827l.052-.018c.513-.203.887-.68.941-1.25L16 17.5v-1a1.5 1.5 0 0 0-.948-1.395L15 15.086zM11.003 15H11v2h.003a1 1 0 0 0 .116-1.993L11.003 15zM14 5.207V8.5a.5.5 0 0 0 .41.492L14.5 9h3.293L14 5.207z"
  }));
};
var IcnAcademy = function IcnAcademy(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M4.165 9.136l.021-.016a.53.53 0 0 1 .01-.007l-.01.006a.528.528 0 0 1 .052-.036l.023-.013a.543.543 0 0 1 .012-.006l.05-.024 7.467-3a.566.566 0 0 1 .338-.025l.082.025 7.467 3c.4.16.429.666.086.876l-.086.043-2.878 1.155.001 4.39a.49.49 0 0 1-.21.398l-.085.05-4.267 1.995a.566.566 0 0 1-.383.034l-.093-.034-4.267-1.995a.505.505 0 0 1-.286-.355l-.009-.093-.001-4.39-2.133-.857V12.5c0 .276-.238.5-.533.5a.525.525 0 0 1-.524-.41L4 12.5V9.498c0-.133.055-.265.165-.362zm11.568 2.407L12.21 12.96a.566.566 0 0 1-.338.025l-.082-.025-3.524-1.417v3.652L12 16.941l3.733-1.746v-3.652zM12 7.043L5.886 9.499l6.113 2.457 6.114-2.457L12 7.043z"
  }));
};
var IcnAccounts = function IcnAccounts(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    "fill-rule": "evenodd",
    d: "M11.5,6.16666667 C13.949851,6.16666667 16,7.19174117 16,8.66666667 L16,13.5 C16,14.9760361 13.9497128,16 11.5,16 C9.12931019,16 7.13269223,15.0410328 7.00634507,13.6414117 L7,13.5 L7,8.66666667 L7.00634465,8.52535557 C7.1326836,7.12667401 9.12917647,6.16666667 11.5,6.16666667 Z M4.5,0 C6.94985098,0 9,1.02507451 9,2.5 L9,5.16666667 C9,5.44280904 8.77614237,5.66666667 8.5,5.66666667 C8.25454011,5.66666667 8.05039163,5.48979151 8.00805567,5.2565423 L8,5.16666667 L8.00108796,4.10260504 C7.17017381,4.66505524 5.90038854,5 4.5,5 C3.1001641,5 1.83082841,4.66531955 0.999895961,4.10327081 L1,5 C1,5.73499576 2.53177117,6.5 4.49867306,6.5 C4.86057799,6.49904131 5.22193878,6.47188703 5.57992306,6.41875176 C5.85307292,6.37820839 6.10737153,6.5667732 6.14791491,6.83992306 C6.18845828,7.11307292 5.99989347,7.36737153 5.72674361,7.40791491 C5.32102809,7.46813487 4.91148586,7.49890972 4.5,7.5 C3.10024306,7.5 1.83089609,7.16568215 0.999939475,6.60373705 L0.999,7.489 L1,7.5 C1,8.23499576 2.53177117,9 4.50177823,9 C4.85397328,9.00125574 5.20577255,8.97627591 5.55425701,8.92527094 C5.82748833,8.88528019 6.08140498,9.07435903 6.12139573,9.34759035 C6.16138647,9.62082166 5.97230764,9.87473831 5.69907632,9.91472906 C5.30146341,9.97292458 4.90006838,10.001426 4.5,10 C3.09969045,10 1.82989386,9.66541812 0.998955523,9.1030714 L1,9.996 C1,10.7349958 2.53177117,11.5 4.49867306,11.5 C4.86057799,11.4990413 5.22193878,11.471887 5.57992306,11.4187518 C5.85307292,11.3782084 6.10737153,11.5667732 6.14791491,11.8399231 C6.18845828,12.1130729 5.99989347,12.3673715 5.72674361,12.4079149 C5.32102809,12.4681349 4.91148586,12.4989097 4.5,12.5 C3.10024306,12.5 1.83089609,12.1656821 0.999939475,11.6037371 L1,12.5 C1,13.2350096 2.53178869,14.000048 4.50171454,14.000051 C4.85401695,14.001259 5.20583665,13.9762665 5.55425701,13.9252709 C5.82748833,13.8852802 6.08140498,14.074359 6.12139573,14.3475903 C6.16138647,14.6208217 5.97230764,14.8747383 5.69907632,14.9147291 C5.30155903,14.9729106 4.90018627,15.0014232 4.5,15.0000955 C2.12932883,15.0000955 0.132693431,14.0410399 0.00634512374,12.6414123 L0,12.5 L0,2.5 L0.0063446481,2.35868891 C0.132683601,0.960007344 2.12917647,0 4.5,0 Z M15.0010445,12.6030714 C14.1701061,13.1654181 12.9003095,13.5 11.5,13.5 C10.1002431,13.5 8.83089609,13.1656821 7.99993948,12.6037371 L8,13.5 C8,14.2349958 9.53177117,15 11.5,15 C13.3925277,15 14.8815258,14.2927106 14.9932645,13.5848951 L15,13.5 L15.0010445,12.6030714 Z M15.001088,10.2692717 C14.1701738,10.8317219 12.9003885,11.1666667 11.5,11.1666667 C10.1001641,11.1666667 8.83082841,10.8319862 7.99989596,10.2699375 L8,11 C8,11.7349958 9.53177117,12.5 11.5,12.5 C13.3925277,12.5 14.8815258,11.7927106 14.9932645,11.0848951 L15,11 L15.001088,10.2692717 Z M11.5,7.16666667 C9.53157299,7.16666667 8,7.93245316 8,8.66666667 C8,9.40088017 9.53157299,10.1666667 11.5,10.1666667 C13.468427,10.1666667 15,9.40088017 15,8.66666667 C15,7.93245316 13.468427,7.16666667 11.5,7.16666667 Z M4.5,1 C2.53157299,1 1,1.76578649 1,2.5 C1,3.23421351 2.53157299,4 4.5,4 C6.46842701,4 8,3.23421351 8,2.5 C8,1.76578649 6.46842701,1 4.5,1 Z",
    transform: "translate(4 4)"
  }));
};
var IcnActivate = function IcnActivate(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M14.167 6.87a6.5 6.5 0 1 1-4.333 0 .5.5 0 0 1 .333.943 5.5 5.5 0 1 0 3.667 0 .5.5 0 0 1 .333-.942zM12.001 4.5a.5.5 0 0 1 .492.41L12.5 5v6.5a.5.5 0 0 1-.992.09l-.008-.09V5a.5.5 0 0 1 .5-.5z"
  }));
};
var IcnAddInstrumentLight = function IcnAddInstrumentLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M15.5 11a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm0 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zm0 1a.5.5 0 0 1 .492.41l.008.09V15h1.5a.5.5 0 0 1 .09.992L17.5 16H16v1.5a.5.5 0 0 1-.992.09L15 17.5V16h-1.5a.5.5 0 0 1-.09-.992L13.5 15H15v-1.5a.5.5 0 0 1 .5-.5zm-2.914-9c.348 0 .683.12.95.34l.11.1 1.915 1.914a1.5 1.5 0 0 1 .432.912l.007.148V9a.5.5 0 0 1-.992.09L15 9V7.414a.5.5 0 0 0-.095-.293l-.051-.06-1.915-1.915a.5.5 0 0 0-.274-.14L12.586 5H5.5a.5.5 0 0 0-.492.41L5 5.5v11a.5.5 0 0 0 .41.492L5.5 17H9a.5.5 0 0 1 .09.992L9 18H5.5a1.5 1.5 0 0 1-1.493-1.356L4 16.5v-11a1.5 1.5 0 0 1 1.356-1.493L5.5 4h7.086zM6.5 8a.5.5 0 0 1 .492.41L7 8.5v2.792l.939-.938a1.5 1.5 0 0 1 2.012-.1l.11.1.387.387a.5.5 0 0 0 .728-.022l.053-.073.239-.4a.5.5 0 0 1 .898.43l-.04.082-.239.401a1.5 1.5 0 0 1-2.232.392l-.114-.103-.387-.387a.5.5 0 0 0-.648-.051l-.06.05L7 12.707V14h2.5a.5.5 0 0 1 .492.41l.008.09a.5.5 0 0 1-.41.492L9.5 15h-3a.5.5 0 0 1-.492-.41L6 14.5v-6a.5.5 0 0 1 .5-.5z"
  }));
};
var IcnAddUserLIght = function IcnAddUserLIght(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M15.5 11a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm0 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zm0 1a.5.5 0 0 1 .492.41l.008.09V15h1.5a.5.5 0 0 1 .09.992L17.5 16H16v1.5a.5.5 0 0 1-.992.09L15 17.5V16h-1.5a.5.5 0 0 1-.09-.992L13.5 15H15v-1.5a.5.5 0 0 1 .5-.5zm-4.537-2.099a.5.5 0 1 1-.392.92A4.002 4.002 0 0 0 5 15.501a.5.5 0 0 1-1-.001 5.002 5.002 0 0 1 6.963-4.599zM9 4a3.25 3.25 0 1 0 0 6.5A3.25 3.25 0 0 0 9 4zm0 1a2.25 2.25 0 1 1 0 4.5A2.25 2.25 0 0 1 9 5z"
  }));
};
var IcnAddUserRegular = function IcnAddUserRegular(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M15.5 11a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm0 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zm0 1a.5.5 0 0 1 .492.41l.008.09V15h1.5a.5.5 0 0 1 .09.992L17.5 16H16v1.5a.5.5 0 0 1-.992.09L15 17.5V16h-1.5a.5.5 0 0 1-.09-.992L13.5 15H15v-1.5a.5.5 0 0 1 .5-.5zm-4.537-2.099a.5.5 0 1 1-.392.92A4.002 4.002 0 0 0 5 15.501a.5.5 0 0 1-1-.001 5.002 5.002 0 0 1 6.963-4.599zM9 4a3.25 3.25 0 1 0 0 6.5A3.25 3.25 0 0 0 9 4zm0 1a2.25 2.25 0 1 1 0 4.5A2.25 2.25 0 0 1 9 5z"
  }));
};
var IcnUserProDefRegular = function IcnUserProDefRegular(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M11.7493564,4.00388213 C10.9882855,4.05579209 10.2904681,4.30323023 9.67891122,4.73804741 C9.10648687,5.14503716 8.63493134,5.71862019 8.35142061,6.35276164 C8.15923403,6.78263684 8.0520661,7.20022751 8.00970081,7.68427882 C7.99912549,7.805114 7.99912549,8.19079307 8.00970081,8.31162826 C8.07518201,9.05981928 8.31616101,9.72251154 8.73948105,10.3185063 C9.10894505,10.838675 9.63401093,11.2898865 10.1988687,11.5726162 C10.8992275,11.9231701 11.6692221,12.0596507 12.4567249,11.972814 C12.9798639,11.9151298 13.5144617,11.7410596 13.9738863,11.4788083 C15.0711589,10.8524511 15.8084161,9.75495446 15.9679101,8.51045962 C16.0184885,8.11580561 16.0084638,7.68764602 15.9395449,7.2996496 C15.7954018,6.48807067 15.4119505,5.75318842 14.8278689,5.16910049 C14.1535835,4.49482147 13.2816574,4.09073162 12.3254937,4.00939384 C12.2163413,4.00010523 11.8553337,3.99665481 11.7493564,4.00388213 M11.8561338,5.00259042 C11.5874554,5.01434362 11.3322651,5.06065866 11.0771963,5.1439617 C10.6110821,5.29618996 10.2264464,5.5322654 9.8798871,5.87882475 C9.7783013,5.98040415 9.63612343,6.1410184 9.63732565,6.15281641 C9.63835756,6.16277719 9.84181083,6.33083642 9.97301648,6.43011127 C10.6505859,6.94275818 11.4875981,7.29835009 12.3286944,7.43088086 C13.0347058,7.54213296 13.7697609,7.51116878 14.4450193,7.34172042 C14.6267906,7.29610955 14.8925051,7.21550795 14.8925051,7.20597608 C14.8925051,7.19356353 14.842554,7.03682859 14.814829,6.96225083 C14.5425658,6.22985877 14.0023859,5.63371676 13.3081277,5.29946114 C12.9954388,5.14891648 12.687167,5.05869979 12.347899,5.0184598 C12.2804525,5.0104579 11.9855023,4.99332102 11.9734098,4.99670102 C11.9716494,4.99719394 11.9188752,4.99984417 11.8561338,5.00259042 M9.13508888,7.10725817 C8.98316149,7.576746 8.95966149,8.14568153 9.07131689,8.65090907 C9.15996521,9.05201582 9.34055222,9.44773248 9.58694051,9.78077821 C9.75286164,10.0050492 9.99192018,10.2441078 10.2161912,10.4100289 C10.7691101,10.8190799 11.4357393,11.0223924 12.1286468,10.9932846 C12.9422358,10.9591069 13.6980638,10.6005127 14.2390439,9.99202854 C14.6128929,9.57153157 14.8547425,9.0729232 14.9532044,8.51967781 C14.9709046,8.42019812 14.9924137,8.2429655 14.9873949,8.2379467 C14.9854297,8.23598144 14.9380712,8.24729933 14.8821539,8.2631047 C13.9101975,8.53775572 12.8484342,8.57268244 11.8574846,8.36261 C10.9121842,8.16221026 9.99592114,7.732047 9.25334425,7.14002757 L9.15091345,7.05836332 L9.13508888,7.10725817 M9.89611496,12.8214193 C9.84497958,12.8327436 9.59309238,12.9208158 9.4416067,12.98035 C7.9865977,13.5521278 6.77012233,14.5894181 5.96952203,15.9409976 C5.35140999,16.984491 5.0114314,18.1978744 5.00059362,19.3990693 C4.99903165,19.5721474 4.99969101,19.5840734 5.01340307,19.6313871 C5.06280364,19.8018149 5.20079491,19.940107 5.36703611,19.9857883 C5.41973987,20.0002686 5.56454236,20.0019586 5.61623467,19.9886946 C5.75626163,19.9527756 5.88276216,19.8511962 5.94537547,19.7243948 C5.99025016,19.6335124 5.9941615,19.6094235 6.00078707,19.3830655 C6.01165046,19.0118859 6.03963153,18.7327218 6.09735408,18.419636 C6.30030162,17.318785 6.79721999,16.3107497 7.54739548,15.4781354 C7.6561958,15.357377 7.87968584,15.1325554 7.97241833,15.0505775 L8.02679928,15.0025085 L9.03216516,17.3496276 C9.58511608,18.6405399 10.0483112,19.7171547 10.0614856,19.7421015 C10.1427401,19.8959621 10.2973113,19.9903974 10.4820145,19.9990075 C10.5729034,20.0032517 10.6354271,19.9896676 10.7219117,19.9468926 C10.82255,19.8971208 10.8913088,19.8301032 10.9423162,19.7320639 C10.9844574,19.651059 10.9971388,19.5959931 10.9968892,19.4950922 C10.9966907,19.4148491 10.9952312,19.4045554 10.9764683,19.3510579 C10.9653553,19.3193704 10.8122756,18.9578442 10.6362913,18.5476729 C10.3679073,17.9221415 10.3176426,17.8003461 10.3245434,17.792293 C10.3290693,17.7870053 10.7079435,17.3322666 11.1664912,16.7817611 C11.6250324,16.2312556 12.0024087,15.7833088 12.0050909,15.786324 C12.0077796,15.7893391 12.3809629,16.2368761 12.8343957,16.7808457 C13.2878285,17.3248152 13.664539,17.7762124 13.6715295,17.7839582 L13.6842301,17.7980352 L13.3543147,18.568145 C13.1728571,18.9917019 13.019739,19.355539 13.0140481,19.376664 C12.9733792,19.527676 13.0141313,19.7010037 13.1203006,19.8285861 C13.180923,19.901429 13.2825216,19.9622371 13.3879867,19.9887906 C13.4570528,20.0061836 13.5635102,20.0030404 13.6378063,19.9814161 C13.7465618,19.9497669 13.844281,19.8813026 13.9053452,19.793973 C13.9434086,19.7395472 13.994608,19.6214007 15.3414889,16.479974 C15.6864222,15.6754624 15.9706499,15.0152283 15.9731017,15.0127893 C15.9797529,15.0061829 16.0635169,15.0821882 16.2167886,15.233898 C17.2101004,16.2171018 17.8236481,17.4977524 17.9684634,18.8901481 C17.9833982,19.0337471 17.9970911,19.2674028 17.9973471,19.3830655 C17.9978976,19.6286856 18.027031,19.7243564 18.1370156,19.8416516 C18.1877605,19.8957637 18.246853,19.9379625 18.3077187,19.9635494 C18.3731102,19.991044 18.4108792,19.9976183 18.5029652,19.9975351 C18.5737724,19.9974711 18.5986424,19.9948016 18.6405979,19.9827668 C18.8090733,19.9344481 18.9451377,19.7917965 18.990166,19.6162603 C19.0010614,19.5737926 19.0007413,19.298623 18.9895579,19.0981977 C18.894412,17.3926074 18.163281,15.7616781 16.9506018,14.5499142 C16.1801783,13.7800733 15.2653555,13.2110673 14.2431729,12.8659419 C14.1003548,12.8177192 14.0943502,12.8162917 14.0223202,12.8134174 C13.9614417,12.8109848 13.9380378,12.8129117 13.8906665,12.8242296 C13.822279,12.8405663 13.7438923,12.8770614 13.6947926,12.9154193 C13.6752872,12.9306613 13.2870923,13.2571263 12.8321359,13.6408977 C12.377186,14.0246691 12.0023703,14.3386639 11.9992079,14.3386639 C11.996052,14.3386639 11.6211851,14.0246691 11.1661711,13.6408977 C10.7111571,13.2571263 10.3227958,12.9305781 10.3031367,12.9152337 C10.1942532,12.8302342 10.0286841,12.7920747 9.89611496,12.8214193 M9.78088751,13.9252022 C9.49349746,14.0399944 9.26178146,14.1529749 8.98188759,14.3147798 C8.88229266,14.3723552 8.85586717,14.3903626 8.85886948,14.398595 C8.87694739,14.4482068 9.8715075,16.7616411 9.87475307,16.7616411 C9.87785781,16.7616411 11.2335151,15.1384256 11.2865454,15.0712096 C11.2930877,15.0629196 11.1887301,14.9724405 10.5963458,14.4728015 C10.2124975,14.1490444 9.89647985,13.8836115 9.89407928,13.8829288 C9.8916787,13.88228 9.84074177,13.9012989 9.78088751,13.9252022 M13.40344,14.4716172 L12.7049568,15.0614473 L13.4123573,15.9099438 C13.8014292,16.376615 14.1217487,16.7606937 14.1241749,16.7634652 C14.1297122,16.7697454 15.1441235,14.4009892 15.1402298,14.3908812 C15.1369089,14.3823095 14.9320025,14.2632284 14.7970072,14.1914225 C14.6214198,14.0980178 14.4069559,13.9996584 14.2092704,13.9218478 C14.152124,13.8993593 14.1045926,13.8811405 14.1036452,13.8813688 C14.1026914,13.8816015 13.7876019,14.1472135 13.40344,14.4716172"
  }));
};
var IcnAddWatchlist = function IcnAddWatchlist(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M15.5 11a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm0 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zm0 .88a.5.5 0 0 1 .491.41l.009.09-.001 1.62h1.622a.5.5 0 0 1 .09.993l-.09.008L15.999 16v1.622a.5.5 0 0 1-.991.09l-.008-.09L14.999 16h-1.62a.5.5 0 0 1-.09-.991l.09-.008 1.62-.001v-1.62a.5.5 0 0 1 .5-.5zM11.99 4c2.574-.044 5.478 1.592 7.593 3.924.555.61.555 1.543.005 2.147-.144.164-.305.333-.495.523a.5.5 0 0 1-.707-.707c.176-.176.323-.33.457-.483a.6.6 0 0 0 0-.807c-1.94-2.14-4.596-3.635-6.835-3.596-2.292.04-4.975 1.526-6.852 3.596a.6.6 0 0 0 .003.81 12.3 12.3 0 0 0 4.176 3.037.5.5 0 1 1-.405.914 13.296 13.296 0 0 1-4.514-3.28 1.6 1.6 0 0 1 0-2.153c2.046-2.257 4.973-3.879 7.575-3.924zm.468 2.041A3.001 3.001 0 0 1 15 9.005c-.002.269-.04.536-.11.796a.5.5 0 1 1-.965-.267c.049-.175.074-.356.076-.532a2 2 0 1 0-2.896 1.792.5.5 0 1 1-.448.894 3 3 0 0 1 1.802-5.647z"
  }));
};
var IcnAlarm = function IcnAlarm(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M8.75 6.87a6.5 6.5 0 0 1 6.974 10.958l.723 1.448a.5.5 0 0 1-.847.524l-.047-.076-.694-1.387a6.5 6.5 0 0 1-5.718 0l-.694 1.387a.5.5 0 0 1-.927-.364l.033-.084.724-1.448A6.5 6.5 0 0 1 8.75 6.871zm6 .867a5.5 5.5 0 0 0-5.5 0l-.21.127a5.5 5.5 0 1 0 5.71-.127zM12 8.5a.5.5 0 0 1 .492.41L12.5 9v3.5a.5.5 0 0 1-.41.492L12 13H9.74a.5.5 0 0 1-.09-.992L9.74 12h1.76V9a.5.5 0 0 1 .5-.5zM7.89 4.188a.5.5 0 0 1-.013.64l-.065.062-2.5 2a.5.5 0 0 1-.69-.718l.066-.062 2.5-2a.5.5 0 0 1 .702.078zm8.847-.128l.075.05 2.5 2a.5.5 0 0 1-.55.83l-.074-.05-2.5-2a.5.5 0 0 1 .55-.83z"
  }));
};
var IcnArrowDown = function IcnArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M6.434 9.234a.8.8 0 0 1 1.042-.077l.09.077L12 13.67l4.434-4.435a.8.8 0 0 1 1.042-.077l.09.077a.8.8 0 0 1 .077 1.042l-.077.09-5 5a.8.8 0 0 1-1.042.077l-.09-.077-5-5a.8.8 0 0 1 0-1.132z"
  }));
};
var IcnArrowLeft = function IcnArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M14.766 6.434a.8.8 0 0 1 .077 1.042l-.077.09L10.33 12l4.435 4.434a.8.8 0 0 1 .077 1.042l-.077.09a.8.8 0 0 1-1.042.077l-.09-.077-5-5a.8.8 0 0 1-.077-1.042l.077-.09 5-5a.8.8 0 0 1 1.132 0z"
  }));
};
var IcnArrowRight = function IcnArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M9.234 17.566a.8.8 0 0 1-.077-1.042l.077-.09L13.67 12 9.234 7.566a.8.8 0 0 1-.077-1.042l.077-.09a.8.8 0 0 1 1.042-.077l.09.077 5 5a.8.8 0 0 1 .077 1.042l-.077.09-5 5a.8.8 0 0 1-1.132 0z"
  }));
};
var IcnArrowUp = function IcnArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M17.566 14.766a.8.8 0 0 1-1.042.077l-.09-.077L12 10.33l-4.434 4.435a.8.8 0 0 1-1.042.077l-.09-.077a.8.8 0 0 1-.077-1.042l.077-.09 5-5a.8.8 0 0 1 1.042-.077l.09.077 5 5a.8.8 0 0 1 0 1.132z"
  }));
};
var IcnBalance = function IcnBalance(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 5a.5.5 0 0 1 .493.41l.008.09-.001 1.017 6.436-.017c.31 0 .563.222.564.498 0 .246-.197.45-.46.494l-.1.008-1.196.002 2.21 4.757.004.01.018.046.011.04.008.041.001.009.003.017.001.026v.01a2.83 2.83 0 0 1-2.874 2.899 2.83 2.83 0 0 1-2.898-2.9v-.01a.459.459 0 0 1 .016-.103l.005-.02a.496.496 0 0 1 .021-.055l.005-.01 2.207-4.753-3.982.011V18h2.569c.63 0 .664.892.105.991l-.105.009H8.933a.5.5 0 0 1-.09-.992l.09-.008H11.5V7.519l-4.033.011 2.26 4.82.003.009.02.05.01.034.009.052.001.02v-.016l.001.016.001.016-.001-.001.001.009.001.01A2.83 2.83 0 0 1 6.9 15.447 2.83 2.83 0 0 1 4.004 12.5l.005-.029.006-.028.002-.008.006-.02a.496.496 0 0 1 .02-.055l.005-.01 2.257-4.815-1.241.003c-.31.001-.563-.222-.564-.498 0-.246.197-.45.46-.493l.1-.009 6.44-.018V5.5A.5.5 0 0 1 12 5zM8.72 13.061H5.054c.054.215.145.417.27.597l.1.132.112.122c.354.355.838.548 1.364.535a1.83 1.83 0 0 0 1.819-1.386zm10.228-.092h-3.666c.054.216.145.417.27.598l.1.132.112.122c.354.355.838.548 1.364.536a1.83 1.83 0 0 0 1.82-1.388zm-12.06-4.32l-1.6 3.412h3.199L6.887 8.649zm10.226-.129l-1.602 3.449h3.206L17.113 8.52z"
  }));
};
var IcnBasket = function IcnBasket(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M14.467 5.616l.069.066 3.038 3.458h.892c.43.015.832.198 1.118.505l.102.12c.256.337.36.758.295 1.159l-.032.149-1.517 6.23a1.545 1.545 0 0 1-1.359 1.188l-.145.009H7.061a1.553 1.553 0 0 1-1.456-1.054l-.036-.133-1.516-6.227a1.519 1.519 0 0 1 .26-1.32c.256-.337.639-.556 1.073-.613l.165-.013h.872l3.04-3.458a.542.542 0 0 1 .751-.057.511.511 0 0 1 .114.657l-.056.076L7.828 9.14h8.342l-2.443-2.782a.511.511 0 0 1 .057-.733.543.543 0 0 1 .683-.009zM5.57 10.18a.526.526 0 0 0-.401.205.498.498 0 0 0-.1.35l.018.097 1.521 6.25c.043.19.198.334.382.37l.08.008h9.849a.491.491 0 0 0 .448-.306l.026-.082 1.522-6.253c.041-.15.01-.31-.085-.434a.525.525 0 0 0-.303-.194l-.09-.011H5.57zm3.232 1.04a.53.53 0 0 1 .525.427l.008.093v4.16c0 .287-.239.52-.533.52a.53.53 0 0 1-.525-.427L8.27 15.9v-4.16c0-.287.238-.52.533-.52zm3.198 0a.53.53 0 0 1 .524.427l.01.093v4.16c0 .287-.24.52-.534.52a.53.53 0 0 1-.525-.427l-.009-.093v-4.16c0-.287.24-.52.534-.52zm3.198 0a.53.53 0 0 1 .524.427l.009.093v4.16c0 .287-.239.52-.533.52a.53.53 0 0 1-.525-.427l-.009-.093v-4.16c0-.287.239-.52.534-.52z"
  }));
};
var IcnBasketLight = function IcnBasketLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M14.467 5.616l.069.066 3.038 3.458h.892c.43.015.832.198 1.118.505l.102.12c.256.337.36.758.295 1.159l-.032.149-1.517 6.23a1.545 1.545 0 0 1-1.359 1.188l-.145.009H7.061a1.553 1.553 0 0 1-1.456-1.054l-.036-.133-1.516-6.227a1.519 1.519 0 0 1 .26-1.32c.256-.337.639-.556 1.073-.613l.165-.013h.872l3.04-3.458a.542.542 0 0 1 .751-.057.511.511 0 0 1 .114.657l-.056.076L7.828 9.14h8.342l-2.443-2.782a.511.511 0 0 1 .057-.733.543.543 0 0 1 .683-.009zM5.57 10.18a.526.526 0 0 0-.401.205.498.498 0 0 0-.1.35l.018.097 1.521 6.25c.043.19.198.334.382.37l.08.008h9.849a.491.491 0 0 0 .448-.306l.026-.082 1.522-6.253c.041-.15.01-.31-.085-.434a.525.525 0 0 0-.303-.194l-.09-.011H5.57zm3.232 1.04a.53.53 0 0 1 .525.427l.008.093v4.16c0 .287-.239.52-.533.52a.53.53 0 0 1-.525-.427L8.27 15.9v-4.16c0-.287.238-.52.533-.52zm3.198 0a.53.53 0 0 1 .524.427l.01.093v4.16c0 .287-.24.52-.534.52a.53.53 0 0 1-.525-.427l-.009-.093v-4.16c0-.287.24-.52.534-.52zm3.198 0a.53.53 0 0 1 .524.427l.009.093v4.16c0 .287-.239.52-.533.52a.53.53 0 0 1-.525-.427l-.009-.093v-4.16c0-.287.239-.52.534-.52z"
  }));
};
var IcnBell = function IcnBell(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12.857 18.36a.5.5 0 1 1 .96.28 1.891 1.891 0 0 1-3.63 0 .5.5 0 0 1 .926-.365l.033.084a.891.891 0 0 0 1.67.11l.04-.11zM12 4a.5.5 0 0 1 .492.41l.008.09v1.022a5.5 5.5 0 0 1 5 5.478c0 1.815.149 3.159.4 4.097.156.584.318.903.426 1.022l.065.069A.5.5 0 0 1 18 17H6a.5.5 0 0 1-.394-.808l.031-.044c.09-.138.232-.444.383-.956.299-1.01.48-2.39.48-4.192l.004-.221A5.5 5.5 0 0 1 11.5 5.522L11.5 4.5A.5.5 0 0 1 12 4zm0 2.5A4.5 4.5 0 0 0 7.5 11c0 1.893-.194 3.368-.52 4.475a8.042 8.042 0 0 1-.124.385l-.052.14h10.325l-.067-.178c-.324-.919-.54-2.363-.56-4.48L16.5 11A4.5 4.5 0 0 0 12 6.5z"
  }));
};
var IcnBellLight = function IcnBellLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12.857 18.36a.5.5 0 1 1 .96.28 1.891 1.891 0 0 1-3.63 0 .5.5 0 0 1 .926-.365l.033.084a.891.891 0 0 0 1.67.11l.04-.11zM12 4a.5.5 0 0 1 .492.41l.008.09v1.022a5.5 5.5 0 0 1 5 5.478c0 1.815.149 3.159.4 4.097.156.584.318.903.426 1.022l.065.069A.5.5 0 0 1 18 17H6a.5.5 0 0 1-.394-.808l.031-.044c.09-.138.232-.444.383-.956.299-1.01.48-2.39.48-4.192l.004-.221A5.5 5.5 0 0 1 11.5 5.522L11.5 4.5A.5.5 0 0 1 12 4zm0 2.5A4.5 4.5 0 0 0 7.5 11c0 1.893-.194 3.368-.52 4.475a8.042 8.042 0 0 1-.124.385l-.052.14h10.325l-.067-.178c-.324-.919-.54-2.363-.56-4.48L16.5 11A4.5 4.5 0 0 0 12 6.5z"
  }));
};
var IcnBlock = function IcnBlock(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm5.29 3.416l-9.874 9.875a7 7 0 0 0 9.874-9.874zM12 5a7 7 0 0 0-5.29 11.584l9.874-9.875A6.973 6.973 0 0 0 12 5z"
  }));
};
var IcnBlockLight = function IcnBlockLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm5.29 3.416l-9.874 9.875a7 7 0 0 0 9.874-9.874zM12 5a7 7 0 0 0-5.29 11.584l9.874-9.875A6.973 6.973 0 0 0 12 5z"
  }));
};
var IcnBlockcard = function IcnBlockcard(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M15.5 11a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm2.803 2.404l-4.9 4.899a3.5 3.5 0 0 0 4.9-4.898zM15.5 12a3.5 3.5 0 0 0-2.803 5.596l4.899-4.9A3.484 3.484 0 0 0 15.5 12zm1-8a1.5 1.5 0 0 1 1.493 1.356L18 5.5v4a.5.5 0 0 1-.992.09L17 9.5V8H5v5.5a.5.5 0 0 0 .41.492L5.5 14h4a.5.5 0 0 1 .09.992L9.5 15h-4a1.5 1.5 0 0 1-1.493-1.356L4 13.5v-8a1.5 1.5 0 0 1 1.356-1.493L5.5 4h11zm-8 7.5a.5.5 0 0 1 .09.992l-.09.008h-2a.5.5 0 0 1-.09-.992l.09-.008h2zm2-2a.5.5 0 0 1 .09.992l-.09.008h-4a.5.5 0 0 1-.09-.992L6.5 9.5h4zm6-4.5h-11a.5.5 0 0 0-.492.41L5 5.5V7h12V5.5a.5.5 0 0 0-.41-.492L16.5 5z"
  }));
};
var IcnBlockcardlight = function IcnBlockcardlight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M15.5 11a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm2.803 2.404l-4.9 4.899a3.5 3.5 0 0 0 4.9-4.898zM15.5 12a3.5 3.5 0 0 0-2.803 5.596l4.899-4.9A3.484 3.484 0 0 0 15.5 12zm1-8a1.5 1.5 0 0 1 1.493 1.356L18 5.5v4a.5.5 0 0 1-.992.09L17 9.5V8H5v5.5a.5.5 0 0 0 .41.492L5.5 14h4a.5.5 0 0 1 .09.992L9.5 15h-4a1.5 1.5 0 0 1-1.493-1.356L4 13.5v-8a1.5 1.5 0 0 1 1.356-1.493L5.5 4h11zm-8 7.5a.5.5 0 0 1 .09.992l-.09.008h-2a.5.5 0 0 1-.09-.992l.09-.008h2zm2-2a.5.5 0 0 1 .09.992l-.09.008h-4a.5.5 0 0 1-.09-.992L6.5 9.5h4zm6-4.5h-11a.5.5 0 0 0-.492.41L5 5.5V7h12V5.5a.5.5 0 0 0-.41-.492L16.5 5z"
  }));
};
var IcnBlocks = function IcnBlocks(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M5.75 4.469a3.5 3.5 0 1 0 3.5 6.062 3.5 3.5 0 0 0-3.5-6.062zm3 .866a2.5 2.5 0 1 1-2.65.094l.15-.094a2.5 2.5 0 0 1 2.5 0zm-3 8.134a3.5 3.5 0 1 0 3.5 6.062 3.5 3.5 0 0 0-3.5-6.062zm3 .866a2.5 2.5 0 1 1-2.65.094l.15-.094a2.5 2.5 0 0 1 2.5 0zm6-9.866a3.5 3.5 0 1 0 3.5 6.062 3.5 3.5 0 0 0-3.5-6.062zm3 .866a2.5 2.5 0 1 1-2.65.094l.15-.094a2.5 2.5 0 0 1 2.5 0zm-3 8.134a3.5 3.5 0 1 0 3.5 6.062 3.5 3.5 0 0 0-3.5-6.062zm3 .866a2.5 2.5 0 1 1-2.65.094l.15-.094a2.5 2.5 0 0 1 2.5 0z"
  }));
};
var IcnBrowser = function IcnBrowser(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M18.425 5A1.58 1.58 0 0 1 20 6.577V17.5a1.5 1.5 0 0 1-1.5 1.5H5.575A1.58 1.58 0 0 1 4 17.423V6.571A1.575 1.575 0 0 1 5.57 5zm.574 3.999h-14L5 17.422c0 .287.21.525.483.57l.094.008H18.5a.5.5 0 0 0 .5-.5l-.001-8.501zM8 5.999L5.573 6A.574.574 0 0 0 5 6.572l-.001 1.427H8v-2zm3 0H9v2h2v-2zM18.423 6L12 5.999v2h6.999L19 6.579a.58.58 0 0 0-.483-.571L18.423 6z"
  }));
};
var IcnBuy = function IcnBuy(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 8c.28 0 .514.202.562.469l.01.102-.001 2.857h2.858a.571.571 0 0 1 .102 1.134l-.102.01-2.858-.001v2.858a.571.571 0 0 1-1.133.102l-.01-.102V12.57H8.571a.571.571 0 0 1-.102-1.133l.102-.01h2.857V8.571c0-.315.256-.571.572-.571z"
  }));
};
var IcnBuysell = function IcnBuysell(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 7c.28 0 .514.202.562.469l.01.102-.001 2.857h2.858a.571.571 0 0 1 .102 1.134l-.102.01-2.858-.001v2.858a.571.571 0 0 1-1.133.102l-.01-.102V11.57H8.571a.571.571 0 0 1-.102-1.133l.102-.01h2.857V7.571c0-.315.256-.571.572-.571zm3.429 9c.315 0 .571.224.571.5 0 .245-.202.45-.469.492L15.43 17H8.57C8.256 17 8 16.776 8 16.5c0-.245.202-.45.469-.492L8.57 16h6.858z"
  }));
};
var IcnCalendar = function IcnCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M15.5 4a.5.5 0 0 1 .492.41L16 4.5V6h2a2 2 0 0 1 1.995 1.85L20 8v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2V4.5a.5.5 0 0 1 .992-.09L9 4.5V6h6V4.5a.5.5 0 0 1 .5-.5zm3.5 7H5v7a1 1 0 0 0 .883.993L6 19h12a1 1 0 0 0 1-1v-7zM8 7H6a1 1 0 0 0-1 1v2h14V8a1 1 0 0 0-.883-.993L18 7h-2v1a.5.5 0 0 1-.992.09L15 8V7H9v1a.5.5 0 0 1-.992.09L8 8V7z"
  }));
};
var IcnCalendarLight = function IcnCalendarLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M15.5 4a.5.5 0 0 1 .492.41L16 4.5V6h2a2 2 0 0 1 1.995 1.85L20 8v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2V4.5a.5.5 0 0 1 .992-.09L9 4.5V6h6V4.5a.5.5 0 0 1 .5-.5zm3.5 7H5v7a1 1 0 0 0 .883.993L6 19h12a1 1 0 0 0 1-1v-7zM8 7H6a1 1 0 0 0-1 1v2h14V8a1 1 0 0 0-.883-.993L18 7h-2v1a.5.5 0 0 1-.992.09L15 8V7H9v1a.5.5 0 0 1-.992.09L8 8V7z"
  }));
};
var IcnCaret = function IcnCaret(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M6.434 9.234a.8.8 0 0 1 1.042-.077l.09.077L12 13.67l4.434-4.435a.8.8 0 0 1 1.042-.077l.09.077a.8.8 0 0 1 .077 1.042l-.077.09-5 5a.8.8 0 0 1-1.042.077l-.09-.077-5-5a.8.8 0 0 1 0-1.132z"
  }));
};
var IcnCard = function IcnCard(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M18 6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zm1 4H5v6a1 1 0 0 0 .883.993L6 17h12a1 1 0 0 0 1-1v-6zm-8 4a.5.5 0 0 1 .09.992L11 15H7.5a.5.5 0 0 1-.09-.992L7.5 14H11zm2-2a.5.5 0 0 1 .09.992L13 13H7.5a.5.5 0 0 1-.09-.992L7.5 12H13zm5-5H6a1 1 0 0 0-1 1v1h14V8a1 1 0 0 0-.883-.993L18 7z"
  }));
};
var IcnCardLight = function IcnCardLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M18 6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zm1 4H5v6a1 1 0 0 0 .883.993L6 17h12a1 1 0 0 0 1-1v-6zm-8 4a.5.5 0 0 1 .09.992L11 15H7.5a.5.5 0 0 1-.09-.992L7.5 14H11zm2-2a.5.5 0 0 1 .09.992L13 13H7.5a.5.5 0 0 1-.09-.992L7.5 12H13zm5-5H6a1 1 0 0 0-1 1v1h14V8a1 1 0 0 0-.883-.993L18 7z"
  }));
};
var IcnChange = function IcnChange(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M16.698 6.995l2.802.002a.5.5 0 0 1 .09.992l-.09.008h-1.756A7.003 7.003 0 0 1 9.305 18.46a.5.5 0 0 1 .385-.923A6.001 6.001 0 0 0 17 8.682L17 10.497a.5.5 0 0 1-.41.492l-.09.008a.5.5 0 0 1-.492-.41l-.008-.09v-3a.5.5 0 0 1 .41-.492l.09-.008h.15l.048-.002zm-2.004-1.459a.5.5 0 0 1-.383.924A6.002 6.002 0 0 0 7 15.312L7 13.497a.5.5 0 0 1 .41-.492l.09-.008a.5.5 0 0 1 .492.41l.008.09v3a.5.5 0 0 1-.41.492l-.09.008h-.15a.503.503 0 0 1-.092-.001H4.5a.5.5 0 0 1-.09-.991l.09-.008h1.756a7.003 7.003 0 0 1 8.438-10.46z"
  }));
};
var IcnChartArea = function IcnChartArea(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "nonzero",
    d: "M4.5 4a.5.5 0 0 1 .492.41L5 4.5l-.001 6.191 4.644-2.32a2.5 2.5 0 0 1 1.473-.24l.188.035 2.804.624a1.5 1.5 0 0 0 1.197-.244l.125-.099 3.733-3.32a.5.5 0 0 1 .826.29l.006.083.002 4.445a.498.498 0 0 1 0 .117l-.002 4.388a.47.47 0 0 1 0 .1v4.95a.5.5 0 0 1-.41.492l-.09.008H4.49a.503.503 0 0 1-.054-.004L4.5 20a.503.503 0 0 1-.387-.183l-.003-.005-.022-.029a.5.5 0 0 1-.022-.035l.044.064a.5.5 0 0 1-.11-.286V4.5a.5.5 0 0 1 .5-.5zm14.495 11.154l-4.498 1.228a2.49 2.49 0 0 1-.747.086l-.188-.014-3.296-.366a1.5 1.5 0 0 0-.98.233l-.12.087-3.24 2.591L18.995 19v-3.846zm0-4.376l-4.394 1.998c-.26.118-.537.19-.82.215l-.214.009h-3.513a1.5 1.5 0 0 0-.628.138l-.144.075-4.283 2.57v2.676l3.542-2.832a2.5 2.5 0 0 1 1.637-.546l.197.013 3.298.366c.14.016.283.012.422-.012l.138-.031 4.762-1.3v-3.339zm0-4.165l-2.9 2.581a2.5 2.5 0 0 1-2.022.605l-.182-.033-2.804-.624a1.5 1.5 0 0 0-.862.063l-.135.06L5 11.809v2.808l3.769-2.261a2.5 2.5 0 0 1 1.093-.349l.193-.007h3.512c.161 0 .32-.026.473-.076l.149-.059 4.807-2.186V6.613z"
  }));
};
var IcnChartBar = function IcnChartBar(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "nonzero",
    d: "M4.5 19a.5.5 0 0 1-.09-.992L4.5 18H5v-6a1 1 0 0 1 .883-.993L6 11h2a1 1 0 0 1 1 1v6h1V6a1 1 0 0 1 .883-.993L11 5h2a1 1 0 0 1 1 1v12h1V9a1 1 0 0 1 .883-.993L16 8h2a1 1 0 0 1 1 1v9h.5a.5.5 0 0 1 .09.992L19.5 19h-15zM8 12H6v6h2v-6zm5-6h-2v12h2V6zm5 3h-2v9h2V9z"
  }));
};
var IcnChartLine = function IcnChartLine(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M4.522 4c.256 0 .469.193.513.447l.008.098V18.91h14.435c.256 0 .47.194.514.448l.008.097c0 .268-.185.49-.428.536l-.094.009H4.522a.529.529 0 0 1-.514-.447L4 19.455V4.545C4 4.244 4.234 4 4.522 4zm15.33 3.145a.5.5 0 0 1 .06.637l-.057.07-4.587 4.63a1.363 1.363 0 0 1-1.821.105l-.115-.104-1.808-1.825a.363.363 0 0 0-.46-.046l-.055.046-4.154 4.194a.5.5 0 0 1-.768-.634l.058-.07 4.153-4.193a1.363 1.363 0 0 1 1.822-.104l.115.104 1.807 1.824a.363.363 0 0 0 .46.047l.056-.047 4.587-4.63a.5.5 0 0 1 .707-.004z"
  }));
};
var IcnChartPie = function IcnChartPie(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "nonzero",
    d: "M11 6.5a.5.5 0 0 1 .5.5v5.5H17a.5.5 0 0 1 .492.41l.008.09A6.5 6.5 0 1 1 11 6.5zm-.5 1.023l-.157.016a5.5 5.5 0 1 0 6.118 6.118l.015-.157H11a.5.5 0 0 1-.492-.41L10.5 13V7.523zM13 4.5a6.5 6.5 0 0 1 6.5 6.5.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5V5a.5.5 0 0 1 .5-.5zm.5 1.023V10.5h4.976l-.015-.157a5.503 5.503 0 0 0-4.804-4.804l-.157-.016z"
  }));
};
var IcnChat = function IcnChat(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M18.5 4A1.5 1.5 0 0 1 20 5.5v10a1.5 1.5 0 0 1-1.5 1.5h-6.833L7.8 19.9a.5.5 0 0 1-.793-.315L7 19.5V17H5.5a1.5 1.5 0 0 1-1.493-1.356L4 15.5v-10A1.5 1.5 0 0 1 5.5 4zm0 1h-13a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v2l3.2-2.4a.5.5 0 0 1 .22-.094L11.5 16h7a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5zm-4 6.5a.5.5 0 0 1 .09.992l-.09.008h-7a.5.5 0 0 1-.09-.992l.09-.008h7zm2-3a.5.5 0 0 1 .09.992l-.09.008h-9a.5.5 0 0 1-.09-.992L7.5 8.5h9z"
  }));
};
var IcnChatting = function IcnChatting(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M11.6209157,5.79068382 L11.8344681,5.79587739 C13.4665089,5.87142475 14.9278657,6.85416178 15.6079353,8.35194469 C16.2558668,9.77894692 16.0847569,11.4315274 15.186942,12.6891776 L15.0669157,12.8476313 L15.5080266,15.4143403 C15.5760949,15.810233 15.1782132,16.1082047 14.8269457,15.9623439 L14.7525743,15.9241686 L12.3959157,14.4696998 L12.364647,14.4771357 C12.2018292,14.5069439 12.0372469,14.5271613 11.871451,14.5376837 L11.6219157,14.5461833 C9.20290851,14.5461833 7.24191571,12.5863159 7.24191571,10.1686971 C7.24191571,7.75107637 9.20291033,5.79119882 11.6209157,5.79068382 Z M11.623156,6.79061294 C9.75519604,6.79061294 8.24191571,8.30304319 8.24191571,10.1686971 C8.24191571,12.0343482 9.75519326,13.5467572 11.619504,13.546763 C11.8723212,13.5455442 12.1241152,13.514572 12.3696832,13.4544863 C12.4998051,13.4226479 12.6372683,13.4443278 12.7512571,13.5146657 L14.3339157,14.4906878 L14.0424715,12.7918685 C14.0220017,12.672814 14.0455017,12.5514664 14.1068024,12.4496316 L14.1597691,12.3772548 C15.0340796,11.3835436 15.2444364,9.96992996 14.6973099,8.76494043 C14.1501841,7.55995238 12.9471712,6.78734094 11.623156,6.79061294 Z M8.13974952,0.0379916314 C10.635982,0.307173301 12.7601468,1.97533841 13.61224,4.33568908 C13.7059578,4.59529295 13.5713596,4.8816731 13.3116067,4.97533705 C13.0518537,5.06900099 12.7653091,4.93448009 12.6715914,4.67487621 C11.9492586,2.67396981 10.1485706,1.25984 8.03247505,1.03165046 C5.91637949,0.803460924 3.855313,1.80115777 2.7225449,3.60201903 C1.5897768,5.4028803 1.58360572,7.69165319 2.70664633,9.49858969 C2.77850643,9.6142103 2.79932795,9.75270843 2.76732515,9.88213947 L2.73339059,9.97701354 L1.55791571,12.4438632 L4.02704264,11.2699231 C4.15010921,11.211385 4.29025925,11.2061714 4.41545939,11.252482 L4.50605585,11.2968475 C5.13836198,11.6900343 5.84341595,11.9519394 6.57917603,12.0669455 C6.85200182,12.1095907 7.03858019,12.3652036 6.99591049,12.6378728 C6.9532408,12.910542 6.69748118,13.0970133 6.4246554,13.0543681 C5.6647974,12.9355952 4.93268724,12.6840759 4.26156736,12.3121587 L4.21691571,12.2859539 L0.716788784,13.9513331 C0.318308574,14.1408752 -0.0964764376,13.7630654 0.0199174561,13.365073 L0.0504408377,13.2853676 L1.71491571,9.78738869 L1.59369034,9.56089721 C0.580739179,7.59045213 0.629525728,5.2320265 1.73785458,3.29986434 L1.87593971,3.07010306 C3.21219909,0.94573378 5.64351704,-0.231190038 8.13974952,0.0379916314 Z M13.0019157,9.66898403 C13.2780581,9.66898403 13.5019157,9.89284165 13.5019157,10.168984 C13.5019157,10.4144439 13.3250406,10.6185924 13.0917913,10.6609284 L13.0019157,10.668984 L10.335249,10.668984 C10.0591067,10.668984 9.83524905,10.4451264 9.83524905,10.168984 C9.83524905,9.92352414 10.0121242,9.71937566 10.2453734,9.6770397 L10.335249,9.66898403 L13.0019157,9.66898403 Z M6.16858238,7.00384783 C6.44472476,7.00384783 6.66858238,7.22770545 6.66858238,7.50384783 C6.66858238,7.74930772 6.49170722,7.9534562 6.25845801,7.99579216 L6.16858238,8.00384783 L4.50191571,8.00384783 C4.22577334,8.00384783 4.00191571,7.7799902 4.00191571,7.50384783 C4.00191571,7.25838794 4.17879087,7.05423946 4.41204008,7.0119035 L4.50191571,7.00384783 L6.16858238,7.00384783 Z M9.16858238,4.00556961 C9.44472476,4.00556961 9.66858238,4.22942723 9.66858238,4.50556961 C9.66858238,4.7510295 9.49170722,4.95517798 9.25845801,4.99751394 L9.16858238,5.00556961 L4.50191571,5.00556961 C4.22577334,5.00556961 4.00191571,4.78171198 4.00191571,4.50556961 C4.00191571,4.26010972 4.17879087,4.05596124 4.41204008,4.01362528 L4.50191571,4.00556961 L9.16858238,4.00556961 Z",
    transform: "translate(4 4)"
  }));
};
var IcnCheck = function IcnCheck(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M18.378 6.666a.5.5 0 0 1 .798.596l-.054.072-9 10a.5.5 0 0 1-.654.08l-.072-.06-4.5-4.5a.5.5 0 0 1 .638-.765l.07.057 4.126 4.127 8.648-9.607z"
  }));
};
var IcnCheckBold = function IcnCheckBold(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M18.378 6.666a.5.5 0 0 1 .798.596l-.054.072-9 10a.5.5 0 0 1-.654.08l-.072-.06-4.5-4.5a.5.5 0 0 1 .638-.765l.07.057 4.126 4.127 8.648-9.607z"
  }));
};
var IcnCheckCircle = function IcnCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm4.31 3.16a.5.5 0 0 1 .132.627l-.05.076-5.223 6.607a1.2 1.2 0 0 1-1.86.064l-.084-.112-1.634-2.318a.5.5 0 0 1 .76-.645l.058.069 1.64 2.328a.2.2 0 0 0 .294.04l.036-.038 5.229-6.615a.5.5 0 0 1 .702-.083z"
  }));
};
var IcnCheckLight = function IcnCheckLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M18.378 6.666a.5.5 0 0 1 .798.596l-.054.072-9 10a.5.5 0 0 1-.654.08l-.072-.06-4.5-4.5a.5.5 0 0 1 .638-.765l.07.057 4.126 4.127 8.648-9.607z"
  }));
};
var IcnChild = function IcnChild(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a8 8 0 0 1 2.393 15.636l-.016.005A8.005 8.005 0 0 1 12 20a8 8 0 1 1 0-16.001zM9.4 14.63c-1.218 0-2.32.646-2.926 1.666a6.985 6.985 0 0 0 6.194 2.673l-.01.039A3.4 3.4 0 0 0 9.4 14.63zM12 5a7 7 0 0 0-6.123 10.395 4.394 4.394 0 0 1 2.838-1.712A2.882 2.882 0 0 1 9.4 8a2.883 2.883 0 0 1 .686 5.684 4.39 4.39 0 0 1 2.75 1.598c.324-.278 1.015-.611 1.222-.688.128-.047.257-.087.387-.12a2.45 2.45 0 1 1 1.767-.013 3.57 3.57 0 0 1 1.206.544c.227.158.434.34.618.542A7 7 0 0 0 12 5zM9.4 9a1.883 1.883 0 1 0 0 3.767A1.883 1.883 0 0 0 9.4 9z"
  }));
};
var IcnClock = function IcnClock(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 1.067a6.933 6.933 0 1 0 0 13.866 6.933 6.933 0 0 0 0-13.866zM12 8.8c.262 0 .48.189.525.437l.008.096v2.445l3.177 3.179a.533.533 0 0 1-.68.815l-.074-.061-3.333-3.334-.02-.022a.536.536 0 0 1-.025-.029l.045.051a.535.535 0 0 1-.148-.281l-.003-.022a.536.536 0 0 1-.005-.054V9.333c0-.294.238-.533.533-.533z"
  }));
};
var IcnClockLight = function IcnClockLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 1.067a6.933 6.933 0 1 0 0 13.866 6.933 6.933 0 0 0 0-13.866zM12 8.8c.262 0 .48.189.525.437l.008.096v2.445l3.177 3.179a.533.533 0 0 1-.68.815l-.074-.061-3.333-3.334-.02-.022a.536.536 0 0 1-.025-.029l.045.051a.535.535 0 0 1-.148-.281l-.003-.022a.536.536 0 0 1-.005-.054V9.333c0-.294.238-.533.533-.533z"
  }));
};
var IcnCloud = function IcnCloud(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M10.251 6.602A4.169 4.169 0 0 0 7.07 9.911l-.179.041a3.834 3.834 0 0 0 .943 7.55H15.5a4.5 4.5 0 0 0 3.46-7.374l-.15-.17a4.5 4.5 0 0 0-3.998-1.404l-.049.008-.007-.012a4.167 4.167 0 0 0-4.307-1.987l-.198.04zm3.79 2.736a.5.5 0 0 0 .58.275A3.5 3.5 0 1 1 15.5 16.5H7.833a2.833 2.833 0 0 1-.271-5.653.5.5 0 0 0 .45-.455 3.167 3.167 0 0 1 6.03-1.055z"
  }));
};
var IcnCode = function IcnCode(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M13.586 4c.348 0 .683.12.95.34l.11.1 3.915 3.913a1.5 1.5 0 0 1 .432.913l.007.148V12.5a.5.5 0 0 1-.992.09L18 12.5V10h-3.5a1.5 1.5 0 0 1-1.493-1.356L13 8.5V5H6.5a.5.5 0 0 0-.492.41L6 5.5v13a.5.5 0 0 0 .41.492L6.5 19h1a.5.5 0 0 1 .09.992L7.5 20h-1a1.5 1.5 0 0 1-1.493-1.356L5 18.5v-13a1.5 1.5 0 0 1 1.356-1.493L6.5 4h7.086zm1.033 9l.09.01c.24.047.406.257.402.49l-.01.089-1.222 6.015a.5.5 0 0 1-.588.386.494.494 0 0 1-.402-.49l.01-.089 1.221-6.015A.498.498 0 0 1 14.62 13zm-3.275 1.4a.486.486 0 0 1-.033.63l-.067.06-1.911 1.41 1.911 1.411a.487.487 0 0 1 .147.614l-.047.075a.505.505 0 0 1-.623.145l-.077-.046L8.2 16.894a.487.487 0 0 1-.072-.723l.072-.064 2.444-1.805a.505.505 0 0 1 .7.098zm5.935-.145l.076.047 2.445 1.805c.24.177.264.513.072.722l-.072.065-2.445 1.805a.505.505 0 0 1-.7-.099.486.486 0 0 1 .033-.63l.067-.059 1.911-1.412-1.91-1.41a.487.487 0 0 1-.148-.613l.047-.076a.505.505 0 0 1 .624-.145zM17.793 9L14 5.207V8.5a.5.5 0 0 0 .41.492L14.5 9h3.293z"
  }));
};
var IcnCodeLight = function IcnCodeLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M13.586 4c.348 0 .683.12.95.34l.11.1 3.915 3.913a1.5 1.5 0 0 1 .432.913l.007.148V12.5a.5.5 0 0 1-.992.09L18 12.5V10h-3.5a1.5 1.5 0 0 1-1.493-1.356L13 8.5V5H6.5a.5.5 0 0 0-.492.41L6 5.5v13a.5.5 0 0 0 .41.492L6.5 19h1a.5.5 0 0 1 .09.992L7.5 20h-1a1.5 1.5 0 0 1-1.493-1.356L5 18.5v-13a1.5 1.5 0 0 1 1.356-1.493L6.5 4h7.086zm1.033 9l.09.01c.24.047.406.257.402.49l-.01.089-1.222 6.015a.5.5 0 0 1-.588.386.494.494 0 0 1-.402-.49l.01-.089 1.221-6.015A.498.498 0 0 1 14.62 13zm-3.275 1.4a.486.486 0 0 1-.033.63l-.067.06-1.911 1.41 1.911 1.411a.487.487 0 0 1 .147.614l-.047.075a.505.505 0 0 1-.623.145l-.077-.046L8.2 16.894a.487.487 0 0 1-.072-.723l.072-.064 2.444-1.805a.505.505 0 0 1 .7.098zm5.935-.145l.076.047 2.445 1.805c.24.177.264.513.072.722l-.072.065-2.445 1.805a.505.505 0 0 1-.7-.099.486.486 0 0 1 .033-.63l.067-.059 1.911-1.412-1.91-1.41a.487.487 0 0 1-.148-.613l.047-.076a.505.505 0 0 1 .624-.145zM17.793 9L14 5.207V8.5a.5.5 0 0 0 .41.492L14.5 9h3.293z"
  }));
};
var IcnConfig = function IcnConfig(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "nonzero",
    d: "M10 12.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 1a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM5.5 15a.5.5 0 0 1 .048.998L5.5 16h-1a.5.5 0 0 1-.048-.998L4.5 15h1zm14 0a.5.5 0 0 1 .048.998L19.5 16h-5a.5.5 0 0 1-.048-.998L14.5 15h5zM17 5.5a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm0 1a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM12.5 8a.5.5 0 0 1 .048.998L12.5 9h-8a.5.5 0 0 1-.048-.998L4.5 8h8z"
  }));
};
var IcnContactLess = function IcnContactLess(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M9.699 15.887a.522.522 0 0 1-.725 0 .491.491 0 0 1 0-.707 4.422 4.422 0 0 0 0-6.364.491.491 0 0 1 0-.707.522.522 0 0 1 .725 0 5.405 5.405 0 0 1 0 7.778zm2.174 2.123a.522.522 0 0 1-.725 0 .491.491 0 0 1 0-.707 7.37 7.37 0 0 0 0-10.606.491.491 0 0 1 0-.707.522.522 0 0 1 .725 0 8.354 8.354 0 0 1 0 12.02zm2.462 1.83a.522.522 0 0 1-.724.026.491.491 0 0 1-.026-.707 10.313 10.313 0 0 0 0-14.318.491.491 0 0 1 .026-.707.522.522 0 0 1 .724.025 11.295 11.295 0 0 1 0 15.682zm-6.96-9.958a2.95 2.95 0 0 1 0 4.24.522.522 0 0 1-.724 0 .491.491 0 0 1-.001-.707 1.967 1.967 0 0 0 0-2.827.491.491 0 0 1 0-.707.522.522 0 0 1 .725 0z"
  }));
};
var IcnContract = function IcnContract(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M15.625 4a.5.5 0 0 1 .295.096l.06.052 3.875 3.907a.5.5 0 0 1 .139.273l.006.078v10.43c0 .6-.454 1.094-1.038 1.157l-.127.007h-4.348a.5.5 0 0 1-.09-.99l.09-.008h4.348a.167.167 0 0 0 .158-.114l.008-.053L19 9.004l-2.849.001c-.6 0-1.095-.454-1.158-1.038l-.007-.127V4.997l-5.826.001a.167.167 0 0 0-.158.114l-.008.053v2.842a.5.5 0 0 1-.99.09l-.009-.09V5.165c0-.6.454-1.095 1.038-1.158L9.16 4h6.465zm-7.13 5.492a2.497 2.497 0 0 1 1.54 4.46l-.043.03v1.013h.5a2.497 2.497 0 0 1 2.491 2.332l.006.164a.508.508 0 0 1-.001.032l-.003.027a.497.497 0 0 1-.008.05l-.003.012-.5 1.997a.5.5 0 0 1-.4.37l-.084.008H4.999a.5.5 0 0 1-.457-.298l-.028-.08-.499-1.997-.005-.02a.501.501 0 0 1-.01-.101l.006.063-.005-.031v-.032a2.496 2.496 0 0 1 2.496-2.496h.498v-1.013l-.041-.03a2.496 2.496 0 0 1-.911-2.437l.04-.173a2.497 2.497 0 0 1 2.411-1.85zm3.354 8.498H5.138l.25.998H11.6l.249-.998zm-3.355-7.5a1.498 1.498 0 0 0-.749 2.795.5.5 0 0 1 .25.432v1.777a.5.5 0 0 1-.5.5h-.998c-.633 0-1.174.391-1.393.946l-.02.051h6.82l-.019-.051a1.5 1.5 0 0 0-1.249-.94l-.144-.007h-.999a.5.5 0 0 1-.5-.499v-1.777a.5.5 0 0 1 .25-.432 1.497 1.497 0 0 0-.749-2.795zm8.69 5.337a.5.5 0 0 1 .09.992l-.09.008h-1.865a.5.5 0 0 1-.09-.992l.09-.008h1.865zm0-2.662a.5.5 0 0 1 .09.992l-.09.008h-3.696a.5.5 0 0 1-.09-.992l.09-.008h3.696zm0-2.663a.5.5 0 0 1 .09.992l-.09.008h-4.695a.5.5 0 0 1-.09-.991l.09-.009h4.695zm-1.199-4.93V7.84c0 .074.048.136.114.158l.052.009 2.249-.001-2.415-2.434z"
  }));
};
var IcnCountryChoice = function IcnCountryChoice(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M14.509 11.328l.115.068 1.647 1.134 1.412-.475.153-.045a1.75 1.75 0 0 1 1.115 3.306l-.141.054-1.438.482-1.244 3.205a1.001 1.001 0 0 1-.387.476l-.11.061-.116.048-.908.306a1 1 0 0 1-1.318-.96l.01-.128.241-1.719-.977.328a1.5 1.5 0 0 1-1.382-.221l-.113-.094-.105-.107-1.592-1.782a1 1 0 0 1 .31-1.567l.117-.047 1.177-.396a.5.5 0 0 1 .44.06l.072.06.574.57.837-.281-.438-.436a1 1 0 0 1 .267-1.608l.12-.048.892-.3c.255-.086.532-.065.77.056zm3.6 1.646L18.01 13l-1.675.564a.503.503 0 0 1-.011.003l-4.236 1.425a.5.5 0 0 1-.44-.06l-.072-.06-.576-.571-.884.298 1.593 1.782a.5.5 0 0 0 .452.161l.083-.02 1.744-.586a.5.5 0 0 1 .66.46l-.005.083-.354 2.52.907-.305 1.33-3.421a.5.5 0 0 1 .226-.258l.08-.035 1.658-.558a.75.75 0 0 0-.381-1.448zm-6.68-8.907c1.359.196 2.57.804 3.512 1.686l-.049-.02a.498.498 0 0 1 .157.123A6.493 6.493 0 0 1 17 10.5a.5.5 0 0 1-1 0c0-1.295-.45-2.497-1.213-3.445l-.655 1.298a.5.5 0 0 0-.049.286l.022.096.37 1.107a.5.5 0 0 1-.913.4l-.036-.084-.37-1.107a1.5 1.5 0 0 1 .023-1.01l.06-.136.81-1.607a5.483 5.483 0 0 0-2.764-1.241 5.486 5.486 0 0 0-3.537.681l2.632.997a1.5 1.5 0 0 1 .965 1.556l-.021.144-.21 1.043a1.5 1.5 0 0 1-.969 1.12l-.138.04-1.138.285-.671 1.685c-.164.411-.434.77-.778 1.04l-.151.109-.766.523c.473.5 1.047.918 1.705 1.22a.5.5 0 0 1-.416.91 6.5 6.5 0 0 1 3.636-12.343zM6.787 6.444a5.495 5.495 0 0 0-.902 7.049l.825-.565c.21-.14.38-.33.497-.553l.063-.137.767-1.923a.5.5 0 0 1 .253-.268l.09-.032 1.386-.347a.5.5 0 0 0 .346-.308l.023-.079.21-1.043a.5.5 0 0 0-.235-.527l-.082-.04-3.241-1.227zm7.27 5.775l-.893.3.793.789 1.129-.38-1.029-.709z"
  }));
};
var IcnCross = function IcnCross(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M7.284 6.589l.07.057L12 11.293l4.646-4.647a.5.5 0 0 1 .765.638l-.057.07L12.707 12l4.647 4.646a.5.5 0 0 1-.638.765l-.07-.057L12 12.707l-4.646 4.647a.5.5 0 0 1-.765-.638l.057-.07L11.293 12 6.646 7.354a.5.5 0 0 1 .638-.765z"
  }));
};
var IcnCrossLight = function IcnCrossLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M7.284 6.589l.07.057L12 11.293l4.646-4.647a.5.5 0 0 1 .765.638l-.057.07L12.707 12l4.647 4.646a.5.5 0 0 1-.638.765l-.07-.057L12 12.707l-4.646 4.647a.5.5 0 0 1-.765-.638l.057-.07L11.293 12 6.646 7.354a.5.5 0 0 1 .638-.765z"
  }));
};
var IcnCsv = function IcnCsv(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M13.586 4c.348 0 .683.12.95.34l.11.1 3.915 3.913a1.5 1.5 0 0 1 .432.913l.007.148V12.5a.5.5 0 0 1-.992.09L18 12.5V10h-3.5a1.5 1.5 0 0 1-1.493-1.356L13 8.5V5H6.5a.5.5 0 0 0-.492.41L6 5.5v13a.5.5 0 0 0 .41.492L6.5 19h2a.5.5 0 0 1 .09.992L8.5 20h-2a1.5 1.5 0 0 1-1.493-1.356L5 18.5v-13a1.5 1.5 0 0 1 1.356-1.493L6.5 4h7.086zM12.5 14a.5.5 0 1 1 0 1 1.5 1.5 0 0 0-1.493 1.356L11 16.5v1a1.5 1.5 0 0 0 1.5 1.5.5.5 0 1 1 0 1 2.5 2.5 0 0 1-2.495-2.336L10 17.5v-1a2.5 2.5 0 0 1 2.5-2.5zm4 0a.5.5 0 0 1 .09.992L16.5 15h-1a.5.5 0 0 0-.5.5c0 .384.143.592.662.995l.138.105c.868.65 1.2 1.066 1.2 1.9a1.5 1.5 0 0 1-1.356 1.493L15.5 20h-1a.5.5 0 0 1-.09-.992L14.5 19h1a.5.5 0 0 0 .5-.5c0-.384-.143-.592-.662-.995L15.2 17.4c-.868-.65-1.2-1.066-1.2-1.9a1.5 1.5 0 0 1 1.356-1.493L15.5 14h1zm4 0a.5.5 0 0 1 .492.41l.008.09v1.697c0 1.275-.377 2.52-1.084 3.581a.5.5 0 0 1-.832 0 6.457 6.457 0 0 1-1.077-3.287L18 16.197V14.5a.5.5 0 0 1 .992-.09l.008.09v1.697c0 .718.142 1.426.413 2.083l.087.196.087-.196a5.457 5.457 0 0 0 .406-1.814l.007-.269V14.5a.5.5 0 0 1 .5-.5zM14 5.207V8.5a.5.5 0 0 0 .41.492L14.5 9h3.293L14 5.207z"
  }));
};
var IcnCsvLight = function IcnCsvLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M13.586 4c.348 0 .683.12.95.34l.11.1 3.915 3.913a1.5 1.5 0 0 1 .432.913l.007.148V12.5a.5.5 0 0 1-.992.09L18 12.5V10h-3.5a1.5 1.5 0 0 1-1.493-1.356L13 8.5V5H6.5a.5.5 0 0 0-.492.41L6 5.5v13a.5.5 0 0 0 .41.492L6.5 19h2a.5.5 0 0 1 .09.992L8.5 20h-2a1.5 1.5 0 0 1-1.493-1.356L5 18.5v-13a1.5 1.5 0 0 1 1.356-1.493L6.5 4h7.086zM12.5 14a.5.5 0 1 1 0 1 1.5 1.5 0 0 0-1.493 1.356L11 16.5v1a1.5 1.5 0 0 0 1.5 1.5.5.5 0 1 1 0 1 2.5 2.5 0 0 1-2.495-2.336L10 17.5v-1a2.5 2.5 0 0 1 2.5-2.5zm4 0a.5.5 0 0 1 .09.992L16.5 15h-1a.5.5 0 0 0-.5.5c0 .384.143.592.662.995l.138.105c.868.65 1.2 1.066 1.2 1.9a1.5 1.5 0 0 1-1.356 1.493L15.5 20h-1a.5.5 0 0 1-.09-.992L14.5 19h1a.5.5 0 0 0 .5-.5c0-.384-.143-.592-.662-.995L15.2 17.4c-.868-.65-1.2-1.066-1.2-1.9a1.5 1.5 0 0 1 1.356-1.493L15.5 14h1zm4 0a.5.5 0 0 1 .492.41l.008.09v1.697c0 1.275-.377 2.52-1.084 3.581a.5.5 0 0 1-.832 0 6.457 6.457 0 0 1-1.077-3.287L18 16.197V14.5a.5.5 0 0 1 .992-.09l.008.09v1.697c0 .718.142 1.426.413 2.083l.087.196.087-.196a5.457 5.457 0 0 0 .406-1.814l.007-.269V14.5a.5.5 0 0 1 .5-.5zM14 5.207V8.5a.5.5 0 0 0 .41.492L14.5 9h3.293L14 5.207z"
  }));
};
var IcnDashboard = function IcnDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M10.353 4.009L5.15 4A1.152 1.152 0 0 0 4 5.154v7.193A1.15 1.15 0 0 0 5.149 13.5h5.201a1.152 1.152 0 0 0 1.15-1.154V5.162a1.152 1.152 0 0 0-1.147-1.153zm-5.24.996L5.15 5l5.199.009c.082 0 .15.068.15.152v7.186a.152.152 0 0 1-.152.153H5.15a.15.15 0 0 1-.15-.152V5.153a.153.153 0 0 1 .112-.148zm13.854-1L18.842 4l-5.197.009a1.145 1.145 0 0 0-1.148 1.138v3.212A1.147 1.147 0 0 0 13.651 9.5h5.196a1.145 1.145 0 0 0 1.15-1.138v-3.22a1.148 1.148 0 0 0-1.03-1.136zM13.643 5.01L18.847 5c.084 0 .15.065.15.145V8.36a.145.145 0 0 1-.147.141h-5.203a.145.145 0 0 1-.15-.144V5.15c0-.077.066-.142.146-.141zM10.347 14.5H5.15A1.144 1.144 0 0 0 4 15.64v3.209a1.147 1.147 0 0 0 1.15 1.142l5.198.01A1.146 1.146 0 0 0 11.5 18.86v-3.217a1.147 1.147 0 0 0-1.153-1.143zm-5.2 1h5.203c.084 0 .15.065.15.146v3.21a.147.147 0 0 1-.148.143l-5.202-.008a.147.147 0 0 1-.15-.145v-3.203a.146.146 0 0 1 .147-.143zm13.702-5h-5.202a1.153 1.153 0 0 0-1.15 1.156v7.19A1.151 1.151 0 0 0 13.647 20l5.202-.009a1.153 1.153 0 0 0 1.148-1.155v-7.182A1.151 1.151 0 0 0 18.85 10.5zm-5.2 1h5.197a.152.152 0 0 1 .151.152v7.185a.153.153 0 0 1-.152.154L13.647 19a.151.151 0 0 1-.15-.152v-7.194a.153.153 0 0 1 .152-.154z"
  }));
};
var IcnDebit = function IcnDebit(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "11.9",
    cy: "11.9",
    r: "11.55",
    fill: "#FFF",
    stroke: "#005191",
    strokeWidth: ".7"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.236 8.789h-4.933l-.503.567-1.625 1.833-.504.567H5.808l.491-.573.233-.271.492-.573H4.787a.757.757 0 00-.743.762v1.612c0 .422.334.763.743.763h8.579c.41 0 .971-.252 1.242-.567l1.298-1.474 2.33-2.646z",
    fill: "#005498"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.225 7.07c.41 0 .744.346.744.761v1.607a.753.753 0 01-.744.762h-2.23l.498-.567.246-.283.497-.567h-4.932l-2.627 2.96H5.783L9.29 7.775l.133-.151c.277-.309.837-.567 1.247-.567h8.554v.012z",
    fill: "#FFD800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.969 16.852v-.233c0-.032-.02-.05-.063-.05h-.152c-.044 0-.075-.007-.082-.026-.012-.019-.012-.056-.012-.12v-.881h.246a.057.057 0 00.044-.02.057.057 0 00.019-.043v-.246a.057.057 0 00-.02-.044.057.057 0 00-.043-.019h-.246v-.321c0-.02-.006-.032-.013-.038a.09.09 0 00-.038-.013h-.006l-.365.063c-.02.007-.032.013-.044.02-.013.012-.02.025-.02.037v.246h-.245a.057.057 0 00-.044.019.057.057 0 00-.019.044v.201c0 .02.006.032.019.038a.102.102 0 00.044.025l.246.038v.882c0 .107.012.195.031.265.025.069.057.12.095.157a.335.335 0 00.157.076c.063.012.139.019.22.019.045 0 .083 0 .12-.007l.12-.019c.032 0 .05-.019.05-.05m-1.31-.032v-.27c0-.02-.006-.032-.019-.038a.09.09 0 00-.037-.013h-.007c-.056.007-.113.013-.164.013-.05.006-.12.006-.207.006a.24.24 0 01-.176-.076.242.242 0 01-.051-.107.634.634 0 01-.019-.17v-.252c0-.069.006-.126.019-.17a.34.34 0 01.05-.107.24.24 0 01.177-.075c.088 0 .157 0 .207.006.05.006.108.006.164.013h.007c.018 0 .031-.007.037-.013.013-.006.02-.019.02-.038v-.27c0-.026-.007-.039-.013-.045-.013-.006-.026-.019-.05-.025-.045-.013-.095-.019-.165-.032-.069-.012-.144-.012-.239-.012a.693.693 0 00-.516.195c-.126.132-.196.321-.196.573v.252c0 .246.063.441.196.574.126.132.302.195.516.195.088 0 .17-.006.24-.013.069-.012.125-.019.163-.031a.095.095 0 00.05-.025c.013-.007.013-.026.013-.045m-1.971-.32a.672.672 0 01-.252.062.299.299 0 01-.145-.025c-.032-.019-.044-.057-.044-.126v-.025c0-.038.006-.07.012-.095a.163.163 0 01.044-.069.165.165 0 01.082-.038.668.668 0 01.133-.012h.17v.327zm.478-.738a.737.737 0 00-.05-.283.526.526 0 00-.139-.19.516.516 0 00-.22-.106 1.088 1.088 0 00-.296-.038c-.1 0-.202.006-.296.019-.095.012-.17.025-.227.044-.038.012-.057.031-.057.07v.245c0 .019.007.031.013.044a.09.09 0 00.038.013h.012c.026 0 .057-.007.088-.007.038 0 .076-.006.12-.006s.095-.006.145-.006h.145a.3.3 0 01.164.037c.038.026.063.082.063.17v.108h-.164c-.258 0-.454.037-.567.12-.12.081-.176.213-.176.39v.025c0 .1.012.183.044.246.031.069.069.12.12.163a.514.514 0 00.358.114c.089 0 .17-.013.234-.038a.92.92 0 00.189-.1v.05c0 .019.006.031.018.044a.057.057 0 00.045.019h.34a.057.057 0 00.044-.02.057.057 0 00.019-.043v-1.084h-.007zm-1.619 1.09v-.233c0-.032-.018-.05-.063-.05h-.15c-.045 0-.076-.007-.083-.026-.012-.019-.012-.056-.012-.12v-.881h.245a.057.057 0 00.045-.02.057.057 0 00.018-.043v-.246a.057.057 0 00-.018-.044.057.057 0 00-.045-.019h-.245v-.321c0-.02-.007-.032-.013-.038-.012-.006-.025-.013-.038-.013h-.006l-.365.063c-.02.007-.032.013-.044.02-.013.012-.02.025-.02.037v.246h-.251a.057.057 0 00-.044.019.057.057 0 00-.02.044v.201c0 .02.007.032.02.038a.102.102 0 00.044.025l.245.038v.882c0 .107.013.195.032.265.025.069.057.12.094.157a.335.335 0 00.158.076c.063.012.139.019.22.019.044 0 .082 0 .12-.007l.12-.019c.038 0 .056-.019.056-.05m-1.322-.006v-1.008c0-.095-.007-.183-.026-.271a.616.616 0 00-.081-.22.367.367 0 00-.164-.145.558.558 0 00-.271-.057.824.824 0 00-.258.038.884.884 0 00-.24.126v-.076a.057.057 0 00-.019-.044.057.057 0 00-.044-.019h-.34a.057.057 0 00-.044.019.057.057 0 00-.019.044v1.613c0 .019.006.031.019.044a.057.057 0 00.044.019h.365a.057.057 0 00.045-.02.057.057 0 00.018-.043v-1.19c.05-.026.101-.051.152-.07a.36.36 0 01.138-.025c.044 0 .082.006.114.012.031.007.05.025.069.044.019.026.025.05.031.089.007.037.007.081.007.132v1.008c0 .019.006.031.019.044a.057.057 0 00.044.019h.365a.057.057 0 00.044-.02c.025-.012.032-.03.032-.043m-2.293-.7c0 .246-.088.372-.271.372-.088 0-.158-.031-.202-.094a.486.486 0 01-.069-.278v-.214c0-.126.025-.214.07-.277.043-.063.113-.094.2-.094.177 0 .272.126.272.371v.214zm.491-.214c0-.12-.019-.233-.05-.327a.635.635 0 00-.384-.403.87.87 0 00-.328-.057.87.87 0 00-.328.057.635.635 0 00-.384.403c-.031.094-.05.208-.05.327v.214c0 .12.019.234.05.328a.635.635 0 00.384.403.87.87 0 00.328.057.87.87 0 00.327-.057.635.635 0 00.385-.403c.031-.094.05-.208.05-.328v-.214zm-1.682.888v-.27c0-.02-.006-.032-.019-.038a.091.091 0 00-.044-.013h-.006a1.551 1.551 0 01-.164.013c-.05.006-.12.006-.208.006a.24.24 0 01-.176-.076.242.242 0 01-.05-.107.634.634 0 01-.02-.17v-.252c0-.069.007-.126.02-.17a.34.34 0 01.05-.107.24.24 0 01.176-.075c.088 0 .158 0 .208.006.05.006.107.006.164.013h.006a.091.091 0 00.044-.013c.013-.006.02-.019.02-.038v-.27c0-.026-.007-.039-.013-.045-.013-.006-.026-.019-.05-.025-.045-.013-.095-.019-.165-.032-.069-.012-.144-.012-.239-.012a.693.693 0 00-.517.195c-.126.132-.195.321-.195.573v.252c0 .246.063.441.195.574.126.132.303.195.517.195.088 0 .17-.006.24-.013.069-.012.12-.019.163-.031a.095.095 0 00.05-.025c.007-.007.013-.026.013-.045m-1.493.026v-1.008c0-.095-.006-.183-.025-.271a.616.616 0 00-.082-.22.367.367 0 00-.164-.145.558.558 0 00-.27-.057.824.824 0 00-.259.038.884.884 0 00-.24.126v-.076a.057.057 0 00-.018-.044.057.057 0 00-.044-.019h-.34a.057.057 0 00-.044.019.057.057 0 00-.02.044v1.613c0 .019.007.031.02.044a.057.057 0 00.044.019h.365a.057.057 0 00.044-.02.057.057 0 00.02-.043v-1.19c.05-.026.1-.051.15-.07a.36.36 0 01.139-.025c.044 0 .082.006.113.012.032.007.05.025.07.044.018.026.025.05.031.089.006.037.006.081.006.132v1.008c0 .019.007.031.02.044a.057.057 0 00.043.019h.366a.057.057 0 00.044-.02c.025-.012.031-.03.031-.043m-2.343-.347a.672.672 0 01-.252.063.299.299 0 01-.145-.025c-.031-.019-.044-.057-.044-.126v-.025c0-.038.006-.07.013-.095a.163.163 0 01.044-.069.165.165 0 01.082-.038.668.668 0 01.132-.012h.17v.327zm.485-.737a.737.737 0 00-.05-.283.526.526 0 00-.139-.19.516.516 0 00-.22-.106 1.088 1.088 0 00-.297-.038c-.1 0-.201.006-.296.019-.094.012-.17.025-.226.044-.038.012-.057.031-.057.07v.245c0 .019.006.031.013.044a.09.09 0 00.037.013h.013c.025 0 .057-.007.088-.007.038 0 .076-.006.126-.006.044 0 .095-.006.145-.006h.145a.3.3 0 01.164.037c.037.026.063.082.063.17v.108h-.164c-.258 0-.454.037-.567.12-.12.081-.176.213-.176.39v.025c0 .1.012.183.044.246.031.069.069.12.12.163a.514.514 0 00.358.114c.089 0 .17-.013.233-.038a.92.92 0 00.19-.1v.05c0 .019.006.031.018.044a.057.057 0 00.044.019h.34a.057.057 0 00.045-.02.057.057 0 00.019-.043v-1.084h-.013zm-2.167.479a.24.24 0 01-.088.195c-.057.044-.17.07-.321.07H4.56v-.567h.34c.12 0 .208.025.252.081.044.057.069.12.069.19v.03zm-.013-.9a.486.486 0 01-.012.094.16.16 0 01-.05.075.334.334 0 01-.095.05.492.492 0 01-.151.02h-.34v-.523H4.794c.157 0 .264.019.327.056.063.038.095.101.095.183l-.007.044zm.517.868a.472.472 0 00-.076-.27.479.479 0 00-.195-.177.427.427 0 00.19-.176.552.552 0 00.068-.265v-.056a.63.63 0 00-.069-.303.528.528 0 00-.195-.195.946.946 0 00-.303-.107 2.452 2.452 0 00-.39-.032h-.151c-.05 0-.101.007-.151.007a.944.944 0 00-.139.012c-.044.007-.076.007-.1.013-.058.012-.102.025-.127.057-.025.025-.038.075-.038.144v1.846c0 .07.013.113.038.145.025.025.07.044.126.057.032.006.07.012.107.012.044.007.088.007.139.013.05.006.1.006.151.006h.158c.132 0 .258-.012.371-.031a.906.906 0 00.303-.107.597.597 0 00.207-.208.671.671 0 00.076-.334v-.05z",
    fill: "#005498"
  }))));
};
var IcnDeleteUserLIght = function IcnDeleteUserLIght(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M15.5 10.999a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm0 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zm-1.216 1.588l.07.057 1.146 1.147 1.146-1.147a.5.5 0 0 1 .765.638l-.057.07-1.147 1.146 1.147 1.146a.5.5 0 0 1-.638.765l-.07-.057-1.146-1.147-1.146 1.147a.5.5 0 0 1-.765-.638l.057-.07 1.147-1.146-1.147-1.146a.5.5 0 0 1 .638-.765zM10.963 10.9a.5.5 0 1 1-.392.92A4.002 4.002 0 0 0 5 15.501a.5.5 0 0 1-1-.001 5.002 5.002 0 0 1 6.963-4.599zM9 4a3.25 3.25 0 1 0 0 6.5A3.25 3.25 0 0 0 9 4zm0 1a2.25 2.25 0 1 1 0 4.5A2.25 2.25 0 0 1 9 5z"
  }));
};
var IcnDeleteUserRegular = function IcnDeleteUserRegular(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M15.5 10.999a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm0 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zm-1.216 1.588l.07.057 1.146 1.147 1.146-1.147a.5.5 0 0 1 .765.638l-.057.07-1.147 1.146 1.147 1.146a.5.5 0 0 1-.638.765l-.07-.057-1.146-1.147-1.146 1.147a.5.5 0 0 1-.765-.638l.057-.07 1.147-1.146-1.147-1.146a.5.5 0 0 1 .638-.765zM10.963 10.9a.5.5 0 1 1-.392.92A4.002 4.002 0 0 0 5 15.501a.5.5 0 0 1-1-.001 5.002 5.002 0 0 1 6.963-4.599zM9 4a3.25 3.25 0 1 0 0 6.5A3.25 3.25 0 0 0 9 4zm0 1a2.25 2.25 0 1 1 0 4.5A2.25 2.25 0 0 1 9 5z"
  }));
};
var IcnDeleteWatchlist = function IcnDeleteWatchlist(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M15.5 11a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm0 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zm2.12 3a.5.5 0 0 1 .09.993l-.09.008h-4.242a.5.5 0 0 1-.09-.992l.09-.008h4.243zM11.99 4c2.574-.044 5.478 1.592 7.593 3.924.555.61.555 1.543.005 2.147-.144.164-.305.333-.495.523a.5.5 0 0 1-.707-.707c.176-.176.323-.33.457-.483a.6.6 0 0 0 0-.807c-1.94-2.14-4.596-3.635-6.835-3.596-2.292.04-4.975 1.526-6.852 3.596a.6.6 0 0 0 .003.81 12.3 12.3 0 0 0 4.176 3.037.5.5 0 1 1-.405.914 13.296 13.296 0 0 1-4.514-3.28 1.6 1.6 0 0 1 0-2.153c2.046-2.257 4.973-3.879 7.575-3.924zm.468 2.041A3.001 3.001 0 0 1 15 9.005c-.002.269-.04.536-.11.796a.5.5 0 1 1-.965-.267c.049-.175.074-.356.076-.532a2 2 0 1 0-2.896 1.792.5.5 0 1 1-.448.894 3 3 0 0 1 1.802-5.647z"
  }));
};
var IcnDesktop = function IcnDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M8 19a.5.5 0 0 1-.09-.992L8 18h1.076l.333-2H6a2 2 0 0 1-1.995-1.85L4 14V7a2 2 0 0 1 1.85-1.995L6 5h12a2 2 0 0 1 1.995 1.85L20 7v7a2 2 0 0 1-1.85 1.995L18 16h-3.41l.333 2H16a.5.5 0 0 1 .09.992L16 19H8zm5.575-3h-3.151l-.334 1.999h3.819L13.575 16zM18 6H6a1 1 0 0 0-.993.883L5 7v7a1 1 0 0 0 .883.993L6 15h12a1 1 0 0 0 .993-.883L19 14V7a1 1 0 0 0-1-1z"
  }));
};
var IcnDownload = function IcnDownload(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M19.5 14a.5.5 0 0 1 .492.41l.008.09v1a2.5 2.5 0 0 1-2.336 2.495L17.5 18h-11a2.5 2.5 0 0 1-2.495-2.336L4 15.5v-1a.5.5 0 0 1 .992-.09L5 14.5v1a1.5 1.5 0 0 0 1.356 1.493L6.5 17h11a1.5 1.5 0 0 0 1.493-1.356L19 15.5v-1a.5.5 0 0 1 .5-.5zM12 6a.5.5 0 0 1 .492.41l.008.09v6.793l2.146-2.147a.5.5 0 0 1 .638-.057l.07.057a.5.5 0 0 1 .057.638l-.057.07-3 3-.013.011a.503.503 0 0 1-.039.033l.052-.044A.502.502 0 0 1 12 15h-.02a.503.503 0 0 1-.052-.005L12 15a.502.502 0 0 1-.284-.089l-.018-.013a.503.503 0 0 1-.04-.033l-.012-.011-3-3a.5.5 0 0 1 .638-.765l.07.057 2.146 2.147V6.5A.5.5 0 0 1 12 6z"
  }));
};
var IcnDownloadLight = function IcnDownloadLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M19.5 14a.5.5 0 0 1 .492.41l.008.09v1a2.5 2.5 0 0 1-2.336 2.495L17.5 18h-11a2.5 2.5 0 0 1-2.495-2.336L4 15.5v-1a.5.5 0 0 1 .992-.09L5 14.5v1a1.5 1.5 0 0 0 1.356 1.493L6.5 17h11a1.5 1.5 0 0 0 1.493-1.356L19 15.5v-1a.5.5 0 0 1 .5-.5zM12 6a.5.5 0 0 1 .492.41l.008.09v6.793l2.146-2.147a.5.5 0 0 1 .638-.057l.07.057a.5.5 0 0 1 .057.638l-.057.07-3 3-.013.011a.503.503 0 0 1-.039.033l.052-.044A.502.502 0 0 1 12 15h-.02a.503.503 0 0 1-.052-.005L12 15a.502.502 0 0 1-.284-.089l-.018-.013a.503.503 0 0 1-.04-.033l-.012-.011-3-3a.5.5 0 0 1 .638-.765l.07.057 2.146 2.147V6.5A.5.5 0 0 1 12 6z"
  }));
};
var IcnDragDrop = function IcnDragDrop(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "nonzero",
    d: "M19.5 18a.5.5 0 0 1 .5.5 1.5 1.5 0 0 1-1.5 1.5.5.5 0 0 1-.09-.992L18.5 19a.5.5 0 0 0 .494-.421L19 18.5a.5.5 0 0 1 .5-.5zm-9 1a.5.5 0 0 1 .09.992L10.5 20h-1a.5.5 0 0 1-.09-.992L9.5 19h1zm3 0a.5.5 0 0 1 .09.992L13.5 20h-1a.5.5 0 0 1-.09-.992L12.5 19h1zm3 0a.5.5 0 0 1 .09.992L16.5 20h-1a.5.5 0 0 1-.09-.992L15.5 19h1zM14.034 8.833c.292 0 .574.099.8.277l.11.096 2.282 2.253a3.16 3.16 0 0 1 .94 2.239 3.13 3.13 0 0 1-.767 2.056l-.171.183-1.42 1.402a2.876 2.876 0 0 1-2.271.817l-.226-.028-.982-.16a4.214 4.214 0 0 1-2.277-1.157 2.05 2.05 0 0 1-.416-2.33l.083-.159.017-.027-.522-.516a1.277 1.277 0 0 1-.348-.62l-.024-.143-.009-.145a1.275 1.275 0 0 1 .607-1.085l.126-.069.118-.049-.004-.03-.009-.145c0-.341.137-.667.38-.907s.57-.373.91-.373l.073.002.073.006.038.007.05-.12c.029-.057.06-.113.097-.166l.058-.077.097-.108a1.295 1.295 0 0 1 1.197-.34l.138.04.118.047.042-.073.04-.06.044-.057.098-.108c.242-.239.569-.373.91-.373zm0 1a.296.296 0 0 0-.208.085.275.275 0 0 0 0 .39c.454.449-.169 1.12-.64.767l-.062-.055-.56-.55a.296.296 0 0 0-.414 0 .275.275 0 0 0-.045.332l.045.058.559.552a.5.5 0 0 1-.633.769l-.07-.058-.559-.551-.005-.006-.273-.269a.296.296 0 0 0-.415 0 .275.275 0 0 0-.045.334l.045.057.272.269.006.006.56.551a.5.5 0 0 1-.634.77l-.07-.058-.558-.551-.003-.003-.04-.032a.298.298 0 0 0-.371.036.275.275 0 0 0-.045.333l.045.058.837.826.838.827a.5.5 0 0 1-.633.77l-.07-.058-.4-.394a1.04 1.04 0 0 0 .266 1.062 3.21 3.21 0 0 0 1.52.838l.217.044.982.16a1.9 1.9 0 0 0 1.5-.397l.132-.118 1.42-1.402a2.16 2.16 0 0 0 .642-1.527 2.133 2.133 0 0 0-.526-1.402l-.117-.125-2.283-2.253a.296.296 0 0 0-.207-.085zM19.5 15a.5.5 0 0 1 .492.41l.008.09v1a.5.5 0 0 1-.992.09L19 16.5v-1a.5.5 0 0 1 .5-.5zM15.833 4c.602 0 1.097.455 1.16 1.04l.007.127v3.5a.5.5 0 0 1-.992.09L16 8.667v-3.5a.167.167 0 0 0-.114-.159L15.833 5H5.167a.167.167 0 0 0-.159.114L5 5.167v10.666c0 .074.048.136.114.159l.053.008H8a.5.5 0 0 1 .09.992L8 17H5.167a1.167 1.167 0 0 1-1.16-1.04L4 15.833V5.167c0-.602.455-1.097 1.04-1.16L5.167 4h10.666zm3.667 8a.5.5 0 0 1 .492.41l.008.09v1a.5.5 0 0 1-.992.09L19 13.5v-1a.5.5 0 0 1 .5-.5zm0-3a.5.5 0 0 1 .492.41L20 9.5v1a.5.5 0 0 1-.992.09L19 10.5v-1a.5.5 0 0 1 .5-.5z"
  }));
};
var IcnDuplicate = function IcnDuplicate(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M15 7a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h9zm0 1H6a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zm3.5-4l.144.007A1.5 1.5 0 0 1 20 5.5v10l-.007.144A1.5 1.5 0 0 1 18.5 17a.5.5 0 1 1 0-1l.09-.008A.5.5 0 0 0 19 15.5v-10l-.008-.09A.5.5 0 0 0 18.5 5h-10l-.09.008A.5.5 0 0 0 8 5.5l-.008.09A.5.5 0 0 1 7 5.5 1.5 1.5 0 0 1 8.5 4h10z"
  }));
};
var IcnEmail = function IcnEmail(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M19.467 6a.54.54 0 0 1 .533.545v10.91a.54.54 0 0 1-.533.545H4.533A.54.54 0 0 1 4 17.455V6.545A.54.54 0 0 1 4.533 6zm-.534 1.862l-5.173 4.071c-.98.771-2.323.814-3.343.129l-.176-.129-5.175-4.071v9.047h13.867V7.862zm-.767-.772H5.833l5.058 3.979c.61.48 1.444.512 2.084.096l.134-.096 5.057-3.979z"
  }));
};
var IcnEmailVerified = function IcnEmailVerified(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M15.5 11a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm0 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zm2.083 1.937a.5.5 0 0 1 .147.624l-.047.076-1.938 2.583a1.001 1.001 0 0 1-1.414.189l-.093-.082-1-1a.5.5 0 0 1 .638-.765l.07.058 1 1 1.937-2.583a.5.5 0 0 1 .7-.1zM17.5 4a1.497 1.497 0 0 1 1.17.562l.007.008c.174.22.288.49.316.786L19 5.5V10a.5.5 0 0 1-.992.09L18 10V5.707l-4.85 3.732a2.705 2.705 0 0 1-3.134.118l-.166-.118L5 5.707V13.5a.5.5 0 0 0 .41.492L5.5 14h4a.5.5 0 0 1 .09.992L9.5 15h-4a1.5 1.5 0 0 1-1.493-1.356L4 13.5v-8c0-.351.12-.675.323-.93l.007-.008.019-.024a1.497 1.497 0 0 1 1.007-.531L5.5 4h12zm-.22 1H5.719l4.741 3.646c.572.44 1.354.47 1.954.088l.126-.088L17.28 5z"
  }));
};
var IcnErrorCircle = function IcnErrorCircle(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm-1.837 4.467l.07.058L12 11.293l1.768-1.768a.5.5 0 0 1 .765.638l-.058.07L12.707 12l1.768 1.767a.5.5 0 0 1-.638.765l-.07-.058L12 12.707l-1.768 1.767a.5.5 0 0 1-.765-.638l.058-.069L11.293 12l-1.768-1.768a.5.5 0 0 1 .638-.765z"
  }));
};
var IcnEuro = function IcnEuro(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M17 4a.5.5 0 1 1 0 1 7.003 7.003 0 0 0-6.71 5H15a.5.5 0 0 1 .09.992L15 11h-4.93a7.06 7.06 0 0 0 .001 2.001L13 13a.5.5 0 0 1 .09.992L13 14l-2.71.001A7.003 7.003 0 0 0 17 19a.5.5 0 1 1 0 1 8.003 8.003 0 0 1-7.748-6H7a.5.5 0 0 1-.09-.992L7 13l2.062.001a8.079 8.079 0 0 1 0-2.001H7a.5.5 0 0 1-.09-.992L7 10h2.252c.888-3.45 4.02-6 7.748-6z"
  }));
};
var IcnExcel = function IcnExcel(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M13.586 4c.348 0 .683.12.95.34l.11.1 3.915 3.914a1.5 1.5 0 0 1 .432.912l.007.148V12.5a.5.5 0 0 1-.992.09L18 12.5V10h-3.5a1.5 1.5 0 0 1-1.493-1.356L13 8.5V5H6.5a.5.5 0 0 0-.492.41L6 5.5v13a.5.5 0 0 0 .41.492L6.5 19h2a.5.5 0 0 1 .09.992L8.5 20h-2a1.5 1.5 0 0 1-1.493-1.356L5 18.5v-13a1.5 1.5 0 0 1 1.356-1.493L6.5 4h7.086zm.914 10a.5.5 0 0 1 .492.41l.008.09v4a.5.5 0 0 0 .41.492l.09.008h1a.5.5 0 0 1 .09.992L16.5 20h-1a1.5 1.5 0 0 1-1.493-1.356L14 18.5v-4a.5.5 0 0 1 .5-.5zm6 0a.5.5 0 0 1 .09.992L20.5 15h-1a.5.5 0 0 0-.5.5c0 .384.143.592.662.995l.138.105c.868.65 1.2 1.066 1.2 1.9a1.5 1.5 0 0 1-1.356 1.493L19.5 20h-1a.5.5 0 0 1-.09-.992L18.5 19h1a.5.5 0 0 0 .5-.5c0-.384-.143-.592-.662-.995L19.2 17.4c-.868-.65-1.2-1.066-1.2-1.9a1.5 1.5 0 0 1 1.356-1.493L19.5 14h1zm-7.814.036a.5.5 0 0 1 .304.563l-.026.087L12.038 17l.926 2.314a.5.5 0 0 1-.887.452l-.041-.08-.536-1.34-.536 1.34a.5.5 0 0 1-.954-.285l.026-.087L10.96 17l-.925-2.314a.5.5 0 0 1 .887-.452l.041.08.536 1.339.536-1.339a.5.5 0 0 1 .65-.278zM14 5.207V8.5a.5.5 0 0 0 .41.492L14.5 9h3.293L14 5.207z"
  }));
};
var IcnExcelLight = function IcnExcelLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M13.586 4c.348 0 .683.12.95.34l.11.1 3.915 3.914a1.5 1.5 0 0 1 .432.912l.007.148V12.5a.5.5 0 0 1-.992.09L18 12.5V10h-3.5a1.5 1.5 0 0 1-1.493-1.356L13 8.5V5H6.5a.5.5 0 0 0-.492.41L6 5.5v13a.5.5 0 0 0 .41.492L6.5 19h2a.5.5 0 0 1 .09.992L8.5 20h-2a1.5 1.5 0 0 1-1.493-1.356L5 18.5v-13a1.5 1.5 0 0 1 1.356-1.493L6.5 4h7.086zm.914 10a.5.5 0 0 1 .492.41l.008.09v4a.5.5 0 0 0 .41.492l.09.008h1a.5.5 0 0 1 .09.992L16.5 20h-1a1.5 1.5 0 0 1-1.493-1.356L14 18.5v-4a.5.5 0 0 1 .5-.5zm6 0a.5.5 0 0 1 .09.992L20.5 15h-1a.5.5 0 0 0-.5.5c0 .384.143.592.662.995l.138.105c.868.65 1.2 1.066 1.2 1.9a1.5 1.5 0 0 1-1.356 1.493L19.5 20h-1a.5.5 0 0 1-.09-.992L18.5 19h1a.5.5 0 0 0 .5-.5c0-.384-.143-.592-.662-.995L19.2 17.4c-.868-.65-1.2-1.066-1.2-1.9a1.5 1.5 0 0 1 1.356-1.493L19.5 14h1zm-7.814.036a.5.5 0 0 1 .304.563l-.026.087L12.038 17l.926 2.314a.5.5 0 0 1-.887.452l-.041-.08-.536-1.34-.536 1.34a.5.5 0 0 1-.954-.285l.026-.087L10.96 17l-.925-2.314a.5.5 0 0 1 .887-.452l.041.08.536 1.339.536-1.339a.5.5 0 0 1 .65-.278zM14 5.207V8.5a.5.5 0 0 0 .41.492L14.5 9h3.293L14 5.207z"
  }));
};
var IcnExclamationCircle = function IcnExclamationCircle(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm0 9.5l.102.007a.75.75 0 1 1-.204 0L12 14.5zM12 7a.5.5 0 0 1 .492.41l.008.09V13a.5.5 0 0 1-.992.09L11.5 13V7.5A.5.5 0 0 1 12 7z"
  }));
};
var IcnExclamationMark = function IcnExclamationMark(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4c.6 0 1.151.315 1.458.822l.072.13 6.315 12.866a1.514 1.514 0 0 1-1.204 2.174l-.156.008H5.515a1.514 1.514 0 0 1-1.421-2.039l.061-.143 6.316-12.865C10.757 4.37 11.35 4 12 4zm0 1a.704.704 0 0 0-.582.307l-.05.087-6.315 12.865a.514.514 0 0 0 .374.733l.088.008h12.97a.514.514 0 0 0 .499-.642l-.037-.1-6.315-12.864A.704.704 0 0 0 12 5zm0 11l.102.007a.75.75 0 1 1-.204 0L12 16zm0-7a.5.5 0 0 1 .492.41l.008.09v5a.5.5 0 0 1-.992.09l-.008-.09v-5A.5.5 0 0 1 12 9z"
  }));
};
var IcnEyeClosed = function IcnEyeClosed(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M18.714 5.654a.5.5 0 0 1 .044.639l-.059.068-2.93 2.815a.496.496 0 0 1-.062.06l-1.612 1.548a.505.505 0 0 1-.191.183l-3.475 3.335a.498.498 0 0 1-.137.15l-.056.033-1.72 1.652a.509.509 0 0 1-.228.221l-2.089 2.003a.5.5 0 0 1-.752-.654l.06-.068 1.727-1.658a13.821 13.821 0 0 1-2.818-2.405 1.6 1.6 0 0 1 0-2.152C6.53 9.091 9.436 7.455 12.005 7.5a8.04 8.04 0 0 1 3.29.742l2.712-2.603a.5.5 0 0 1 .707.015zM17.46 9.516a13.87 13.87 0 0 1 2.123 1.908 1.6 1.6 0 0 1 0 2.151c-2.113 2.337-4.983 3.97-7.581 3.925a7.107 7.107 0 0 1-2.151-.323.5.5 0 1 1 .297-.954c.599.186 1.222.28 1.86.277 2.273.039 4.896-1.453 6.835-3.596a.6.6 0 0 0 0-.809 12.873 12.873 0 0 0-1.971-1.77.5.5 0 1 1 .588-.81zM14.5 12a.5.5 0 0 1 .5.5 3 3 0 0 1-3 3 .5.5 0 0 1 0-1 2 2 0 0 0 2-2 .5.5 0 0 1 .5-.5zm-2.51-3.5c-2.238-.04-4.894 1.457-6.834 3.596a.601.601 0 0 0 .003.81 12.833 12.833 0 0 0 2.818 2.362l1.376-1.322a3.067 3.067 0 0 1 4.24-4.07l.92-.882A7.048 7.048 0 0 0 11.99 8.5zm-1.34 2.555a2.067 2.067 0 0 0-.527 2.152l2.699-2.591a2.067 2.067 0 0 0-2.172.439z"
  }));
};
var IcnFacebookCircle = function IcnFacebookCircle(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm2.394 4.5h-1.766c-1.603 0-1.905 1.2-1.905 1.943v.86H9.5v1.599h1.223V16.5h2.04v-4.598h1.57l.167-1.6h-1.737V9.54a.395.395 0 0 1 .104-.309.412.412 0 0 1 .303-.13h1.224V7.5z"
  }));
};
var IcnFacebookSquare = function IcnFacebookSquare(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M18.833 4C19.478 4 20 4.522 20 5.167v13.666c0 .645-.522 1.167-1.167 1.167h-4.378v-5.74h1.629a.325.325 0 0 0 .318-.297l.242-2.026a.351.351 0 0 0-.079-.266.31.31 0 0 0-.24-.113h-1.87v-.715c0-.303.113-.593.315-.807.201-.214.475-.335.76-.335h1.152c.176 0 .318-.15.318-.337V7.338C17 7.15 16.858 7 16.682 7H15.53c-2 0-3.62 1.72-3.62 3.843v.715h-1.592c-.176 0-.318.152-.318.338v2.026c0 .187.142.338.318.338h1.591V20H5.167A1.167 1.167 0 0 1 4 18.833V5.167C4 4.522 4.522 4 5.167 4z"
  }));
};
var IcnFile = function IcnFile(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M13.905 4a.528.528 0 0 1 .39.147l4.55 4.334c.114.108.16.242.154.372v9.315c0 1.012-.862 1.833-1.925 1.833H6.924c-1.062 0-1.924-.82-1.924-1.833V5.834c0-1.012.862-1.833 1.925-1.833zM13.4 5.001H6.925c-.483 0-.875.373-.875.833v12.334c0 .46.392.833.875.833h10.15c.482 0 .874-.373.874-.833l-.001-8.834h-2.624c-1.012 0-1.842-.744-1.919-1.69l-.006-.143v-2.5zm-1.568 11.667c.29 0 .525.224.525.5 0 .245-.185.45-.43.492l-.095.008H8.15a.513.513 0 0 1-.525-.5c0-.246.186-.45.43-.492l.095-.008h3.681zm4.018-2.114c.29 0 .525.224.525.5 0 .246-.186.45-.43.492l-.095.008h-7.7a.513.513 0 0 1-.524-.5c0-.245.186-.45.43-.492l.095-.008h7.7zm0-2.106c.29 0 .525.224.525.5 0 .245-.186.45-.43.492l-.095.008h-7.7a.513.513 0 0 1-.524-.5c0-.246.186-.45.43-.492l.095-.008h7.7zm0-2.114c.29 0 .525.224.525.5 0 .246-.186.45-.43.492l-.095.008h-7.7a.513.513 0 0 1-.524-.5c0-.245.186-.45.43-.492l.095-.008h7.7zm-1.4-4.625v1.792c0 .425.334.775.765.827l.11.006h1.882L14.45 5.709z"
  }));
};
var IcnFileEmpty = function IcnFileEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M13.586 4a1.5 1.5 0 0 1 1.06.44l3.915 3.914A1.5 1.5 0 0 1 19 9.414V18.5a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 18.5v-13A1.5 1.5 0 0 1 6.5 4zM13 5H6.5a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5V10h-3.5a1.5 1.5 0 0 1-1.493-1.356L13 8.5V5zm4.793 4L14 5.207V8.5a.5.5 0 0 0 .41.492L14.5 9h3.293z"
  }));
};
var IcnFileEmptyLight = function IcnFileEmptyLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M17.596 7.775l-2.403-2.376A1.383 1.383 0 0 0 14.222 5H8.375A1.372 1.372 0 0 0 7 6.362V18.14c0 .75.616 1.359 1.375 1.359h8.25c.76 0 1.375-.609 1.375-1.36V8.739c0-.36-.146-.708-.404-.963zm-.647.643c.06.06.1.13.12.21h-2.736V5.922c.08.02.152.06.212.119l2.404 2.376zm-.324 10.176h-8.25a.457.457 0 0 1-.458-.453V6.36c0-.248.206-.452.458-.452h5.042v2.945c0 .376.306.68.687.68h2.98v8.607c0 .25-.207.453-.459.453z"
  }));
};
var IcnFileLight = function IcnFileLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M13.905 4a.528.528 0 0 1 .39.147l4.55 4.334c.114.108.16.242.154.372v9.315c0 1.012-.862 1.833-1.925 1.833H6.924c-1.062 0-1.924-.82-1.924-1.833V5.834c0-1.012.862-1.833 1.925-1.833zM13.4 5.001H6.925c-.483 0-.875.373-.875.833v12.334c0 .46.392.833.875.833h10.15c.482 0 .874-.373.874-.833l-.001-8.834h-2.624c-1.012 0-1.842-.744-1.919-1.69l-.006-.143v-2.5zm-1.568 11.667c.29 0 .525.224.525.5 0 .245-.185.45-.43.492l-.095.008H8.15a.513.513 0 0 1-.525-.5c0-.246.186-.45.43-.492l.095-.008h3.681zm4.018-2.114c.29 0 .525.224.525.5 0 .246-.186.45-.43.492l-.095.008h-7.7a.513.513 0 0 1-.524-.5c0-.245.186-.45.43-.492l.095-.008h7.7zm0-2.106c.29 0 .525.224.525.5 0 .245-.186.45-.43.492l-.095.008h-7.7a.513.513 0 0 1-.524-.5c0-.246.186-.45.43-.492l.095-.008h7.7zm0-2.114c.29 0 .525.224.525.5 0 .246-.186.45-.43.492l-.095.008h-7.7a.513.513 0 0 1-.524-.5c0-.245.186-.45.43-.492l.095-.008h7.7zm-1.4-4.625v1.792c0 .425.334.775.765.827l.11.006h1.882L14.45 5.709z"
  }));
};
var IcnFood = function IcnFood(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M6.5 4.5a.5.5 0 0 1 .492.41L7 5v4a1.5 1.5 0 0 1-1 1.415V19a.5.5 0 0 1-.992.09L5 19v-8.585c-.539-.19-.937-.68-.993-1.27L4 9V5a.5.5 0 0 1 .992-.09L5 5v4a.5.5 0 0 0 .992.09L6 9V5a.5.5 0 0 1 .5-.5zm11.304.02a1 1 0 0 1 1.119.597c.508 1.228.806 2.621.954 4.243l.039.464.03.458.022.47.022.767.007.58.003.655v.749a1 1 0 0 1-.884.99L19 14.5h-1.002V19a.5.5 0 0 1-.41.492l-.09.008a.5.5 0 0 1-.491-.41l-.008-.09V5.5a1 1 0 0 1 .805-.98zm.195.98l-.001 8H19l-.003-1.381-.007-.569-.02-.75-.023-.457-.029-.444-.037-.449c-.125-1.376-.363-2.565-.748-3.608l-.134-.342zM8.19 8.666a5.282 5.282 0 0 1 7.175.515.5.5 0 1 1-.732.682 4.282 4.282 0 0 0-5.817-.418.5.5 0 1 1-.626-.78zm6.443 7.471a.5.5 0 1 1 .732.682 5.285 5.285 0 0 1-7.732 0 .5.5 0 1 1 .732-.682 4.285 4.285 0 0 0 6.268 0z"
  }));
};
var IcnFortuneoLeft = function IcnFortuneoLeft(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: "#5E6467",
    fillRule: "evenodd",
    d: "M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11zM8 12l6 3V9l-6 3z"
  }));
};
var IcnGoogleCircle = function IcnGoogleCircle(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18zM7.764 8.802a3.777 3.777 0 0 0-1.624 4.22c.451 1.617 1.907 2.732 3.562 2.728 2.27 0 3.446-1.815 3.446-3.75a3.833 3.833 0 0 0-.03-.5H9.846v1.345h1.728v.02a1.854 1.854 0 0 1-1.9 1.385 2.21 2.21 0 0 1-2.117-1.61 2.257 2.257 0 0 1 .926-2.516 2.179 2.179 0 0 1 2.638.196l1.083-1.07a3.649 3.649 0 0 0-4.44-.448zm8.39 1.323a.462.462 0 0 0-.462.462v.944h-.916a.469.469 0 1 0 0 .938l.916-.001v.945a.462.462 0 1 0 .923 0v-.945h.916a.469.469 0 1 0 0-.937h-.916v-.944a.462.462 0 0 0-.461-.462z"
  }));
};
var IcnHardKeyLeft = function IcnHardKeyLeft(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11zM8 12l6 3V9l-6 3z"
  }));
};
var IcnHardKeyOk = function IcnHardKeyOk(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: "#41BA84",
    fillRule: "evenodd",
    d: "M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11zm-.36-11.221c0-1.067-.261-1.884-.784-2.452-.523-.569-1.278-.853-2.266-.853-.987 0-1.745.282-2.274.846-.529.564-.793 1.38-.793 2.45 0 1.07.264 1.89.791 2.461s1.283.857 2.268.857c.984 0 1.74-.286 2.267-.857.527-.571.791-1.389.791-2.452zm-4.689 0c0-.718.138-1.26.413-1.624.276-.365.684-.547 1.226-.547 1.081 0 1.622.724 1.622 2.17 0 1.445-.544 2.167-1.63 2.167-.542 0-.95-.181-1.222-.545-.273-.363-.409-.903-.409-1.621zM18.14 15l-2.26-3.582 2.242-2.843H16.61l-1.74 2.184-.536.756v-2.94h-1.362V15h1.362v-2.294l.576-.413L16.593 15h1.547z"
  }));
};
var IcnHardKeyRight = function IcnHardKeyRight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 23C5.925 23 1 18.075 1 12S5.925 1 12 1s11 4.925 11 11-4.925 11-11 11zm4-11l-6-3v6l6-3z"
  }));
};
var IcnHelp = function IcnHelp(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 5a7 7 0 0 1 3.698 12.945l.068-.057a.502.502 0 0 1-.077.063A6.973 6.973 0 0 1 12 19a6.967 6.967 0 0 1-3.701-1.058A7 7 0 0 1 12 5zm.166 9.994L12 15c-.055 0-.11-.002-.165-.004l-2.422 2.42c.783.374 1.66.584 2.587.584.926 0 1.804-.21 2.587-.585l-2.421-2.421zm-2.873-1.7l-2.184 2.183c.39.546.868 1.025 1.414 1.414l2.184-2.183a3.012 3.012 0 0 1-1.414-1.414zm5.414 0a3.012 3.012 0 0 1-1.413 1.413l2.183 2.184a6.034 6.034 0 0 0 1.414-1.414zm-8.122-3.88A5.976 5.976 0 0 0 6 12c0 .926.21 1.804.585 2.587l2.42-2.421L9 12c0-.056.002-.111.005-.166zm10.83 0l-2.421 2.419L15 12c0 .056-.002.111-.005.166l2.42 2.42c.375-.782.585-1.66.585-2.586 0-.926-.21-1.804-.585-2.587zM12 10a2.017 2.017 0 0 0-.311.024A2 2 0 1 0 12 10zm3.477-2.89l-2.183 2.183a3.012 3.012 0 0 1 1.413 1.413l2.184-2.183a6.034 6.034 0 0 0-1.414-1.414zm-6.954 0A6.034 6.034 0 0 0 7.11 8.522l2.184 2.183a3.012 3.012 0 0 1 1.413-1.413zM12 6c-.927 0-1.804.21-2.588.585l2.421 2.42L12 9c.056 0 .111.002.166.005l2.422-2.42A5.976 5.976 0 0 0 12 6z"
  }));
};
var IcnHistory = function IcnHistory(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "nonzero",
    d: "M13 5a7 7 0 0 1 0 14 .5.5 0 1 1 0-1 6 6 0 1 0-5.953-6.758l1.1-1.098a.5.5 0 0 1 .637-.057l.07.057a.5.5 0 0 1 .057.638l-.057.07-2.032 2.03a.498.498 0 0 1-.276.116c-.002-.002-.004-.002-.005-.002A.178.178 0 0 1 6.5 13l-.04-.004h-.007L6.5 13a.498.498 0 0 1-.282-.087v-.002a.255.255 0 0 1-.04-.029l-2.032-2.03a.5.5 0 0 1 .638-.765l.07.057 1.178 1.18A7 7 0 0 1 13 5zm-.5 2.498a.5.5 0 0 1 .492.41l.008.09v4h3a.5.5 0 0 1 .492.41l.008.09a.5.5 0 0 1-.41.492l-.09.008h-3.5a.5.5 0 0 1-.492-.41l-.008-.09v-4.5a.5.5 0 0 1 .5-.5z"
  }));
};
var IcnHolder = function IcnHolder(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 12.5a5.997 5.997 0 0 0-3.815 1.37A6.962 6.962 0 0 0 12 19a6.967 6.967 0 0 0 3.815-1.13A5.997 5.997 0 0 0 12 16.5zM12 5a7 7 0 0 0-4.628 12.252 6.997 6.997 0 0 1 9.257-.002A7 7 0 0 0 12 5zm0 1.5a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm0 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
  }));
};
var IcnHome = function IcnHome(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M17.5 12.788a.5.5 0 0 1 .492.408l.008.09v4.969h1a.5.5 0 0 1 .09.993l-.09.008H5a.5.5 0 0 1-.09-.992l.09-.008 1-.001v-4.97a.5.5 0 1 1 .992-.09l.008.09v4.97h3v-3.479c0-.775.595-1.412 1.356-1.484l.144-.007h1c.78 0 1.42.592 1.493 1.348l.007.143v3.48h3v-4.97c0-.245.177-.448.41-.49l.09-.008zm-5 1.491h-1a.5.5 0 0 0-.492.408l-.008.09v3.478h2v-3.479a.498.498 0 0 0-.41-.489l-.09-.008zM12 4.75c.348 0 .684.12.95.338l.11.099 1.472 1.462a.5.5 0 0 1 .378-.315l.09-.008h2.5a.5.5 0 0 1 .492.408l.008.09v3.273l1.854 1.843a.495.495 0 0 1 0 .703.502.502 0 0 1-.638.057l-.07-.057-6.792-6.753a.502.502 0 0 0-.648-.051l-.06.05-6.792 6.754a.502.502 0 0 1-.708 0 .495.495 0 0 1-.057-.634l.057-.07 6.793-6.752c.281-.28.663-.437 1.061-.437zm5 2.57h-1.5v.292L17 9.103V7.32z"
  }));
};
var IcnIdcard = function IcnIdcard(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 5a2 2 0 0 1 2 2h4.5a1.5 1.5 0 0 1 1.497 1.397L20 8.5v9a1.5 1.5 0 0 1-1.397 1.497L18.5 19h-13a1.5 1.5 0 0 1-1.497-1.397L4 17.5v-9a1.5 1.5 0 0 1 1.397-1.497L5.5 7H10a2 2 0 0 1 2-2zm-2 3H5.5a.5.5 0 0 0-.495.432L5 8.5v9a.5.5 0 0 0 .432.495L5.5 18h.535a3.504 3.504 0 0 1 2.326-2.81 2.25 2.25 0 0 1 .014-3.888l.132-.071a2.25 2.25 0 0 1 2.118 3.968l.014-.01A3.504 3.504 0 0 1 12.965 18H18.5a.5.5 0 0 0 .495-.432L19 17.5v-9a.5.5 0 0 0-.432-.495L18.5 8H14v1a1 1 0 0 1-.883.993L13 10h-2a1 1 0 0 1-1-1V8zm-.5 8a2.5 2.5 0 0 0-2.446 1.98L7.05 18h4.9l-.034-.144a2.501 2.501 0 0 0-2.283-1.853zm8-2a.5.5 0 0 1 .068.995L17.5 15h-4a.5.5 0 0 1-.068-.995L13.5 14h4zm-7.375-1.833a1.25 1.25 0 1 0-1.25 2.166 1.25 1.25 0 0 0 1.25-2.166zM16.5 12a.5.5 0 0 1 .068.995L16.5 13h-3a.5.5 0 0 1-.068-.995L13.5 12h3zM12 6a1 1 0 0 0-1 1v2h2V7a1 1 0 0 0-1-1z"
  }));
};
var IcnIdea = function IcnIdea(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M13.067 18.933a.533.533 0 0 1 .096 1.058l-.096.009h-2.134a.533.533 0 0 1-.096-1.058l.096-.009h2.134zm-.652-11.73A4.8 4.8 0 0 1 16.8 12a4.79 4.79 0 0 1-2.966 4.42l-.206.08-.028.008v.824c0 .23-.144.425-.347.5l-.09.025-.096.009h-2.134a.533.533 0 0 1-.526-.447l-.007-.087v-.824l-.03-.01a4.801 4.801 0 0 1-3.156-4.879l.022-.222.033-.224a4.8 4.8 0 0 1 5.146-3.971zm4.414 8.35l.074.062.754.755a.533.533 0 0 1-.68.816l-.074-.062-.755-.755a.533.533 0 0 1 .68-.816zm-8.977.062a.533.533 0 0 1 .061.68l-.061.074-.755.755a.533.533 0 0 1-.816-.68l.062-.074.754-.755a.533.533 0 0 1 .755 0zm.468-4.26a3.733 3.733 0 0 0 2.747 4.245.533.533 0 0 1 .392.426l.008.09v.683h1.066v-.683c0-.183.093-.348.24-.445l.076-.042.085-.03a3.733 3.733 0 1 0-4.614-4.245zM7.023 5.747l.074.062.755.754a.533.533 0 0 1-.68.816l-.075-.062-.754-.754a.533.533 0 0 1 .68-.816zm10.634.062a.533.533 0 0 1 .062.68l-.062.074-.754.754a.533.533 0 0 1-.816-.68l.061-.074.755-.754a.533.533 0 0 1 .754 0zM12 4c.262 0 .48.189.525.437l.008.096V5.6a.533.533 0 0 1-1.058.096l-.008-.096V4.533c0-.294.238-.533.533-.533zm7.467 6.4a.533.533 0 0 1 .096 1.058l-.096.009H18.4a.533.533 0 0 1-.096-1.058l.096-.009h1.067zM5.6 11.467a.533.533 0 0 1 .096 1.058l-.096.008H4.533a.533.533 0 0 1-.096-1.058l.096-.008H5.6z"
  }));
};
var IcnInfo = function IcnInfo(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm-.5 5.5a1 1 0 0 1 .993.883l.007.117V14a.5.5 0 0 0 .41.492l.09.008h.5a.5.5 0 0 1 .09.992l-.09.008H13a1.5 1.5 0 0 1-1.493-1.356L11.5 14v-2.5H11a.5.5 0 0 1-.09-.992L11 10.5h.5zm.25-2.5l.102.007a.75.75 0 1 1-.204 0L11.75 8z"
  }));
};
var IcnInputfieldErase = function IcnInputfieldErase(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm-1.837 4.467l.07.058L12 11.293l1.768-1.768a.5.5 0 0 1 .765.638l-.058.07L12.707 12l1.768 1.767a.5.5 0 0 1-.638.765l-.07-.058L12 12.707l-1.768 1.767a.5.5 0 0 1-.765-.638l.058-.069L11.293 12l-1.768-1.768a.5.5 0 0 1 .638-.765z"
  }));
};
var IcnInsurances = function IcnInsurances(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4l.447.004c1.953.04 3.882.464 5.683 1.25.533.244.874.779.87 1.363v5.076a8.438 8.438 0 0 1-5.409 7.875l-.693.267a2.5 2.5 0 0 1-1.795 0l-.694-.267A8.438 8.438 0 0 1 5 11.693V6.62a1.494 1.494 0 0 1 .879-1.37A14.972 14.972 0 0 1 12 4zm.005 1.001a13.97 13.97 0 0 0-5.718 1.162.493.493 0 0 0-.287.454v5.076a7.438 7.438 0 0 0 4.767 6.941l.695.267a1.5 1.5 0 0 0 1.077 0l.694-.266A7.438 7.438 0 0 0 18 11.693v-5.08a.489.489 0 0 0-.279-.446A13.967 13.967 0 0 0 12.005 5zm2.795 4.1a.5.5 0 0 1 .148.623L14.9 9.8l-2.623 3.5a1.177 1.177 0 0 1-1.68.212l-.094-.085-1.356-1.356a.5.5 0 0 1 .637-.765l.07.058 1.356 1.356a.177.177 0 0 0 .23.016l.037-.035L14.1 9.2a.5.5 0 0 1 .7-.1z"
  }));
};
var IcnKeytrade = function IcnKeytrade(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zM10.54 9.732c.102-.18.03-.373-.173-.405l-4.601-.874c-.204-.043-.438.085-.53.288l-.213.533c-.071.202.03.426.224.49l4.031 1.43a.477.477 0 0 0 .55-.214l.712-1.248zm2.566-1.002c.203 0 .346-.17.305-.384l-.315-1.962C13.055 6.17 12.86 6 12.658 6h-.306a.463.463 0 0 0-.437.384l-.346 1.962c-.041.213.101.384.305.384h1.232zm.112 1.237c-.112-.181-.367-.341-.57-.341h-.306a.719.719 0 0 0-.57.341L7.14 17.933a.502.502 0 0 0 .082.597l.468.384a.334.334 0 0 0 .509-.075l4.072-5.94c.122-.17.316-.17.438 0l4.072 5.94a.35.35 0 0 0 .509.075l.468-.384a.502.502 0 0 0 .081-.597l-4.621-7.966zm1.964 1.002a.492.492 0 0 0 .55.214l4.021-1.419c.194-.064.295-.288.224-.49l-.214-.533a.53.53 0 0 0-.529-.288l-4.591.874c-.204.043-.285.224-.173.405l.712 1.237z",
    fill: props.color,
    fillRule: "evenodd"
  }));
};
var IcnLinkedinCircle = function IcnLinkedinCircle(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm-2.819 7.522H7.022v6.228h2.16v-6.228zm5.433-.004c-.697.01-1.369.262-1.901.715v-.71h-2.27v6.227h2.27v-3.241c0-.529.426-.957.95-.957a.925.925 0 0 1 .675.277.96.96 0 0 1 .276.68v3.241H17v-3.188c0-1.993-.977-3.044-2.386-3.044zM8.111 7.25C7.497 7.25 7 7.75 7 8.368c0 .617.497 1.117 1.11 1.117.614 0 1.111-.5 1.111-1.117a1.128 1.128 0 0 0-1.11-1.118z"
  }));
};
var IcnList = function IcnList(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M6 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm0 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm0 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm0 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM19.5 5.5a.5.5 0 0 1 .09.992l-.09.008h-10a.5.5 0 0 1-.09-.992L9.5 5.5h10zm0 6a.5.5 0 0 1 .09.992l-.09.008h-10a.5.5 0 0 1-.09-.992l.09-.008h10zm0 6a.5.5 0 0 1 .09.992l-.09.008h-10a.5.5 0 0 1-.09-.992l.09-.008h10z"
  }));
};
var IcnListsimple = function IcnListsimple(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M18.5 15.5a.5.5 0 0 1 .09.992l-.09.008h-13a.5.5 0 0 1-.09-.992l.09-.008h13zm0-4a.5.5 0 0 1 .09.992l-.09.008h-13a.5.5 0 0 1-.09-.992l.09-.008h13zm0-4a.5.5 0 0 1 .09.992l-.09.008h-13a.5.5 0 0 1-.09-.992L5.5 7.5h13z"
  }));
};
var IcnLocker = function IcnLocker(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a4 4 0 0 1 3.995 3.8L16 8v2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2V8a4 4 0 0 1 4-4zm4 7H8a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm-4 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm0-9a3 3 0 0 0-2.995 2.824L9 8v2h6V8a3 3 0 0 0-3-3z"
  }));
};
var IcnLockerLight = function IcnLockerLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a4 4 0 0 1 3.995 3.8L16 8v2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2V8a4 4 0 0 1 4-4zm4 7H8a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm-4 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm0-9a3 3 0 0 0-2.995 2.824L9 8v2h6V8a3 3 0 0 0-3-3z"
  }));
};
var IcnLongArrowDown = function IcnLongArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 5.3a.7.7 0 0 1 .694.605L12.7 6l-.001 10.311 4.806-4.806a.7.7 0 0 1 1.064.903l-.074.087-6 6a.7.7 0 0 1-.903.074l-.087-.074-6-6a.7.7 0 0 1 .903-1.064l.087.074 4.805 4.807V6a.7.7 0 0 1 .7-.7z"
  }));
};
var IcnLongArrowDownLight = function IcnLongArrowDownLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 5.3a.7.7 0 0 1 .694.605L12.7 6l-.001 10.311 4.806-4.806a.7.7 0 0 1 1.064.903l-.074.087-6 6a.7.7 0 0 1-.903.074l-.087-.074-6-6a.7.7 0 0 1 .903-1.064l.087.074 4.805 4.807V6a.7.7 0 0 1 .7-.7z"
  }));
};
var IcnLongArrowLeft = function IcnLongArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M18.7 12a.7.7 0 0 1-.605.694L18 12.7H7.689l4.806 4.805a.7.7 0 0 1-.903 1.064l-.087-.074-6-6a.7.7 0 0 1-.074-.903l.074-.087 6-6a.7.7 0 0 1 1.064.903l-.074.087L7.689 11.3H18a.7.7 0 0 1 .7.7z"
  }));
};
var IcnLongArrowRight = function IcnLongArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M5.3 12a.7.7 0 0 1 .605-.694L6 11.3h10.311l-4.806-4.805a.7.7 0 0 1 .903-1.064l.087.074 6 6a.7.7 0 0 1 .074.903l-.074.087-6 6a.7.7 0 0 1-1.064-.903l.074-.087 4.806-4.805H6a.7.7 0 0 1-.7-.7z"
  }));
};
var IcnMarkets = function IcnMarkets(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: props.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.043",
    d: "M7.733 14.783c.293.003.53.235.534.521h0v4.348h-3.2v-4.348a.535.535 0 0 1 .533-.521h0zm5.334-4.174c.293.003.53.235.533.521h0v8.522h-3.2V11.13a.535.535 0 0 1 .533-.521h0zm5.333 2.434c.293.004.53.236.533.522h0v6.087h-3.2v-6.087a.535.535 0 0 1 .534-.522h0zM4 19.653h16M20 4l-3.591 3.513c-.41.398-1.01.547-1.565.39l-4.088-1.058a1.617 1.617 0 0 0-1.544.404l-4.145 4.055M20 7.13V4h-3.2"
  }));
};
var IcnMinus = function IcnMinus(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M19.5 11.5a.5.5 0 0 1 .09.992l-.09.008h-15a.5.5 0 0 1-.09-.992l.09-.008h15z"
  }));
};
var IcnMinusCircle = function IcnMinusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm3 6.5a.5.5 0 0 1 .09.992L15 12.5H9a.5.5 0 0 1-.09-.992L9 11.5h6z"
  }));
};
var IcnMinusLight = function IcnMinusLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M19.5 11.5a.5.5 0 0 1 .09.992l-.09.008h-15a.5.5 0 0 1-.09-.992l.09-.008h15z"
  }));
};
var IcnMoon = function IcnMoon(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4l.377.01a7.952 7.952 0 0 1 2.92.71A.676.676 0 0 1 15 6a6 6 0 1 0 .017 12c.31.01.572.23.637.532a.681.681 0 0 1-.374.756A7.926 7.926 0 0 1 12 20a8 8 0 1 1 0-16zm0 1a7 7 0 1 0 1.304 13.876l.187-.041-.128-.028a7.003 7.003 0 0 1-5.359-6.566L8 12a7.005 7.005 0 0 1 5.352-6.807l.131-.03-.178-.038a6.925 6.925 0 0 0-.976-.117zm1.5 8a.5.5 0 0 1 .492.41l.008.09v.5h.5a.5.5 0 0 1 .09.992L14.5 15H14v.5a.5.5 0 0 1-.992.09L13 15.5V15h-.5a.5.5 0 0 1-.09-.992L12.5 14h.5v-.5a.5.5 0 0 1 .5-.5zm2-5a.5.5 0 0 1 .492.41L16 8.5V9h.5a.5.5 0 0 1 .09.992L16.5 10H16v.5a.5.5 0 0 1-.992.09L15 10.5V10h-.5a.5.5 0 0 1-.09-.992L14.5 9h.5v-.5a.5.5 0 0 1 .5-.5zm3 4a.5.5 0 0 1 .492.41l.008.09v.5h.5a.5.5 0 0 1 .09.992L19.5 14H19v.5a.5.5 0 0 1-.992.09L18 14.5V14h-.5a.5.5 0 0 1-.09-.992L17.5 13h.5v-.5a.5.5 0 0 1 .5-.5z"
  }));
};
var IcnMortgage = function IcnMortgage(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M4.523 7.75c.257 0 .47.177.515.41l.008.09v.529l1.852-.294a3.838 3.838 0 0 1 1.309.02l.256.057 4.143 1.08c.385.1.71.348.899.684.091.164.147.341.165.522l4.6-.335a1.634 1.634 0 0 1 1.457.675c.323.459.362 1.049.103 1.544-.159.303-.417.546-.734.694l-.14.057-7.277 2.608a2.724 2.724 0 0 1-1.53.09l-.215-.06-4.888-1.557v.686c0 .276-.234.5-.523.5a.517.517 0 0 1-.515-.41L4 15.25v-7c0-.276.234-.5.523-.5zm2.77 1.695l-.223.026-2.024.322v3.717l5.22 1.663c.291.093.604.102.9.026l.145-.045 7.278-2.607a.556.556 0 0 0 .306-.262.516.516 0 0 0-.037-.54.566.566 0 0 0-.408-.233l-.1-.001-5.014.364a1.477 1.477 0 0 1-.97.49l-.143.006H8.185a.512.512 0 0 1-.523-.5c0-.245.185-.45.43-.492l.093-.008h4.038a.407.407 0 0 0 .387-.265.375.375 0 0 0-.028-.308.4.4 0 0 0-.174-.163l-.078-.029-4.142-1.08a2.741 2.741 0 0 0-.894-.08z"
  }));
};
var IcnNoImage = function IcnNoImage(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "nonzero",
    d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm4.087 11.933a.487.487 0 0 1-.42.234H8.333a.487.487 0 0 1-.42-.234.493.493 0 0 1 0-.48 4.56 4.56 0 0 1 8.24 0 .493.493 0 0 1-.066.48zM12 6.9a2.467 2.467 0 1 1 0 4.933A2.467 2.467 0 0 1 12 6.9z"
  }));
};
var IcnNoPincode = function IcnNoPincode(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "nonzero",
    d: "M12 16a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM4.784 4.089l.07.057 15 15a.5.5 0 0 1-.638.765l-.07-.057-6.13-6.13a2.001 2.001 0 0 1-2.74-2.74l-3.26-3.26a2 2 0 0 1-2.74-2.74l-.13-.13a.5.5 0 0 1 .638-.765zM12 17a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-6-7a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm12 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM6 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm12 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-6.707 1.707a1 1 0 0 0 .965.26l-1.224-1.225a1 1 0 0 0 .259.965zM12 4a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm6 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM5.034 5.742a1 1 0 0 0 1.224 1.224L5.034 5.742zM12 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm6 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  }));
};
var IcnOnlinePayment = function IcnOnlinePayment(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm2.243 12.002H9.757c.269 1.18.655 2.188 1.124 2.91a7.06 7.06 0 0 0 2.239-.001l-.114.165c.52-.728.947-1.8 1.237-3.074zm-5.51 0H6.256a7.02 7.02 0 0 0 3.298 2.559c-.34-.733-.617-1.601-.821-2.56zm9.011 0h-2.477c-.204.958-.482 1.826-.821 2.56a7.027 7.027 0 0 0 3.298-2.56zM8.34 12.5H5.018c.062.89.292 1.734.656 2.5h2.877a19.723 19.723 0 0 1-.212-2.5zm6.322 0H9.34c.02.871.098 1.714.224 2.501h4.874c.126-.787.204-1.63.224-2.5zm4.321 0h-3.32c-.02.864-.093 1.705-.213 2.5h2.877c.364-.766.594-1.61.656-2.5zM8.56 9H5.674a6.958 6.958 0 0 0-.656 2.5H8.34c.022-.863.097-1.704.219-2.5zm5.87 0H9.57a18.916 18.916 0 0 0-.23 2.5h5.319a18.916 18.916 0 0 0-.231-2.5zm3.897 0h-2.885c.122.796.197 1.637.219 2.5h3.322a6.958 6.958 0 0 0-.656-2.5zm-8.76-3.565l-.08.03A7.022 7.022 0 0 0 6.255 8H8.74c.207-.965.486-1.837.826-2.565zM12 5c-.373 0-.74.03-1.097.085l.087-.123c-.51.699-.934 1.765-1.225 3.038h4.47c-.275-1.2-.667-2.216-1.139-2.915A7.074 7.074 0 0 0 12 5zm2.433.434l.013.03c.334.722.61 1.584.813 2.536h2.486a7.02 7.02 0 0 0-3.312-2.566z"
  }));
};
var IcnOptions = function IcnOptions(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M6.25 9.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5zm0 1a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5zm10.375-.699a2.25 2.25 0 1 0 2.25 3.898 2.25 2.25 0 0 0-2.25-3.898zm1.75.866a1.25 1.25 0 1 1-1.25 2.166 1.25 1.25 0 0 1 1.25-2.166zM12 9.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5zm0 1a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5z"
  }));
};
var IcnPaperclip = function IcnPaperclip(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M11.469 5.095a3.443 3.443 0 0 1 3.404-.978 3.545 3.545 0 0 1 2.5 2.562A3.651 3.651 0 0 1 16.577 10l-.154.162-6.016 6.171a1.965 1.965 0 0 1-2.804-.024 2.09 2.09 0 0 1-.132-2.75l.114-.13 6.01-6.165c.196-.2.512-.2.708 0a.522.522 0 0 1 .057.654l-.057.071-6.005 6.158a1.044 1.044 0 0 0 .012 1.437.982.982 0 0 0 1.303.1l.093-.082 6.016-6.17c.65-.644.91-1.597.682-2.493a2.532 2.532 0 0 0-1.785-1.83c-.816-.22-1.68-.001-2.307.576l-.13.129-6.011 6.16c-1.563 1.602-1.563 4.199 0 5.8a3.93 3.93 0 0 0 5.497.155l.16-.155 7.317-7.503c.196-.2.512-.2.708 0a.522.522 0 0 1 .057.654l-.057.071-7.318 7.503a4.914 4.914 0 0 1-7.072 0c-1.893-1.941-1.95-5.052-.172-7.064l.172-.185 6.005-6.155z"
  }));
};
var IcnPaperclipLight = function IcnPaperclipLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M11.469 5.095a3.443 3.443 0 0 1 3.404-.978 3.545 3.545 0 0 1 2.5 2.562A3.651 3.651 0 0 1 16.577 10l-.154.162-6.016 6.171a1.965 1.965 0 0 1-2.804-.024 2.09 2.09 0 0 1-.132-2.75l.114-.13 6.01-6.165c.196-.2.512-.2.708 0a.522.522 0 0 1 .057.654l-.057.071-6.005 6.158a1.044 1.044 0 0 0 .012 1.437.982.982 0 0 0 1.303.1l.093-.082 6.016-6.17c.65-.644.91-1.597.682-2.493a2.532 2.532 0 0 0-1.785-1.83c-.816-.22-1.68-.001-2.307.576l-.13.129-6.011 6.16c-1.563 1.602-1.563 4.199 0 5.8a3.93 3.93 0 0 0 5.497.155l.16-.155 7.317-7.503c.196-.2.512-.2.708 0a.522.522 0 0 1 .057.654l-.057.071-7.318 7.503a4.914 4.914 0 0 1-7.072 0c-1.893-1.941-1.95-5.052-.172-7.064l.172-.185 6.005-6.155z"
  }));
};
var IcnParent = function IcnParent(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 1a7 7 0 0 0-6.123 10.396 4.388 4.388 0 0 1 2.837-1.713 2.883 2.883 0 1 1 1.372.001 4.399 4.399 0 0 1 3.65 5.098 6.992 6.992 0 0 0 3.71-2.383l.114.161a2.69 2.69 0 0 0-3.184-1.052.5.5 0 1 1-.346-.938c.12-.044.243-.082.366-.114a2.45 2.45 0 1 1 1.825.001 3.677 3.677 0 0 1 1.815 1.09A7 7 0 0 0 12 5zm3.309 5.733a1.45 1.45 0 1 0 0 2.9 1.45 1.45 0 0 0 0-2.9z"
  }));
};
var IcnPayments = function IcnPayments(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M13.147 4.5l-.001 1h-4.91c-.964 0-1.855.507-2.348 1.332l-.09.164a2.74 2.74 0 0 0 .92 3.516l1.36.905a.5.5 0 0 0 .777-.416v-1l.008-.09a.5.5 0 0 1 .492-.41h3.791v1a.5.5 0 0 0 .808.394l3.854-3a.5.5 0 0 0 0-.789l-3.854-3a.5.5 0 0 0-.807.395zm.999 1.023l2.54 1.977-2.54 1.978V9a.5.5 0 0 0-.5-.5H9.356l-.145.007A1.5 1.5 0 0 0 7.855 10l-.001.065-.58-.386a1.735 1.735 0 0 1-.59-2.22l.071-.131a1.73 1.73 0 0 1 1.48-.828h5.412a.5.5 0 0 0 .5-.5l-.001-.478zm1 8.478l-.007.09a.5.5 0 0 1-.492.41H11v-1a.5.5 0 0 0-.792-.405l-4.146 3a.5.5 0 0 0 0 .81l4.146 3 .072.044a.5.5 0 0 0 .72-.45v-1h4.767c.964.001 1.856-.505 2.349-1.33l.09-.164a2.739 2.739 0 0 0-.92-3.515l-1.362-.906a.5.5 0 0 0-.777.416v1zm1 0v-.067l.585.39c.728.484.98 1.436.59 2.218l-.073.131a1.728 1.728 0 0 1-1.48.828H10.5l-.09.008a.5.5 0 0 0-.41.492l-.001.52-2.793-2.02L10 14.48V15a.5.5 0 0 0 .5.5h4.147a1.5 1.5 0 0 0 1.5-1.5z"
  }));
};
var IcnPen = function IcnPen(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M17.062 4l.212.006c.704.047 1.37.346 1.874.848a2.925 2.925 0 0 1-.024 4.152l-9.667 9.667a.5.5 0 0 1-.229.13l-4.603 1.182a.5.5 0 0 1-.609-.609l1.18-4.603a.5.5 0 0 1 .13-.23l9.664-9.662A2.926 2.926 0 0 1 17.062 4zM5.946 15.868l-.752 2.937 2.939-.754-2.187-2.183zm9.124-9.655l-8.683 8.682 2.719 2.713 8.68-8.679-2.716-2.716zM17.069 5l-.17.009a1.932 1.932 0 0 0-1.198.575l.079-.075 2.712 2.713c.247-.268.411-.598.477-.953l.023-.167.009-.17a1.924 1.924 0 0 0-.56-1.37A1.927 1.927 0 0 0 17.069 5z"
  }));
};
var IcnPenLight = function IcnPenLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M17.062 4l.212.006c.704.047 1.37.346 1.874.848a2.925 2.925 0 0 1-.024 4.152l-9.667 9.667a.5.5 0 0 1-.229.13l-4.603 1.182a.5.5 0 0 1-.609-.609l1.18-4.603a.5.5 0 0 1 .13-.23l9.664-9.662A2.926 2.926 0 0 1 17.062 4zM5.946 15.868l-.752 2.937 2.939-.754-2.187-2.183zm9.124-9.655l-8.683 8.682 2.719 2.713 8.68-8.679-2.716-2.716zM17.069 5l-.17.009a1.932 1.932 0 0 0-1.198.575l.079-.075 2.712 2.713c.247-.268.411-.598.477-.953l.023-.167.009-.17a1.924 1.924 0 0 0-.56-1.37A1.927 1.927 0 0 0 17.069 5z"
  }));
};
var IcnPhone = function IcnPhone(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M5.445 7.242a1.5 1.5 0 0 1 2.12 0l1.769 1.767a1.5 1.5 0 0 1 .021 2.1l-.063.07a.5.5 0 0 0 .042.659l2.828 2.828c.195.196.512.196.73-.022l.125-.108a1.5 1.5 0 0 1 1.973.13l1.77 1.768a1.5 1.5 0 0 1 0 2.122l-.42.419a3.503 3.503 0 0 1-4.367.47 27.598 27.598 0 0 1-7.422-7.422 3.503 3.503 0 0 1 .474-4.362zm1.414.707a.5.5 0 0 0-.707 0l-.42.42a2.5 2.5 0 0 0-.345 3.106 26.57 26.57 0 0 0 7.134 7.135 2.5 2.5 0 0 0 3.112-.342l.42-.42a.5.5 0 0 0 0-.707l-1.77-1.768a.5.5 0 0 0-.353-.146.495.495 0 0 0-.279.082l-.075.065a1.5 1.5 0 0 1-2.121 0l-2.828-2.83a1.507 1.507 0 0 1-.105-2.003l.156-.177a.5.5 0 0 0-.051-.648zM11.499 9a3.5 3.5 0 0 1 3.5 3.5.5.5 0 1 1-1 0 2.5 2.5 0 0 0-2.5-2.5.5.5 0 0 1 0-1zm0-2.5a6 6 0 0 1 6 6 .5.5 0 1 1-1 0 5 5 0 0 0-5-5 .5.5 0 0 1 0-1zm0-2.5a8.5 8.5 0 0 1 8.5 8.5.5.5 0 1 1-1 0A7.5 7.5 0 0 0 11.5 5a.5.5 0 0 1 0-1z"
  }));
};
var IcnPincode = function IcnPincode(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M5 4.268a2 2 0 1 0 .158-.082L5 4.268zm1.5.866a1 1 0 1 1-1 1.732 1 1 0 0 1 1-1.732zM12 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm0 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm5-.732a2 2 0 1 0 .158-.082L17 4.268zm1.5.866a1 1 0 1 1-1 1.732 1 1 0 0 1 1-1.732zM5 10.268a2 2 0 1 0 2 3.464 2 2 0 0 0-2-3.464zm1.5.866a1 1 0 1 1-1 1.732 1 1 0 0 1 1-1.732zM12 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm0 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm5-.732a2 2 0 1 0 .158-.082l-.158.082zm1.5.866a1 1 0 1 1-1 1.732 1 1 0 0 1 1-1.732zM12 16a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm0 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
  }));
};
var IcnPlay = function IcnPlay(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm-1.565 3.144a1.595 1.595 0 0 1 1.701.247l3.121 2.734a1.167 1.167 0 0 1-.001 1.751l-3.118 2.725A1.587 1.587 0 0 1 9.5 14.407V9.583c.005-.62.37-1.182.935-1.439zm1.045 1.002a.593.593 0 0 0-.98.44v4.823a.587.587 0 0 0 .978.441l3.118-2.725a.167.167 0 0 0 .001-.249z"
  }));
};
var IcnPlayLight = function IcnPlayLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm-1.565 3.144a1.595 1.595 0 0 1 1.701.247l3.121 2.734a1.167 1.167 0 0 1-.001 1.751l-3.118 2.725A1.587 1.587 0 0 1 9.5 14.407V9.583c.005-.62.37-1.182.935-1.439zm1.045 1.002a.593.593 0 0 0-.98.44v4.823a.587.587 0 0 0 .978.441l3.118-2.725a.167.167 0 0 0 .001-.249z"
  }));
};
var IcnPlus = function IcnPlus(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a.5.5 0 0 1 .492.41l.008.09v7h7a.5.5 0 0 1 .09.992l-.09.008h-7v7a.5.5 0 0 1-.992.09l-.008-.09v-7h-7a.5.5 0 0 1-.09-.992l.09-.008h7v-7A.5.5 0 0 1 12 4z"
  }));
};
var IcnPlusCircle = function IcnPlusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm0 3.5a.5.5 0 0 1 .492.41L12.5 9v2.5H15a.5.5 0 0 1 .09.992L15 12.5h-2.5V15a.5.5 0 0 1-.992.09L11.5 15v-2.5H9a.5.5 0 0 1-.09-.992L9 11.5h2.5V9a.5.5 0 0 1 .5-.5z"
  }));
};
var IcnPlusLight = function IcnPlusLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a.5.5 0 0 1 .492.41l.008.09v7h7a.5.5 0 0 1 .09.992l-.09.008h-7v7a.5.5 0 0 1-.992.09l-.008-.09v-7h-7a.5.5 0 0 1-.09-.992l.09-.008h7v-7A.5.5 0 0 1 12 4z"
  }));
};
var IcnPost = function IcnPost(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M15 4a2 2 0 0 1 .15 3.995L15 8h-3v1h5.5a2.5 2.5 0 0 1 2.495 2.336L20 11.5V16a1 1 0 0 1-.883.993L19 17h-6v2.5a.5.5 0 0 1-.992.09L12 19.5V17H5a1 1 0 0 1-1-1v-4.5A2.5 2.5 0 0 1 6.5 9H11V4.5a.5.5 0 0 1 .5-.5H15zm2.5 6H12v1.5a.5.5 0 0 1-.992.09L11 11.5V10H8.499l.019.024c.034.047.067.095.098.144l-.098-.144a2.504 2.504 0 0 1 .474 1.271l.001.018c.005.062.007.124.007.187V16h10v-4.5a1.5 1.5 0 0 0-1.5-1.5zm-11 0A1.5 1.5 0 0 0 5 11.5V16h3v-4.5a1.5 1.5 0 0 0-1.356-1.493zM15 5h-3v2h3a1 1 0 0 0 0-2z"
  }));
};
var IcnPourcentage = function IcnPourcentage(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M16.5 14a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zm2.218-8.718a.5.5 0 0 1 0 .708L5.99 18.718a.5.5 0 1 1-.708-.708L18.01 5.282a.5.5 0 0 1 .708 0zM16.5 15a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-9-10a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zm0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z"
  }));
};
var IcnPrintLight = function IcnPrintLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M15.5 4a1.5 1.5 0 0 1 1.493 1.356L17 5.5V8h1.5a1.5 1.5 0 0 1 1.493 1.356L20 9.5v5a1.5 1.5 0 0 1-1.356 1.493L18.5 16H17v3.5a.5.5 0 0 1-.41.492L16.5 20h-9a.5.5 0 0 1-.492-.41L7 19.5V16H5.5a1.5 1.5 0 0 1-1.493-1.356L4 14.5v-5a1.5 1.5 0 0 1 1.356-1.493L5.5 8H7V5.5a1.5 1.5 0 0 1 1.356-1.493L8.5 4h7zm.5 9H8v6h8v-6zm-3 3a.5.5 0 0 1 .09.992L13 17H9.5a.5.5 0 0 1-.09-.992L9.5 16H13zm5.5-7h-13a.5.5 0 0 0-.492.41L5 9.5v5a.5.5 0 0 0 .41.492L5.5 15H7v-2.5a.5.5 0 0 1 .41-.492L7.5 12h9a.5.5 0 0 1 .492.41l.008.09V15h1.5a.5.5 0 0 0 .492-.41L19 14.5v-5a.5.5 0 0 0-.41-.492L18.5 9zm-4 5a.5.5 0 0 1 .09.992L14.5 15h-5a.5.5 0 0 1-.09-.992L9.5 14h5zm-7-4a.5.5 0 0 1 .09.992L7.5 11h-1a.5.5 0 0 1-.09-.992L6.5 10h1zm8-5h-7a.5.5 0 0 0-.492.41L8 5.5V8h8V5.5a.5.5 0 0 0-.326-.469l-.084-.023L15.5 5z"
  }));
};
var IcnProducts = function IcnProducts(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M19.95 15.283a.5.5 0 0 1-.156.621l-.077.047-7.02 3.379c-.392.202-.848.224-1.245.071l-.146-.065-7.013-3.386a.5.5 0 0 1 .35-.932l.084.032 7.026 3.391a.526.526 0 0 0 .397.035l.1-.041 7.034-3.386a.5.5 0 0 1 .667.234zm0-3a.5.5 0 0 1-.156.621l-.077.047-7.02 3.379c-.392.202-.848.224-1.245.071l-.146-.065-7.013-3.386a.5.5 0 0 1 .35-.932l.084.032 7.026 3.391a.526.526 0 0 0 .397.035l.1-.041 7.034-3.386a.5.5 0 0 1 .667.234zm-7.404-7.68l.15.068 6.802 3.52a.91.91 0 0 1 .096 1.56l-.096.058-6.802 3.52c-.39.203-.847.225-1.253.068l-.149-.068-6.8-3.52a.91.91 0 0 1-.097-1.56l.097-.058 6.8-3.52c.39-.203.847-.225 1.252-.068zm-.7.918l-.094.038-6.647 3.44 6.648 3.442a.528.528 0 0 0 .292.057l.098-.02.094-.037L18.884 9l-6.647-3.441a.528.528 0 0 0-.39-.038z"
  }));
};
var IcnQuestionCircleLight = function IcnQuestionCircleLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm0 10l.102.007a.75.75 0 1 1-.204 0L12 15zm2.436-5.561a2.5 2.5 0 0 1-1.603 2.918.5.5 0 0 0-.325.383l-.008.09v.67a.5.5 0 0 1-.992.09l-.008-.09v-.67a1.5 1.5 0 0 1 .865-1.36l.135-.055a1.5 1.5 0 1 0-2-1.415.5.5 0 0 1-1 0 2.5 2.5 0 0 1 4.936-.561z"
  }));
};
var IcnReceiving = function IcnReceiving(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M5.5 10.839c.78 0 1.42.612 1.493 1.394l.007.149v1.212c.237-.077.492-.09.739-.034.341.077.641.28.836.553l.833 1.314a3.64 3.64 0 0 1 .585 1.765l.007.236v2.058a.507.507 0 0 1-.5.514.504.504 0 0 1-.492-.422L9 19.486v-2.059c0-.435-.107-.862-.314-1.245l-.112-.187-.773-1.223a.423.423 0 0 0-.622-.133.464.464 0 0 0-.18.256l.001.133-.008.08.023.067.9 1.543a.523.523 0 0 1-.171.706.49.49 0 0 1-.633-.102l-.053-.075-.918-1.576a1.51 1.51 0 0 1-.14-.857v-2.432a.507.507 0 0 0-.5-.515.504.504 0 0 0-.492.422L5 12.382v3.543c.002.52.157 1.025.438 1.444l.111.154 1.334 1.632a.524.524 0 0 1-.061.724.49.49 0 0 1-.64.003l-.065-.065-1.34-1.64a3.659 3.659 0 0 1-.768-2.005L4 15.927v-3.545c0-.853.672-1.543 1.5-1.543zm13 0c.78 0 1.42.612 1.493 1.394l.007.149v3.547a3.672 3.672 0 0 1-.639 2.058l-.145.198-1.333 1.632a.49.49 0 0 1-.705.062.525.525 0 0 1-.112-.648l.051-.076 1.327-1.625c.318-.404.508-.896.548-1.41l.008-.193v-3.545a.507.507 0 0 0-.5-.515.504.504 0 0 0-.492.422l-.008.093.001 2.483c.02.23-.01.468-.098.699l-.06.14-.9 1.543a.492.492 0 0 1-.687.177.522.522 0 0 1-.21-.622l.039-.084.881-1.509a.452.452 0 0 0 .04-.126L17 15.028v-.12a.46.46 0 0 0-.187-.274.417.417 0 0 0-.58.09l-.047.07-.765 1.207a2.592 2.592 0 0 0-.415 1.237l-.006.19v2.058a.507.507 0 0 1-.5.514.504.504 0 0 1-.492-.422L14 19.486V17.43a3.65 3.65 0 0 1 .467-1.797l.12-.2.747-1.177c.2-.356.537-.608.927-.696.248-.056.503-.043.738.033L17 12.382c0-.853.672-1.543 1.5-1.543zm-5.572-6.505l.114.103 2.502 2.501c.549.55.571 1.43.076 2.035l-.106.117-2.573 2.573c-.565.565-1.447.612-2.038.133l-.114-.103-2.502-2.501c-.549-.55-.571-1.43-.075-2.035l.106-.117 2.573-2.573c.565-.565 1.447-.612 2.037-.133zm-1.26.78l-.07.06-2.573 2.573a.51.51 0 0 0-.068.648l.058.07 2.501 2.501c.174.174.447.19.646.05l.071-.06 2.573-2.573a.51.51 0 0 0 .068-.648l-.057-.07-2.502-2.5a.504.504 0 0 0-.646-.05z"
  }));
};
var IcnRedo = function IcnRedo(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M14.505 10.001a.5.5 0 0 1-.09-.992l.09-.008h3.82a7 7 0 1 0-6.32 10 .5.5 0 0 1 0 1 8 8 0 1 1 7-11.866V4.501a.5.5 0 0 1 .41-.492l.09-.008a.5.5 0 0 1 .492.41l.008.09v5a.5.5 0 0 1-.41.492l-.09.008h-5z"
  }));
};
var IcnRedoLight = function IcnRedoLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M14.505 10.001a.5.5 0 0 1-.09-.992l.09-.008h3.82a7 7 0 1 0-6.32 10 .5.5 0 0 1 0 1 8 8 0 1 1 7-11.866V4.501a.5.5 0 0 1 .41-.492l.09-.008a.5.5 0 0 1 .492.41l.008.09v5a.5.5 0 0 1-.41.492l-.09.008h-5z"
  }));
};
var IcnReorderLight = function IcnReorderLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M19.5 13a.5.5 0 0 1 .09.992L19.5 14h-7v4.293l1.646-1.647a.5.5 0 0 1 .638-.057l.07.057a.5.5 0 0 1 .057.638l-.057.07-2.5 2.5-.013.011a.503.503 0 0 1-.039.033l.052-.044A.502.502 0 0 1 12 20h-.02a.503.503 0 0 1-.052-.005L12 20a.502.502 0 0 1-.284-.089l-.018-.013a.503.503 0 0 1-.04-.033l-.012-.011-2.5-2.5a.5.5 0 0 1 .638-.765l.07.057 1.646 1.647V14h-7a.5.5 0 0 1-.09-.992L4.5 13h15zM12 4h.012c.02 0 .041.002.062.005L12 4a.502.502 0 0 1 .284.089l.018.013c.014.01.027.02.04.033l.012.011 2.5 2.5a.5.5 0 0 1-.638.765l-.07-.057L12.5 5.707V10h7a.5.5 0 0 1 .09.992L19.5 11h-15a.5.5 0 0 1-.09-.992L4.5 10h7V5.705L9.854 7.354a.5.5 0 0 1-.638.057l-.07-.057a.5.5 0 0 1-.057-.638l.057-.07 2.5-2.5.013-.011a.503.503 0 0 1 .039-.033l-.052.044A.502.502 0 0 1 12 4z"
  }));
};
var IcnReplacementCards = function IcnReplacementCards(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M18 6a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2zm1 4H5v6a1 1 0 0 0 .883.993L6 17h12a1 1 0 0 0 1-1v-6zm-8 4a.5.5 0 0 1 .09.992L11 15H7.5a.5.5 0 0 1-.09-.992L7.5 14H11zm2-2a.5.5 0 0 1 .09.992L13 13H7.5a.5.5 0 0 1-.09-.992L7.5 12H13zm5-5H6a1 1 0 0 0-1 1v1h14V8a1 1 0 0 0-.883-.993L18 7z"
  }));
};
var IcnSavings = function IcnSavings(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M15.262 8.106a5.87 5.87 0 0 1 2.702 4.32A1.5 1.5 0 0 0 19 11a.5.5 0 1 1 1 0 2.5 2.5 0 0 1-2.024 2.455 5.785 5.785 0 0 1-1.772 3.686l-.204.183V19a1 1 0 0 1-.883.993L15 20h-1a1 1 0 0 1-.993-.883L13 19v-.166l-.257.054a6.842 6.842 0 0 1-2.488-.004L10 18.829V19a1 1 0 0 1-.883.993L9 20H8a1 1 0 0 1-.993-.883L7 19v-1.69l-.062-.052c-.32-.29-.61-.614-.862-.965L5.877 16 4.5 16a.5.5 0 0 1-.492-.41L4 15.5v-4a.5.5 0 0 1 .41-.492L4.5 11l.881-.001.07-.173A6.045 6.045 0 0 1 7.498 8.27l.23-.157a.5.5 0 1 1 .544.839 5.045 5.045 0 0 0-2.062 2.7.5.5 0 0 1-.385.339L5.733 12 5 11.999v3L6.16 15a.5.5 0 0 1 .384.18l.05.072c.315.552.73 1.04 1.222 1.442a.5.5 0 0 1 .176.298l.008.09V19h1v-.827a.5.5 0 0 1 .659-.475c1.195.4 2.487.403 3.684.007a.5.5 0 0 1 .65.392l.007.083V19h1v-1.909a.5.5 0 0 1 .189-.391A4.789 4.789 0 0 0 17 13.007a4.869 4.869 0 0 0-2.271-4.055.5.5 0 0 1 .533-.846zM11.5 4a2.5 2.5 0 0 1 1.702 4.331c.176.063.35.137.52.22a.5.5 0 0 1-.444.897 4.009 4.009 0 0 0-3.556 0 .5.5 0 1 1-.444-.896c.17-.084.344-.158.52-.222A2.5 2.5 0 0 1 11.5 4zm0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z"
  }));
};
var IcnSearch = function IcnSearch(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M5.316 6.607a6.542 6.542 0 1 1 10.193 8.195l4.345 4.345a.5.5 0 0 1-.638.765l-.07-.058-4.344-4.345a6.542 6.542 0 0 1-9.486-8.902zm5.9-1.566a5.542 5.542 0 1 0 3.245 9.42l.013-.012a5.544 5.544 0 0 0-3.259-9.408z"
  }));
};
var IcnSearchLight = function IcnSearchLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M5.316 6.607a6.542 6.542 0 1 1 10.193 8.195l4.345 4.345a.5.5 0 0 1-.638.765l-.07-.058-4.344-4.345a6.542 6.542 0 0 1-9.486-8.902zm5.9-1.566a5.542 5.542 0 1 0 3.245 9.42l.013-.012a5.544 5.544 0 0 0-3.259-9.408z"
  }));
};
var IcnSelect1AccountOff = function IcnSelect1AccountOff(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm0 1a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 7.5a7 7 0 0 1 7 7 .5.5 0 1 1-1 0 6 6 0 1 0-12 0 .5.5 0 1 1-1 0 7 7 0 0 1 7-7z"
  }));
};
var IcnSelect1AccountOn = function IcnSelect1AccountOn(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm0 8.5a7 7 0 0 0-7 7 .5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5 7 7 0 0 0-7-7z"
  }));
};
var IcnSelect2AccountOff = function IcnSelect2AccountOff(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M9 12.5a5 5 0 0 1 5 5 .5.5 0 1 1-1 0 4 4 0 1 0-8 0 .5.5 0 1 1-1 0 5 5 0 0 1 5-5zM15.818 8a2.75 2.75 0 0 1 .768 5.391A4.184 4.184 0 0 1 20 17.5a.5.5 0 0 1-1 .001 3.184 3.184 0 0 0-4.285-2.986.5.5 0 0 1-.346-.938c.222-.082.448-.144.677-.187A2.75 2.75 0 0 1 15.818 8zM9 6a3.25 3.25 0 1 1 0 6.5A3.25 3.25 0 0 1 9 6zm6.818 3a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5zM9 7a2.25 2.25 0 1 0 0 4.5A2.25 2.25 0 0 0 9 7z"
  }));
};
var IcnSelect2AccountOn = function IcnSelect2AccountOn(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M9 12.5a5 5 0 0 1 5 5 .5.5 0 0 1-.41.492L13.5 18h-9a.5.5 0 0 1-.5-.5 5 5 0 0 1 5-5zM15.818 8a2.75 2.75 0 0 1 .768 5.391A4.184 4.184 0 0 1 20 17.5a.5.5 0 0 1-.5.501h-3.908a.5.5 0 0 1-.5-.5c0-1.228-.319-2.277-.956-3.163a.5.5 0 0 1 .233-.76c.222-.083.448-.145.677-.188A2.75 2.75 0 0 1 15.818 8zM9 6a3.25 3.25 0 1 1 0 6.5A3.25 3.25 0 0 1 9 6z"
  }));
};
var IcnSelectMinirOff = function IcnSelectMinirOff(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "nonzero",
    d: "M9.25 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm0 1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm0 4a3.5 3.5 0 0 0-3.5 3.5v2l.008.09a.5.5 0 0 0 .492.41h.547l.455 4.55a.5.5 0 0 0 .498.45h3l.084-.007a.5.5 0 0 0 .414-.443l.454-4.55h.548a.5.5 0 0 0 .5-.5v-2A3.5 3.5 0 0 0 9.25 9zm.164 1.005A2.5 2.5 0 0 1 11.75 12.5l-.001 1.5h-.499l-.084.007a.5.5 0 0 0-.414.443L10.297 19H8.202l-.454-4.55-.016-.083A.5.5 0 0 0 7.25 14h-.501l.001-1.5a2.5 2.5 0 0 1 2.5-2.5l.164.005zm7.584 3.558a3.001 3.001 0 0 1 1.246 2.245l.006.192v.5a.5.5 0 0 1-.41.492l-.09.008h-.577l-.43 2.582a.5.5 0 0 1-.403.41l-.09.008h-2a.5.5 0 0 1-.47-.33l-.023-.088-.25-1.504a.5.5 0 0 1 .963-.252l.023.088.18 1.085h1.153l.43-2.581a.5.5 0 0 1 .404-.41l.09-.008h.5a2.001 2.001 0 0 0-2.641-1.895.5.5 0 0 1-.32-.947 3.001 3.001 0 0 1 2.71.405zM15.25 9a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
  }));
};
var IcnSelectMinirOn = function IcnSelectMinirOn(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "nonzero",
    d: "M9.25 4a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm0 5a3.5 3.5 0 0 0-3.5 3.5v2l.008.09a.5.5 0 0 0 .492.41h.547l.455 4.55a.5.5 0 0 0 .498.45h3l.084-.007a.5.5 0 0 0 .414-.443l.454-4.55h.548a.5.5 0 0 0 .5-.5v-2A3.5 3.5 0 0 0 9.25 9zm7.748 4.563a3.001 3.001 0 0 1 1.246 2.245l.006.192v.5a.5.5 0 0 1-.41.492l-.09.008h-.577l-.43 2.582a.5.5 0 0 1-.403.41l-.09.008h-2a.5.5 0 0 1-.47-.33l-.023-.088-.25-1.504v-4.27c0-.334.52-.562.782-.65a3.001 3.001 0 0 1 2.71.405zM15.25 9a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
  }));
};
var IcnSell = function IcnSell(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M15.429 11.5c.315 0 .571.224.571.5 0 .245-.202.45-.469.492l-.102.008H8.57C8.256 12.5 8 12.276 8 12c0-.245.202-.45.469-.492l.102-.008h6.858z"
  }));
};
var IcnSendDoc = function IcnSendDoc(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M17.465 4.245a1.697 1.697 0 0 1 1.813.036c.544.36.816 1 .693 1.627L17.5 18.69a1.631 1.631 0 0 1-1.252 1.27 1.683 1.683 0 0 1-1.702-.602l-1.03-1.336-1.775 1.176a1.698 1.698 0 0 1-1.557.161l-.15-.068a1.603 1.603 0 0 1-.883-1.422V14.92H5.657c-.64 0-1.214-.357-1.488-.901l-.058-.129-.047-.135a1.588 1.588 0 0 1 .715-1.808zm1.502 1.303l-6.941 8.874 3.344 4.336a.635.635 0 0 0 .54.242l.104-.014a.617.617 0 0 0 .474-.48L18.96 5.721a.59.59 0 0 0 .008-.174zm-7.843 9.373h-.943v2.948c0 .193.094.373.25.487l.084.051a.642.642 0 0 0 .646-.035l1.736-1.151-1.773-2.3zm.002-1l6.915-8.844-.03.016-12.686 7.703a.601.601 0 0 0-.271.684.625.625 0 0 0 .603.442l5.469-.001z"
  }));
};
var IcnSettings = function IcnSettings(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M13.229 4.596a1.807 1.807 0 0 1 3.145 1.303l-.047.934a.806.806 0 0 0 .843.845l.934-.048a1.807 1.807 0 0 1 1.3 3.146l-.695.627a.807.807 0 0 0 0 1.198l.695.627a1.807 1.807 0 0 1-1.303 3.145l-.934-.047a.806.806 0 0 0-.846.847l.048.936a1.807 1.807 0 0 1-3.14 1.299l-.628-.695a.806.806 0 0 0-1.198.001l-.63.695a1.807 1.807 0 0 1-3.141-1.302l.048-.933a.806.806 0 0 0-.847-.847l-.933.048a1.806 1.806 0 0 1-1.305-3.144l.694-.627a.807.807 0 0 0-.001-1.198l-.694-.63a1.807 1.807 0 0 1 1.3-3.143l.936.048a.806.806 0 0 0 .846-.851l-.044-.935a1.807 1.807 0 0 1 3.142-1.3l.627.694a.805.805 0 0 0 1.199-.003zm1.65.466a.807.807 0 0 0-.91.206l-.628.69a1.805 1.805 0 0 1-2.682.001l-.626-.691a.806.806 0 0 0-1.402.58l.044.931a1.806 1.806 0 0 1-1.897 1.9l-.932-.046a.806.806 0 0 0-.58 1.401l.693.63a1.808 1.808 0 0 1 0 2.683l-.694.626a.806.806 0 0 0 .584 1.403l.933-.048a1.806 1.806 0 0 1 1.897 1.897l-.048.931a.806.806 0 0 0 1.401.58l.63-.693a1.807 1.807 0 0 1 2.682 0l.625.691a.806.806 0 0 0 1.4-.577l-.047-.933a1.806 1.806 0 0 1 1.896-1.897l.934.047a.806.806 0 0 0 .582-1.403l-.695-.628a1.808 1.808 0 0 1 0-2.683l.695-.626a.807.807 0 0 0-.58-1.404l-.935.047a1.806 1.806 0 0 1-1.891-1.895l.047-.934a.806.806 0 0 0-.497-.786zM11.998 8.5a3.502 3.502 0 1 1 0 7.004 3.502 3.502 0 0 1 0-7.004zm0 1a2.501 2.501 0 1 0 0 5.003 2.501 2.501 0 0 0 0-5.002z"
  }));
};
var IcnSettingsLight = function IcnSettingsLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M13.229 4.596a1.807 1.807 0 0 1 3.145 1.303l-.047.934a.806.806 0 0 0 .843.845l.934-.048a1.807 1.807 0 0 1 1.3 3.146l-.695.627a.807.807 0 0 0 0 1.198l.695.627a1.807 1.807 0 0 1-1.303 3.145l-.934-.047a.806.806 0 0 0-.846.847l.048.936a1.807 1.807 0 0 1-3.14 1.299l-.628-.695a.806.806 0 0 0-1.198.001l-.63.695a1.807 1.807 0 0 1-3.141-1.302l.048-.933a.806.806 0 0 0-.847-.847l-.933.048a1.806 1.806 0 0 1-1.305-3.144l.694-.627a.807.807 0 0 0-.001-1.198l-.694-.63a1.807 1.807 0 0 1 1.3-3.143l.936.048a.806.806 0 0 0 .846-.851l-.044-.935a1.807 1.807 0 0 1 3.142-1.3l.627.694a.805.805 0 0 0 1.199-.003zm1.65.466a.807.807 0 0 0-.91.206l-.628.69a1.805 1.805 0 0 1-2.682.001l-.626-.691a.806.806 0 0 0-1.402.58l.044.931a1.806 1.806 0 0 1-1.897 1.9l-.932-.046a.806.806 0 0 0-.58 1.401l.693.63a1.808 1.808 0 0 1 0 2.683l-.694.626a.806.806 0 0 0 .584 1.403l.933-.048a1.806 1.806 0 0 1 1.897 1.897l-.048.931a.806.806 0 0 0 1.401.58l.63-.693a1.807 1.807 0 0 1 2.682 0l.625.691a.806.806 0 0 0 1.4-.577l-.047-.933a1.806 1.806 0 0 1 1.896-1.897l.934.047a.806.806 0 0 0 .582-1.403l-.695-.628a1.808 1.808 0 0 1 0-2.683l.695-.626a.807.807 0 0 0-.58-1.404l-.935.047a1.806 1.806 0 0 1-1.891-1.895l.047-.934a.806.806 0 0 0-.497-.786zM11.998 8.5a3.502 3.502 0 1 1 0 7.004 3.502 3.502 0 0 1 0-7.004zm0 1a2.501 2.501 0 1 0 0 5.003 2.501 2.501 0 0 0 0-5.002z"
  }));
};
var IcnShoppingBag = function IcnShoppingBag(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M15.307 4.335a2.496 2.496 0 0 1 1.266 1.987l.007.178-.001 1h.634c.718 0 1.332.491 1.488 1.168l.025.138 1.261 9.5c.057.428-.077.86-.367 1.184a1.536 1.536 0 0 1-.983.501l-.164.009H9.965l-.011-.001L5.526 20c-.384 0-.752-.142-1.032-.395l-.115-.115A1.485 1.485 0 0 1 4 18.466l.013-.16 1.26-9.5c.093-.7.669-1.236 1.372-1.3l.142-.006h2.159l.001-.997a2.489 2.489 0 0 1 1.132-2.084.514.514 0 0 1 .706.139c.156.23.093.54-.141.693-.383.251-.627.656-.672 1.101l-.007.15-.001.998h1.527v-1c0-.893.485-1.718 1.272-2.165a2.583 2.583 0 0 1 2.544 0zM16.58 11c0 .276-.228.5-.51.5a.507.507 0 0 1-.5-.41l-.008-.09-.001-2.5h-2.034a.504.504 0 0 1-.51-.5c0-.245.18-.45.418-.492l.092-.008h2.034v-1c0-.536-.29-1.031-.762-1.299a1.55 1.55 0 0 0-1.527 0c-.43.244-.709.675-.756 1.154l-.007.145V11c0 .276-.228.5-.509.5a.507.507 0 0 1-.5-.41L11.49 11V8.5H8.984c.023.065.042.132.056.201l.018.105L10.411 19h8.062a.513.513 0 0 0 .383-.17.495.495 0 0 0 .126-.31l-.004-.085-1.261-9.5a.504.504 0 0 0-.421-.428l-.083-.007h-.634V11zM7.534 8.499l-.747.001a.508.508 0 0 0-.487.355l-.017.08-1.261 9.5a.494.494 0 0 0 .122.395.511.511 0 0 0 .296.163l.086.007 3.859-.001L8.049 8.935a.502.502 0 0 0-.342-.409l-.079-.02-.072-.006h-.011l-.011-.001z"
  }));
};
var IcnSignCircle = function IcnSignCircle(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm1.063 3.108a2 2 0 0 1 2.829 2.828l-5.041 5.04a.5.5 0 0 1-.283.142l-2.475.354a.5.5 0 0 1-.565-.565l.353-2.476a.5.5 0 0 1 .141-.283zm2.121.707a1 1 0 0 0-1.414 0l-4.924 4.923-.235 1.65 1.649-.236 4.924-4.923a1 1 0 0 0 .084-1.32z"
  }));
};
var IcnSignout = function IcnSignout(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M13.615 4.5A1.456 1.456 0 0 1 15 5.865V9a.5.5 0 0 1-.991.09L14 9V5.977a.461.461 0 0 0-.336-.466L13.59 5.5H5.433a.458.458 0 0 0-.43.41L5 6v12.023a.461.461 0 0 0 .334.466l.074.011h8.157a.458.458 0 0 0 .431-.411L14 18v-3a.5.5 0 0 1 .992-.09L15 15v2.977a1.46 1.46 0 0 1-1.266 1.51l-.144.013H5.383A1.456 1.456 0 0 1 4 18.135V5.883a1.46 1.46 0 0 1 1.265-1.37l.143-.013h8.207zm3.669 4.591l.07.058 2.5 2.5.012.014a.503.503 0 0 1 .032.038l-.045-.052a.502.502 0 0 1 .147.354v.022a.503.503 0 0 1-.005.044l.005-.066a.502.502 0 0 1-.089.284l-.013.018a.503.503 0 0 1-.03.036l-.015.015-2.5 2.5a.5.5 0 0 1-.765-.638l.058-.069 1.647-1.647H9a.5.5 0 0 1-.09-.991l.09-.008 9.291-.001-1.645-1.646a.5.5 0 0 1-.058-.638l.058-.069a.5.5 0 0 1 .638-.058z"
  }));
};
var IcnSignoutLight = function IcnSignoutLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M13.615 4.5A1.456 1.456 0 0 1 15 5.865V9a.5.5 0 0 1-.991.09L14 9V5.977a.461.461 0 0 0-.336-.466L13.59 5.5H5.433a.458.458 0 0 0-.43.41L5 6v12.023a.461.461 0 0 0 .334.466l.074.011h8.157a.458.458 0 0 0 .431-.411L14 18v-3a.5.5 0 0 1 .992-.09L15 15v2.977a1.46 1.46 0 0 1-1.266 1.51l-.144.013H5.383A1.456 1.456 0 0 1 4 18.135V5.883a1.46 1.46 0 0 1 1.265-1.37l.143-.013h8.207zm3.669 4.591l.07.058 2.5 2.5.012.014a.503.503 0 0 1 .032.038l-.045-.052a.502.502 0 0 1 .147.354v.022a.503.503 0 0 1-.005.044l.005-.066a.502.502 0 0 1-.089.284l-.013.018a.503.503 0 0 1-.03.036l-.015.015-2.5 2.5a.5.5 0 0 1-.765-.638l.058-.069 1.647-1.647H9a.5.5 0 0 1-.09-.991l.09-.008 9.291-.001-1.645-1.646a.5.5 0 0 1-.058-.638l.058-.069a.5.5 0 0 1 .638-.058z"
  }));
};
var IcnSkype = function IcnSkype(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M8.604 4c.7.001 1.39.165 2.012.474l.185.099.234-.035a7.481 7.481 0 0 1 5.347 1.355l.24.18.223.183A7.495 7.495 0 0 1 19.486 12c0 .296-.017.592-.051.881l-.034.242.096.175a4.61 4.61 0 0 1 .119 3.939l-.11.233-.117.217A4.602 4.602 0 0 1 15.41 20c-.699 0-1.388-.16-2.012-.468l-.185-.099-.234.037a7.481 7.481 0 0 1-5.362-1.349l-.24-.181-.224-.182A7.495 7.495 0 0 1 4.507 12c0-.263.014-.526.041-.788l.044-.345-.089-.166a4.61 4.61 0 0 1-.116-3.944l.11-.234.118-.216A4.602 4.602 0 0 1 8.38 4.005L8.604 4zm-.181 6.099c0 1.26.751 1.941 2.44 2.421l.35.094.716.176c.142.035.274.069.396.102l.337.096.282.094c.64.233.807.464.807.865 0 .643-.624 1.14-1.644 1.14-.665 0-1.082-.192-1.544-.687l-.213-.244-.135-.16c-.332-.385-.566-.548-.91-.55a.832.832 0 0 0-.802.868c-.013 1.34 1.686 2.293 3.73 2.293 2.118 0 3.544-1.16 3.544-2.954 0-1.226-.764-1.929-2.409-2.413l-.346-.096-1.143-.283-.346-.093c-.839-.243-1.031-.432-1.031-.801 0-.599.51-.98 1.371-.98.673 0 1.103.177 1.608.64l.283.263c.296.268.518.375.85.379a.867.867 0 0 0 .684-.269.887.887 0 0 0 .248-.715c-.162-1.016-1.504-1.774-3.234-1.933l-.232-.018c-2.137-.136-3.63.975-3.657 2.765z"
  }));
};
var IcnSport = function IcnSport(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a7.998 7.998 0 0 1 7.973 8.658 8.005 8.005 0 0 1-6.116 7.125l-.008.002a8.022 8.022 0 0 1-3.697 0l-.009-.002A8.004 8.004 0 0 1 4 12a8 8 0 0 1 8-8zM9.438 16.47l1.172 2.392a7.033 7.033 0 0 0 2.78 0l1.171-2.392-.715-.801h-3.693l-.715.801zm7.869.095l-1.815.277-.791 1.618a7.018 7.018 0 0 0 2.606-1.895zm-10.615-.001A7.018 7.018 0 0 0 9.3 18.46l-.792-1.618zm10.399-5.628l-1.338.656-1.12 3.458.717.802 2.754-.422a6.954 6.954 0 0 0 .852-2.637l-1.865-1.857zm-10.183 0l-1.864 1.857c.107.95.404 1.841.852 2.637l2.753.422.717-.802-1.12-3.458-1.338-.656zM12 9.423l-2.756 2.004 1.049 3.242h3.413l1.049-3.242L12 9.423zm5.993-1.04l-.27 1.771 1.251 1.245a7 7 0 0 0-.98-3.016zM6.007 8.381a6.957 6.957 0 0 0-.982 3.018l1.251-1.245zm8.909-2.745L12.5 7.265V8.55l2.893 2.104 1.343-.658.416-2.735-.202-.21a6.998 6.998 0 0 0-2.034-1.415zm-5.834 0a7.02 7.02 0 0 0-2.235 1.626l.416 2.734 1.343.658L11.5 8.549V7.266zM12 5c-.602 0-1.187.076-1.745.22L12 6.396l1.744-1.176A6.998 6.998 0 0 0 12 5z"
  }));
};
var IcnStar = function IcnStar(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M11.87 4.008c-.341.042-.643.25-.802.561L8.962 8.743l-4.019.399a1.034 1.034 0 0 0-.88.677l-.038.129c-.077.345.027.71.282.962l3.327 3.296-1.231 4.477c-.107.4.03.822.349 1.08l.11.08c.305.187.69.207 1.015.043l4.121-2.042 4.132 2.046a1.04 1.04 0 0 0 1.122-.124l.1-.092c.246-.26.344-.631.25-.984l-1.234-4.482 3.326-3.295c.288-.285.383-.71.245-1.09l-.054-.123a1.037 1.037 0 0 0-.835-.556l-4.013-.399-2.106-4.173A1.047 1.047 0 0 0 12 4l-.13.008zm.129.992c.017 0 .033.01.04.025l2.23 4.417a.5.5 0 0 0 .397.272l4.294.425c.022.002.034.012.039.025a.037.037 0 0 1-.009.039l-3.533 3.502a.5.5 0 0 0-.13.488l1.31 4.758c.003.012-.003.029-.015.04a.042.042 0 0 1-.046.004l-4.355-2.157a.5.5 0 0 0-.444 0L7.43 18.991c-.017.009-.035.007-.048-.003a.042.042 0 0 1-.014-.044l1.309-4.754a.5.5 0 0 0-.13-.488L5.01 10.2a.037.037 0 0 1 .023-.063l4.3-.426a.5.5 0 0 0 .398-.272l2.227-4.417A.045.045 0 0 1 12 5z"
  }));
};
var IcnStarLight = function IcnStarLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M11.87 4.008c-.341.042-.643.25-.802.561L8.962 8.743l-4.019.399a1.034 1.034 0 0 0-.88.677l-.038.129c-.077.345.027.71.282.962l3.327 3.296-1.231 4.477c-.107.4.03.822.349 1.08l.11.08c.305.187.69.207 1.015.043l4.121-2.042 4.132 2.046a1.04 1.04 0 0 0 1.122-.124l.1-.092c.246-.26.344-.631.25-.984l-1.234-4.482 3.326-3.295c.288-.285.383-.71.245-1.09l-.054-.123a1.037 1.037 0 0 0-.835-.556l-4.013-.399-2.106-4.173A1.047 1.047 0 0 0 12 4l-.13.008zm.129.992c.017 0 .033.01.04.025l2.23 4.417a.5.5 0 0 0 .397.272l4.294.425c.022.002.034.012.039.025a.037.037 0 0 1-.009.039l-3.533 3.502a.5.5 0 0 0-.13.488l1.31 4.758c.003.012-.003.029-.015.04a.042.042 0 0 1-.046.004l-4.355-2.157a.5.5 0 0 0-.444 0L7.43 18.991c-.017.009-.035.007-.048-.003a.042.042 0 0 1-.014-.044l1.309-4.754a.5.5 0 0 0-.13-.488L5.01 10.2a.037.037 0 0 1 .023-.063l4.3-.426a.5.5 0 0 0 .398-.272l2.227-4.417A.045.045 0 0 1 12 5z"
  }));
};
var IcnStop = function IcnStop(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm2.5 4a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5zm-.5 1h-4v4h4v-4z"
  }));
};
var IcnStopLight = function IcnStopLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm2.5 4a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5zm-.5 1h-4v4h4v-4z"
  }));
};
var IcnThreeDots = function IcnThreeDots(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M6 14.143a2.143 2.143 0 1 1 0-4.286 2.143 2.143 0 0 1 0 4.286zm6 0a2.143 2.143 0 1 1 0-4.286 2.143 2.143 0 0 1 0 4.286zm6 0a2.143 2.143 0 1 1 0-4.286 2.143 2.143 0 0 1 0 4.286z"
  })));
};
var IcnTransfer = function IcnTransfer(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M17.784 11.589l.07.057 2.011 2.013.017.019.009.01-.027-.03.03.035.029.04a.52.52 0 0 1 .077.247V14l-.004.053.001-.007a.392.392 0 0 1-.02.105l-.015.04a.494.494 0 0 1-.05.093l-.014.018a.503.503 0 0 1-.033.04l-2.011 2.012a.5.5 0 0 1-.765-.638l.057-.07 1.146-1.146H11a.5.5 0 0 1-.09-.992L11 13.5h7.294l-1.148-1.146a.5.5 0 0 1-.057-.638l.057-.07a.5.5 0 0 1 .638-.057zM4.005 9.926l.006-.031a.513.513 0 0 1 .012-.046l.015-.04a.494.494 0 0 1 .05-.093l.014-.018a.503.503 0 0 1 .033-.04l2.011-2.012a.5.5 0 0 1 .765.638l-.057.07L5.706 9.5H13a.5.5 0 0 1 .09.992L13 10.5H5.706l1.148 1.146a.5.5 0 0 1 .057.638l-.057.07a.5.5 0 0 1-.638.057l-.07-.057-2.011-2.013-.017-.019-.009-.01.026.029-.03-.035-.028-.04a.52.52 0 0 1-.066-.161l-.006-.03A.51.51 0 0 1 4 10.011V10l.005-.074z"
  }));
};
var IcnTransferLight = function IcnTransferLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M17.784 11.589l.07.057 2.011 2.013.017.019.009.01-.027-.03.03.035.029.04a.52.52 0 0 1 .077.247V14l-.004.053.001-.007a.392.392 0 0 1-.02.105l-.015.04a.494.494 0 0 1-.05.093l-.014.018a.503.503 0 0 1-.033.04l-2.011 2.012a.5.5 0 0 1-.765-.638l.057-.07 1.146-1.146H11a.5.5 0 0 1-.09-.992L11 13.5h7.294l-1.148-1.146a.5.5 0 0 1-.057-.638l.057-.07a.5.5 0 0 1 .638-.057zM4.005 9.926l.006-.031a.513.513 0 0 1 .012-.046l.015-.04a.494.494 0 0 1 .05-.093l.014-.018a.503.503 0 0 1 .033-.04l2.011-2.012a.5.5 0 0 1 .765.638l-.057.07L5.706 9.5H13a.5.5 0 0 1 .09.992L13 10.5H5.706l1.148 1.146a.5.5 0 0 1 .057.638l-.057.07a.5.5 0 0 1-.638.057l-.07-.057-2.011-2.013-.017-.019-.009-.01.026.029-.03-.035-.028-.04a.52.52 0 0 1-.066-.161l-.006-.03A.51.51 0 0 1 4 10.011V10l.005-.074z"
  }));
};
var IcnTrash = function IcnTrash(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M13.532 4c.799 0 1.455.612 1.526 1.392l.006.14-.001 1.191h4.426a.51.51 0 0 1 .092 1.013l-.092.009-1.403-.001-.906 10.843a1.525 1.525 0 0 1-1.384 1.407l-.14.006h-7.31a1.525 1.525 0 0 1-1.509-1.27l-.017-.138-.907-10.848H4.511a.51.51 0 0 1-.092-1.012l.092-.009h4.425V5.532c0-.8.612-1.455 1.393-1.526l.14-.006h3.063zm3.53 3.744H6.937l.902 10.768a.504.504 0 0 0 .336.438l.082.022.087.007h7.314c.235 0 .434-.16.49-.385l.014-.087.9-10.763zm-6.594 2.554c.25 0 .46.18.502.419l.009.092v5.106a.51.51 0 0 1-1.013.092l-.009-.092v-5.106a.51.51 0 0 1 .511-.511zm3.064 0c.25 0 .46.18.502.419l.009.092v5.106a.51.51 0 0 1-1.013.092l-.009-.092v-5.106a.51.51 0 0 1 .51-.511zm0-5.277h-3.064a.51.51 0 0 0-.502.42l-.009.09v1.192h4.085V5.532a.51.51 0 0 0-.332-.479l-.086-.023-.092-.009z"
  }));
};
var IcnTrashLight = function IcnTrashLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M13.532 4c.799 0 1.455.612 1.526 1.392l.006.14-.001 1.191h4.426a.51.51 0 0 1 .092 1.013l-.092.009-1.403-.001-.906 10.843a1.525 1.525 0 0 1-1.384 1.407l-.14.006h-7.31a1.525 1.525 0 0 1-1.509-1.27l-.017-.138-.907-10.848H4.511a.51.51 0 0 1-.092-1.012l.092-.009h4.425V5.532c0-.8.612-1.455 1.393-1.526l.14-.006h3.063zm3.53 3.744H6.937l.902 10.768a.504.504 0 0 0 .336.438l.082.022.087.007h7.314c.235 0 .434-.16.49-.385l.014-.087.9-10.763zm-6.594 2.554c.25 0 .46.18.502.419l.009.092v5.106a.51.51 0 0 1-1.013.092l-.009-.092v-5.106a.51.51 0 0 1 .511-.511zm3.064 0c.25 0 .46.18.502.419l.009.092v5.106a.51.51 0 0 1-1.013.092l-.009-.092v-5.106a.51.51 0 0 1 .51-.511zm0-5.277h-3.064a.51.51 0 0 0-.502.42l-.009.09v1.192h4.085V5.532a.51.51 0 0 0-.332-.479l-.086-.023-.092-.009z"
  }));
};
var IcnTravel = function IcnTravel(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M11.884 6c.34-.002.664.139.895.385l.094.112 1.84 2.502h3.08c.433.014.85.151 1.206.393l.148.11.14.122c.452.428.71 1.023.713 1.653a2.243 2.243 0 0 1-.7 1.613c-.442.42-1.037.64-1.621.61H14.59l-3.286 4.053c-.231.28-.574.443-.942.447H8.98a1.227 1.227 0 0 1-1.125-1.773l1.323-2.707H7.262a1.947 1.947 0 0 1-1.719-1.045l-.065-.139-1.38-3.12A1.236 1.236 0 0 1 5.216 7.5l1.547.054a.499.499 0 0 1 .427.273L7.783 9l2.202-.001-.6-1.216a1.236 1.236 0 0 1 .971-1.777l.14-.006h1.388zm2.518 4.002L7.477 10a.499.499 0 0 1-.445-.274l-.599-1.183L5.228 8.5c-.078 0-.15.04-.192.106a.231.231 0 0 0-.023.211l1.38 3.121a.95.95 0 0 0 .87.582h2.714a.5.5 0 0 1 .448.72l-1.678 3.432a.227.227 0 0 0 .01.223.232.232 0 0 0 .21.105h1.39c.07 0 .136-.032.178-.082l3.431-4.233a.498.498 0 0 1 .388-.185h3.493a1.236 1.236 0 0 0 1.155-1.224 1.288 1.288 0 0 0-.4-.926 1.299 1.299 0 0 0-.97-.35l-3.096.002a.5.5 0 0 1-.134 0zM11.886 7H10.49a.233.233 0 0 0-.23.281l.02.057L11.096 9h2.377l-1.403-1.907a.225.225 0 0 0-.13-.086L11.885 7z"
  }));
};
var IcnTwitter = function IcnTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M20 8.155L18.497 7.5l.787-1.745-1.833.618a3.173 3.173 0 0 0-2.147-.873c-1.778.004-3.218 1.467-3.222 3.273V9.5c-2.534.531-4.746-.872-6.8-3.273-.359 1.94 0 3.395 1.073 4.365L4 10.228c.188 1.59 1.47 2.815 3.043 2.91l-1.97.727c.717 1.454 2.02 1.68 3.76 1.818A8.154 8.154 0 0 1 4 17.138c9.135 4.124 14.497-1.935 14.497-7.274V9.26L20 8.155z"
  }));
};
var IcnXCircle = function IcnXCircle(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 28 28",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M14,0 C6.26919557,0 0,6.26919557 0,14 C0,21.7308044 6.26919557,28 14,28 C21.7308044,28 28,21.7308044 28,14 C28,6.26919557 21.7308044,0 14,0 Z M20.3613523,7.15719084 C20.4746732,7.26297826 20.5414193,7.40960289 20.5468902,7.56477195 C20.5523611,7.71994101 20.4961083,7.87092764 20.3905208,7.98447837 L15.6442269,13.0892052 L20.8828846,20.0632273 C21.0157472,20.2404315 21.037321,20.4777314 20.9386041,20.6761122 C20.8398872,20.8744929 20.6378417,21 20.4167724,21 L17.2210746,21 C17.037865,21 16.8652545,20.9137837 16.7549624,20.7670653 L13.0680675,15.8600918 L8.46294909,20.8138708 C8.32080813,20.9667726 8.10812928,21.0320075 7.90502661,20.9850021 C7.70192393,20.9379967 7.53925356,20.7858923 7.47829185,20.5859851 C7.41733014,20.3860779 7.46733862,20.1687386 7.60947959,20.0158368 L12.3557734,14.91111 L7.11711578,7.93708778 C6.98431602,7.75996785 6.96269455,7.52280045 7.0612657,7.3244644 C7.15983685,7.12612836 7.36168039,7.00066902 7.5826446,7.00039235 L10.7789258,7.00039235 C10.9619301,7.00048342 11.134286,7.08669581 11.2444546,7.2332498 L14.9313495,12.1402233 L19.5358845,7.18644429 C19.6413646,7.07279322 19.7875634,7.00585272 19.9422817,7.00036584 C20.097,6.99487896 20.247548,7.05129572 20.3607689,7.15719084 L20.3613523,7.15719084 Z M14.4401524,13.4314705 C14.4237029,13.4123899 14.4085034,13.3922604 14.3946496,13.3712084 L10.4878244,8.16994523 L8.75230033,8.16994523 L17.5115925,19.8303699 L19.2471166,19.8303699 L14.4401524,13.4314705 Z"
  }));
};
var IcnUserLight = function IcnUserLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm0 1a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 7.5a7 7 0 0 1 7 7 .5.5 0 1 1-1 0 6 6 0 1 0-12 0 .5.5 0 1 1-1 0 7 7 0 0 1 7-7z"
  }));
};
var IcnUserRegular = function IcnUserRegular(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm0 1a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 7.5a7 7 0 0 1 7 7 .5.5 0 1 1-1 0 6 6 0 1 0-12 0 .5.5 0 1 1-1 0 7 7 0 0 1 7-7z"
  }));
};
var IcnVisa = function IcnVisa(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm-.573-14.894h-1.212L9.213 14.91h1.212l1.002-5.803zm5.1 3.747l.638-2.179.367 2.18h-1.005zm1.352 2.056H19l-.978-5.803h-1.035c-.233 0-.429.168-.516.426l-1.819 5.377h1.273l.253-.866h1.555l.146.866zm-3.163-1.894c.005-1.532-1.71-1.617-1.699-2.3.004-.209.164-.43.514-.487.174-.028.653-.05 1.196.26l.212-1.23A2.71 2.71 0 0 0 13.805 9c-1.197 0-2.04.789-2.048 1.918-.007.836.602 1.302 1.061 1.58.472.284.631.466.63.72-.004.39-.378.562-.726.569-.61.012-.963-.204-1.245-.367l-.22 1.272c.283.16.806.3 1.348.308 1.273 0 2.107-.78 2.11-1.985zm-5.02-3.909H8.421l-1.261 3.95-.51-3.358c-.06-.375-.297-.592-.56-.592H4.03L4 9.275c.423.114.905.297 1.196.493.178.12.23.225.288.51l.966 4.631h1.282l1.963-5.803z",
    fill: "#182E66",
    fillRule: "evenodd"
  }));
};
var IcnWait = function IcnWait(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M14.978 6a1.5 1.5 0 0 1 1.49 1.737c-.338 1.946-1.395 3.38-3.148 4.264 1.753.884 2.81 2.318 3.149 4.272A1.5 1.5 0 0 1 14.98 18H9.022a1.5 1.5 0 0 1-1.49-1.737C7.87 14.317 8.928 12.884 10.68 12c-1.753-.883-2.81-2.317-3.149-4.271A1.5 1.5 0 0 1 9.022 6zm-2.979 6.527l-.104.037c-1.948.704-3.05 1.981-3.375 3.86a.5.5 0 0 0 .5.576h5.963a.5.5 0 0 0 .499-.566c-.341-1.97-1.527-3.276-3.636-3.958l.153.051zM14.981 7H9.017a.5.5 0 0 0-.499.567c.341 1.97 1.527 3.276 3.636 3.957L12 11.472l.105-.036c1.863-.672 2.952-1.87 3.329-3.618l.046-.242a.5.5 0 0 0-.5-.576zM17.5 4a.5.5 0 0 1 .09.992L17.5 5h-11a.5.5 0 0 1-.09-.992L6.5 4h11zm0 15a.5.5 0 0 1 .09.992L17.5 20h-11a.5.5 0 0 1-.09-.992L6.5 19h11z"
  }));
};
var IcnWallet = function IcnWallet(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M14.527 4.326c.33.11.61.328.795.617l.073.128 1.425 2.82a2.486 2.486 0 0 1 2.175 2.292l.005.163v.58c.583.204 1 .754 1 1.4v2.97c0 .646-.417 1.196-1 1.4v.58c0 1.311-1.032 2.385-2.336 2.469l-.164.005h-10a2.49 2.49 0 0 1-2.495-2.312L4 17.275v-6.929c0-1.312 1.032-2.386 2.336-2.47l.037-.001 7.009-3.468a1.514 1.514 0 0 1 1.145-.08zM16.5 8.861h-10c-.78 0-1.42.59-1.493 1.342L5 10.346v6.93a1.49 1.49 0 0 0 1.356 1.477l.144.007h10c.78 0 1.42-.589 1.493-1.342l.007-.143v-.495h-2c-1.598 0-2.904-1.236-2.995-2.795L13 13.811c0-1.64 1.343-2.97 3-2.97h2v-.495a1.49 1.49 0 0 0-1.356-1.478l-.144-.007zm2 2.97H16c-1.105 0-2 .886-2 1.98a1.99 1.99 0 0 0 2 1.98h2.5c.276 0 .5-.222.5-.495v-2.97a.497.497 0 0 0-.5-.495zM16 13.068l.102.007c.366.05.648.36.648.736 0 .41-.336.742-.75.742a.746.746 0 0 1-.75-.742c0-.376.282-.687.648-.736l.102-.007zm-2.079-7.81l-.092.034-5.213 2.579h7.075l-1.19-2.357a.499.499 0 0 0-.58-.257z"
  }));
};
var IcnWatchlist = function IcnWatchlist(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M11.999 7l.27.003c2.512.072 5.264 1.663 7.317 3.92a1.61 1.61 0 0 1-.001 2.155c-2.123 2.336-4.989 3.965-7.578 3.922l-.28-.002c-2.53-.072-5.267-1.668-7.314-3.922a1.61 1.61 0 0 1 .002-2.155c2.124-2.338 5.006-3.963 7.584-3.92zm.008 1.002h-.017c-2.252-.038-4.886 1.446-6.834 3.59a.608.608 0 0 0-.001.814C7.1 14.548 9.719 16.038 12.007 16c2.271.038 4.89-1.451 6.836-3.593a.608.608 0 0 0 .002-.813c-1.952-2.146-4.585-3.63-6.838-3.592zM12 9l.198.007A3 3 0 1 1 11.999 9zm0 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
  }));
};
var IcnWidthdraw = function IcnWidthdraw(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M15.5 6.667a.5.5 0 0 1 .494.426l1.414 9.427a1 1 0 0 1-.988 1.147H7.579a1 1 0 0 1-.987-1.148l1.414-9.426a.5.5 0 0 1 .494-.426zm-.431.999H8.93l-1.349 9h8.837l-1.349-9zm-3.911 2.747a2.254 2.254 0 0 1 1.842.071c.619.313 1 .89 1 1.516 0 .966-.895 1.75-2 1.75s-2-.784-2-1.75c0-.625.381-1.203 1-1.516zm1.342.83a1.125 1.125 0 0 0-1 0c-.31.156-.5.444-.5.757 0 .483.448.875 1 .875s1-.392 1-.875c0-.313-.19-.601-.5-.758zM19.007 4c.506.007.922.387.985.883L20 5v4.007a1.007 1.007 0 0 1-.883.985L19 10h-.833a.5.5 0 0 1-.09-.992l.09-.008h.826l.005-.001L19 5.007l-.001-.005L5 5v3.993l.001.005.832.002a.5.5 0 0 1 .09.992l-.09.008h-.84a1.007 1.007 0 0 1-.985-.883L4 9V4.993c.007-.506.387-.922.883-.985L5 4h14.007zM17 19a.5.5 0 0 1 .09.992L17 20H7a.5.5 0 0 1-.09-.992L7 19h10z"
  }));
};
var IcnXml = function IcnXml(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M13.586 4c.348 0 .684.12.95.34l.11.1 3.915 3.913a1.5 1.5 0 0 1 .432.913l.007.148V12.5a.5.5 0 0 1-.992.09L18 12.5V10h-3.5a1.5 1.5 0 0 1-1.493-1.356L13 8.5 12.999 5H6.5a.5.5 0 0 0-.492.41L6 5.5v13a.5.5 0 0 0 .41.492L6.5 19h1a.5.5 0 0 1 .09.992L7.5 20h-1a1.5 1.5 0 0 1-1.493-1.356L5 18.5v-13a1.5 1.5 0 0 1 1.356-1.493L6.5 4h7.086zM18.5 14a.5.5 0 0 1 .492.41l.008.09v4a.5.5 0 0 0 .41.492l.09.008h1a.5.5 0 0 1 .09.992L20.5 20h-1a1.5 1.5 0 0 1-1.493-1.356L18 18.5v-4a.5.5 0 0 1 .5-.5zm-1.508.409L17 14.5v5a.5.5 0 0 1-.992.09L16 19.5l-.001-3.195-.57.952a.5.5 0 0 1-.804.074l-.054-.074-.572-.953L14 19.5a.5.5 0 0 1-.41.492L13.5 20a.5.5 0 0 1-.492-.41L13 19.5v-5c0-.475.587-.668.875-.332l.054.075 1.07 1.785 1.072-1.785c.245-.408.847-.27.921.166zm-5.306-.373a.5.5 0 0 1 .304.563l-.026.087L11.038 17l.926 2.314a.5.5 0 0 1-.887.452l-.041-.08-.536-1.34-.536 1.34a.5.5 0 0 1-.954-.285l.026-.087L9.96 17l-.925-2.314a.5.5 0 0 1 .887-.452l.041.08.536 1.339.536-1.339a.5.5 0 0 1 .65-.278zM14 5.207V8.5a.5.5 0 0 0 .41.492L14.5 9h3.293L14 5.207z"
  }));
};
var IcnXmlLight = function IcnXmlLight(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M13.586 4c.348 0 .684.12.95.34l.11.1 3.915 3.913a1.5 1.5 0 0 1 .432.913l.007.148V12.5a.5.5 0 0 1-.992.09L18 12.5V10h-3.5a1.5 1.5 0 0 1-1.493-1.356L13 8.5 12.999 5H6.5a.5.5 0 0 0-.492.41L6 5.5v13a.5.5 0 0 0 .41.492L6.5 19h1a.5.5 0 0 1 .09.992L7.5 20h-1a1.5 1.5 0 0 1-1.493-1.356L5 18.5v-13a1.5 1.5 0 0 1 1.356-1.493L6.5 4h7.086zM18.5 14a.5.5 0 0 1 .492.41l.008.09v4a.5.5 0 0 0 .41.492l.09.008h1a.5.5 0 0 1 .09.992L20.5 20h-1a1.5 1.5 0 0 1-1.493-1.356L18 18.5v-4a.5.5 0 0 1 .5-.5zm-1.508.409L17 14.5v5a.5.5 0 0 1-.992.09L16 19.5l-.001-3.195-.57.952a.5.5 0 0 1-.804.074l-.054-.074-.572-.953L14 19.5a.5.5 0 0 1-.41.492L13.5 20a.5.5 0 0 1-.492-.41L13 19.5v-5c0-.475.587-.668.875-.332l.054.075 1.07 1.785 1.072-1.785c.245-.408.847-.27.921.166zm-5.306-.373a.5.5 0 0 1 .304.563l-.026.087L11.038 17l.926 2.314a.5.5 0 0 1-.887.452l-.041-.08-.536-1.34-.536 1.34a.5.5 0 0 1-.954-.285l.026-.087L9.96 17l-.925-2.314a.5.5 0 0 1 .887-.452l.041.08.536 1.339.536-1.339a.5.5 0 0 1 .65-.278zM14 5.207V8.5a.5.5 0 0 0 .41.492L14.5 9h3.293L14 5.207z"
  }));
};
var IcnYoutubeCircle = function IcnYoutubeCircle(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm3.471 5.5H8.53l-.14.006C7.612 8.576 7 9.22 7 10.005v3.99l.007.149c.035.344.19.668.44.915.288.282.676.441 1.082.441h6.942l.14-.006c.778-.07 1.389-.714 1.389-1.499v-3.99l-.006-.137A1.52 1.52 0 0 0 15.47 8.5zM10.89 9.935l3.009 1.894-3.01 1.895V9.935z"
  }));
};
var IcnZeroEuro = function IcnZeroEuro(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 6c1.085 0 2.089.414 2.908 1.119a5.347 5.347 0 0 0-.285 1.915C13.973 8.087 13.021 7.5 12 7.5c-1.866 0-3.5 1.96-3.5 4.5s1.634 4.5 3.5 4.5 3.5-1.96 3.5-4.5c0-.118-.004-.235-.01-.35.378.484.875.837 1.48.997C16.702 15.657 14.58 18 12 18c-2.761 0-5-2.686-5-6s2.239-6 5-6zm5.691 0c.488 0 .924.118 1.309.353l-.307.75c-.376-.204-.71-.305-1.002-.305-.344 0-.625.112-.843.336-.218.225-.364.564-.437 1.018h1.668v.618h-1.723l-.007.18v.22l.007.157h1.492v.613h-1.43c.157.834.6 1.25 1.332 1.25.348 0 .705-.082 1.07-.248v.814c-.318.163-.69.244-1.114.244-.588 0-1.065-.176-1.432-.53-.367-.352-.606-.862-.718-1.53h-.275v-.613h.216l-.007-.149V9.03l.007-.26h-.216v-.618h.267c.093-.67.326-1.197.699-1.579C16.62 6.191 17.1 6 17.69 6z"
  }));
};
var IcnCashTefth = function IcnCashTefth(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M19.5 9.5a.5.5 0 0 1 .492.41L20 10v6a1.5 1.5 0 0 1-1.356 1.493l-.144.007h-11a.5.5 0 0 1-.09-.992l.09-.008h11a.5.5 0 0 0 .492-.41L19 16v-6a.5.5 0 0 1 .5-.5zm-3.5-3a2 2 0 0 1 1.995 1.85L18 8.5v5a2 2 0 0 1-1.85 1.995L16 15.5H6a2 2 0 0 1-1.995-1.85L4 13.5v-5a2 2 0 0 1 1.85-1.995L6 6.5h10zm0 1H6a1 1 0 0 0-.993.883L5 8.5v5a1 1 0 0 0 .883.993L6 14.5h10a1 1 0 0 0 .993-.883L17 13.5v-5a1 1 0 0 0-1-1zm-.75 4.5l.102.007a.75.75 0 1 1-.204 0L15.25 12zM11 8.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zm0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-4.25-1l.102.007a.75.75 0 1 1-.204 0L6.75 8.5z"
  }));
};
var IcnConcierge = function IcnConcierge(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M13.033 4.001a.5.5 0 0 1 .536.462c.04.532.248 1.035.593 1.436l.135.146.712.704a.5.5 0 0 1 .06.639l-.058.07-3.174 3.189a.5.5 0 0 0 .641.762l.068-.056 4.232-4.254a.5.5 0 0 1 .852.293l.002.089-.113 1.94a.538.538 0 0 0 1.063.147l.012-.087.156-2.77a.5.5 0 0 1 .996-.033l.003.09-.156 2.77a1.538 1.538 0 0 1-3.074-.034l.002-.14.036-.625-3.303 3.32a1.5 1.5 0 0 1-1.291.423l-.157-.033a1.5 1.5 0 0 1-.784-2.389l.106-.119 2.82-2.835-.355-.351a3.487 3.487 0 0 1-.997-1.99l-.024-.228A.5.5 0 0 1 13.033 4zM11.214 13a.5.5 0 0 1 .09.992l-.09.008h-2v1.026a4.5 4.5 0 0 1 3.919 3.62l.035.213a1 1 0 0 1-.99 1.142H5.25a1 1 0 0 1-.99-1.142 4.5 4.5 0 0 1 3.954-3.833V14h-2a.5.5 0 0 1-.09-.992l.09-.008h5zm-2.5 3l-.017-.001a3.5 3.5 0 0 0-3.447 3l6.928.002-.03-.183a3.5 3.5 0 0 0-3.434-2.82l.017.002a.51.51 0 0 1-.017 0z"
  }));
};
var IcnGuarantee = function IcnGuarantee(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M17.501 4a2.5 2.5 0 0 1 2.494 2.336L20 6.5v2a.5.5 0 0 1-.41.492L19.5 9H16v9a2 2 0 0 1-1.85 1.995L14 20H7l-.105-.009c-.527-.093-.527-.889 0-.982l.222-.016a1 1 0 0 0 .876-.876L8 18v-1.5a.5.5 0 0 1 .992-.09L9 16.5V18c0 .351-.09.682-.25.969l-.019.03L14 19a1 1 0 0 0 .993-.883L15 18V6.607c0-.554.164-1.135.496-1.607H11.5a.5.5 0 0 1-.09-.992L11.5 4h6.001zM5.75 4.469a3.5 3.5 0 0 1 3.964 5.742l.49 3.608a1 1 0 0 1-1.593.972l-.098-.085L7.5 13.692l-1.013 1.014a1 1 0 0 1-1.053.23l-.118-.053a1 1 0 0 1-.537-.92l.014-.123.496-3.627a3.5 3.5 0 0 1 .461-5.744zm3.029 6.289a3.501 3.501 0 0 1-2.555.001l-.444 3.239 1.366-1.366a.5.5 0 0 1 .638-.058l.07.058 1.366 1.365zM8.75 5.335a2.5 2.5 0 0 0-2.5 0l-.15.094a2.5 2.5 0 1 0 2.65-.094zM7.5 6.75l.102.007a.75.75 0 1 1-.204 0L7.5 6.75zM17.5 5c-.937 0-1.442.757-1.495 1.48L16 6.607V8h3V6.5a1.5 1.5 0 0 0-1.356-1.493L17.5 5z"
  }));
};
var IcnKeysPapers = function IcnKeysPapers(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M14.527 4.326c.33.11.61.328.795.617l.073.128 1.425 2.82a2.486 2.486 0 0 1 2.175 2.292l.005.163v.58c.583.204 1 .754 1 1.4v2.97c0 .646-.417 1.196-1 1.4v.58c0 1.311-1.032 2.385-2.336 2.469l-.164.005h-10a2.49 2.49 0 0 1-2.495-2.312L4 17.275v-6.929c0-1.312 1.032-2.386 2.336-2.47l.037-.001 7.009-3.468a1.514 1.514 0 0 1 1.145-.08zM16.5 8.861h-10c-.78 0-1.42.59-1.493 1.342L5 10.346v6.93a1.49 1.49 0 0 0 1.356 1.477l.144.007h10c.78 0 1.42-.589 1.493-1.342l.007-.143v-.495h-2c-1.598 0-2.904-1.236-2.995-2.795L13 13.811c0-1.64 1.343-2.97 3-2.97h2v-.495a1.49 1.49 0 0 0-1.356-1.478l-.144-.007zm2 2.97H16c-1.105 0-2 .886-2 1.98a1.99 1.99 0 0 0 2 1.98h2.5c.276 0 .5-.222.5-.495v-2.97a.497.497 0 0 0-.5-.495zM16 13.068l.102.007c.366.05.648.36.648.736 0 .41-.336.742-.75.742a.746.746 0 0 1-.75-.742c0-.376.282-.687.648-.736l.102-.007zm-2.079-7.81l-.092.034-5.213 2.579h7.075l-1.19-2.357a.499.499 0 0 0-.58-.257z"
  }));
};
var IcnPerchaseInsurance = function IcnPerchaseInsurance(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4l.447.004c1.953.04 3.882.464 5.683 1.25.533.244.874.779.87 1.363v5.076a8.438 8.438 0 0 1-5.409 7.875l-.693.267a2.5 2.5 0 0 1-1.795 0l-.694-.267A8.438 8.438 0 0 1 5 11.693V6.62a1.494 1.494 0 0 1 .879-1.37A14.972 14.972 0 0 1 12 4zm.005 1.001a13.97 13.97 0 0 0-5.718 1.162.493.493 0 0 0-.287.454v5.076a7.438 7.438 0 0 0 4.767 6.941l.695.267a1.5 1.5 0 0 0 1.077 0l.694-.266A7.438 7.438 0 0 0 18 11.693v-5.08a.489.489 0 0 0-.279-.446A13.967 13.967 0 0 0 12.005 5zM12 7.651c.312 0 .597.176.739.457l.632 1.277 1.423.206c.27.038.5.206.62.447l.045.107a.815.815 0 0 1-.208.842l-1.03.999.243 1.408a.816.816 0 0 1-.243.73l-.09.074a.828.828 0 0 1-.862.058L12 13.593l-1.27.664a.827.827 0 0 1-.761.002l-.098-.06a.816.816 0 0 1-.334-.805l.242-1.407-1.03-.998a.815.815 0 0 1-.236-.732l.03-.114a.821.821 0 0 1 .662-.551l1.423-.206.635-1.28a.825.825 0 0 1 .622-.447zm0 1.219l-.518 1.046a.823.823 0 0 1-.62.447l-1.15.166.832.806c.166.16.255.383.249.61l-.012.115-.197 1.145 1.034-.54a.828.828 0 0 1 .66-.046l.105.046 1.032.54-.196-1.146a.815.815 0 0 1 .16-.639l.076-.084.833-.808-1.148-.166a.823.823 0 0 1-.564-.35l-.059-.099L12 8.87z"
  }));
};
var IcnTicket = function IcnTicket(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M15.5 11a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm0 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zm-1.13 1.674l.07.058 1.06 1.061 1.06-1.06a.5.5 0 0 1 .766.637l-.058.07-1.061 1.06 1.06 1.06a.5.5 0 0 1-.637.766l-.07-.058-1.06-1.061-1.06 1.06a.5.5 0 0 1-.766-.637l.058-.07 1.061-1.06-1.06-1.06a.5.5 0 0 1 .637-.766zM18.5 4a1.5 1.5 0 0 1 1.493 1.356L20 5.5v1.542a1 1 0 0 1-.716.957l-.117.027A2.003 2.003 0 0 0 17.54 9.6a.5.5 0 1 1-.98-.2 3.004 3.004 0 0 1 2.25-2.321L19 7.04V5.5a.5.5 0 0 0-.41-.492L18.5 5h-13a.5.5 0 0 0-.492.41L5 5.5v1.542l.178.035a3 3 0 0 1 0 5.849L5 12.96V14.5a.5.5 0 0 0 .41.492L5.5 15h4a.5.5 0 0 1 .09.992L9.5 16h-4a1.5 1.5 0 0 1-1.493-1.356L4 14.5v-1.54a1 1 0 0 1 .718-.958l.117-.027a2 2 0 0 0 .001-3.947.998.998 0 0 1-.83-.874L4 7.043V5.5a1.5 1.5 0 0 1 1.356-1.493L5.5 4h13zm-9 8a.5.5 0 0 1 .492.41l.008.09v1a.5.5 0 0 1-.992.09L9 13.5v-1a.5.5 0 0 1 .5-.5zm0-3a.5.5 0 0 1 .492.41L10 9.5v1a.5.5 0 0 1-.992.09L9 10.5v-1a.5.5 0 0 1 .5-.5zm0-3a.5.5 0 0 1 .492.41L10 6.5v1a.5.5 0 0 1-.992.09L9 7.5v-1a.5.5 0 0 1 .5-.5z"
  }));
};
var IcnTravelAccident = function IcnTravelAccident(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm.5 2A1.5 1.5 0 0 1 14 8.5V10h1.5a1.5 1.5 0 0 1 1.493 1.356L17 11.5v1a1.5 1.5 0 0 1-1.5 1.5H14v1.5a1.5 1.5 0 0 1-1.356 1.493L12.5 17h-1a1.5 1.5 0 0 1-1.5-1.5V14H8.5a1.5 1.5 0 0 1-1.493-1.356L7 12.5v-1A1.5 1.5 0 0 1 8.5 10H10V8.5a1.5 1.5 0 0 1 1.356-1.493L11.5 7zm0 1h-1a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-.5-.5z"
  }));
};
var IcnTravelAssistance = function IcnTravelAssistance(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a6 6 0 0 1 5.983 5.546 2.503 2.503 0 0 1 2.012 2.29L20 12v2a2.5 2.5 0 0 1-2 2.45v.05a2.5 2.5 0 0 1-2.336 2.495L15.5 19h-1.086A1.5 1.5 0 0 1 13 20h-1a1.506 1.506 0 0 1-1.492-1.355L10.5 18.5A1.5 1.5 0 0 1 12 17h1c.642 0 1.197.406 1.41 1h1.09a1.5 1.5 0 0 0 1.493-1.356L17 16.5l-.117-.007a1 1 0 0 1-.876-.876L16 15.5v-5a1 1 0 0 1 .883-.993l.092-.006a5 5 0 0 0-9.95 0 .999.999 0 0 1 .968.884L8 10.5v5a1 1 0 0 1-.883.993L7 16.5h-.5a2.5 2.5 0 0 1-2.495-2.336L4 14v-2a2.5 2.5 0 0 1 2.018-2.454A6 6 0 0 1 12 4zm1 14h-1c-.276 0-.5.224-.5.471l.003.088A.5.5 0 0 0 12 19h1c.276 0 .5-.224.5-.471l-.003-.088A.5.5 0 0 0 13 18zm1.37-4.042a.5.5 0 0 1-.033.706 3.47 3.47 0 0 1-4.674 0 .5.5 0 1 1 .674-.739 2.47 2.47 0 0 0 3.326 0 .5.5 0 0 1 .707.033zM7 10.5h-.5a1.5 1.5 0 0 0-1.493 1.356L5 12v2a1.5 1.5 0 0 0 1.356 1.493l.144.007H7v-5zm10.5 0H17v5h.5a1.5 1.5 0 0 0 1.493-1.356L19 14v-2a1.5 1.5 0 0 0-1.5-1.5zm-7.5-.343a.5.5 0 0 1 .492.41l.008.09v.874a.5.5 0 0 1-.992.09l-.008-.09v-.874a.5.5 0 0 1 .5-.5zm4 0a.5.5 0 0 1 .492.41l.008.09v.874a.5.5 0 0 1-.992.09l-.008-.09v-.874a.5.5 0 0 1 .5-.5z"
  }));
};
var IcnTravelCancel = function IcnTravelCancel(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M18.75 12.4A4.472 4.472 0 0 1 20 15.508 4.498 4.498 0 0 1 15.498 20a4.493 4.493 0 0 1-3.181-1.313 4.47 4.47 0 0 1-1.322-3.18 4.498 4.498 0 0 1 4.503-4.492c1.24 0 2.363.5 3.177 1.31l.006.005zm-.449 1.016l-4.9 4.889a3.49 3.49 0 0 0 2.097.695c1.933 0 3.5-1.564 3.5-3.493 0-.784-.26-1.508-.697-2.09zm-2.803-1.401a3.496 3.496 0 0 0-3.5 3.492c0 .785.258 1.508.696 2.091l4.9-4.889a3.49 3.49 0 0 0-2.096-.694zm-4.74-7.883l.116.07L13.055 5.7l1.9-.636a2.114 2.114 0 0 1 2.676 1.327 2.107 2.107 0 0 1-1.181 2.614l-.148.056-1.914.641-.183.473a.501.501 0 0 1-.561.31l-.087-.024a.5.5 0 0 1-.312-.56l.025-.087.267-.69a.5.5 0 0 1 .227-.259l.08-.035 2.139-.717a1.108 1.108 0 0 0-.591-2.133l-.117.032L7.64 8.573a.502.502 0 0 1-.44-.06l-.073-.06-.802-.796-1.224.41a.144.144 0 0 0-.074.057l-.019.043a.143.143 0 0 0 .006.092l.025.04 2.054 2.293a.79.79 0 0 0 .725.25l.114-.028 2.25-.755a.501.501 0 0 1 .66.46l-.005.084-.456 3.242a.5.5 0 0 1-.997-.048l.004-.09.343-2.442-1.48.497a1.794 1.794 0 0 1-1.791-.387l-.115-.117-2.053-2.293a1.142 1.142 0 0 1 .371-1.798l.119-.047 1.517-.509a.502.502 0 0 1 .441.06l.072.06.802.795 1.38-.464-.727-.721a1.142 1.142 0 0 1 .32-1.847l.123-.049L9.86 4.06c.299-.1.623-.072.899.073zM10.223 5l-.043.007-1.151.386a.143.143 0 0 0-.084.198l.029.04 1.082 1.075 1.812-.608-1.561-1.073A.146.146 0 0 0 10.222 5z"
  }));
};
var IcnTravelTrubbles = function IcnTravelTrubbles(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M7.5 20A3.5 3.5 0 0 1 4 16.5v-6A3.5 3.5 0 0 1 7.5 7H9a3 3 0 1 1 6 0h1.5a3.5 3.5 0 0 1 3.5 3.5v6a3.5 3.5 0 0 1-3.5 3.5zM8 8h-.5A2.5 2.5 0 0 0 5 10.5v6A2.5 2.5 0 0 0 7.5 19H8V8zm7 0H9v11h6V8zm1.5 0H16v11h.5a2.5 2.5 0 0 0 2.495-2.336L19 16.5v-6A2.5 2.5 0 0 0 16.5 8zM12 5a2 2 0 0 0-2 2h4a2 2 0 0 0-1.85-1.995z"
  }));
};
var IcnCheckCirclePlein = function IcnCheckCirclePlein(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm4.31 4.16a.5.5 0 0 0-.702.083l-5.229 6.615-.036.039a.197.197 0 0 1-.294-.041l-1.64-2.328-.059-.069a.5.5 0 0 0-.759.645l1.634 2.318.085.112a1.2 1.2 0 0 0 1.86-.064l5.222-6.607.05-.076a.5.5 0 0 0-.132-.627z"
  }));
};
var IcnInstagramCircle = function IcnInstagramCircle(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm1.143 3h-2.286l-.198.005A3.857 3.857 0 0 0 7 10.857v2.286l.005.198A3.857 3.857 0 0 0 10.857 17h2.286l.198-.005A3.857 3.857 0 0 0 17 13.143v-2.286l-.005-.198A3.857 3.857 0 0 0 13.143 7zm0 .857a3 3 0 0 1 3 3v2.286l-.005.176a3 3 0 0 1-2.995 2.824h-2.286l-.176-.005a3 3 0 0 1-2.824-2.995v-2.286l.005-.176a3 3 0 0 1 2.995-2.824zM12 9.571a2.429 2.429 0 1 0 0 4.858 2.429 2.429 0 0 0 0-4.858zm0 .858a1.571 1.571 0 1 1 0 3.142 1.571 1.571 0 0 1 0-3.142zm2.646-1.715a.646.646 0 1 0 0 1.292.646.646 0 0 0 0-1.292zm0 .435a.211.211 0 1 1 0 .422.211.211 0 0 1 0-.422z"
  }));
};
var IcnCompliance = function IcnCompliance(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M15.5 11a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm0 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zm-2.914-8c.348 0 .683.12.95.34l.11.1 2.915 2.914a1.5 1.5 0 0 1 .432.912l.007.148V9.5a.5.5 0 0 1-.992.09L16 9.5V9h-2.5a1.5 1.5 0 0 1-1.493-1.356L12 7.5V5H5.5a.5.5 0 0 0-.492.41L5 5.5v11a.5.5 0 0 0 .41.492L5.5 17h4a.5.5 0 0 1 .09.992L9.5 18h-4a1.5 1.5 0 0 1-1.493-1.356L4 16.5v-11a1.5 1.5 0 0 1 1.356-1.493L5.5 4h7.086zm4.997 9.937a.5.5 0 0 1 .147.624l-.047.076-1.938 2.583a1.001 1.001 0 0 1-1.414.189l-.093-.082-1-1a.5.5 0 0 1 .638-.765l.07.058 1 1 1.937-2.583a.5.5 0 0 1 .7-.1zM15.793 8L13 5.207V7.5a.5.5 0 0 0 .41.492L13.5 8h2.293z"
  }));
};
var IcnDiamant = function IcnDiamant(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M16.144 5c.251 0 .494.06.712.173l-.062-.027a1.54 1.54 0 0 1 .593.476L19.689 8.7a1.557 1.557 0 0 1-.048 1.927l-6.45 7.815a1.553 1.553 0 0 1-1.19.556h.043a1.553 1.553 0 0 1-1.237-.56v.001l-6.445-7.81A1.554 1.554 0 0 1 4 9.666l.002-.032c0-.329.102-.658.31-.935l2.304-3.078c.136-.18.307-.327.5-.432l.037-.02C7.37 5.06 7.61 5 7.86 5zm-1.712 5.185H9.57l2.431 6.765 2.431-6.765zm-5.963 0h-3.13l5.545 6.719-2.415-6.719zm10.193 0h-3.129l-2.414 6.716 5.543-6.716zM7.179 6.597l-1.91 2.551h2.827l-.917-2.551zm9.643 0l-.917 2.551h2.826l-1.909-2.551zM12 6.382L9.93 9.148h4.144L12 6.382zm-1.035-.345H8.079l.936 2.604 1.95-2.604zm4.958 0h-2.886l1.95 2.604.936-2.604z"
  }));
};
var IcnKeyEvent = function IcnKeyEvent(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M15.833 4a.5.5 0 0 1 .492.41l.008.09V6H18a2 2 0 0 1 1.995 1.85L20 8v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h1.666V4.5a.5.5 0 0 1 .993-.09l.008.09L8.666 6h6.667V4.5a.5.5 0 0 1 .5-.5zM19 10.666H5V18a1 1 0 0 0 .883.993L6 19h12a1 1 0 0 0 1-1v-7.334zm-3.468 1.376a.5.5 0 0 1 .058.638l-.058.07-4.541 4.54a.5.5 0 0 1-.638.059l-.07-.058-1.815-1.817a.5.5 0 0 1 .638-.765l.069.058 1.462 1.463 4.188-4.188a.5.5 0 0 1 .707 0zM7.666 7H6a1 1 0 0 0-1 1v1.666h14V8a1 1 0 0 0-.883-.993L18 7h-1.667v.667a.5.5 0 0 1-.992.09l-.008-.09V7H8.666v.667a.5.5 0 0 1-.991.09l-.008-.09L7.666 7z"
  }));
};
var IcnPromo = function IcnPromo(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M11.997 4c1.125 0 2.14.622 2.659 1.585l.012.027.07-.02a3.018 3.018 0 0 1 2.723.653l.146.137c.76.759 1.048 1.852.791 2.865l-.019.066.027.013a3.005 3.005 0 0 1 1.588 2.463l.005.185a3.008 3.008 0 0 1-1.555 2.69l-.034.016.022.073c.24.95.003 1.97-.654 2.719l-.137.146a3.018 3.018 0 0 1-2.87.79l-.07-.02-.012.027a3.022 3.022 0 0 1-2.473 1.58L12.03 20a3.022 3.022 0 0 1-2.659-1.585l-.01-.02-.066.021a3.018 3.018 0 0 1-2.76-.628l-.149-.138a3.006 3.006 0 0 1-.796-2.896l.02-.071-.19-.109a3.015 3.015 0 0 1-1.414-2.371L4 12.017c0-1.123.623-2.136 1.587-2.655l.02-.01-.02-.066a3.006 3.006 0 0 1 .629-2.755l.138-.149a3.018 3.018 0 0 1 2.901-.795l.07.02.11-.19a3.022 3.022 0 0 1 2.375-1.411zm0 1.003c-.876 0-1.652.565-1.92 1.397a.503.503 0 0 1-.699.297 2.012 2.012 0 0 0-2.31.39A2.003 2.003 0 0 0 6.7 9.399a.501.501 0 0 1-.296.703 2.013 2.013 0 0 0 0 3.832.501.501 0 0 1 .298.698 2.003 2.003 0 0 0 .39 2.307 2.012 2.012 0 0 0 2.315.367.503.503 0 0 1 .704.295 2.015 2.015 0 0 0 3.838 0c.093-.29.42-.43.695-.3.768.367 1.685.21 2.287-.391.602-.601.759-1.516.392-2.283a.501.501 0 0 1 .295-.692 2.01 2.01 0 0 0 1.377-1.951 2.006 2.006 0 0 0-1.404-1.915.501.501 0 0 1-.302-.694 2.003 2.003 0 0 0-.392-2.283 2.012 2.012 0 0 0-2.286-.392.503.503 0 0 1-.695-.299 2.015 2.015 0 0 0-1.92-1.397zm2.39 7.482c.925 0 1.675.748 1.675 1.671s-.75 1.672-1.675 1.672a1.673 1.673 0 0 1-1.674-1.672c0-.923.75-1.671 1.674-1.671zm.858-3.53a.501.501 0 0 1 .058.64l-.058.069-5.358 5.348a.503.503 0 0 1-.768-.64l.058-.069 5.358-5.349a.503.503 0 0 1 .71 0zm-.858 4.533a.67.67 0 1 0 0 1.338.67.67 0 0 0 0-1.338zm-4.353-5.35a1.673 1.673 0 0 1 0 3.343 1.673 1.673 0 0 1-1.674-1.67c0-.924.75-1.672 1.674-1.672zm0 1.004a.67.67 0 1 0 0 1.338.67.67 0 0 0 0-1.338z"
  }));
};
var IcnQuestionCircle = function IcnQuestionCircle(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm0 10l.102.007a.75.75 0 1 1-.204 0L12 15zm2.436-5.561a2.5 2.5 0 0 1-1.603 2.918.5.5 0 0 0-.325.383l-.008.09v.67a.5.5 0 0 1-.992.09l-.008-.09v-.67a1.5 1.5 0 0 1 .865-1.36l.135-.055a1.5 1.5 0 1 0-2-1.415.5.5 0 0 1-1 0 2.5 2.5 0 0 1 4.936-.561z"
  }));
};
var IcnLongArrowRise = function IcnLongArrowRise(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M7.055 16.945a.7.7 0 0 0 .919.062l.071-.062 7.705-7.706v7.21a.7.7 0 0 0 1.39.114l.01-.113v-8.9a.7.7 0 0 0-.587-.69l-.113-.01h-8.9a.7.7 0 0 0-.113 1.391l.113.01h7.21l-7.705 7.704a.7.7 0 0 0 0 .99z"
  }));
};
var IcnLongArrowFall = function IcnLongArrowFall(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M7.055 7.055a.7.7 0 0 1 .918-.063l.072.063 7.704 7.706V7.55a.7.7 0 0 1 1.391-.114l.01.114v8.9a.7.7 0 0 1-.587.69l-.114.01H7.55a.7.7 0 0 1-.114-1.391l.114-.01h7.21L7.055 8.045a.7.7 0 0 1 0-.99z"
  }));
};
var ImgCardBlocked = function ImgCardBlocked(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.120027939 1.71961149 0.120027939 1.71961149 1.78852299 0 1.78852299"
  })), /*#__PURE__*/React.createElement("g", {
    id: "imgCardBlocked",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-42",
    transform: "translate(19.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.76315,43.05985 C59.6534,42.61335 59.9384,42.1591 60.4004,42.04535 C60.86215,41.9316 61.32565,42.2011 61.43565,42.64785 C61.54565,43.0941 61.2604,43.5481 60.79865,43.66185 C60.33665,43.7756 59.87315,43.5061 59.76315,43.05985",
    id: "Fill-1",
    fill: "#CA4036",
    opacity: "0.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1932,40.7881 C3.0832,40.34185 3.36845,39.8876 3.8302,39.77385 C4.2922,39.6601 4.7557,39.9296 4.8657,40.3761 C4.9757,40.8226 4.69045,41.2766 4.2287,41.39035 C3.7667,41.5041 3.3032,41.2346 3.1932,40.7881",
    id: "Fill-3",
    fill: "#CA4036",
    opacity: "0.1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    opacity: "0.1",
    transform: "translate(0.000000, 36.938000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.023525,1.1604 C-0.086475,0.71415 0.198775,0.2599 0.660775,0.14615 C1.122525,0.03215 1.586025,0.3019 1.696025,0.7484 C1.806025,1.19465 1.520775,1.64865 1.059025,1.7624 C0.597025,1.8764 0.133525,1.60665 0.023525,1.1604",
    id: "Fill-5",
    fill: "#CA4036",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.26865,37.00955 L2.70165,35.40005 C2.65215,35.2588 2.77365,35.11705 2.92065,35.1443 L4.59815,35.4583 L6.2759,35.77205 C6.4229,35.79955 6.4849,35.9758 6.38765,36.0893 L5.27715,37.3853 L4.1664,38.6813 C4.06915,38.79505 3.8854,38.76055 3.83565,38.6193 L3.26865,37.00955 Z",
    id: "Fill-8",
    fill: "#CA4036",
    opacity: "0.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.403775,19.76905 L60.403775,35.94405 C60.403775,37.1938 59.390775,38.20705 58.141025,38.20705",
    id: "Stroke-10",
    stroke: "#CA4036",
    strokeWidth: "0.5",
    opacity: "0.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.39195,12.26905 C14.39195,11.0193 15.40495,10.00605 16.6547,10.00605 L45.32345,10.00605",
    id: "Stroke-12",
    stroke: "#CA4036",
    strokeWidth: "0.5",
    opacity: "0.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.28,9.081075 L5.82675,9.081075 L5.82675,7.628075 C5.82675,7.328075 5.5815,7.083075 5.28175,7.083075 C4.98225,7.083075 4.737,7.328075 4.737,7.628075 L4.737,9.081075 L3.28375,9.081075 C2.984,9.081075 2.73875,9.326325 2.73875,9.626075 C2.73875,9.925825 2.984,10.170825 3.28375,10.170825 L4.737,10.170825 L4.737,11.624325 C4.737,11.923825 4.98225,12.169325 5.28175,12.169325 C5.5815,12.169325 5.82675,11.923825 5.82675,11.624325 L5.82675,10.170825 L7.28,10.170825 C7.57975,10.170825 7.825,9.925825 7.825,9.626075 C7.825,9.326325 7.57975,9.081075 7.28,9.081075",
    id: "Fill-14",
    fill: "#CA4036",
    opacity: "0.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5958,42.2034 C13.5958,43.45315 11.36255,43.0294 10.40955,43.0294 C9.45655,43.0294 8.6843,42.01615 8.6843,40.7664 L8.6843,15.2894 C8.6843,14.03965 9.45655,13.02665 10.40955,13.02665 C11.36255,13.02665 10.91755,14.03965 10.91755,15.2894 L10.91755,42.0124 L13.5958,42.2034",
    id: "Fill-16",
    fillOpacity: "0.3",
    fill: "#CA4036"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.797325,24.128675 L57.797325,40.549925 C57.797325,41.510175 57.018575,42.288925 56.058075,42.288925 L12.688825,42.288925 C11.728325,42.288925 10.949825,41.510175 10.949825,40.549925 L10.949825,13.967175 C10.949825,13.006925 11.728325,12.228175 12.688825,12.228175 L45.073325,12.228175",
    id: "Stroke-18",
    stroke: "#CA4036",
    strokeWidth: "1.469",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.509,27.6753 L11.2725,27.6753 C11.12925,27.6753 11.01325,27.55905 11.01325,27.4158 L11.01325,23.4843 L11.01325,20.89955 C11.01325,20.7563 11.12925,20.64005 11.2725,20.64005 L57.509,20.64005 C57.65225,20.64005 57.7685,20.7563 57.7685,20.89955 L57.7685,22.7953 L57.7685,27.4158 C57.7685,27.55905 57.65225,27.6753 57.509,27.6753 Z",
    id: "Stroke-20",
    stroke: "#CA4036",
    strokeWidth: "1.469"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "16.01035",
    y1: "37.493925",
    x2: "22.47385",
    y2: "37.493925",
    id: "Stroke-22",
    stroke: "#CA4036",
    strokeWidth: "1.469",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "26.293075",
    y1: "37.493925",
    x2: "32.756575",
    y2: "37.493925",
    id: "Stroke-24",
    stroke: "#CA4036",
    strokeWidth: "1.469",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1677,33.94705 C42.4277,33.94705 42.66095,34.11955 42.71995,34.41905 L43.22445,37.09805 L44.4707,33.94705 L45.72895,33.94705 L43.78845,38.57655 L42.5222,38.57655 L41.5677,34.8818 C41.50945,34.65455 41.45895,34.57105 41.2827,34.47505 C40.99545,34.3188 40.5197,34.17255 40.10145,34.0818 L40.12995,33.94705 L42.1677,33.94705 Z",
    id: "Fill-26",
    fill: "#CA4036"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.478975,36.9363 L53.109225,35.19755 L53.471975,36.9363 L52.478975,36.9363 Z M53.956225,33.9473 L52.933225,33.9473 L52.858475,33.95205 C52.661975,33.9778 52.500225,34.10405 52.423725,34.28655 L50.627225,38.57655 L51.884225,38.57655 L52.134475,37.88555 L53.670725,37.88555 L53.814975,38.57655 L54.922725,38.57655 L53.956225,33.9473 Z",
    id: "Fill-28",
    fill: "#CA4036"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-30",
    fill: "#CA4036",
    points: "47.439925 33.94705 46.449675 38.57655 45.252175 38.57655 46.242425 33.94705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.79025,33.862575 C50.1935,33.862575 50.52825,33.939575 50.7985,34.029075 L50.91025,34.067825 L50.7005,35.049575 C50.16325,34.802575 49.691,34.819825 49.519,34.842325 C49.173,34.887575 49.0145,35.063825 49.0115,35.230325 C48.9995,35.775825 50.69425,35.843325 50.6895,37.065325 C50.685,38.027325 49.862,38.649075 48.6045,38.649075 C48.12175,38.643825 47.6555,38.553075 47.363,38.441075 L47.27225,38.403075 L47.48925,37.388575 C47.76775,37.518825 48.11775,37.690825 48.71975,37.681075 C49.064,37.675575 49.433,37.538575 49.436,37.228075 C49.43775,37.040575 49.30475,36.902325 48.91725,36.703825 L48.73325,36.612075 C48.2925,36.386325 47.75925,36.020075 47.76625,35.393075 C47.77325,34.492075 48.60675,33.862575 49.79025,33.862575",
    id: "Fill-32",
    fill: "#CA4036"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.124475,20.41385 L47.487475,20.41385 C46.310975,20.41385 45.356975,19.4601 45.356975,18.28335 L45.356975,8.4471 C45.356975,7.2706 46.310975,6.31635 47.487475,6.31635 L58.124475,6.31635 C59.301225,6.31635 60.254975,7.2706 60.254975,8.4471 L60.254975,18.28335 C60.254975,18.79335 59.967725,20.41385 58.124475,20.41385 Z",
    id: "Stroke-34",
    stroke: "#CA4036",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.43015,6.1111 L48.43015,4.52535 C48.43015,2.09535 50.4004,0.1251 52.8309,0.1251 C55.2609,0.1251 57.23115,2.09535 57.23115,4.52535 L57.23115,6.1016",
    id: "Stroke-36",
    stroke: "#CA4036",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6096,12.258325 C53.6096,12.257575 53.60935,12.257075 53.6091,12.256325 C54.0906,11.978075 54.41535,11.459325 54.41535,10.863325 C54.41535,9.974575 53.69485,9.254075 52.8061,9.254075 C51.91735,9.254075 51.1971,9.974575 51.1971,10.863325 C51.1971,11.459325 51.5216,11.978075 52.00285,12.256325 C52.00285,12.257075 52.0026,12.257575 52.00235,12.258325 L51.3856,16.407825 C51.3456,16.675325 51.5406,16.917575 51.79585,16.917575 L53.81635,16.917575 C54.07185,16.917575 54.2666,16.675325 54.22685,16.407825 L53.6096,12.258325 Z",
    id: "Fill-38",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6096,12.258325 C53.6096,12.257575 53.60935,12.257075 53.6091,12.256325 C54.0906,11.978075 54.41535,11.459325 54.41535,10.863325 C54.41535,9.974575 53.69485,9.254075 52.8061,9.254075 C51.91735,9.254075 51.1971,9.974575 51.1971,10.863325 C51.1971,11.459325 51.5216,11.978075 52.00285,12.256325 C52.00285,12.257075 52.0026,12.257575 52.00235,12.258325 L51.3856,16.407825 C51.3456,16.675325 51.5406,16.917575 51.79585,16.917575 L53.81635,16.917575 C54.07185,16.917575 54.2666,16.675325 54.22685,16.407825 L53.6096,12.258325 Z",
    id: "Stroke-40",
    stroke: "#CA4036",
    strokeWidth: "1.25"
  }))));
};
var ImgEnvironment = function ImgEnvironment(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    id: "imgEnvironment",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(22.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.9177643,10.1471158 L56.9177643,49.6108861 C56.9177643,50.8770488 55.8819714,51.9036134 54.6038656,51.9036134 L2.43957489,51.9036134 C1.16146916,51.9036134 0.125676211,50.8770488 0.125676211,49.6108861 L0.125676211,2.48545072 C0.125676211,1.21928804 1.16146916,0.192723445 2.43957489,0.192723445 L45.9790374,0.192723445",
    id: "Stroke-1",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.227626,41.7308708 L22.9241194,41.7308708 C21.9950445,41.7308708 21.2417405,40.9844593 21.2417405,40.0638852 L21.2417405,9.60183732 C21.2417405,8.68126316 21.9950445,7.93485167 22.9241194,7.93485167 L39.227626,7.93485167 C39.4533661,7.93485167 39.6685599,7.97888995 39.8654233,8.05875598 C40.4781106,8.30755981 40.9100048,8.904689 40.9100048,9.60183732 L40.9100048,40.0638852 C40.9100048,40.9844593 40.156952,41.7308708 39.227626,41.7308708",
    id: "Fill-3",
    fill: "#AEEDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.227626,41.7308708 L22.9241194,41.7308708 C21.9950445,41.7308708 21.2417405,40.9844593 21.2417405,40.0638852 L21.2417405,9.60183732 C21.2417405,8.68126316 21.9950445,7.93485167 22.9241194,7.93485167 L39.227626,7.93485167 C39.4533661,7.93485167 39.6685599,7.97888995 39.8654233,8.05875598 C40.4781106,8.30755981 40.9100048,8.904689 40.9100048,9.60183732 L40.9100048,40.0638852 C40.9100048,40.9844593 40.156952,41.7308708 39.227626,41.7308708 Z",
    id: "Stroke-5",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9435863,44.9145397 L18.6400797,44.9145397 C17.7110048,44.9145397 16.9577009,44.1681282 16.9577009,43.2475541 L16.9577009,12.7855062 C16.9577009,11.8649321 17.7110048,11.1185206 18.6400797,11.1185206 L34.9435863,11.1185206 C35.1693264,11.1185206 35.3845203,11.1625589 35.5813837,11.2424249 C36.1940709,11.4912287 36.6259652,12.0883579 36.6259652,12.7855062 L36.6259652,43.2475541 C36.6259652,44.1681282 35.8726612,44.9145397 34.9435863,44.9145397",
    id: "Fill-7",
    fill: "#00B3DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9435863,44.9145397 L18.6400797,44.9145397 C17.7110048,44.9145397 16.9577009,44.1681282 16.9577009,43.2475541 L16.9577009,12.7855062 C16.9577009,11.8649321 17.7110048,11.1185206 18.6400797,11.1185206 L34.9435863,11.1185206 C35.1693264,11.1185206 35.3845203,11.1625589 35.5813837,11.2424249 C36.1940709,11.4912287 36.6259652,12.0883579 36.6259652,12.7855062 L36.6259652,43.2475541 C36.6259652,44.1681282 35.8726612,44.9145397 34.9435863,44.9145397 Z",
    id: "Stroke-9",
    stroke: "#2C3B45",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "21.1106907",
    y1: "13.8509837",
    x2: "32.4730256",
    y2: "13.8509837",
    id: "Stroke-11",
    stroke: "#2C3B45",
    strokeWidth: "1.06625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "26.7630568",
    y1: "42.1526679",
    x2: "26.820559",
    y2: "42.1526679",
    id: "Stroke-13",
    stroke: "#2C3B45",
    strokeWidth: "1.06625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "38.6568978",
    y1: "31.4008842",
    x2: "38.6568978",
    y2: "39.3262813",
    id: "Stroke-15",
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "55.6476687",
    y1: "1.11897033",
    x2: "49.9918626",
    y2: "6.72277895",
    id: "Stroke-17",
    stroke: "#FFFFFF",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "56.4654555",
    y1: "0.433067943",
    x2: "50.0026097",
    y2: "6.83678086",
    id: "Stroke-19",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6101471,21.5344938 L25.6985128,21.5344938 C25.4712661,21.5344938 25.2872088,21.716867 25.2872088,21.9422833 C25.2872088,22.1674507 25.4712661,22.3498239 25.6985128,22.3498239 L26.6233189,22.3498239 L26.6233189,22.9355081 C26.6233189,23.1604268 26.8076273,23.3432976 27.0346229,23.3432976 C27.2621207,23.3432976 27.446178,23.1604268 27.446178,22.9355081 L27.446178,22.3498239 L27.6101471,22.3498239 C28.2564819,22.3498239 28.7822881,21.8288287 28.7822881,21.1881589 C28.7822881,20.5477378 28.2564819,20.0267426 27.6101471,20.0267426 L26.4593498,20.0267426 C26.2667551,20.0267426 26.1100678,19.871489 26.1100678,19.6806565 C26.1100678,19.4895751 26.2667551,19.3343215 26.4593498,19.3343215 L28.3709841,19.3343215 C28.5982308,19.3343215 28.7822881,19.1519483 28.7822881,18.9270297 C28.7822881,18.7016134 28.5982308,18.5192402 28.3709841,18.5192402 L27.446178,18.5192402 L27.446178,17.933556 C27.446178,17.7083885 27.2621207,17.5260153 27.0346229,17.5260153 C26.8076273,17.5260153 26.6233189,17.7083885 26.6233189,17.933556 L26.6233189,18.5192402 L26.4593498,18.5192402 C25.813015,18.5192402 25.2872088,19.0402354 25.2872088,19.6806565 C25.2872088,20.3210775 25.813015,20.8420727 26.4593498,20.8420727 L27.6101471,20.8420727 C27.8027419,20.8420727 27.9596802,20.9973263 27.9596802,21.1881589 C27.9596802,21.3792402 27.8027419,21.5344938 27.6101471,21.5344938",
    id: "Fill-21",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7878639,31.7529416 C20.0321855,31.7529416 20.2300533,31.5568842 20.2300533,31.3147981 L20.2300533,23.9969799 C20.2300533,23.7551426 20.0321855,23.5590852 19.7878639,23.5590852 C19.5437934,23.5590852 19.3459256,23.7551426 19.3459256,23.9969799 L19.3459256,31.3147981 C19.3459256,31.5568842 19.5437934,31.7529416 19.7878639,31.7529416",
    id: "Fill-23",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3255079,26.4107254 L22.7929441,25.6931751 L23.2702877,27.3424957 C23.3061952,27.4668976 23.3953361,27.5689072 23.5143581,27.6216536 C23.632878,27.6746488 23.7697282,27.6721608 23.8872436,27.6166775 L25.057878,27.0568689 L26.0253714,28.8049646 C26.0941731,28.9293665 26.2192216,29.0129646 26.3613449,29.0293856 C26.5029661,29.0458067 26.6445872,28.9935579 26.7405079,28.8883139 L27.3657502,28.2038545 L29.0732392,30.5030507 C29.1568559,30.6157589 29.2891863,30.6816919 29.4293009,30.6816919 C29.4365828,30.6816919 29.4438648,30.6814431 29.4511467,30.6811943 C29.5992965,30.6739789 29.7336357,30.5936153 29.8097194,30.467223 L30.5507194,29.2299215 L31.2512921,29.7307636 C31.4318339,29.8601416 31.6819308,29.83551 31.8338471,29.6735388 L33.4461687,27.9540555 C33.6121467,27.7766584 33.6018515,27.4997397 33.4228163,27.3350316 C33.2442833,27.1703234 32.9645564,27.1805244 32.7980762,27.3579215 L31.451922,28.7937684 L30.67627,28.2394335 C30.5753273,28.1675292 30.4495256,28.1404096 30.3274903,28.1657876 C30.2062084,28.1906679 30.1007458,28.2650603 30.0372172,28.3708019 L29.389878,29.4513569 L27.7569661,27.2529263 C27.6783714,27.1469359 27.5558339,27.0815005 27.4235035,27.0747828 C27.2856489,27.0690603 27.162107,27.1210603 27.0732172,27.2183426 L26.5019617,27.8440842 L25.6311423,26.2708976 C25.5178956,26.0663809 25.2637811,25.986266 25.0516004,26.0870316 L23.9756313,26.6015579 L23.4967811,24.94751 C23.4608736,24.8226105 23.3709793,24.7201033 23.2509529,24.6676057 C23.1314286,24.6153569 22.9940762,24.6180938 22.8765608,24.6753187 L20.9345432,25.6250029 C20.7155828,25.7319885 20.6254374,25.9947254 20.7336621,26.2116823 C20.8416357,26.4286392 21.1065476,26.517711 21.3255079,26.4107254",
    id: "Fill-25",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7226075,33.5179062 L22.8144885,33.5179062 C22.570167,33.5179062 22.3722991,33.7139636 22.3722991,33.9560498 C22.3722991,34.1976383 22.570167,34.3939445 22.8144885,34.3939445 L24.7226075,34.3939445 C24.9669291,34.3939445 25.1647969,34.1976383 25.1647969,33.9560498 C25.1647969,33.7139636 24.9669291,33.5179062 24.7226075,33.5179062",
    id: "Fill-27",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1553744,33.5179062 L27.2472555,33.5179062 C27.0029339,33.5179062 26.8050661,33.7139636 26.8050661,33.9560498 C26.8050661,34.1976383 27.0029339,34.3939445 27.2472555,34.3939445 L29.1553744,34.3939445 C29.399696,34.3939445 29.5975639,34.1976383 29.5975639,33.9560498 C29.5975639,33.7139636 29.399696,33.5179062 29.1553744,33.5179062",
    id: "Fill-29",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0951291,33.5179062 L31.186759,33.5179062 C30.9426885,33.5179062 30.7448207,33.7139636 30.7448207,33.9560498 C30.7448207,34.1976383 30.9426885,34.3939445 31.186759,34.3939445 L33.0951291,34.3939445 C33.3391996,34.3939445 33.5370674,34.1976383 33.5370674,33.9560498 C33.5370674,33.7139636 33.3391996,33.5179062 33.0951291,33.5179062",
    id: "Fill-31",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-33",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "49.4587744 0.124501435 56.8127789 0.124501435 56.8127789 6.84046316"
  }))));
};
var ImgLock = function ImgLock(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    id: "/imgLock",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(23.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8715,47.17105 C45.1395,45.98105 46.3215,45.23355 47.5115,45.5013 C48.7015,45.76955 49.44925,46.9513 49.18125,48.14155 C48.91325,49.33155 47.73125,50.07905 46.54125,49.8113 C45.351,49.54305 44.6035,48.3613 44.8715,47.17105 Z",
    id: "Stroke-1",
    stroke: "#AEEDFC",
    strokeWidth: "0.625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.75005,49.4628 C44.2358,50.38105 45.10505,51.08955 46.19805,51.33555 C48.1828,51.7823 50.15405,50.5358 50.6008,48.55105 C50.9638,46.93855 49.8343,45.2103 48.4743,44.42605 L51.0053,33.1143 L52.27355,33.4158 C52.4618,33.45805 52.65055,33.3388 52.6928,33.15055 L53.3963,30.09605 C53.43855,29.9078 53.3193,29.71905 53.13105,29.6768 L51.86305,29.37555 L52.09405,28.3488 C52.13655,28.16055 52.01705,27.9718 51.8288,27.92955 L51.1243,27.72705 C50.93605,27.6848 50.7473,27.8038 50.70505,27.99205 L47.0853,44.0693 C46.4968,44.11655 45.56105,44.3053 45.0713,44.6078",
    id: "Stroke-3",
    stroke: "#AEEDFC",
    strokeWidth: "0.625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1137,52.23575 C10.1277,52.23575 5.20695,50.19 5.20695,47.204 L5.20695,22.2435 C5.20695,19.2575 7.2527,16.96175 10.2387,16.96175 L7.8207,18.79175 L7.23745,24.12525 L7.3207,47.2085 L8.8207,50.04175 L10.98745,51.12525 L13.3207,51.7085 L13.98745,51.54175 L13.1137,52.23575 Z",
    id: "Fill-5",
    fill: "#AEEDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.731,51.61075 L12.73875,51.61075 C9.7525,51.61075 7.332,49.19 7.332,46.204 L7.332,21.2435 C7.332,18.2575 9.7525,15.83675 12.73875,15.83675 L39.731,15.83675 C42.717,15.83675 45.13775,18.2575 45.13775,21.2435 L45.13775,46.204 C45.13775,49.19 42.717,51.61075 39.731,51.61075 Z",
    id: "Stroke-7",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "22.508225",
    y1: "48.17275",
    x2: "29.961475",
    y2: "48.17275",
    id: "Stroke-9",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.368325,54.98525 L8.070825,54.98525 L8.070825,53.688 C8.070825,53.42 7.851825,53.20125 7.584075,53.20125 C7.316575,53.20125 7.097575,53.42 7.097575,53.688 L7.097575,54.98525 L5.800075,54.98525 C5.532575,54.98525 5.313575,55.20425 5.313575,55.47175 C5.313575,55.7395 5.532575,55.9585 5.800075,55.9585 L7.097575,55.9585 L7.097575,57.256 C7.097575,57.5235 7.316575,57.7425 7.584075,57.7425 C7.851825,57.7425 8.070825,57.5235 8.070825,57.256 L8.070825,55.9585 L9.368325,55.9585 C9.635825,55.9585 9.854825,55.7395 9.854825,55.47175 C9.854825,55.20425 9.635825,54.98525 9.368325,54.98525",
    id: "Fill-11",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.893975,55.5536 C0.768475,55.0446 1.093725,54.52685 1.620475,54.39685 C2.147225,54.2671 2.675975,54.5746 2.801225,55.0836 C2.926725,55.5926 2.601475,56.1106 2.074725,56.24035 C1.547975,56.3701 1.019225,56.0626 0.893975,55.5536",
    id: "Fill-13",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5e-05,51.42055 L5e-05,49.4743 C5e-05,49.30355 0.18455,49.19705 0.3323,49.2823 L2.01805,50.25555 L3.70355,51.22855 C3.8513,51.3138 3.8513,51.5273 3.70355,51.61255 L2.01805,52.58555 L0.3323,53.5588 C0.18455,53.6443 5e-05,53.53755 5e-05,53.3668 L5e-05,51.42055 Z",
    id: "Fill-15",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5678,5.057275 L6.90855,5.057275 C6.84855,3.737525 6.86605,1.770775 7.7303,0.955275 C8.30855,0.409525 9.1093,0.365775 9.8388,0.469025 C10.0663,0.501275 10.29805,0.547775 10.49705,0.684025 C11.1093,1.103025 11.15505,1.697275 11.12505,2.543525 C11.27705,1.716025 11.94155,1.019525 12.64205,1.106025 C13.3428,1.192775 13.88855,2.202025 13.5708,2.958275 C13.98705,2.439775 14.78005,2.670525 15.12305,3.261775 C15.46605,3.853275 15.45505,4.503025 15.3208,5.205775 L17.0788,5.205775",
    id: "Stroke-17",
    stroke: "#AEEDFC",
    strokeWidth: "0.625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.030575,53.85415 L44.577325,53.85415 L44.577325,52.40115 C44.577325,52.10115 44.332075,51.85615 44.032325,51.85615 C43.732825,51.85615 43.487575,52.10115 43.487575,52.40115 L43.487575,53.85415 L42.034325,53.85415 C41.734575,53.85415 41.489325,54.0994 41.489325,54.3994 C41.489325,54.6989 41.734575,54.94415 42.034325,54.94415 L43.487575,54.94415 L43.487575,56.3974 C43.487575,56.69715 43.732825,56.9424 44.032325,56.9424 C44.332075,56.9424 44.577325,56.69715 44.577325,56.3974 L44.577325,54.94415 L46.030575,54.94415 C46.330325,54.94415 46.575575,54.6989 46.575575,54.3994 C46.575575,54.0994 46.330325,53.85415 46.030575,53.85415",
    id: "Fill-19",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11345,13.4037 L6.11345,11.45745 C6.11345,11.2867 6.29795,11.1802 6.4457,11.26545 L8.13145,12.2387 L9.81695,13.2117 C9.9647,13.29695 9.9647,13.51045 9.81695,13.5957 L8.13145,14.5687 L6.4457,15.54195 C6.29795,15.62745 6.11345,15.5207 6.11345,15.34995 L6.11345,13.4037 Z",
    id: "Fill-21",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.037025,11.0978 C9.873525,10.43505 10.297275,9.7603 10.983275,9.5913 C11.669275,9.4223 12.357775,9.82255 12.521275,10.4858 C12.684525,11.14855 12.261025,11.82305 11.574775,11.99205 C10.888775,12.1613 10.200275,11.7608 10.037025,11.0978",
    id: "Fill-23",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.23845,11.325825 L40.23845,9.379575 C40.23845,9.208825 40.42295,9.102075 40.5707,9.187575 L42.25645,10.160825 L43.94195,11.133825 C44.0897,11.219075 44.0897,11.432575 43.94195,11.517825 L42.25645,12.490825 L40.5707,13.464075 C40.42295,13.549575 40.23845,13.442825 40.23845,13.272075 L40.23845,11.325825 Z",
    id: "Fill-25",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.130675,15.315575 L15.130675,11.291575 C15.130675,5.124575 20.130175,0.125075 26.297425,0.125075 C32.464425,0.125075 37.463925,5.124575 37.463925,11.291575 L37.463925,15.291575",
    id: "Stroke-27",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.63165,15.315575 L17.63165,11.970825 C17.63165,6.908325 21.5114,2.804575 26.2974,2.804575 C31.0834,2.804575 34.96315,6.908325 34.96315,11.970825 L34.96315,15.291575",
    id: "Stroke-29",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2741,30.91495 C28.27385,30.9132 28.27335,30.91145 28.2731,30.9097 C29.49435,30.20395 30.3181,28.8872 30.3181,27.3752 C30.3181,25.11995 28.4901,23.2917 26.23485,23.2917 C23.9796,23.2917 22.1516,25.11995 22.1516,27.3752 C22.1516,28.8872 22.9756,30.20395 24.19685,30.9097 C24.1966,30.91145 24.19585,30.9132 24.1956,30.91495 L22.62985,41.44445 C22.52885,42.12395 23.02335,42.73845 23.6711,42.73845 L28.7986,42.73845 C29.44635,42.73845 29.94085,42.12395 29.8401,41.44445 L28.2741,30.91495 Z",
    id: "Fill-31",
    fill: "#00B3DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2741,30.91495 C28.27385,30.9132 28.27335,30.91145 28.2731,30.9097 C29.49435,30.20395 30.3181,28.8872 30.3181,27.3752 C30.3181,25.11995 28.4901,23.2917 26.23485,23.2917 C23.9796,23.2917 22.1516,25.11995 22.1516,27.3752 C22.1516,28.8872 22.9756,30.20395 24.19685,30.9097 C24.1966,30.91145 24.19585,30.9132 24.1956,30.91495 L22.62985,41.44445 C22.52885,42.12395 23.02335,42.73845 23.6711,42.73845 L28.7986,42.73845 C29.44635,42.73845 29.94085,42.12395 29.8401,41.44445 L28.2741,30.91495 Z",
    id: "Stroke-33",
    stroke: "#2C3B45",
    strokeWidth: "1.5"
  }))));
};
var ImgLogin = function ImgLogin(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0928 0.11815 2.55705 0.11815 2.55705 2.5 0.0928 2.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.007075 0.10765 3.5965 0.10765 3.5965 3.6974 0.007075 3.6974"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0.117125 0.2075 3.6981875 0.2075 3.6981875 4.27876043 0.117125 4.27876043"
  })), /*#__PURE__*/React.createElement("g", {
    id: "/imgLogin",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-62",
    transform: "translate(24.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.12615,29.27205 L14.71565,29.27205 C13.3814,29.27205 12.2999,28.6823 12.2999,27.9548 L12.2999,3.88355 C12.2999,3.15605 13.3814,2.56655 14.71565,2.56655 L38.12615,2.56655 C38.45015,2.56655 38.75915,2.60105 39.04165,2.6643 C39.9219,2.8608 40.5419,3.3328 40.5419,3.88355 L40.5419,27.9548 C40.5419,28.6823 39.46015,29.27205 38.12615,29.27205",
    id: "Fill-1",
    fill: "#00B3DB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(14.750000, 54.542500)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.55705,1.30915 C2.55705,1.9669 2.00555,2.50015 1.3248,2.50015 C0.64455,2.50015 0.0928,1.9669 0.0928,1.30915 C0.0928,0.6514 0.64455,0.11815 1.3248,0.11815 C2.00555,0.11815 2.55705,0.6514 2.55705,1.30915",
    id: "Fill-3",
    fill: "#E2F8FE",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.702075,14.938825 C7.702075,15.596575 7.150575,16.129575 6.469825,16.129575 C5.789575,16.129575 5.237825,15.596575 5.237825,14.938825 C5.237825,14.281075 5.789575,13.747825 6.469825,13.747825 C7.150575,13.747825 7.702075,14.281075 7.702075,14.938825",
    id: "Fill-6",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(47.000000, 43.542500)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.212075,1.5179 L2.186325,1.5179 L2.186325,0.49215 C2.186325,0.2809 2.013325,0.10765 1.801825,0.10765 C1.590325,0.10765 1.417075,0.2809 1.417075,0.49215 L1.417075,1.5179 L0.391575,1.5179 C0.180075,1.5179 0.007075,1.6909 0.007075,1.9024 C0.007075,2.11415 0.180075,2.28715 0.391575,2.28715 L1.417075,2.28715 L1.417075,3.31265 C1.417075,3.52415 1.590325,3.6974 1.801825,3.6974 C2.013325,3.6974 2.186325,3.52415 2.186325,3.31265 L2.186325,2.28715 L3.212075,2.28715 C3.423575,2.28715 3.596575,2.11415 3.596575,1.9024 C3.596575,1.6909 3.423575,1.5179 3.212075,1.5179",
    id: "Fill-8",
    fill: "#E2F8FE",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M44.367125,52.5355 L44.367125,50.70825 C44.367125,50.54825 44.540375,50.448 44.679125,50.52825 L46.261625,51.44175 L47.844125,52.3555 C47.982875,52.4355 47.982875,52.6355 47.844125,52.71575 L46.261625,53.6295 L44.679125,54.543 C44.540375,54.62325 44.367125,54.523 44.367125,54.363 L44.367125,52.5355 Z",
    id: "Fill-11",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(43.000000, 0.042500)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.117125,2.243 L0.117125,0.41575 C0.117125,0.25575 0.290375,0.1555 0.429125,0.23575 L2.011625,1.14925 L3.594125,2.063 C3.732875,2.143 3.732875,2.343 3.594125,2.42325 L2.011625,3.337 L0.429125,4.2505 C0.290375,4.33075 0.117125,4.2305 0.117125,4.0705 L0.117125,2.243 Z",
    id: "Fill-13",
    fill: "#E2F8FE",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.658625,49.434175 C12.658625,50.768425 20.440125,51.509175 19.105875,51.509175 L11.548875,51.509175 C10.214625,51.509175 9.132875,50.427675 9.132875,49.093425 L9.132875,5.407925 C9.132875,4.073675 10.214625,2.991925 11.548875,2.991925 L12.799375,2.991925 L12.658625,49.434175 Z",
    id: "Fill-16",
    fill: "#AEEDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.56145,46.767675 C44.56145,47.315675 44.1017,47.760175 43.5347,47.760175 C42.96745,47.760175 42.5077,47.315675 42.5077,46.767675 C42.5077,46.219675 42.96745,45.775175 43.5347,45.775175 C44.1017,45.775175 44.56145,46.219675 44.56145,46.767675",
    id: "Fill-18",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.33025,11.2645 C5.33025,11.8125 4.8705,12.25675 4.3035,12.25675 C3.73625,12.25675 3.2765,11.8125 3.2765,11.2645 C3.2765,10.7165 3.73625,10.272 4.3035,10.272 C4.8705,10.272 5.33025,10.7165 5.33025,11.2645",
    id: "Fill-20",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8593,41.613125 L3.2033,42.883375 L1.93305,41.227375 C1.67105,40.886125 1.1773,40.820875 0.8358,41.082875 C0.4943,41.344875 0.42905,41.838625 0.69105,42.180375 L1.9613,43.836125 L0.3053,45.106375 C-0.03595,45.368375 -0.1012,45.861875 0.1608,46.203375 C0.4228,46.545125 0.91655,46.610125 1.25805,46.348125 L2.91405,45.077875 L4.1843,46.733875 C4.4463,47.075625 4.9398,47.140375 5.2813,46.878625 C5.62305,46.616625 5.68805,46.122875 5.4263,45.781375 L4.15605,44.125375 L5.81205,42.855125 C6.1533,42.593125 6.21855,42.099375 5.95655,41.757875 C5.69455,41.416375 5.20055,41.351125 4.8593,41.613125",
    id: "Fill-22",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.185475,50.8873 L14.775225,50.8873 C13.440975,50.8873 12.359475,49.8058 12.359475,48.47155 L12.359475,4.3273 C12.359475,2.9933 13.440975,1.91155 14.775225,1.91155 L38.185475,1.91155 C38.509725,1.91155 38.818725,1.97555 39.101225,2.09105 C39.981475,2.45205 40.601225,3.3173 40.601225,4.3273 L40.601225,48.47155 C40.601225,49.8058 39.519725,50.8873 38.185475,50.8873 Z",
    id: "Stroke-24",
    stroke: "#2C3B45",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "18.322925",
    y1: "5.871175",
    x2: "34.637925",
    y2: "5.871175",
    id: "Stroke-26",
    stroke: "#2C3B45",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "20.902275",
    y1: "21.412925",
    x2: "21.248775",
    y2: "21.412925",
    id: "Stroke-28",
    stroke: "#2C3B45",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "24.46575",
    y1: "21.412925",
    x2: "24.8125",
    y2: "21.412925",
    id: "Stroke-30",
    stroke: "#2C3B45",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "28.029475",
    y1: "21.412925",
    x2: "28.375975",
    y2: "21.412925",
    id: "Stroke-32",
    stroke: "#2C3B45",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "31.5932",
    y1: "21.412925",
    x2: "31.9397",
    y2: "21.412925",
    id: "Stroke-34",
    stroke: "#2C3B45",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "26.43915",
    y1: "46.88485",
    x2: "26.52165",
    y2: "46.88485",
    id: "Stroke-36",
    stroke: "#2C3B45",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "43.5175",
    y1: "31.30405",
    x2: "43.5175",
    y2: "42.78905",
    id: "Stroke-38",
    stroke: "#2C3B45",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.68865,33.493 C25.2264,33.246 25.85565,33.12075 26.5584,33.12075 C27.25665,33.12075 27.8859,33.246 28.42915,33.4935 C28.45515,33.5055 28.48315,33.511 28.5099,33.511 C28.58415,33.511 28.65515,33.46825 28.6879,33.3965 C28.7324,33.29875 28.68915,33.18275 28.59115,33.13825 C27.99665,32.86775 27.3129,32.73025 26.5584,32.73025 C25.79865,32.73025 25.1144,32.86775 24.52565,33.1385 C24.4279,33.1835 24.3849,33.2995 24.4299,33.39725 C24.47515,33.495 24.59015,33.538 24.68865,33.493",
    id: "Fill-40",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9655,35.01425 C24.68475,34.286 25.581,33.90125 26.55775,33.90125 C27.5385,33.90125 28.43575,34.286 29.1515,35.014 C29.18975,35.0525 29.24025,35.072 29.2905,35.072 C29.33975,35.072 29.38925,35.05325 29.4275,35.016 C29.50425,34.94025 29.5055,34.817 29.42975,34.74 C28.63875,33.936 27.6455,33.511 26.55775,33.511 C25.47425,33.511 24.48175,33.936 23.688,34.7395 C23.61225,34.8165 23.613,34.94025 23.6895,35.016 C23.7665,35.09175 23.88975,35.0905 23.9655,35.01425",
    id: "Fill-42",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5578,34.2916 C26.27955,34.2916 26.00305,34.32585 25.7363,34.39385 C25.63155,34.42035 25.5683,34.52635 25.5948,34.6311 C25.62155,34.7356 25.72855,34.7981 25.8323,34.7721 C26.06755,34.71235 26.31205,34.68185 26.5578,34.68185 C28.17205,34.68185 29.4848,35.9946 29.4848,37.6091 C29.4848,37.7166 29.57255,37.8041 29.68005,37.8041 C29.7878,37.8041 29.8753,37.7166 29.8753,37.6091 C29.8753,35.7796 28.38705,34.2916 26.5578,34.2916",
    id: "Fill-44",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.631525,37.61215 C23.644025,36.8239 23.946025,36.09115 24.482525,35.54865 C24.665275,35.36365 24.869275,35.20515 25.089025,35.07665 C25.182025,35.02265 25.213275,34.90315 25.158775,34.8099 C25.105275,34.7174 24.986025,34.68565 24.892025,34.74015 C24.643025,34.88565 24.411525,35.0654 24.205025,35.27465 C23.597275,35.8889 23.255025,36.7169 23.2410056,37.6064 C23.239525,37.7139 23.325275,37.80265 23.433525,37.80415 L23.436775,37.80415 C23.543025,37.80415 23.629775,37.71915 23.631525,37.61215",
    id: "Fill-46",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.41155,37.657075 C24.41155,37.059325 24.6338,36.506075 25.03755,36.097825 C25.4428,35.688075 25.98205,35.462575 26.5578,35.462575 C27.1773,35.462575 27.7673,35.731325 28.17605,36.200575 C28.24655,36.281575 28.3703,36.289825 28.4513,36.219075 C28.53255,36.148075 28.5408,36.024825 28.47005,35.943575 C27.98705,35.389825 27.29005,35.072075 26.5578,35.072075 C25.87705,35.072075 25.23905,35.339075 24.76055,35.823325 C24.28355,36.305075 24.0213,36.956325 24.0213,37.667075 C24.0223,38.087075 23.8913,38.590325 23.6563,39.074075 L23.5468,39.269075 C23.49405,39.363325 23.5273,39.482075 23.6213,39.535075 C23.6518,39.552075 23.68455,39.560325 23.71705,39.560325 C23.78505,39.560325 23.85155,39.524575 23.88705,39.460825 L24.00205,39.255825 C24.2718,38.700575 24.4133,38.151075 24.41155,37.657075",
    id: "Fill-48",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.237475,39.138525 C29.113725,38.573775 29.103225,38.034775 29.096725,37.712525 L29.094725,37.609025 C29.094725,37.319775 29.045725,37.035775 28.949975,36.764525 C28.913975,36.663025 28.803475,36.610025 28.700975,36.645775 C28.599225,36.681775 28.546225,36.792775 28.582225,36.894775 C28.663225,37.123775 28.704225,37.364275 28.704225,37.614025 L28.706725,37.720275 C28.713725,38.056775 28.724475,38.619775 28.860475,39.237025 L29.083725,39.972275 C29.108975,40.056525 29.186725,40.110275 29.270725,40.110275 C29.289475,40.110275 29.308475,40.107525 29.327475,40.102025 C29.430475,40.070525 29.488725,39.962025 29.457725,39.858525 L29.237475,39.138525 Z",
    id: "Fill-50",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.706725,40.17905 C28.384725,39.1738 28.324725,38.0433 28.314225,37.60905 C28.314225,36.6408 27.525975,35.85255 26.557725,35.85255 C25.589475,35.85255 24.801975,36.6528 24.801975,37.6428 C24.802725,37.8483 24.764725,38.9328 23.940725,40.1218 C23.878725,40.2103 23.900975,40.3318 23.989225,40.39305 C24.077475,40.45455 24.199725,40.4328 24.260975,40.34455 C25.129725,39.09205 25.193225,37.95905 25.191975,37.63655 C25.191975,36.8683 25.804975,36.2433 26.557725,36.2433 C27.310975,36.2433 27.923725,36.85605 27.923725,37.61405 C27.937975,38.1808 28.009975,39.2828 28.334725,40.2973 L28.514975,40.87605 C28.541225,40.95955 28.618225,41.01305 28.701475,41.01305 C28.720725,41.01305 28.740225,41.0103 28.759725,41.00455 C28.862725,40.97205 28.920225,40.8628 28.888225,40.76005 L28.706725,40.17905 Z",
    id: "Fill-52",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.533375,37.608975 C27.533375,37.071225 27.095625,36.633225 26.557875,36.633225 C26.019875,36.633225 25.581875,37.071225 25.581875,37.616225 C25.584375,37.680725 25.627625,39.213725 24.388125,40.826975 C24.322625,40.912475 24.338625,41.034975 24.423875,41.100475 C24.509875,41.166225 24.632125,41.149725 24.697625,41.064475 C26.021875,39.341225 25.974375,37.671725 25.971875,37.608975 C25.971875,37.286225 26.234625,37.023475 26.557375,37.023475 C26.880125,37.023475 27.142875,37.286225 27.143125,37.613475 C27.148625,37.831975 27.149875,39.803475 25.626125,41.782975 C25.560375,41.868475 25.576125,41.990975 25.661625,42.056725 C25.697625,42.083975 25.739375,42.097225 25.780625,42.097225 C25.839375,42.097225 25.896875,42.071225 25.935125,42.020975 C27.543625,39.932475 27.538875,37.836475 27.533375,37.608975",
    id: "Fill-54",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.462575,38.581625 C26.473075,38.583125 26.483575,38.583875 26.493825,38.583875 C26.587825,38.583875 26.670825,38.515625 26.686325,38.420125 C26.765825,37.924625 26.752825,37.613375 26.752075,37.600375 C26.747075,37.493125 26.662825,37.407625 26.548825,37.414125 C26.441575,37.418875 26.357825,37.509875 26.362325,37.617625 C26.362325,37.620125 26.373325,37.906125 26.300575,38.357625 C26.283825,38.464125 26.356325,38.564375 26.462575,38.581625",
    id: "Fill-56",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.369325,38.988625 C26.265575,38.957875 26.157325,39.017125 26.126325,39.120125 C25.882575,39.943875 25.476825,40.714375 24.920825,41.410625 C24.853825,41.494875 24.867325,41.617625 24.951825,41.685125 C24.987825,41.713875 25.030825,41.727625 25.073325,41.727625 C25.130825,41.727625 25.187325,41.702625 25.226075,41.654375 C25.813325,40.919125 26.242325,40.103625 26.501075,39.231375 C26.531575,39.128125 26.472575,39.019125 26.369325,38.988625",
    id: "Fill-58",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.025325,40.579425 C27.931575,40.299175 27.844075,40.002925 27.843575,40.001675 C27.820325,39.922675 27.750075,39.866675 27.667575,39.862175 C27.583325,39.856175 27.509075,39.904675 27.477075,39.980675 C27.472575,39.990925 27.037825,41.012925 26.539575,41.797425 C26.481575,41.888425 26.508575,42.009175 26.599575,42.066675 C26.632075,42.087425 26.668075,42.097175 26.704075,42.097175 C26.769075,42.097175 26.831825,42.065175 26.868825,42.006675 C27.170575,41.531925 27.444575,40.985675 27.623325,40.605925 C27.633575,40.637175 27.644075,40.668675 27.654575,40.699925 L27.888325,41.443925 C27.920575,41.546425 28.029325,41.604425 28.133075,41.571675 C28.235575,41.539175 28.292825,41.429675 28.260575,41.326675 L28.025325,40.579425 Z",
    id: "Fill-60",
    fill: "#2C3B45"
  }))));
};
var ImgPincodePhone = function ImgPincodePhone(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.0928 0.11815 2.55705 0.11815 2.55705 2.5 0.0928 2.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.117125 0.2075 3.6981875 0.2075 3.6981875 4.27876043 0.117125 4.27876043"
  })), /*#__PURE__*/React.createElement("g", {
    id: "/imgPincodePhone",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-57",
    transform: "translate(24.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.6242,22.384125 L40.55045,20.174875 C40.28195,20.116125 40.1102,19.847875 40.1692,19.579375 L41.79295,12.175125 C41.8517,11.906625 42.1197,11.734875 42.38845,11.793875 L52.4622,14.003125 C52.7307,14.061875 52.9022,14.329875 52.84345,14.598375 L51.2197,22.002875 C51.1607,22.271375 50.8927,22.442875 50.6242,22.384125 Z",
    id: "Stroke-1",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.183775,13.72275 L51.491025,12.353 L51.473275,12.435 L51.495775,12.3325 C51.920275,10.39675 50.683775,8.4655 48.747775,8.041 L48.256775,7.93325 C46.320775,7.509 44.389525,8.74525 43.965025,10.68125 L43.664525,12.05225",
    id: "Stroke-3",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.999925,13.348225 L50.221675,12.359225 L50.208675,12.418225 L50.224925,12.344475 C50.531425,10.946725 49.707425,9.567225 48.393425,9.279225 L48.060175,9.205975 C46.746425,8.917725 45.420925,9.825975 45.114175,11.223725 L44.897175,12.213725",
    id: "Stroke-5",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.108825,18.901225 L46.108825,18.901225 C45.687075,18.808725 45.419825,18.391475 45.512325,17.969475 L45.913325,16.141475 C46.005825,15.719475 46.423075,15.452475 46.844825,15.544975 C47.266825,15.637475 47.533825,16.054475 47.441325,16.476725 L47.040575,18.304725 C46.947825,18.726725 46.530575,18.993725 46.108825,18.901225 Z",
    id: "Stroke-7",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(14.750000, 57.792500)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.55705,1.30915 C2.55705,1.9669 2.00555,2.50015 1.3248,2.50015 C0.64455,2.50015 0.0928,1.9669 0.0928,1.30915 C0.0928,0.6514 0.64455,0.11815 1.3248,0.11815 C2.00555,0.11815 2.55705,0.6514 2.55705,1.30915",
    id: "Fill-9",
    fill: "#E2F8FE",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.212075,48.3104 L49.186325,48.3104 L49.186325,47.28465 C49.186325,47.0734 49.013325,46.90015 48.801825,46.90015 C48.590325,46.90015 48.417075,47.0734 48.417075,47.28465 L48.417075,48.3104 L47.391575,48.3104 C47.180075,48.3104 47.007075,48.4834 47.007075,48.6949 C47.007075,48.90665 47.180075,49.07965 47.391575,49.07965 L48.417075,49.07965 L48.417075,50.10515 C48.417075,50.31665 48.590325,50.4899 48.801825,50.4899 C49.013325,50.4899 49.186325,50.31665 49.186325,50.10515 L49.186325,49.07965 L50.212075,49.07965 C50.423575,49.07965 50.596575,48.90665 50.596575,48.6949 C50.596575,48.4834 50.423575,48.3104 50.212075,48.3104",
    id: "Fill-12",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.367125,55.7855 L44.367125,53.95825 C44.367125,53.79825 44.540375,53.698 44.679125,53.77825 L46.261625,54.69175 L47.844125,55.6055 C47.982875,55.6855 47.982875,55.8855 47.844125,55.96575 L46.261625,56.8795 L44.679125,57.793 C44.540375,57.87325 44.367125,57.773 44.367125,57.613 L44.367125,55.7855 Z",
    id: "Fill-14",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(5.500000, 0.042500)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.117125,2.243 L0.117125,0.41575 C0.117125,0.25575 0.290375,0.1555 0.429125,0.23575 L2.011625,1.14925 L3.594125,2.063 C3.732875,2.143 3.732875,2.343 3.594125,2.42325 L2.011625,3.337 L0.429125,4.2505 C0.290375,4.33075 0.117125,4.2305 0.117125,4.0705 L0.117125,2.243 Z",
    id: "Fill-16",
    fill: "#E2F8FE",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.658625,52.684175 C12.658625,54.018425 20.440125,54.759175 19.105875,54.759175 L11.548875,54.759175 C10.214625,54.759175 9.132875,53.677675 9.132875,52.343425 L9.132875,8.657925 C9.132875,7.323675 10.214625,6.241925 11.548875,6.241925 L12.799375,6.241925 L12.658625,52.684175 Z",
    id: "Fill-19",
    fill: "#AEEDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.56145,50.017675 C44.56145,50.565675 44.1017,51.010175 43.5347,51.010175 C42.96745,51.010175 42.5077,50.565675 42.5077,50.017675 C42.5077,49.469675 42.96745,49.025175 43.5347,49.025175 C44.1017,49.025175 44.56145,49.469675 44.56145,50.017675",
    id: "Fill-21",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8593,44.863125 L3.2033,46.133375 L1.93305,44.477375 C1.67105,44.136125 1.1773,44.070875 0.8358,44.332875 C0.4943,44.594875 0.42905,45.088625 0.69105,45.430375 L1.9613,47.086125 L0.3053,48.356375 C-0.03595,48.618375 -0.1012,49.111875 0.1608,49.453375 C0.4228,49.795125 0.91655,49.860125 1.25805,49.598125 L2.91405,48.327875 L4.1843,49.983875 C4.4463,50.325625 4.9398,50.390375 5.2813,50.128625 C5.62305,49.866625 5.68805,49.372875 5.4263,49.031375 L4.15605,47.375375 L5.81205,46.105125 C6.1533,45.843125 6.21855,45.349375 5.95655,45.007875 C5.69455,44.666375 5.20055,44.601125 4.8593,44.863125",
    id: "Fill-23",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.185475,54.1373 L14.775225,54.1373 C13.440975,54.1373 12.359475,53.0558 12.359475,51.72155 L12.359475,7.5773 C12.359475,6.2433 13.440975,5.16155 14.775225,5.16155 L38.185475,5.16155 C38.509725,5.16155 38.818725,5.22555 39.101225,5.34105 C39.981475,5.70205 40.601225,6.5673 40.601225,7.5773 L40.601225,51.72155 C40.601225,53.0558 39.519725,54.1373 38.185475,54.1373 Z",
    id: "Stroke-25",
    stroke: "#2C3B45",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "18.322925",
    y1: "9.121175",
    x2: "34.637925",
    y2: "9.121175",
    id: "Stroke-27",
    stroke: "#2C3B45",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "26.43915",
    y1: "50.13485",
    x2: "26.52165",
    y2: "50.13485",
    id: "Stroke-29",
    stroke: "#2C3B45",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "43.5175",
    y1: "34.55405",
    x2: "43.5175",
    y2: "46.03905",
    id: "Stroke-31",
    stroke: "#2C3B45",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.190125,26.82505 C18.348875,26.7518 18.500125,26.67855 18.644125,26.6053 C18.788375,26.53205 18.903125,26.4783 18.988375,26.4443 C19.073875,26.41005 19.142375,26.3928 19.193625,26.3928 C19.278875,26.3928 19.352625,26.4218 19.414875,26.47905 C19.477125,26.53655 19.508375,26.6078 19.508375,26.6933 C19.508375,26.74205 19.493125,26.7928 19.462625,26.8453 C19.432125,26.8978 19.399875,26.9313 19.365625,26.9458 C19.050625,27.0703 18.704125,27.1608 18.325625,27.2168 C18.393875,27.2803 18.478125,27.36455 18.578375,27.46955 C18.678375,27.57455 18.730875,27.6308 18.735875,27.63805 C18.772375,27.6893 18.823625,27.7528 18.889625,27.82855 C18.955625,27.90405 19.001125,27.96355 19.026875,28.00605 C19.052375,28.04905 19.065375,28.1008 19.065375,28.1618 C19.065375,28.2398 19.036125,28.3083 18.977375,28.3668 C18.918875,28.4253 18.843125,28.4548 18.750375,28.4548 C18.657625,28.4548 18.553125,28.38255 18.437125,28.23855 C18.321125,28.09455 18.171875,27.8358 17.988625,27.4623 C17.803125,27.79905 17.678625,28.0213 17.615125,28.1288 C17.551625,28.2363 17.490625,28.31755 17.432125,28.37205 C17.373375,28.4273 17.306375,28.4548 17.230625,28.4548 C17.140375,28.4548 17.065125,28.42355 17.005375,28.3613 C16.945375,28.2988 16.915625,28.23255 16.915625,28.1618 C16.915625,28.0958 16.927875,28.0458 16.952375,28.01155 C17.176875,27.7063 17.411375,27.44155 17.655375,27.2168 C17.450375,27.18505 17.267375,27.1498 17.106125,27.1108 C16.945125,27.07155 16.774125,27.0143 16.593375,26.93855 C16.564125,26.92405 16.535375,26.89055 16.507375,26.83805 C16.479125,26.78555 16.465375,26.73705 16.465375,26.6933 C16.465375,26.6078 16.496375,26.53655 16.558625,26.47905 C16.620875,26.4218 16.692375,26.3928 16.772875,26.3928 C16.831375,26.3928 16.904625,26.4108 16.992625,26.4458 C17.080625,26.48155 17.192125,26.5328 17.327625,26.5998 C17.463125,26.66705 17.617625,26.74205 17.790875,26.82505 C17.759125,26.6713 17.732875,26.49505 17.712125,26.29605 C17.691375,26.09705 17.681125,25.9608 17.681125,25.88755 C17.681125,25.7973 17.709625,25.7198 17.767125,25.6548 C17.824375,25.59055 17.898375,25.55805 17.988625,25.55805 C18.076625,25.55805 18.149125,25.59055 18.206375,25.6548 C18.263875,25.7198 18.292625,25.8058 18.292625,25.9133 C18.292625,25.94255 18.288375,26.00055 18.279625,26.08705 C18.271125,26.17405 18.258875,26.2788 18.243125,26.40205 C18.227125,26.52555 18.209625,26.6663 18.190125,26.82505",
    id: "Fill-33",
    fill: "#2E3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.190125,26.82505 C18.348875,26.7518 18.500125,26.67855 18.644125,26.6053 C18.788375,26.53205 18.903125,26.4783 18.988375,26.4443 C19.073875,26.41005 19.142375,26.3928 19.193625,26.3928 C19.278875,26.3928 19.352625,26.4218 19.414875,26.47905 C19.477125,26.53655 19.508375,26.6078 19.508375,26.6933 C19.508375,26.74205 19.493125,26.7928 19.462625,26.8453 C19.432125,26.8978 19.399875,26.9313 19.365625,26.9458 C19.050625,27.0703 18.704125,27.1608 18.325625,27.2168 C18.393875,27.2803 18.478125,27.36455 18.578375,27.46955 C18.678375,27.57455 18.730875,27.6308 18.735875,27.63805 C18.772375,27.6893 18.823625,27.7528 18.889625,27.82855 C18.955625,27.90405 19.001125,27.96355 19.026875,28.00605 C19.052375,28.04905 19.065375,28.1008 19.065375,28.1618 C19.065375,28.2398 19.036125,28.3083 18.977375,28.3668 C18.918875,28.4253 18.843125,28.4548 18.750375,28.4548 C18.657625,28.4548 18.553125,28.38255 18.437125,28.23855 C18.321125,28.09455 18.171875,27.8358 17.988625,27.4623 C17.803125,27.79905 17.678625,28.0213 17.615125,28.1288 C17.551625,28.2363 17.490625,28.31755 17.432125,28.37205 C17.373375,28.4273 17.306375,28.4548 17.230625,28.4548 C17.140375,28.4548 17.065125,28.42355 17.005375,28.3613 C16.945375,28.2988 16.915625,28.23255 16.915625,28.1618 C16.915625,28.0958 16.927875,28.0458 16.952375,28.01155 C17.176875,27.7063 17.411375,27.44155 17.655375,27.2168 C17.450375,27.18505 17.267375,27.1498 17.106125,27.1108 C16.945125,27.07155 16.774125,27.0143 16.593375,26.93855 C16.564125,26.92405 16.535375,26.89055 16.507375,26.83805 C16.479125,26.78555 16.465375,26.73705 16.465375,26.6933 C16.465375,26.6078 16.496375,26.53655 16.558625,26.47905 C16.620875,26.4218 16.692375,26.3928 16.772875,26.3928 C16.831375,26.3928 16.904625,26.4108 16.992625,26.4458 C17.080625,26.48155 17.192125,26.5328 17.327625,26.5998 C17.463125,26.66705 17.617625,26.74205 17.790875,26.82505 C17.759125,26.6713 17.732875,26.49505 17.712125,26.29605 C17.691375,26.09705 17.681125,25.9608 17.681125,25.88755 C17.681125,25.7973 17.709625,25.7198 17.767125,25.6548 C17.824375,25.59055 17.898375,25.55805 17.988625,25.55805 C18.076625,25.55805 18.149125,25.59055 18.206375,25.6548 C18.263875,25.7198 18.292625,25.8058 18.292625,25.9133 C18.292625,25.94255 18.288375,26.00055 18.279625,26.08705 C18.271125,26.17405 18.258875,26.2788 18.243125,26.40205 C18.227125,26.52555 18.209625,26.6663 18.190125,26.82505 Z",
    id: "Stroke-35",
    stroke: "#2C3B45",
    strokeWidth: "0.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.999925,26.82505 C24.158675,26.7518 24.309925,26.67855 24.453925,26.6053 C24.598175,26.53205 24.712925,26.4783 24.798175,26.4443 C24.883675,26.41005 24.952175,26.3928 25.003425,26.3928 C25.088675,26.3928 25.162675,26.4218 25.224925,26.47905 C25.287175,26.53655 25.318175,26.6078 25.318175,26.6933 C25.318175,26.74205 25.303175,26.7928 25.272675,26.8453 C25.242175,26.8978 25.209675,26.9313 25.175425,26.9458 C24.860425,27.0703 24.513925,27.1608 24.135425,27.2168 C24.203675,27.2803 24.287925,27.36455 24.388175,27.46955 C24.488175,27.57455 24.540675,27.6308 24.545675,27.63805 C24.582175,27.6893 24.633425,27.7528 24.699425,27.82855 C24.765425,27.90405 24.811175,27.96355 24.836925,28.00605 C24.862425,28.04905 24.875175,28.1008 24.875175,28.1618 C24.875175,28.2398 24.845925,28.3083 24.787175,28.3668 C24.728675,28.4253 24.652925,28.4548 24.560175,28.4548 C24.467425,28.4548 24.363175,28.38255 24.247175,28.23855 C24.131175,28.09455 23.981675,27.8358 23.798425,27.4623 C23.612925,27.79905 23.488425,28.0213 23.424925,28.1288 C23.361425,28.2363 23.300425,28.31755 23.241925,28.37205 C23.183175,28.4273 23.116175,28.4548 23.040425,28.4548 C22.950175,28.4548 22.875175,28.42355 22.815425,28.3613 C22.755425,28.2988 22.725425,28.23255 22.725425,28.1618 C22.725425,28.0958 22.737675,28.0458 22.762175,28.01155 C22.986675,27.7063 23.221175,27.44155 23.465175,27.2168 C23.260175,27.18505 23.077175,27.1498 22.915925,27.1108 C22.754925,27.07155 22.583925,27.0143 22.403175,26.93855 C22.373925,26.92405 22.345425,26.89055 22.317425,26.83805 C22.289175,26.78555 22.275175,26.73705 22.275175,26.6933 C22.275175,26.6078 22.306425,26.53655 22.368675,26.47905 C22.430925,26.4218 22.502175,26.3928 22.582675,26.3928 C22.641175,26.3928 22.714425,26.4108 22.802425,26.4458 C22.890425,26.48155 23.002175,26.5328 23.137675,26.5998 C23.273175,26.66705 23.427425,26.74205 23.600675,26.82505 C23.568925,26.6713 23.542925,26.49505 23.522175,26.29605 C23.501425,26.09705 23.490925,25.9608 23.490925,25.88755 C23.490925,25.7973 23.519675,25.7198 23.577175,25.6548 C23.634425,25.59055 23.708175,25.55805 23.798425,25.55805 C23.886425,25.55805 23.959175,25.59055 24.016425,25.6548 C24.073925,25.7198 24.102425,25.8058 24.102425,25.9133 C24.102425,25.94255 24.098425,26.00055 24.089675,26.08705 C24.081175,26.17405 24.068925,26.2788 24.053175,26.40205 C24.037175,26.52555 24.019425,26.6663 23.999925,26.82505",
    id: "Fill-37",
    fill: "#2E3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.999925,26.82505 C24.158675,26.7518 24.309925,26.67855 24.453925,26.6053 C24.598175,26.53205 24.712925,26.4783 24.798175,26.4443 C24.883675,26.41005 24.952175,26.3928 25.003425,26.3928 C25.088675,26.3928 25.162675,26.4218 25.224925,26.47905 C25.287175,26.53655 25.318175,26.6078 25.318175,26.6933 C25.318175,26.74205 25.303175,26.7928 25.272675,26.8453 C25.242175,26.8978 25.209675,26.9313 25.175425,26.9458 C24.860425,27.0703 24.513925,27.1608 24.135425,27.2168 C24.203675,27.2803 24.287925,27.36455 24.388175,27.46955 C24.488175,27.57455 24.540675,27.6308 24.545675,27.63805 C24.582175,27.6893 24.633425,27.7528 24.699425,27.82855 C24.765425,27.90405 24.811175,27.96355 24.836925,28.00605 C24.862425,28.04905 24.875175,28.1008 24.875175,28.1618 C24.875175,28.2398 24.845925,28.3083 24.787175,28.3668 C24.728675,28.4253 24.652925,28.4548 24.560175,28.4548 C24.467425,28.4548 24.363175,28.38255 24.247175,28.23855 C24.131175,28.09455 23.981675,27.8358 23.798425,27.4623 C23.612925,27.79905 23.488425,28.0213 23.424925,28.1288 C23.361425,28.2363 23.300425,28.31755 23.241925,28.37205 C23.183175,28.4273 23.116175,28.4548 23.040425,28.4548 C22.950175,28.4548 22.875175,28.42355 22.815425,28.3613 C22.755425,28.2988 22.725425,28.23255 22.725425,28.1618 C22.725425,28.0958 22.737675,28.0458 22.762175,28.01155 C22.986675,27.7063 23.221175,27.44155 23.465175,27.2168 C23.260175,27.18505 23.077175,27.1498 22.915925,27.1108 C22.754925,27.07155 22.583925,27.0143 22.403175,26.93855 C22.373925,26.92405 22.345425,26.89055 22.317425,26.83805 C22.289175,26.78555 22.275175,26.73705 22.275175,26.6933 C22.275175,26.6078 22.306425,26.53655 22.368675,26.47905 C22.430925,26.4218 22.502175,26.3928 22.582675,26.3928 C22.641175,26.3928 22.714425,26.4108 22.802425,26.4458 C22.890425,26.48155 23.002175,26.5328 23.137675,26.5998 C23.273175,26.66705 23.427425,26.74205 23.600675,26.82505 C23.568925,26.6713 23.542925,26.49505 23.522175,26.29605 C23.501425,26.09705 23.490925,25.9608 23.490925,25.88755 C23.490925,25.7973 23.519675,25.7198 23.577175,25.6548 C23.634425,25.59055 23.708175,25.55805 23.798425,25.55805 C23.886425,25.55805 23.959175,25.59055 24.016425,25.6548 C24.073925,25.7198 24.102425,25.8058 24.102425,25.9133 C24.102425,25.94255 24.098425,26.00055 24.089675,26.08705 C24.081175,26.17405 24.068925,26.2788 24.053175,26.40205 C24.037175,26.52555 24.019425,26.6663 23.999925,26.82505 Z",
    id: "Stroke-39",
    stroke: "#2C3B45",
    strokeWidth: "0.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.81,26.82505 C29.96875,26.7518 30.12,26.67855 30.264,26.6053 C30.40825,26.53205 30.523,26.4783 30.60825,26.4443 C30.69375,26.41005 30.76225,26.3928 30.8135,26.3928 C30.89875,26.3928 30.9725,26.4218 31.03475,26.47905 C31.097,26.53655 31.12825,26.6078 31.12825,26.6933 C31.12825,26.74205 31.113,26.7928 31.0825,26.8453 C31.052,26.8978 31.01975,26.9313 30.9855,26.9458 C30.6705,27.0703 30.324,27.1608 29.9455,27.2168 C30.01375,27.2803 30.098,27.36455 30.19825,27.46955 C30.29825,27.57455 30.35075,27.6308 30.35575,27.63805 C30.39225,27.6893 30.4435,27.7528 30.5095,27.82855 C30.5755,27.90405 30.621,27.96355 30.64675,28.00605 C30.67225,28.04905 30.68525,28.1008 30.68525,28.1618 C30.68525,28.2398 30.656,28.3083 30.59725,28.3668 C30.53875,28.4253 30.463,28.4548 30.37025,28.4548 C30.2775,28.4548 30.173,28.38255 30.057,28.23855 C29.941,28.09455 29.79175,27.8358 29.6085,27.4623 C29.423,27.79905 29.2985,28.0213 29.235,28.1288 C29.1715,28.2363 29.1105,28.31755 29.052,28.37205 C28.99325,28.4273 28.92625,28.4548 28.8505,28.4548 C28.76025,28.4548 28.685,28.42355 28.62525,28.3613 C28.56525,28.2988 28.5355,28.23255 28.5355,28.1618 C28.5355,28.0958 28.54775,28.0458 28.57225,28.01155 C28.79675,27.7063 29.03125,27.44155 29.27525,27.2168 C29.07025,27.18505 28.88725,27.1498 28.726,27.1108 C28.565,27.07155 28.394,27.0143 28.21325,26.93855 C28.184,26.92405 28.15525,26.89055 28.12725,26.83805 C28.099,26.78555 28.08525,26.73705 28.08525,26.6933 C28.08525,26.6078 28.11625,26.53655 28.1785,26.47905 C28.24075,26.4218 28.31225,26.3928 28.39275,26.3928 C28.45125,26.3928 28.5245,26.4108 28.6125,26.4458 C28.7005,26.48155 28.812,26.5328 28.9475,26.5998 C29.083,26.66705 29.2375,26.74205 29.41075,26.82505 C29.379,26.6713 29.35275,26.49505 29.332,26.29605 C29.31125,26.09705 29.301,25.9608 29.301,25.88755 C29.301,25.7973 29.3295,25.7198 29.387,25.6548 C29.44425,25.59055 29.51825,25.55805 29.6085,25.55805 C29.6965,25.55805 29.769,25.59055 29.82625,25.6548 C29.88375,25.7198 29.9125,25.8058 29.9125,25.9133 C29.9125,25.94255 29.90825,26.00055 29.8995,26.08705 C29.891,26.17405 29.87875,26.2788 29.863,26.40205 C29.847,26.52555 29.8295,26.6663 29.81,26.82505",
    id: "Fill-41",
    fill: "#2E3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.81,26.82505 C29.96875,26.7518 30.12,26.67855 30.264,26.6053 C30.40825,26.53205 30.523,26.4783 30.60825,26.4443 C30.69375,26.41005 30.76225,26.3928 30.8135,26.3928 C30.89875,26.3928 30.9725,26.4218 31.03475,26.47905 C31.097,26.53655 31.12825,26.6078 31.12825,26.6933 C31.12825,26.74205 31.113,26.7928 31.0825,26.8453 C31.052,26.8978 31.01975,26.9313 30.9855,26.9458 C30.6705,27.0703 30.324,27.1608 29.9455,27.2168 C30.01375,27.2803 30.098,27.36455 30.19825,27.46955 C30.29825,27.57455 30.35075,27.6308 30.35575,27.63805 C30.39225,27.6893 30.4435,27.7528 30.5095,27.82855 C30.5755,27.90405 30.621,27.96355 30.64675,28.00605 C30.67225,28.04905 30.68525,28.1008 30.68525,28.1618 C30.68525,28.2398 30.656,28.3083 30.59725,28.3668 C30.53875,28.4253 30.463,28.4548 30.37025,28.4548 C30.2775,28.4548 30.173,28.38255 30.057,28.23855 C29.941,28.09455 29.79175,27.8358 29.6085,27.4623 C29.423,27.79905 29.2985,28.0213 29.235,28.1288 C29.1715,28.2363 29.1105,28.31755 29.052,28.37205 C28.99325,28.4273 28.92625,28.4548 28.8505,28.4548 C28.76025,28.4548 28.685,28.42355 28.62525,28.3613 C28.56525,28.2988 28.5355,28.23255 28.5355,28.1618 C28.5355,28.0958 28.54775,28.0458 28.57225,28.01155 C28.79675,27.7063 29.03125,27.44155 29.27525,27.2168 C29.07025,27.18505 28.88725,27.1498 28.726,27.1108 C28.565,27.07155 28.394,27.0143 28.21325,26.93855 C28.184,26.92405 28.15525,26.89055 28.12725,26.83805 C28.099,26.78555 28.08525,26.73705 28.08525,26.6933 C28.08525,26.6078 28.11625,26.53655 28.1785,26.47905 C28.24075,26.4218 28.31225,26.3928 28.39275,26.3928 C28.45125,26.3928 28.5245,26.4108 28.6125,26.4458 C28.7005,26.48155 28.812,26.5328 28.9475,26.5998 C29.083,26.66705 29.2375,26.74205 29.41075,26.82505 C29.379,26.6713 29.35275,26.49505 29.332,26.29605 C29.31125,26.09705 29.301,25.9608 29.301,25.88755 C29.301,25.7973 29.3295,25.7198 29.387,25.6548 C29.44425,25.59055 29.51825,25.55805 29.6085,25.55805 C29.6965,25.55805 29.769,25.59055 29.82625,25.6548 C29.88375,25.7198 29.9125,25.8058 29.9125,25.9133 C29.9125,25.94255 29.90825,26.00055 29.8995,26.08705 C29.891,26.17405 29.87875,26.2788 29.863,26.40205 C29.847,26.52555 29.8295,26.6663 29.81,26.82505 Z",
    id: "Stroke-43",
    stroke: "#2C3B45",
    strokeWidth: "0.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6198,26.82505 C35.77855,26.7518 35.9298,26.67855 36.0738,26.6053 C36.21805,26.53205 36.3328,26.4783 36.41805,26.4443 C36.50355,26.41005 36.57205,26.3928 36.6233,26.3928 C36.70855,26.3928 36.7823,26.4218 36.84455,26.47905 C36.9068,26.53655 36.93805,26.6078 36.93805,26.6933 C36.93805,26.74205 36.9228,26.7928 36.8923,26.8453 C36.8618,26.8978 36.82955,26.9313 36.7953,26.9458 C36.4803,27.0703 36.1338,27.1608 35.7553,27.2168 C35.82355,27.2803 35.9078,27.36455 36.00805,27.46955 C36.10805,27.57455 36.16055,27.6308 36.16555,27.63805 C36.20205,27.6893 36.2533,27.7528 36.3193,27.82855 C36.3853,27.90405 36.4308,27.96355 36.45655,28.00605 C36.48205,28.04905 36.49505,28.1008 36.49505,28.1618 C36.49505,28.2398 36.4658,28.3083 36.40705,28.3668 C36.34855,28.4253 36.2728,28.4548 36.18005,28.4548 C36.0873,28.4548 35.9828,28.38255 35.8668,28.23855 C35.7508,28.09455 35.60155,27.8358 35.4183,27.4623 C35.2328,27.79905 35.1083,28.0213 35.0448,28.1288 C34.9813,28.2363 34.9203,28.31755 34.8618,28.37205 C34.80305,28.4273 34.73605,28.4548 34.6603,28.4548 C34.57005,28.4548 34.4948,28.42355 34.43505,28.3613 C34.37505,28.2988 34.3453,28.23255 34.3453,28.1618 C34.3453,28.0958 34.35755,28.0458 34.38205,28.01155 C34.60655,27.7063 34.84105,27.44155 35.08505,27.2168 C34.88005,27.18505 34.69705,27.1498 34.5358,27.1108 C34.3748,27.07155 34.2038,27.0143 34.02305,26.93855 C33.9938,26.92405 33.96505,26.89055 33.93705,26.83805 C33.9088,26.78555 33.89505,26.73705 33.89505,26.6933 C33.89505,26.6078 33.92605,26.53655 33.9883,26.47905 C34.05055,26.4218 34.12205,26.3928 34.20255,26.3928 C34.26105,26.3928 34.3343,26.4108 34.4223,26.4458 C34.5103,26.48155 34.6218,26.5328 34.7573,26.5998 C34.8928,26.66705 35.0473,26.74205 35.22055,26.82505 C35.1888,26.6713 35.16255,26.49505 35.1418,26.29605 C35.12105,26.09705 35.1108,25.9608 35.1108,25.88755 C35.1108,25.7973 35.1393,25.7198 35.1968,25.6548 C35.25405,25.59055 35.32805,25.55805 35.4183,25.55805 C35.5063,25.55805 35.5788,25.59055 35.63605,25.6548 C35.69355,25.7198 35.7223,25.8058 35.7223,25.9133 C35.7223,25.94255 35.71805,26.00055 35.7093,26.08705 C35.7008,26.17405 35.68855,26.2788 35.6728,26.40205 C35.6568,26.52555 35.6393,26.6663 35.6198,26.82505",
    id: "Fill-45",
    fill: "#2E3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6198,26.82505 C35.77855,26.7518 35.9298,26.67855 36.0738,26.6053 C36.21805,26.53205 36.3328,26.4783 36.41805,26.4443 C36.50355,26.41005 36.57205,26.3928 36.6233,26.3928 C36.70855,26.3928 36.7823,26.4218 36.84455,26.47905 C36.9068,26.53655 36.93805,26.6078 36.93805,26.6933 C36.93805,26.74205 36.9228,26.7928 36.8923,26.8453 C36.8618,26.8978 36.82955,26.9313 36.7953,26.9458 C36.4803,27.0703 36.1338,27.1608 35.7553,27.2168 C35.82355,27.2803 35.9078,27.36455 36.00805,27.46955 C36.10805,27.57455 36.16055,27.6308 36.16555,27.63805 C36.20205,27.6893 36.2533,27.7528 36.3193,27.82855 C36.3853,27.90405 36.4308,27.96355 36.45655,28.00605 C36.48205,28.04905 36.49505,28.1008 36.49505,28.1618 C36.49505,28.2398 36.4658,28.3083 36.40705,28.3668 C36.34855,28.4253 36.2728,28.4548 36.18005,28.4548 C36.0873,28.4548 35.9828,28.38255 35.8668,28.23855 C35.7508,28.09455 35.60155,27.8358 35.4183,27.4623 C35.2328,27.79905 35.1083,28.0213 35.0448,28.1288 C34.9813,28.2363 34.9203,28.31755 34.8618,28.37205 C34.80305,28.4273 34.73605,28.4548 34.6603,28.4548 C34.57005,28.4548 34.4948,28.42355 34.43505,28.3613 C34.37505,28.2988 34.3453,28.23255 34.3453,28.1618 C34.3453,28.0958 34.35755,28.0458 34.38205,28.01155 C34.60655,27.7063 34.84105,27.44155 35.08505,27.2168 C34.88005,27.18505 34.69705,27.1498 34.5358,27.1108 C34.3748,27.07155 34.2038,27.0143 34.02305,26.93855 C33.9938,26.92405 33.96505,26.89055 33.93705,26.83805 C33.9088,26.78555 33.89505,26.73705 33.89505,26.6933 C33.89505,26.6078 33.92605,26.53655 33.9883,26.47905 C34.05055,26.4218 34.12205,26.3928 34.20255,26.3928 C34.26105,26.3928 34.3343,26.4108 34.4223,26.4458 C34.5103,26.48155 34.6218,26.5328 34.7573,26.5998 C34.8928,26.66705 35.0473,26.74205 35.22055,26.82505 C35.1888,26.6713 35.16255,26.49505 35.1418,26.29605 C35.12105,26.09705 35.1108,25.9608 35.1108,25.88755 C35.1108,25.7973 35.1393,25.7198 35.1968,25.6548 C35.25405,25.59055 35.32805,25.55805 35.4183,25.55805 C35.5063,25.55805 35.5788,25.59055 35.63605,25.6548 C35.69355,25.7198 35.7223,25.8058 35.7223,25.9133 C35.7223,25.94255 35.71805,26.00055 35.7093,26.08705 C35.7008,26.17405 35.68855,26.2788 35.6728,26.40205 C35.6568,26.52555 35.6393,26.6663 35.6198,26.82505 Z",
    id: "Stroke-47",
    stroke: "#2C3B45",
    strokeWidth: "0.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "16.49725",
    y1: "30.046725",
    x2: "19.07425",
    y2: "30.046725",
    id: "Stroke-49",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "22.33075",
    y1: "30.046725",
    x2: "24.9075",
    y2: "30.046725",
    id: "Stroke-51",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "28.24725",
    y1: "30.046725",
    x2: "30.82425",
    y2: "30.046725",
    id: "Stroke-53",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "33.95575",
    y1: "30.046725",
    x2: "36.5325",
    y2: "30.046725",
    id: "Stroke-55",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var ImgCardLockTemporary = function ImgCardLockTemporary(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.120027939 1.71961149 0.120027939 1.71961149 1.78852299 0 1.78852299"
  })), /*#__PURE__*/React.createElement("g", {
    id: "imgCardLockTemporary",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-44",
    transform: "translate(19.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.76315,43.05985 C59.6534,42.61335 59.9384,42.1591 60.4004,42.04535 C60.86215,41.9316 61.32565,42.2011 61.43565,42.64785 C61.54565,43.0941 61.2604,43.5481 60.79865,43.66185 C60.33665,43.7756 59.87315,43.5061 59.76315,43.05985",
    id: "Fill-1",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 36.938000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.023525,1.1604 C-0.086475,0.71415 0.198775,0.2599 0.660775,0.14615 C1.122525,0.03215 1.586025,0.3019 1.696025,0.7484 C1.806025,1.19465 1.520775,1.64865 1.059025,1.7624 C0.597025,1.8764 0.133525,1.60665 0.023525,1.1604",
    id: "Fill-5",
    fill: "#E2F8FE",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.26865,37.00955 L2.70165,35.40005 C2.65215,35.2588 2.77365,35.11705 2.92065,35.1443 L4.59815,35.4583 L6.2759,35.77205 C6.4229,35.79955 6.4849,35.9758 6.38765,36.0893 L5.27715,37.3853 L4.1664,38.6813 C4.06915,38.79505 3.8854,38.76055 3.83565,38.6193 L3.26865,37.00955 Z",
    id: "Fill-8",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.403775,19.76905 L60.403775,38.1916013 C60.403775,39.6150067 59.390775,40.76905 58.141025,40.76905",
    id: "Stroke-10",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.39195,12.26905 C14.39195,11.0193 15.40495,10.00605 16.6547,10.00605 L45.32345,10.00605",
    id: "Stroke-12",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.28,9.081075 L5.82675,9.081075 L5.82675,7.628075 C5.82675,7.328075 5.5815,7.083075 5.28175,7.083075 C4.98225,7.083075 4.737,7.328075 4.737,7.628075 L4.737,9.081075 L3.28375,9.081075 C2.984,9.081075 2.73875,9.326325 2.73875,9.626075 C2.73875,9.925825 2.984,10.170825 3.28375,10.170825 L4.737,10.170825 L4.737,11.624325 C4.737,11.923825 4.98225,12.169325 5.28175,12.169325 C5.5815,12.169325 5.82675,11.923825 5.82675,11.624325 L5.82675,10.170825 L7.28,10.170825 C7.57975,10.170825 7.825,9.925825 7.825,9.626075 C7.825,9.326325 7.57975,9.081075 7.28,9.081075",
    id: "Fill-14",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2208,42.4534 C13.2208,43.70315 10.98755,43.2794 10.03455,43.2794 C9.08155,43.2794 8.3093,42.26615 8.3093,41.0164 L8.3093,15.5394 C8.3093,14.28965 9.08155,13.27665 10.03455,13.27665 C10.98755,13.27665 10.54255,14.28965 10.54255,15.5394 L10.54255,41.2624",
    id: "Fill-16",
    fill: "#AEEDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.797325,24.128675 L57.797325,40.549925 C57.797325,41.510175 57.018575,42.288925 56.058075,42.288925 L12.688825,42.288925 C11.728325,42.288925 10.949825,41.510175 10.949825,40.549925 L10.949825,13.967175 C10.949825,13.006925 11.728325,12.228175 12.688825,12.228175 L45.073325,12.228175",
    id: "Stroke-18",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.509,27.6753 L11.2725,27.6753 C11.12925,27.6753 11.01325,27.55905 11.01325,27.4158 L11.01325,23.4843 L11.01325,20.89955 C11.01325,20.7563 11.12925,20.64005 11.2725,20.64005 L57.509,20.64005 C57.65225,20.64005 57.7685,20.7563 57.7685,20.89955 L57.7685,22.7953 L57.7685,27.4158 C57.7685,27.55905 57.65225,27.6753 57.509,27.6753",
    id: "Fill-20",
    fill: "#00B3DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.509,27.6753 L11.2725,27.6753 C11.12925,27.6753 11.01325,27.55905 11.01325,27.4158 L11.01325,23.4843 L11.01325,20.89955 C11.01325,20.7563 11.12925,20.64005 11.2725,20.64005 L57.509,20.64005 C57.65225,20.64005 57.7685,20.7563 57.7685,20.89955 L57.7685,22.7953 L57.7685,27.4158 C57.7685,27.55905 57.65225,27.6753 57.509,27.6753 Z",
    id: "Stroke-22",
    stroke: "#2C3B45",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "16.01035",
    y1: "37.493925",
    x2: "22.47385",
    y2: "37.493925",
    id: "Stroke-24",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "26.293075",
    y1: "37.493925",
    x2: "32.756575",
    y2: "37.493925",
    id: "Stroke-26",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1677,33.94705 C42.4277,33.94705 42.66095,34.11955 42.71995,34.41905 L43.22445,37.09805 L44.4707,33.94705 L45.72895,33.94705 L43.78845,38.57655 L42.5222,38.57655 L41.5677,34.8818 C41.50945,34.65455 41.45895,34.57105 41.2827,34.47505 C40.99545,34.3188 40.5197,34.17255 40.10145,34.0818 L40.12995,33.94705 L42.1677,33.94705 Z",
    id: "Fill-28",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.478975,36.9363 L53.109225,35.19755 L53.471975,36.9363 L52.478975,36.9363 Z M53.956225,33.9473 L52.933225,33.9473 L52.858475,33.95205 C52.661975,33.9778 52.500225,34.10405 52.423725,34.28655 L50.627225,38.57655 L51.884225,38.57655 L52.134475,37.88555 L53.670725,37.88555 L53.814975,38.57655 L54.922725,38.57655 L53.956225,33.9473 Z",
    id: "Fill-30",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-32",
    fill: "#2C3B45",
    points: "47.439925 33.94705 46.449675 38.57655 45.252175 38.57655 46.242425 33.94705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.79025,33.862575 C50.1935,33.862575 50.52825,33.939575 50.7985,34.029075 L50.91025,34.067825 L50.7005,35.049575 C50.16325,34.802575 49.691,34.819825 49.519,34.842325 C49.173,34.887575 49.0145,35.063825 49.0115,35.230325 C48.9995,35.775825 50.69425,35.843325 50.6895,37.065325 C50.685,38.027325 49.862,38.649075 48.6045,38.649075 C48.12175,38.643825 47.6555,38.553075 47.363,38.441075 L47.27225,38.403075 L47.48925,37.388575 C47.76775,37.518825 48.11775,37.690825 48.71975,37.681075 C49.064,37.675575 49.433,37.538575 49.436,37.228075 C49.43775,37.040575 49.30475,36.902325 48.91725,36.703825 L48.73325,36.612075 C48.2925,36.386325 47.75925,36.020075 47.76625,35.393075 C47.77325,34.492075 48.60675,33.862575 49.79025,33.862575",
    id: "Fill-34",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.124475,20.41385 L47.487475,20.41385 C46.310975,20.41385 45.356975,19.4601 45.356975,18.28335 L45.356975,8.4471 C45.356975,7.2706 46.310975,6.31635 47.487475,6.31635 L58.124475,6.31635 C59.301225,6.31635 60.254975,7.2706 60.254975,8.4471 L60.254975,18.28335 C60.254975,18.79335 59.967725,20.41385 58.124475,20.41385 Z",
    id: "Stroke-36",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.43015,6.1111 L48.43015,4.52535 C48.43015,2.09535 50.4004,0.1251 52.8309,0.1251 C55.2609,0.1251 57.23115,2.09535 57.23115,4.52535 L57.23115,6.1016",
    id: "Stroke-38",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6096,12.258325 C53.6096,12.257575 53.60935,12.257075 53.6091,12.256325 C54.0906,11.978075 54.41535,11.459325 54.41535,10.863325 C54.41535,9.974575 53.69485,9.254075 52.8061,9.254075 C51.91735,9.254075 51.1971,9.974575 51.1971,10.863325 C51.1971,11.459325 51.5216,11.978075 52.00285,12.256325 C52.00285,12.257075 52.0026,12.257575 52.00235,12.258325 L51.3856,16.407825 C51.3456,16.675325 51.5406,16.917575 51.79585,16.917575 L53.81635,16.917575 C54.07185,16.917575 54.2666,16.675325 54.22685,16.407825 L53.6096,12.258325 Z",
    id: "Fill-40",
    fill: "#00B3DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6096,12.258325 C53.6096,12.257575 53.60935,12.257075 53.6091,12.256325 C54.0906,11.978075 54.41535,11.459325 54.41535,10.863325 C54.41535,9.974575 53.69485,9.254075 52.8061,9.254075 C51.91735,9.254075 51.1971,9.974575 51.1971,10.863325 C51.1971,11.459325 51.5216,11.978075 52.00285,12.256325 C52.00285,12.257075 52.0026,12.257575 52.00235,12.258325 L51.3856,16.407825 C51.3456,16.675325 51.5406,16.917575 51.79585,16.917575 L53.81635,16.917575 C54.07185,16.917575 54.2666,16.675325 54.22685,16.407825 L53.6096,12.258325 Z",
    id: "Stroke-42",
    stroke: "#2C3B45",
    strokeWidth: "1.5"
  }))));
};
var ImgCardPending = function ImgCardPending(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    id: "imgCardPending",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-43",
    transform: "translate(19.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.76315,41.6811 C59.6534,41.2346 59.9384,40.78035 60.4004,40.6666 C60.86215,40.55285 61.32565,40.82235 61.43565,41.2691 C61.54565,41.71535 61.2604,42.16935 60.79865,42.2831 C60.33665,42.39685 59.87315,42.12735 59.76315,41.6811",
    id: "Fill-1",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.02365,36.71965 C-0.08635,36.2734 0.1989,35.81915 0.66065,35.7054 C1.12265,35.5914 1.58615,35.86115 1.69615,36.30765 C1.80615,36.7539 1.5209,37.2079 1.05915,37.32165 C0.59715,37.43565 0.1334,37.1659 0.02365,36.71965",
    id: "Fill-5",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.268775,35.6308 L2.701525,34.0213 C2.652025,33.88005 2.773775,33.7383 2.920525,33.76555 L4.598275,34.07955 L6.275775,34.3933 C6.422775,34.4208 6.485025,34.59705 6.387775,34.71055 L5.277025,36.00655 L4.166525,37.30255 C4.069025,37.4163 3.885525,37.3818 3.835775,37.24055 L3.268775,35.6308 Z",
    id: "Fill-7",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.403775,18.3903 L60.403775,36.8128513 C60.403775,38.2362567 59.390775,39.3903 58.141025,39.3903",
    id: "Stroke-9",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.391825,10.8903 C14.391825,9.64055 15.3788003,8.6273 16.5961429,8.6273 L48.2711182,8.6273",
    id: "Stroke-11",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.28,7.702325 L5.827,7.702325 L5.827,6.249325 C5.827,5.949325 5.5815,5.704325 5.282,5.704325 C4.98225,5.704325 4.73675,5.949325 4.73675,6.249325 L4.73675,7.702325 L3.28375,7.702325 C2.984,7.702325 2.73875,7.947575 2.73875,8.247325 C2.73875,8.547075 2.984,8.792075 3.28375,8.792075 L4.73675,8.792075 L4.73675,10.245575 C4.73675,10.545075 4.98225,10.790575 5.282,10.790575 C5.5815,10.790575 5.827,10.545075 5.827,10.245575 L5.827,8.792075 L7.28,8.792075 C7.57975,8.792075 7.825,8.547075 7.825,8.247325 C7.825,7.947575 7.57975,7.702325 7.28,7.702325",
    id: "Fill-13",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.034675,41.90065 C9.081675,41.90065 8.309425,40.8874 8.309425,39.63765 L8.309425,14.16065 C8.309425,12.9109 9.081675,11.8979 10.034675,11.8979 C10.987425,11.8979 10.542675,12.9109 10.542675,14.16065 L10.949575,39.63765 L13.220925,41.07465 C13.220925,42.3244 10.987425,41.90065 10.034675,41.90065 Z",
    id: "Fill-15",
    fill: "#AEEDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.797325,22.749925 L57.797325,39.171175 C57.797325,40.131425 57.018575,40.910175 56.058075,40.910175 L12.688825,40.910175 C11.728575,40.910175 10.949575,40.131425 10.949575,39.171175 L10.949575,12.588425 C10.949575,11.628175 11.728575,10.849425 12.688825,10.849425 L47.4405518,10.849425",
    id: "Stroke-17",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.509,26.29655 L11.27275,26.29655 C11.12925,26.29655 11.01325,26.1803 11.01325,26.03705 L11.01325,22.10555 L11.01325,19.5208 C11.01325,19.37755 11.12925,19.2613 11.27275,19.2613 L57.509,19.2613 C57.65225,19.2613 57.7685,19.37755 57.7685,19.5208 L57.7685,21.41655 L57.7685,26.03705 C57.7685,26.1803 57.65225,26.29655 57.509,26.29655",
    id: "Fill-19",
    fill: "#00B3DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.509,26.29655 L11.27275,26.29655 C11.12925,26.29655 11.01325,26.1803 11.01325,26.03705 L11.01325,22.10555 L11.01325,19.5208 C11.01325,19.37755 11.12925,19.2613 11.27275,19.2613 L57.509,19.2613 C57.65225,19.2613 57.7685,19.37755 57.7685,19.5208 L57.7685,21.41655 L57.7685,26.03705 C57.7685,26.1803 57.65225,26.29655 57.509,26.29655 Z",
    id: "Stroke-21",
    stroke: "#2C3B45",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "16.010225",
    y1: "36.115175",
    x2: "22.473725",
    y2: "36.115175",
    id: "Stroke-23",
    stroke: "#2C3B45",
    strokeWidth: "1.469",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "26.29295",
    y1: "36.115175",
    x2: "32.75645",
    y2: "36.115175",
    id: "Stroke-25",
    stroke: "#2C3B45",
    strokeWidth: "1.469",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1677,32.5683 C42.4277,32.5683 42.66095,32.7408 42.71995,33.0403 L43.22445,35.7193 L44.4707,32.5683 L45.72895,32.5683 L43.78845,37.1978 L42.5222,37.1978 L41.5677,33.50305 C41.50945,33.2758 41.45895,33.1923 41.2827,33.0963 C40.99545,32.94005 40.5197,32.7938 40.10145,32.70305 L40.12995,32.5683 L42.1677,32.5683 Z",
    id: "Fill-27",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.478975,35.55755 L53.109225,33.8188 L53.471975,35.55755 L52.478975,35.55755 Z M53.956225,32.56855 L52.933225,32.56855 L52.858475,32.5733 C52.661975,32.59905 52.500225,32.7253 52.423725,32.9078 L50.627225,37.1978 L51.884225,37.1978 L52.134475,36.5068 L53.670725,36.5068 L53.814975,37.1978 L54.922725,37.1978 L53.956225,32.56855 Z",
    id: "Fill-29",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31",
    fill: "#2C3B45",
    points: "47.439925 32.5683 46.449675 37.1978 45.252175 37.1978 46.242425 32.5683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.79025,32.483825 C50.1935,32.483825 50.52825,32.560825 50.7985,32.650325 L50.91025,32.689075 L50.7005,33.670825 C50.16325,33.423825 49.691,33.441075 49.519,33.463575 C49.173,33.508825 49.0145,33.685075 49.0115,33.851575 C48.9995,34.397075 50.69425,34.464575 50.6895,35.686575 C50.685,36.648575 49.862,37.270325 48.6045,37.270325 C48.12175,37.265075 47.6555,37.174325 47.363,37.062325 L47.27225,37.024325 L47.48925,36.009825 C47.76775,36.140075 48.11775,36.312075 48.71975,36.302325 C49.064,36.296825 49.433,36.159825 49.436,35.849325 C49.43775,35.661825 49.30475,35.523575 48.91725,35.325075 L48.73325,35.233325 C48.2925,35.007575 47.75925,34.641325 47.76625,34.014325 C47.77325,33.113325 48.60675,32.483825 49.79025,32.483825",
    id: "Fill-33",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.473916,7.60687475 C55.89012,6.56986698 54.8514929,5 54.8514929,5 L48.1485973,5 C48.1485973,5 47.1096892,6.56986698 50.5258932,7.60687475 L51.5190084,9 L52.473916,7.60687475 Z",
    id: "Fill-35",
    fill: "#AEEDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6911943,9.55108973 C43.3467923,12.4115483 45.2758574,19 45.2758574,19 L57.7241426,19 C57.7241426,19 59.6532077,12.4115483 53.3088057,9.55108973 L53.3088057,9.44891027 C59.6532077,6.5881687 57.7241426,0 57.7241426,0 L45.2758574,0 C45.2758574,0 43.3467923,6.5881687 49.6911943,9.44891027 L49.6911943,9.55108973 Z",
    id: "Stroke-37",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var ImgCardPinPaper = function ImgCardPinPaper(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    id: "imgCardPinPaper",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-49",
    transform: "translate(23.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4791,8.000625 L24.44735,0.876375 C24.57285,0.422125 25.0431,0.155375 25.49735,0.280875 L48.04635,6.510625 C48.5006,6.636125 48.7671,7.106375 48.6416,7.560625 L45.43435,18.937375",
    id: "Stroke-1",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.915375,7.997925 L25.555625,5.680925 L26.116125,3.652175 C26.241625,3.197675 26.711875,2.930925 27.166125,3.056675 L45.407625,8.096425 C45.861875,8.221925 46.128625,8.691925 46.003125,9.146425 L43.677625,17.563175",
    id: "Stroke-3",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.311375,16.233025 L16.311375,8.977775 C16.311375,8.445275 16.743125,8.013775 17.275125,8.013775 L24.849625,8.013775 L36.941125,8.013775 L41.701625,12.887775 L41.701625,16.910525",
    id: "Stroke-5",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "19.42855",
    y1: "11.1698",
    x2: "32.23105",
    y2: "11.1698",
    id: "Stroke-7",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "19.42855",
    y1: "13.5033",
    x2: "23.19755",
    y2: "13.5033",
    id: "Stroke-9",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.555275,13.11315 L39.435025,12.97515 L37.177275,12.81565 C37.067525,12.80765 36.974275,12.71415 36.966525,12.6044 L36.806525,10.3469 L36.668525,8.2264",
    id: "Stroke-11",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.263525,7.904175 L29.265775,6.102175 C29.589275,5.810925 30.068025,5.772925 30.433525,6.008925 L33.894525,8.244175 L27.263525,7.904175 Z",
    id: "Fill-13",
    fill: "#AEEDFC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "51.53745",
    y1: "34.44105",
    x2: "51.53745",
    y2: "44.5408",
    id: "Stroke-15",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "17.785725",
    y1: "35.331675",
    x2: "41.031975",
    y2: "35.331675",
    id: "Stroke-17",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "17.785725",
    y1: "27.415175",
    x2: "30.812725",
    y2: "27.415175",
    id: "Stroke-19",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "17.785725",
    y1: "52.116325",
    x2: "41.327225",
    y2: "52.116325",
    id: "Stroke-21",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.12875,49.4281 L12.08675,18.3146 L13.96175,16.8146 L12.454,16.61835 C10.6865,16.61835 9.25375,17.69985 9.25375,19.0341 L9.25375,49.4281 L9.25025,49.3111",
    id: "Fill-23",
    fill: "#AEEDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9305,47.335575 L12.21175,59.367825 L13.493,60.950325 L16.07575,61.377075 C15.64625,61.377075 11.612,61.316325 11.23775,61.205575 C10.0715,60.861075 9.25025,60.034325 9.25025,59.069325 L9.25025,57.498075 L9.25375,57.142825 L9.25375,47.965325 C9.25375,47.965325 8.85775,47.502075 11.9305,47.335575",
    id: "Fill-25",
    fill: "#AEEDFC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(42.500000, 17.442500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.08675,0.0508 L0.08675,3.64405 C0.08675,4.65405 0.908,5.5193 2.07425,5.88005 C2.44825,5.9958 2.85775,6.05955 3.28725,6.05955 L6.251,6.05955",
    id: "Fill-27",
    fill: "#AEEDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.08675,0.0508 L0.08675,3.64405 C0.08675,4.65405 0.908,5.5193 2.07425,5.88005 C2.44825,5.9958 2.85775,6.05955 3.28725,6.05955 L6.251,6.05955",
    id: "Stroke-29",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.553325,43.06115 L11.556825,43.17815 L11.556825,19.03415 C11.556825,17.6999 12.989575,16.6184 14.756825,16.6184 L42.145575,16.6184 L48.970825,23.03415 L48.970825,43.17815 L48.976325,43.06115 L48.976325,46.6069 L48.970825,46.72365 L48.970825,56.32965 L48.967575,56.70165 L48.967575,58.3459 C48.967575,59.68015 47.534825,60.76165 45.767075,60.76165 L14.753825,60.76165 C14.324325,60.76165 13.914825,60.69765 13.540825,60.5819 C12.374575,60.2214 11.553325,59.3559 11.553325,58.3459 L11.553325,56.70165 L11.556825,56.32965 L11.556825,46.72365 L11.553325,46.6069 L11.553325,43.06115 Z",
    id: "Stroke-31",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.167825,19.0619 C49.042325,18.5529 49.367575,18.03515 49.894325,17.9054 C50.421075,17.7754 50.949825,18.0829 51.075075,18.5919 C51.200575,19.1009 50.875325,19.61915 50.348575,19.74865 C49.821825,19.87865 49.293075,19.57115 49.167825,19.0619",
    id: "Fill-33",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5201,27.0348 C2.29335,26.1153 2.88085,25.1798 3.8326,24.94555 C4.7841,24.7108 5.73885,25.2663 5.96535,26.1858 C6.1921,27.1053 5.60435,28.04055 4.65285,28.2753 C3.7016,28.50955 2.7466,27.9543 2.5201,27.0348",
    id: "Fill-35",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.02695,29.7423 C-0.09855,29.2333 0.2267,28.7153 0.75345,28.58555 C1.2802,28.4558 1.80895,28.76305 1.93445,29.2723 C2.0597,29.7813 1.73445,30.2993 1.2077,30.4288 C0.68095,30.5588 0.15245,30.2513 0.02695,29.7423",
    id: "Fill-37",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.421475,61.627075 L7.373225,61.627075 L7.373225,60.578825 C7.373225,60.362325 7.196225,60.185575 6.979975,60.185575 C6.763725,60.185575 6.586725,60.362325 6.586725,60.578825 L6.586725,61.627075 L5.538475,61.627075 C5.322225,61.627075 5.145475,61.804075 5.145475,62.020325 C5.145475,62.236575 5.322225,62.413575 5.538475,62.413575 L6.586725,62.413575 L6.586725,63.461825 C6.586725,63.678075 6.763725,63.855075 6.979975,63.855075 C7.196225,63.855075 7.373225,63.678075 7.373225,63.461825 L7.373225,62.413575 L8.421475,62.413575 C8.637725,62.413575 8.814725,62.236575 8.814725,62.020325 C8.814725,61.804075 8.637725,61.627075 8.421475,61.627075",
    id: "Fill-39",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.004475,33.328 L4.004475,31.3815 C4.004475,31.211 4.188975,31.10425 4.336725,31.1895 L6.022225,32.163 L7.707975,33.136 C7.855725,33.22125 7.855725,33.4345 7.707975,33.52 L6.022225,34.493 L4.336725,35.46625 C4.188975,35.5515 4.004475,35.445 4.004475,35.27425 L4.004475,33.328 Z",
    id: "Fill-41",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.18905,62.737425 L50.18905,61.431175 C50.18905,61.316675 50.31305,61.245175 50.4123,61.302425 L51.5433,61.955425 L52.6743,62.608425 C52.77355,62.665925 52.77355,62.808925 52.6743,62.866175 L51.5433,63.519175 L50.4123,64.172175 C50.31305,64.229675 50.18905,64.158175 50.18905,64.043675 L50.18905,62.737425 Z",
    id: "Fill-43",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1273,45.8722 L18.3373,45.8722 C18.0683,45.8722 17.8483,45.65195 17.8483,45.38295 L17.8483,42.1947 C17.8483,41.9257 18.0683,41.70545 18.3373,41.70545 L41.1273,41.70545 C41.3963,41.70545 41.61655,41.9257 41.61655,42.1947 L41.61655,45.38295 C41.61655,45.65195 41.3963,45.8722 41.1273,45.8722",
    id: "Fill-45",
    fill: "#00B3DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1273,45.8722 L18.3373,45.8722 C18.0683,45.8722 17.8483,45.65195 17.8483,45.38295 L17.8483,42.1947 C17.8483,41.9257 18.0683,41.70545 18.3373,41.70545 L41.1273,41.70545 C41.3963,41.70545 41.61655,41.9257 41.61655,42.1947 L41.61655,45.38295 C41.61655,45.65195 41.3963,45.8722 41.1273,45.8722 Z",
    id: "Stroke-47",
    stroke: "#2C3B45",
    strokeWidth: "1.5"
  }))));
};
var ImgCardPinSms = function ImgCardPinSms(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.4735,0.15625 L13.59025,0.15625 C14.29475,0.15625 14.86575,0.65775 14.86575,1.27625 L14.86575,5.7565 C14.86575,6.37525 14.29475,6.87675 13.59025,6.87675 L1.4735,6.87675 C0.76925,6.87675 0.198,6.37525 0.198,5.7565 L0.198,1.27625 C0.198,0.65775 0.76925,0.15625 1.4735,0.15625 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.4735,0.15625 L13.59025,0.15625 C14.295,0.15625 14.86575,0.65775 14.86575,1.27625 L14.86575,5.7565 C14.86575,6.37525 14.295,6.87675 13.59025,6.87675 L1.4735,6.87675 C0.76925,6.87675 0.19825,6.37525 0.19825,5.7565 L0.19825,1.27625 C0.19825,0.65775 0.76925,0.15625 1.4735,0.15625 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.31025,0.17675 C0.606,0.17675 0.035,0.67825 0.035,1.297 L0.035,1.297 L0.035,5.77725 C0.035,6.3955 0.606,6.89725 1.31025,6.89725 L1.31025,6.89725 L17.2535,6.89725 C17.95775,6.89725 18.529,6.3955 18.529,5.77725 L18.529,5.77725 L18.529,1.297 C18.529,0.67825 17.95775,0.17675 17.2535,0.17675 L17.2535,0.17675 L1.31025,0.17675 Z",
    id: "path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "img_cardPinSms",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-48",
    transform: "translate(20.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-38",
    transform: "translate(0.000000, 0.197500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.17615,3.621025 L39.17615,0.997275 C39.17615,0.465775 39.6109,0.031025 40.1424,0.031025 L58.33165,0.031025 C58.86315,0.031025 59.2979,0.465775 59.2979,0.997275 L59.2979,6.745275 C59.2979,7.276775 58.86315,7.711525 58.33165,7.711525 L58.0384,7.711525 L58.0384,9.757025 L56.0499,7.711525 L40.9944,7.711525",
    id: "Stroke-1",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.695425,27.710125 L54.402425,27.710125 L54.402175,29.755625 L52.413925,27.710125 L46.051175,27.710125 C45.519675,27.710125 45.084925,27.275375 45.084925,26.743875 L45.084925,20.996125 C45.084925,20.464625 45.519675,20.029625 46.051175,20.029625 L54.695425,20.029625 C55.226925,20.029625 55.661675,20.464625 55.661675,20.996125 L55.661675,26.743875 C55.661675,27.275375 55.226925,27.710125 54.695425,27.710125 Z",
    id: "Stroke-3",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.51135,9.97355 L54.6386,9.97355 C55.1701,9.97355 55.60485,10.4083 55.60485,10.9398 L55.60485,16.6878 C55.60485,17.21905 55.1701,17.65405 54.6386,17.65405 L44.9711,17.65405 L42.97735,19.6993 L42.98285,17.65405 L40.6391,17.65405 L40.51135,9.97355 Z",
    id: "Stroke-5",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.358525,57.391275 C17.358525,58.049025 16.807025,58.582275 16.126275,58.582275 C15.446025,58.582275 14.894275,58.049025 14.894275,57.391275 C14.894275,56.733525 15.446025,56.200275 16.126275,56.200275 C16.807025,56.200275 17.358525,56.733525 17.358525,57.391275",
    id: "Fill-7",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.26355,46.600025 L49.2378,46.600025 L49.2378,45.574275 C49.2378,45.363025 49.0648,45.189775 48.8533,45.189775 C48.6418,45.189775 48.46855,45.363025 48.46855,45.574275 L48.46855,46.600025 L47.44305,46.600025 C47.23155,46.600025 47.05855,46.773025 47.05855,46.984525 C47.05855,47.196275 47.23155,47.369275 47.44305,47.369275 L48.46855,47.369275 L48.46855,48.394775 C48.46855,48.606275 48.6418,48.779525 48.8533,48.779525 C49.0648,48.779525 49.2378,48.606275 49.2378,48.394775 L49.2378,47.369275 L50.26355,47.369275 C50.47505,47.369275 50.64805,47.196275 50.64805,46.984525 C50.64805,46.773025 50.47505,46.600025 50.26355,46.600025",
    id: "Fill-9",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.418575,54.075125 L44.418575,52.247875 C44.418575,52.087875 44.591825,51.987625 44.730575,52.067875 L46.313075,52.981375 L47.895575,53.895125 C48.034325,53.975125 48.034325,54.175125 47.895575,54.255375 L46.313075,55.169125 L44.730575,56.082625 C44.591825,56.162875 44.418575,56.062625 44.418575,55.902625 L44.418575,54.075125 Z",
    id: "Fill-11",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.710075,50.9738 C12.710075,52.30805 20.491575,53.0488 19.157325,53.0488 L11.600325,53.0488 C10.266075,53.0488 9.184325,51.9673 9.184325,50.63305 L9.184325,6.94755 C9.184325,5.6133 10.266075,4.53155 11.600325,4.53155 L12.850825,4.53155 L12.710075,50.9738 Z",
    id: "Fill-13",
    fill: "#AEEDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.612925,48.3073 C44.612925,48.8553 44.153175,49.2998 43.586175,49.2998 C43.018925,49.2998 42.559175,48.8553 42.559175,48.3073 C42.559175,47.7593 43.018925,47.3148 43.586175,47.3148 C44.153175,47.3148 44.612925,47.7593 44.612925,48.3073",
    id: "Fill-15",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.910775,43.15275 L3.254775,44.423 L1.984525,42.767 C1.722525,42.42575 1.228775,42.3605 0.887275,42.6225 C0.545775,42.8845 0.480525,43.37825 0.742525,43.72 L2.012775,45.37575 L0.356775,46.646 C0.015525,46.908 -0.049725,47.4015 0.212275,47.743 C0.474275,48.08475 0.968025,48.14975 1.309525,47.88775 L2.965525,46.6175 L4.235775,48.2735 C4.497775,48.61525 4.991275,48.68 5.332775,48.41825 C5.674525,48.15625 5.739525,47.6625 5.477775,47.321 L4.207525,45.665 L5.863525,44.39475 C6.204775,44.13275 6.270025,43.639 6.008025,43.2975 C5.746025,42.956 5.252025,42.89075 4.910775,43.15275",
    id: "Fill-17",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.23695,52.426925 L14.8267,52.426925 C13.49245,52.426925 12.41095,51.345425 12.41095,50.011175 L12.41095,5.866925 C12.41095,4.532925 13.49245,3.451175 14.8267,3.451175 L38.23695,3.451175 C38.5612,3.451175 38.8702,3.515175 39.1527,3.630675 C40.03295,3.991675 40.6527,4.856925 40.6527,5.866925 L40.6527,50.011175 C40.6527,51.345425 39.5712,52.426925 38.23695,52.426925 Z",
    id: "Stroke-19",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "18.3744",
    y1: "7.4108",
    x2: "34.6894",
    y2: "7.4108",
    id: "Stroke-21",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "26.4906",
    y1: "48.424475",
    x2: "26.5731",
    y2: "48.424475",
    id: "Stroke-23",
    stroke: "#2C3B45",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "43.568975",
    y1: "32.843675",
    x2: "43.568975",
    y2: "44.328675",
    id: "Stroke-25",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(16.000000, 24.750000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4735,0.156175 L13.59025,0.156175 C14.29475,0.156175 14.86575,0.657675 14.86575,1.276175 L14.86575,5.756425 C14.86575,6.375175 14.29475,6.876675 13.59025,6.876675 L1.4735,6.876675 C0.76925,6.876675 0.198,6.375175 0.198,5.756425 L0.198,1.276175 C0.198,0.657675 0.76925,0.156175 1.4735,0.156175",
    id: "Fill-27",
    fill: "#AEEDFC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-31"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-34"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-33"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M18.560425,34.426925 L34.503425,34.426925 C35.207925,34.426925 35.778925,34.928425 35.778925,35.546675 L35.778925,40.027175 C35.778925,40.645675 35.207925,41.147175 34.503425,41.147175 L18.560425,41.147175 C17.856175,41.147175 17.284925,40.645675 17.284925,40.027175 L17.284925,35.546675 C17.284925,34.928425 17.856175,34.426925 18.560425,34.426925",
    id: "Fill-36",
    fill: "#AEEDFC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-42",
    transform: "translate(17.250000, 34.447500)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-40"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-41",
    fill: "#AEEDFC",
    mask: "url(#mask-6)",
    points: "0.28175 6.537125 18.28175 6.537125 18.28175 0.537125 0.28175 0.537125"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-47",
    transform: "translate(16.750000, 15.447500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.932975,6.79875 L16.854725,9.416 L16.846975,6.78325 L17.448725,6.792 L19.333475,6.792 C20.036225,6.792 20.605975,6.28925 20.605975,5.669 L20.605975,1.177 C20.605975,0.55675 20.036225,0.054 19.333475,0.054 L1.516225,0.054 C0.813225,0.054 0.243725,0.55675 0.243725,1.177 L0.243725,5.669 C0.243725,6.28925 0.813225,6.792 1.516225,6.792 L14.385975,6.792 L14.932975,6.79875 Z",
    id: "Fill-43",
    fill: "#00B3DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.932975,6.79875 L16.854725,9.416 L16.846975,6.78325 L17.448725,6.792 L19.333475,6.792 C20.036225,6.792 20.605975,6.28925 20.605975,5.669 L20.605975,1.177 C20.605975,0.55675 20.036225,0.054 19.333475,0.054 L1.516225,0.054 C0.813225,0.054 0.243725,0.55675 0.243725,1.177 L0.243725,5.669 C0.243725,6.28925 0.813225,6.792 1.516225,6.792 L14.385975,6.792 L14.932975,6.79875 Z",
    id: "Stroke-45",
    stroke: "#2C3B45",
    strokeWidth: "1.5"
  })))));
};
var ImgCardRefused = function ImgCardRefused(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.120027939 1.71961149 0.120027939 1.71961149 1.78852299 0 1.78852299"
  })), /*#__PURE__*/React.createElement("g", {
    id: "imgCardRefused",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(18.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.76315,37.9276 C59.6534,37.4811 59.9384,37.02685 60.4004,36.9131 C60.86215,36.79935 61.32565,37.06885 61.43565,37.5156 C61.54565,37.96185 61.2604,38.41585 60.79865,38.5296 C60.33665,38.64335 59.87315,38.37385 59.76315,37.9276",
    id: "Fill-1",
    fill: "#CA4036",
    opacity: "0.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1932,35.65585 C3.0832,35.2096 3.36845,34.75535 3.8302,34.6416 C4.2922,34.52785 4.7557,34.79735 4.8657,35.24385 C4.9757,35.69035 4.69045,36.14435 4.2287,36.2581 C3.7667,36.37185 3.3032,36.10235 3.1932,35.65585",
    id: "Fill-3",
    fill: "#CA4036",
    opacity: "0.1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    opacity: "0.1",
    transform: "translate(0.000000, 31.805750)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.023525,1.1604 C-0.086475,0.71415 0.198775,0.2599 0.660775,0.14615 C1.122525,0.03215 1.586025,0.3019 1.696025,0.7484 C1.806025,1.19465 1.520775,1.64865 1.059025,1.7624 C0.597025,1.8764 0.133525,1.60665 0.023525,1.1604",
    id: "Fill-5",
    fill: "#CA4036",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.26865,31.8773 L2.70165,30.2678 C2.65215,30.12655 2.77365,29.9848 2.92065,30.01205 L4.59815,30.32605 L6.2759,30.6398 C6.4229,30.6673 6.4849,30.84355 6.38765,30.95705 L5.27715,32.25305 L4.1664,33.54905 C4.06915,33.6628 3.8854,33.6283 3.83565,33.48705 L3.26865,31.8773 Z",
    id: "Fill-8",
    fill: "#CA4036",
    opacity: "0.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.403775,14.6368 L60.403775,30.8118 C60.403775,32.06155 59.390775,33.0748 58.141025,33.0748",
    id: "Stroke-10",
    stroke: "#CA4036",
    strokeWidth: "0.5",
    opacity: "0.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.39195,7.1368 C14.39195,5.88705 15.40495,4.8738 16.6547,4.8738 L45.32345,4.8738",
    id: "Stroke-12",
    stroke: "#CA4036",
    strokeWidth: "0.5",
    opacity: "0.3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.28,3.948825 L5.82675,3.948825 L5.82675,2.495825 C5.82675,2.195825 5.5815,1.950825 5.28175,1.950825 C4.98225,1.950825 4.737,2.195825 4.737,2.495825 L4.737,3.948825 L3.28375,3.948825 C2.984,3.948825 2.73875,4.194075 2.73875,4.493825 C2.73875,4.793575 2.984,5.038575 3.28375,5.038575 L4.737,5.038575 L4.737,6.492075 C4.737,6.791575 4.98225,7.037075 5.28175,7.037075 C5.5815,7.037075 5.82675,6.791575 5.82675,6.492075 L5.82675,5.038575 L7.28,5.038575 C7.57975,5.038575 7.825,4.793575 7.825,4.493825 C7.825,4.194075 7.57975,3.948825 7.28,3.948825",
    id: "Fill-14",
    fill: "#CA4036",
    opacity: "0.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5958,37.07115 C13.5958,38.3209 11.36255,37.89715 10.40955,37.89715 C9.45655,37.89715 8.6843,36.8839 8.6843,35.63415 L8.6843,10.15715 C8.6843,8.9074 9.45655,7.8944 10.40955,7.8944 C11.36255,7.8944 10.91755,8.9074 10.91755,10.15715 L10.91755,36.88015 L13.5958,37.07115",
    id: "Fill-16",
    fillOpacity: "0.3",
    fill: "#CA4036"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.797325,18.996425 L57.797325,35.417675 C57.797325,36.377925 57.018575,37.156675 56.058075,37.156675 L12.688825,37.156675 C11.728325,37.156675 10.949825,36.377925 10.949825,35.417675 L10.949825,8.834925 C10.949825,7.874675 11.728325,7.095925 12.688825,7.095925 L45.073325,7.095925",
    id: "Stroke-18",
    stroke: "#CA4036",
    strokeWidth: "1.469",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.768525,16.767425 L57.768525,17.663175 L57.768525,22.283425 C57.768525,22.426925 57.652275,22.543175 57.509025,22.543175 L11.272525,22.543175 C11.129275,22.543175 11.013275,22.426925 11.013275,22.283425 L11.013275,18.352175 L11.013275,15.767425 C11.013275,15.624175 11.129275,15.507925 11.272525,15.507925 L47.656775,15.507925",
    id: "Stroke-20",
    stroke: "#CA4036",
    strokeWidth: "1.469"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "16.01035",
    y1: "32.361675",
    x2: "22.47385",
    y2: "32.361675",
    id: "Stroke-22",
    stroke: "#CA4036",
    strokeWidth: "1.469",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "26.293075",
    y1: "32.361675",
    x2: "32.756575",
    y2: "32.361675",
    id: "Stroke-24",
    stroke: "#CA4036",
    strokeWidth: "1.469",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1677,28.8148 C42.4277,28.8148 42.66095,28.9873 42.71995,29.2868 L43.22445,31.9658 L44.4707,28.8148 L45.72895,28.8148 L43.78845,33.4443 L42.5222,33.4443 L41.5677,29.74955 C41.50945,29.5223 41.45895,29.4388 41.2827,29.3428 C40.99545,29.18655 40.5197,29.0403 40.10145,28.94955 L40.12995,28.8148 L42.1677,28.8148 Z",
    id: "Fill-26",
    fill: "#CA4036"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.478975,31.80405 L53.109225,30.0653 L53.471975,31.80405 L52.478975,31.80405 Z M53.956225,28.81505 L52.933225,28.81505 L52.858475,28.8198 C52.661975,28.84555 52.500225,28.9718 52.423725,29.1543 L50.627225,33.4443 L51.884225,33.4443 L52.134475,32.7533 L53.670725,32.7533 L53.814975,33.4443 L54.922725,33.4443 L53.956225,28.81505 Z",
    id: "Fill-28",
    fill: "#CA4036"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-30",
    fill: "#CA4036",
    points: "47.439925 28.8148 46.449675 33.4443 45.252175 33.4443 46.242425 28.8148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.79025,28.730325 C50.1935,28.730325 50.52825,28.807325 50.7985,28.896825 L50.91025,28.935575 L50.7005,29.917325 C50.16325,29.670325 49.691,29.687575 49.519,29.710075 C49.173,29.755325 49.0145,29.931575 49.0115,30.098075 C48.9995,30.643575 50.69425,30.711075 50.6895,31.933075 C50.685,32.895075 49.862,33.516825 48.6045,33.516825 C48.12175,33.511575 47.6555,33.420825 47.363,33.308825 L47.27225,33.270825 L47.48925,32.256325 C47.76775,32.386575 48.11775,32.558575 48.71975,32.548825 C49.064,32.543325 49.433,32.406325 49.436,32.095825 C49.43775,31.908325 49.30475,31.770075 48.91725,31.571575 L48.73325,31.479825 C48.2925,31.254075 47.75925,30.887825 47.76625,30.260825 C47.77325,29.359825 48.60675,28.730325 49.79025,28.730325",
    id: "Fill-32",
    fill: "#CA4036"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.06785,9.00013231 C45.06785,4.02957823 49.0974875,0 54.06785,0 C59.0384772,0 63.06785,4.02957823 63.06785,9.00013231 C63.06785,13.9704218 59.0384772,18 54.06785,18 C49.0974875,18 45.06785,13.9704218 45.06785,9.00013231 Z",
    id: "Stroke-34",
    stroke: "#CA4036",
    strokeWidth: "1.1595",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72.9144177,30 L75.918603,26.9958147 C76.0271323,26.8872853 76.0271323,26.711791 75.918603,26.6032617 L75.3967383,26.081397 C75.288209,25.9728677 75.1127147,25.9728677 75.0041853,26.081397 L72,29.0855823 L68.9958147,26.081397 C68.8872853,25.9728677 68.711791,25.9728677 68.6032617,26.081397 L68.081397,26.6032617 C67.9728677,26.711791 67.9728677,26.8872853 68.081397,26.9958147 L71.0855823,30 L68.081397,33.0041853 C67.9728677,33.1127147 67.9728677,33.288209 68.081397,33.3967383 L68.6032617,33.918603 C68.711791,34.0271323 68.8872853,34.0271323 68.9958147,33.918603 L72,30.9144177 L75.0041853,33.918603 C75.1127147,34.0271323 75.288209,34.0271323 75.3967383,33.918603 L75.918603,33.3967383 C76.0271323,33.288209 76.0271323,33.1127147 75.918603,33.0041853 L72.9144177,30 Z",
    id: "Mask",
    fill: "#CA4036"
  })));
};
var ImgCardReplace = function ImgCardReplace(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.203675 3.76415 0.203675 3.76415 23.2499573 0 23.2499573"
  })), /*#__PURE__*/React.createElement("g", {
    id: "imgCardReplace",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-48",
    transform: "translate(18.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 16.317500)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.76415,22.563925 C3.76415,23.521675 2.05265,23.196925 1.32215,23.196925 C0.59215,23.196925 -0.0001,22.420675 -0.0001,21.462925 L-0.0001,1.937675 C-0.0001,0.979925 0.59215,0.203675 1.32215,0.203675 C2.05265,0.203675 1.71165,0.979925 1.71165,1.937675 L1.71165,22.417675 L3.76415,22.563925",
    id: "Fill-1",
    fill: "#AEEDFC",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.2263,29.753 L37.2263,37.6145 C37.2263,38.33675 36.6408,38.922 35.9188,38.922 L3.31055,38.922 C2.58855,38.922 2.00305,38.33675 2.00305,37.6145 L2.00305,17.628 C2.00305,16.90575 2.58855,16.3205 3.31055,16.3205 L18.78505,16.3205",
    id: "Stroke-4",
    stroke: "#2C3B45",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(2.000000, 22.567500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2047,5.172075 C23.2047,5.279825 23.1172,5.367075 23.0097,5.367075 L0.2457,5.367075 C0.13795,5.367075 0.0507,5.279825 0.0507,5.172075 L0.0507,2.216325 L0.0507,0.272575 C0.0507,0.165075 0.13795,0.077575 0.2457,0.077575 L23.1347,0.077575",
    id: "Fill-6",
    fill: "#00B3DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2047,5.172075 C23.2047,5.279825 23.1172,5.367075 23.0097,5.367075 L0.2457,5.367075 C0.13795,5.367075 0.0507,5.279825 0.0507,5.172075 L0.0507,2.216325 L0.0507,0.272575 C0.0507,0.165075 0.13795,0.077575 0.2457,0.077575 L23.1347,0.077575",
    id: "Stroke-8",
    stroke: "#2C3B45",
    strokeWidth: "1.25"
  })), /*#__PURE__*/React.createElement("line", {
    x1: "5.807975",
    y1: "35.316975",
    x2: "10.667475",
    y2: "35.316975",
    id: "Stroke-10",
    stroke: "#2C3B45",
    strokeWidth: "1.25",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "13.539175",
    y1: "35.316975",
    x2: "18.398675",
    y2: "35.316975",
    id: "Stroke-12",
    stroke: "#2C3B45",
    strokeWidth: "1.25",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49375,11.780825 L9.49375,9.834575 C9.49375,9.663825 9.67825,9.557325 9.826,9.642575 L11.51175,10.615825 L13.19725,11.588825 C13.345,11.674075 13.345,11.887575 13.19725,11.972825 L11.51175,12.945825 L9.826,13.919075 C9.67825,14.004575 9.49375,13.897825 9.49375,13.727075 L9.49375,11.780825 Z",
    id: "Fill-14",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.996075,29.96005 C61.913325,29.62455 62.127825,29.28305 62.475075,29.19755 C62.822325,29.1118 63.171075,29.31455 63.253575,29.6503 C63.336325,29.98605 63.121825,30.3273 62.774575,30.41305 C62.427325,30.4983 62.078825,30.2958 61.996075,29.96005",
    id: "Fill-16",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8828,6.8094 C27.8828,5.86965 28.64455,5.1079 29.58405,5.1079 L60.77655,5.1079 C61.71605,5.1079 62.4778,5.86965 62.4778,6.8094 L62.4778,24.61015 C62.4778,25.5499 61.71605,26.31165 60.77655,26.31165",
    id: "Stroke-18",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.051975,8.648525 C11.861475,7.875025 12.355475,7.088275 13.155975,6.891275 C13.955975,6.694025 14.759225,7.161025 14.949725,7.934525 C15.140475,8.707775 14.645975,9.494525 13.845975,9.691775 C13.045725,9.889025 12.242475,9.421775 12.051975,8.648525",
    id: "Fill-20",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.218625,33.148525 C39.028125,32.375025 39.522375,31.588275 40.322625,31.391275 C41.122625,31.194025 41.925875,31.661025 42.116375,32.434525 C42.307125,33.207775 41.812875,33.994525 41.012625,34.191775 C40.212375,34.389025 39.409125,33.921775 39.218625,33.148525",
    id: "Fill-22",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.210425,29.38045 L26.602175,29.38045 C25.880175,29.38045 25.294675,28.79495 25.294675,28.07295 L25.294675,8.0862 C25.294675,7.36445 25.880175,6.77895 26.602175,6.77895 L59.210425,6.77895 C59.932675,6.77895 60.517925,7.36445 60.517925,8.0862 L60.517925,28.07295 C60.517925,28.79495 59.932675,29.38045 59.210425,29.38045 Z",
    id: "Stroke-24",
    stroke: "#2C3B45",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.30125,18.39315 L25.5375,18.39315 C25.42975,18.39315 25.3425,18.30565 25.3425,18.1979 L25.3425,15.24215 L25.3425,13.29865 C25.3425,13.19065 25.42975,13.1034 25.5375,13.1034 L60.30125,13.1034 C60.409,13.1034 60.49625,13.19065 60.49625,13.29865 L60.49625,18.1979 C60.49625,18.30565 60.409,18.39315 60.30125,18.39315",
    id: "Fill-26",
    fill: "#00B3DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.30125,18.39315 L25.5375,18.39315 C25.42975,18.39315 25.3425,18.30565 25.3425,18.1979 L25.3425,15.24215 L25.3425,13.29865 C25.3425,13.19065 25.42975,13.1034 25.5375,13.1034 L60.30125,13.1034 C60.409,13.1034 60.49625,13.19065 60.49625,13.29865 L60.49625,18.1979 C60.49625,18.30565 60.409,18.39315 60.30125,18.39315 Z",
    id: "Stroke-28",
    stroke: "#2C3B45",
    strokeWidth: "1.25"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "29.0996",
    y1: "25.775225",
    x2: "33.9591",
    y2: "25.775225",
    id: "Stroke-30",
    stroke: "#2C3B45",
    strokeWidth: "1.25",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "36.8308",
    y1: "25.775225",
    x2: "41.69055",
    y2: "25.775225",
    id: "Stroke-32",
    stroke: "#2C3B45",
    strokeWidth: "1.25",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.766575,23.108475 C48.962075,23.108475 49.137325,23.238475 49.181825,23.463475 L49.561075,25.477725 L50.498075,23.108475 L51.444075,23.108475 L49.985325,26.589225 L49.033075,26.589225 L48.315325,23.811475 C48.271575,23.640475 48.233825,23.577725 48.101075,23.505725 C47.885075,23.387975 47.527575,23.278225 47.213075,23.209725 L47.234575,23.108475 L48.766575,23.108475 Z",
    id: "Fill-34",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5194,25.356025 L56.9934,24.048775 L57.2659,25.356025 L56.5194,25.356025 Z M57.63015,23.108775 L56.8609,23.108775 L56.80465,23.112275 C56.65715,23.131775 56.53515,23.226275 56.4779,23.363775 L55.12715,26.589275 L56.07215,26.589275 L56.26015,26.069525 L57.4154,26.069525 L57.5239,26.589275 L58.35665,26.589275 L57.63015,23.108775 Z",
    id: "Fill-36",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-38",
    fill: "#2C3B45",
    points: "52.730575 23.108475 51.986075 26.589225 51.085575 26.589225 51.830325 23.108475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.497675,23.045 C54.800925,23.045 55.052675,23.10275 55.255925,23.17 L55.339925,23.19925 L55.181925,23.9375 C54.778425,23.7515 54.423175,23.76475 54.293925,23.7815 C54.033925,23.8155 53.914675,23.948 53.912175,24.07325 C53.903175,24.48375 55.177425,24.53425 55.173925,25.453 C55.170425,26.17625 54.551675,26.644 53.606175,26.644 C53.243425,26.64 52.892675,26.5715 52.672925,26.4875 L52.604675,26.45875 L52.767675,25.69625 C52.977175,25.794 53.240175,25.9235 53.692675,25.916 C53.951675,25.912 54.229175,25.809 54.231425,25.5755 C54.232675,25.4345 54.132675,25.3305 53.841425,25.18125 L53.703175,25.1125 C53.371675,24.9425 52.970675,24.667 52.975925,24.196 C52.981175,23.51825 53.607675,23.045 54.497675,23.045",
    id: "Fill-40",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.557225,1.998125 L25.104225,1.998125 L25.104225,0.545125 C25.104225,0.245125 24.858975,0.000125 24.559225,0.000125 C24.259475,0.000125 24.014225,0.245125 24.014225,0.545125 L24.014225,1.998125 L22.560975,1.998125 C22.261225,1.998125 22.015975,2.243125 22.015975,2.543125 C22.015975,2.842875 22.261225,3.087875 22.560975,3.087875 L24.014225,3.087875 L24.014225,4.541375 C24.014225,4.840875 24.259475,5.086375 24.559225,5.086375 C24.858975,5.086375 25.104225,4.840875 25.104225,4.541375 L25.104225,3.087875 L26.557225,3.087875 C26.856975,3.087875 27.102225,2.842875 27.102225,2.543125 C27.102225,2.243125 26.856975,1.998125 26.557225,1.998125",
    id: "Fill-42",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.057225,33.498125 L60.604225,33.498125 L60.604225,32.045125 C60.604225,31.745125 60.358975,31.500125 60.059225,31.500125 C59.759475,31.500125 59.514225,31.745125 59.514225,32.045125 L59.514225,33.498125 L58.060975,33.498125 C57.761225,33.498125 57.515975,33.743125 57.515975,34.043125 C57.515975,34.342875 57.761225,34.587875 58.060975,34.587875 L59.514225,34.587875 L59.514225,36.041375 C59.514225,36.340875 59.759475,36.586375 60.059225,36.586375 C60.358975,36.586375 60.604225,36.340875 60.604225,36.041375 L60.604225,34.587875 L62.057225,34.587875 C62.356975,34.587875 62.602225,34.342875 62.602225,34.043125 C62.602225,33.743125 62.356975,33.498125 62.057225,33.498125",
    id: "Fill-44",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.07665,12.76935 L19.4289,16.1216 C19.5329,16.2256 19.5329,16.3956 19.4289,16.4996 L16.07665,19.85185",
    id: "Stroke-46",
    stroke: "#2C3B45",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var ImgCardSending = function ImgCardSending(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    id: "imgCardSending",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-49",
    transform: "translate(6.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.897025,43.61235 C72.787025,43.16585 73.072275,42.7116 73.534275,42.59785 C73.996025,42.4841 74.459525,42.7536 74.569525,43.20035 C74.679525,43.6466 74.394275,44.1006 73.932525,44.21435 C73.470525,44.3281 73.007025,44.0586 72.897025,43.61235",
    id: "Fill-1",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1574,38.6509 C13.0474,38.20465 13.33265,37.7504 13.79465,37.63665 C14.2564,37.52265 14.7199,37.7924 14.8299,38.2389 C14.9399,38.68515 14.65465,39.13915 14.1929,39.2529 C13.7309,39.3669 13.2674,39.09715 13.1574,38.6509",
    id: "Fill-5",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.402525,37.56205 L15.835525,35.95255 C15.786025,35.8113 15.907525,35.66955 16.054525,35.6968 L17.732025,36.0108 L19.409775,36.32455 C19.556775,36.35205 19.618775,36.5283 19.521525,36.6418 L18.411025,37.9378 L17.300275,39.2338 C17.203025,39.34755 17.019275,39.31305 16.969525,39.1718 L16.402525,37.56205 Z",
    id: "Fill-7",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.525825,12.82155 C27.525825,11.5718 28.538825,10.55855 29.788575,10.55855 L71.274825,10.55855 C72.524575,10.55855 73.537825,11.5718 73.537825,12.82155 L73.537825,36.49655 C73.537825,37.7463 72.524575,38.75955 71.274825,38.75955",
    id: "Stroke-9",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-11",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "71.579775 0.8682 71.768775 0.06245 60.065025 4.2872 69.833025 6.52745 70.815525 3.34395 72.285775 5.04945 71.498525 5.2832"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "66.397275",
    y1: "3.61185",
    x2: "60.065025",
    y2: "4.2871",
    id: "Stroke-13",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "69.41205",
    y1: "3.3057",
    x2: "67.97105",
    y2: "3.4122",
    id: "Stroke-15",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.93645,40.59355 C76.98495,40.54005 81.93445,37.09205 84.6732,31.72055 C87.41195,26.34855 87.85695,19.21655 85.81795,13.36705 C85.1657,11.49555 84.2472,9.7153 82.9277,8.53605 C81.6082,7.35655 79.8397,7.33955 78.3362,8.0873 C76.4797,9.01055 75.3897,10.9103 75.9447,13.3368 C76.49995,15.7633 78.60045,16.95705 80.5722,16.57605 C82.5442,16.1948 84.14795,14.7953 84.1832,12.2693 C84.2382,8.36705 81.1287,5.61505 78.18495,4.46005 C75.8467,3.5423 73.3807,3.1488 70.9357,3.3028",
    id: "Stroke-17",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.413875,9.633575 L18.960625,9.633575 L18.960625,8.180575 C18.960625,7.880575 18.715375,7.635575 18.415625,7.635575 C18.116125,7.635575 17.870875,7.880575 17.870875,8.180575 L17.870875,9.633575 L16.417625,9.633575 C16.117875,9.633575 15.872625,9.878825 15.872625,10.178575 C15.872625,10.478325 16.117875,10.723325 16.417625,10.723325 L17.870875,10.723325 L17.870875,12.176825 C17.870875,12.476325 18.116125,12.721825 18.415625,12.721825 C18.715375,12.721825 18.960625,12.476325 18.960625,12.176825 L18.960625,10.723325 L20.413875,10.723325 C20.713625,10.723325 20.958875,10.478325 20.958875,10.178575 C20.958875,9.878825 20.713625,9.633575 20.413875,9.633575",
    id: "Fill-19",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.168425,43.8319 C22.215425,43.8319 21.443175,42.81865 21.443175,41.5689 L21.443175,16.0919 C21.443175,14.84215 22.215425,13.82915 23.168425,13.82915 C24.121425,13.82915 23.676425,14.84215 23.676425,16.0919 L23.676425,41.8149 L26.354675,43.0059 C26.354675,44.25565 24.121425,43.8319 23.168425,43.8319 Z",
    id: "Fill-21",
    fill: "#AEEDFC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "16.671575",
    y1: "15.612575",
    x2: "0.125075",
    y2: "15.612575",
    id: "Stroke-23",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "16.671575",
    y1: "20.798375",
    x2: "6.071825",
    y2: "20.798375",
    id: "Stroke-25",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "16.54925",
    y1: "26.07155",
    x2: "10.42875",
    y2: "26.07155",
    id: "Stroke-27",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "7.51995",
    y1: "26.07155",
    x2: "4.9632",
    y2: "26.07155",
    id: "Stroke-29",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.192075,42.84135 L25.822575,42.84135 C24.862325,42.84135 24.083575,42.06285 24.083575,41.10235 L24.083575,14.51985 C24.083575,13.55935 24.862325,12.78085 25.822575,12.78085 L69.192075,12.78085 C70.152575,12.78085 70.931075,13.55935 70.931075,14.51985 L70.931075,41.10235 C70.931075,42.06285 70.152575,42.84135 69.192075,42.84135 Z",
    id: "Stroke-31",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.642875,28.2278 L24.406375,28.2278 C24.263125,28.2278 24.147125,28.11155 24.147125,27.9683 L24.147125,24.0368 L24.147125,21.45205 C24.147125,21.3088 24.263125,21.19255 24.406375,21.19255 L70.642875,21.19255 C70.786125,21.19255 70.902375,21.3088 70.902375,21.45205 L70.902375,27.9683 C70.902375,28.11155 70.786125,28.2278 70.642875,28.2278",
    id: "Fill-33",
    fill: "#00B3DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.642875,28.2278 L24.406375,28.2278 C24.263125,28.2278 24.147125,28.11155 24.147125,27.9683 L24.147125,24.0368 L24.147125,21.45205 C24.147125,21.3088 24.263125,21.19255 24.406375,21.19255 L70.642875,21.19255 C70.786125,21.19255 70.902375,21.3088 70.902375,21.45205 L70.902375,27.9683 C70.902375,28.11155 70.786125,28.2278 70.642875,28.2278 Z",
    id: "Stroke-35",
    stroke: "#2C3B45",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "29.144225",
    y1: "38.046425",
    x2: "35.607725",
    y2: "38.046425",
    id: "Stroke-37",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "39.426925",
    y1: "38.046425",
    x2: "45.890425",
    y2: "38.046425",
    id: "Stroke-39",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.301575,34.49955 C55.561575,34.49955 55.794825,34.67205 55.853825,34.97155 L56.358325,37.65055 L57.604575,34.49955 L58.863075,34.49955 L56.922325,39.12905 L55.655825,39.12905 L54.701575,35.4343 C54.643325,35.20705 54.592825,35.12355 54.416575,35.02755 C54.129075,34.8713 53.653575,34.72505 53.235325,34.6343 L53.263825,34.49955 L55.301575,34.49955 Z",
    id: "Fill-41",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.612975,37.4888 L66.243225,35.75005 L66.605975,37.4888 L65.612975,37.4888 Z M67.090225,34.4998 L66.067225,34.4998 L65.992225,34.50455 C65.795975,34.5303 65.633975,34.65655 65.557725,34.83905 L63.760975,39.12905 L65.017975,39.12905 L65.268225,38.43805 L66.804475,38.43805 L66.948975,39.12905 L68.056475,39.12905 L67.090225,34.4998 Z",
    id: "Fill-43",
    fill: "#2C3B45"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-45",
    fill: "#2C3B45",
    points: "60.573775 34.49955 59.583525 39.12905 58.386025 39.12905 59.376275 34.49955"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.924,34.415075 C63.3275,34.415075 63.66225,34.492075 63.93225,34.581575 L64.04425,34.620325 L63.83425,35.602075 C63.29725,35.355075 62.825,35.372325 62.65275,35.394825 C62.307,35.440075 62.1485,35.616325 62.14525,35.782825 C62.13325,36.328325 63.828,36.395825 63.8235,37.617825 C63.819,38.579825 62.99575,39.201575 61.73825,39.201575 C61.25575,39.196325 60.7895,39.105575 60.497,38.993575 L60.40625,38.955575 L60.623,37.941075 C60.90175,38.071325 61.2515,38.243325 61.8535,38.233575 C62.198,38.228075 62.567,38.091075 62.56975,37.780575 C62.5715,37.593075 62.4385,37.454825 62.051,37.256325 L61.86725,37.164575 C61.42625,36.938825 60.893,36.572575 60.9,35.945575 C60.907,35.044575 61.7405,34.415075 62.924,34.415075",
    id: "Fill-47",
    fill: "#2C3B45"
  }))));
};
var ImgAlerts = function ImgAlerts(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .182h3.354v3.831H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M63.94 35.917a7.187 7.187 0 0 1 4.08-1.263c4 0 7.243 3.258 7.243 7.278s-3.243 7.277-7.244 7.277a7.187 7.187 0 0 1-3.416-.858"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M44.05 18.867c-7.824 0-13.292 7.464-13.292 16.36V45.95c0 4.345-4.965 4.806-5.167 4.806h.755c-1.716 0-3.12 1.363-3.12 3.03v.086c0 1.666 1.404 3.03 3.12 3.03h4.997l-3.456-1.412-1.337-2.577.466-1.885 3.424-1.053 3.112-2.232s.934-1.425.872-3.47l-.436-12.023s.263-8.73 10.061-13.382"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M28.192 42.567c0 .516-.43.934-.962.934-.53 0-.961-.418-.961-.934 0-.515.43-.933.961-.933.532 0 .962.418.962.933M28.728 38.19c0 .669-.56 1.212-1.249 1.212-.69 0-1.248-.543-1.248-1.213s.559-1.212 1.248-1.212c.69 0 1.249.543 1.249 1.212M65.327 28.773c-.343-1.4.546-2.822 1.987-3.179 1.441-.357 2.887.488 3.23 1.887.343 1.4-.546 2.822-1.987 3.179-1.441.357-2.887-.488-3.23-1.887M42.173 61.399h-1.63v-1.636a.614.614 0 0 0-.61-.614.614.614 0 0 0-.61.614v1.636h-1.63a.614.614 0 0 0 0 1.227h1.63v1.637c0 .337.274.613.61.613.336 0 .61-.276.61-.613v-1.637h1.63a.614.614 0 0 0 0-1.227"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23 44.876)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M0 2.098V.378c0-.15.162-.244.292-.17l1.482.86 1.482.86c.13.076.13.264 0 .34l-1.482.859-1.482.86A.195.195 0 0 1 0 3.817v-1.72z",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M69.041 50.082c-.201 0-5.167-.465-5.167-4.85V34.41c0-8.978-6.4-16.324-14.225-16.324h-1.342c-7.824 0-14.225 7.346-14.225 16.324v10.82c0 4.386-4.965 4.851-5.167 4.851M63.626 46.043H52.104M46.63 17.484a2.354 2.354 0 0 1 2.348-2.36 2.354 2.354 0 0 1 2.349 2.36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M53.325 56.283c0 2.411-1.946 4.367-4.347 4.367-2.4 0-4.347-1.956-4.347-4.367"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M53.325 56.283c0 2.411-1.946 4.367-4.347 4.367-2.4 0-4.347-1.956-4.347-4.367"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M68.286 56.284H29.67c-1.716 0-3.12-1.376-3.12-3.057v-.088c0-1.681 1.404-3.057 3.12-3.057h38.616c1.716 0 3.12 1.376 3.12 3.057v.088c0 1.68-1.404 3.057-3.12 3.057z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    d: "M68.5 38v4.48M68.5 44.183v.414"
  })));
};
var ImgAnalysts = function ImgAnalysts(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .127h4.104V4.14H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0 .127h4.104V4.14H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M.138.018h3.97v4H.137z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M.025.182h3.334v3.82H.025z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M27.786 21.723l-2.027.307a.231.231 0 0 1-.261-.194l-.706-4.737a.232.232 0 0 1 .193-.264l2.027-.307a.23.23 0 0 1 .261.195l.706 4.737a.232.232 0 0 1-.193.263zM32.226 21.965l-2.18.33a.152.152 0 0 1-.173-.128l-.29-1.945a.153.153 0 0 1 .127-.174l2.181-.33a.153.153 0 0 1 .173.128l.29 1.945a.154.154 0 0 1-.128.174zM36.442 22.096l-1.929.292a.28.28 0 0 1-.318-.236l-1.07-7.186a.282.282 0 0 1 .234-.32l1.93-.293a.28.28 0 0 1 .317.237l1.07 7.186a.282.282 0 0 1-.234.32zM40.823 22.304l-1.978.3a.255.255 0 0 1-.29-.216l-.883-5.93a.257.257 0 0 1 .214-.292l1.978-.3a.256.256 0 0 1 .29.216l.883 5.93a.257.257 0 0 1-.214.292zM45.08 22.09l-1.907.288a.292.292 0 0 1-.33-.246l-1.163-7.806a.293.293 0 0 1 .244-.333l1.906-.288a.292.292 0 0 1 .33.246l1.164 7.806a.293.293 0 0 1-.244.333z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13 28.445)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M.056 2.63C-.206 1.555.475.462 1.576.19c1.103-.274 2.21.374 2.472 1.448.262 1.074-.418 2.166-1.52 2.44-1.103.274-2.21-.375-2.472-1.449",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.83 13.124)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M.056 2.63C-.206 1.555.475.462 1.576.19c1.103-.274 2.21.374 2.472 1.448.262 1.074-.418 2.166-1.52 2.44-1.103.274-2.21-.375-2.472-1.449",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M24.008 57.796c0 1.215-2.336.803-3.454.803-1.119 0-2.025-.986-2.025-2.201V27.334c0-1.216.906-2.201 2.025-2.201l.736 32.477 2.718.186z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M44.927 60.967a.851.851 0 0 1 .635-1.019.843.843 0 0 1 1.032.606.851.851 0 0 1-.635 1.018.844.844 0 0 1-1.032-.605M32.22 61.219a.851.851 0 0 1 .634-1.02.843.843 0 0 1 1.032.606.851.851 0 0 1-.634 1.019.844.844 0 0 1-1.032-.605M62.867 19.274a.851.851 0 0 1 .635-1.019.843.843 0 0 1 1.032.606.851.851 0 0 1-.635 1.018.844.844 0 0 1-1.032-.605M81.992 38.643a.851.851 0 0 1 .635-1.02.843.843 0 0 1 1.031.606.85.85 0 0 1-.634 1.018.844.844 0 0 1-1.032-.604M15.962 34.498a.851.851 0 0 1 .635-1.019.843.843 0 0 1 1.031.606.85.85 0 0 1-.634 1.018.844.844 0 0 1-1.032-.605"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.894 62.855)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M3.682 1.59H2.548V.447a.428.428 0 0 0-.425-.43.428.428 0 0 0-.426.43V1.59H.563a.428.428 0 0 0 0 .857h1.134V3.59c0 .236.192.429.426.429a.428.428 0 0 0 .425-.43V2.448h1.134a.428.428 0 0 0 0-.857",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M81.944 34.92H80.81v-1.144a.428.428 0 0 0-.425-.428.428.428 0 0 0-.425.428v1.143h-1.134a.428.428 0 0 0 0 .858h1.134v1.143c0 .235.191.428.425.428a.428.428 0 0 0 .425-.428v-1.143h1.134a.428.428 0 0 0 0-.858M40.807 61.933v-1.715c0-.15.162-.244.29-.17l1.474.858 1.473.858c.13.075.13.263 0 .338l-1.473.857-1.473.857a.194.194 0 0 1-.29-.169v-1.714z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(84.512 29.199)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M.025 2.092V.377c0-.15.161-.244.29-.169l1.474.857 1.473.858c.129.075.129.263 0 .338l-1.473.857-1.473.858a.194.194 0 0 1-.291-.17V2.092z",
    mask: "url(#h)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M74.909 58.06H22.874a1.773 1.773 0 0 1-1.766-1.78V23.9c0-.983.79-1.78 1.766-1.78h52.035c.975 0 1.765.797 1.765 1.78v32.38c0 .983-.79 1.78-1.765 1.78zM65.756 28.292H24.472"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M25.622 25.214c0 .48-.387.87-.863.87a.867.867 0 0 1-.864-.87c0-.481.387-.87.864-.87.476 0 .863.389.863.87M28.4 25.214c0 .48-.386.87-.863.87a.867.867 0 0 1-.863-.87c0-.481.386-.87.863-.87s.863.389.863.87"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25",
    d: "M79.97 53.934V41.297"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M39.179 54.678H36.52a.502.502 0 0 1-.498-.503V38.017c0-.276.224-.502.498-.502h2.658c.274 0 .498.226.498.502v16.158a.502.502 0 0 1-.498.503M45.545 54.678h-2.931a.364.364 0 0 1-.362-.365v-8.309c0-.2.162-.364.362-.364h2.93c.2 0 .362.164.362.364v8.31c0 .2-.162.364-.361.364M51.61 54.678h-2.604a.529.529 0 0 1-.525-.53V36.137a.53.53 0 0 1 .525-.53h2.605c.288 0 .525.239.525.53v18.011c0 .291-.237.53-.525.53M57.907 54.678h-2.738a.461.461 0 0 1-.458-.462V40.632c0-.254.206-.462.458-.462h2.738c.252 0 .458.208.458.462v13.584a.461.461 0 0 1-.458.462M64.087 54.678h-2.64a.51.51 0 0 1-.507-.511V37.451c0-.28.228-.51.506-.51h2.641a.51.51 0 0 1 .507.51v16.716a.51.51 0 0 1-.507.51"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M65.55 25.292c0-4.532 3.644-8.205 8.139-8.205 4.495 0 8.14 3.673 8.14 8.205 0 4.53-3.645 8.204-8.14 8.204-4.495 0-8.14-3.673-8.14-8.204"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M65.55 25.292c0-4.532 3.644-8.205 8.139-8.205 4.495 0 8.14 3.673 8.14 8.205 0 4.53-3.645 8.204-8.14 8.204-4.495 0-8.14-3.673-8.14-8.204z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M75.843 23.417a2.066 2.066 0 0 1-2.057 2.074 2.066 2.066 0 0 1-2.058-2.074c0-1.146.921-2.074 2.058-2.074 1.136 0 2.057.928 2.057 2.074zM70.566 29.131s.647-2.857 3.362-2.857c2.716 0 3.46 2.857 3.46 2.857"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M16.961 53.17c0-4.53 3.644-8.204 8.14-8.204 4.495 0 8.14 3.673 8.14 8.205 0 4.53-3.645 8.204-8.14 8.204-4.496 0-8.14-3.673-8.14-8.204"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M16.961 53.17c0-4.53 3.644-8.204 8.14-8.204 4.495 0 8.14 3.673 8.14 8.205 0 4.53-3.645 8.204-8.14 8.204-4.496 0-8.14-3.673-8.14-8.204z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M27.255 51.296a2.066 2.066 0 0 1-2.057 2.075 2.066 2.066 0 0 1-2.058-2.075c0-1.146.921-2.074 2.058-2.074 1.136 0 2.057.928 2.057 2.074zM21.978 57.01s.647-2.857 3.362-2.857c2.716 0 3.46 2.857 3.46 2.857M32.974 46.01c1.15-2.618 4.34-4.13 7.074-3.352 1.145.326 2.167.99 3.28 1.417 1.113.428 2.438.592 3.442-.052.745-.478 1.18-1.313 1.807-1.94 1.17-1.174 3.067-1.539 4.583-.88 1.053.457 1.875 1.33 2.887 1.875 2.346 1.263 5.381.5 7.41-1.231 2.03-1.733 3.226-4.25 4.127-6.772"
  })));
};
var ImgAppTrading = function ImgAppTrading(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.107.053h4.675v4.735H.107z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M62.942 54.799l.585-.208c.067.358.16.71.276 1.054.128.34.28.671.457.99l-.609.215a1.09 1.09 0 0 0-.658 1.386 1.07 1.07 0 0 0 1.367.666l1.218-.432a7.432 7.432 0 0 0 7.796 1.842 7.405 7.405 0 0 0 2.213-1.274c.463-.376.536-1.06.164-1.529a1.064 1.064 0 0 0-1.51-.166 5.27 5.27 0 0 1-1.576.917 5.283 5.283 0 0 1-4.735-.624l2.507-.89a1.09 1.09 0 0 0 .658-1.384 1.07 1.07 0 0 0-1.368-.667l-3.442 1.221a5.481 5.481 0 0 1-.71-2.051l3.443-1.221a1.09 1.09 0 0 0 .658-1.385 1.07 1.07 0 0 0-1.367-.667l-2.507.89c.677-2.276 2.769-3.814 5.114-3.76a1.08 1.08 0 0 0 1.086-1.076 1.082 1.082 0 0 0-1.062-1.1h-.017c-3.87-.087-7.147 2.874-7.5 6.779l-.481 2.474zM63.271 42.158c.617.303 1.36.042 1.659-.583l.778-1.624.444.218c1.755.862 3.874.117 4.725-1.66.851-1.776.116-3.924-1.638-4.786l-3.123-1.534a1.075 1.075 0 0 1-.489-1.427 1.05 1.05 0 0 1 1.408-.494l5.188 2.55c.617.302 1.36.042 1.659-.583.299-.625.042-1.377-.575-1.68l-2.51-1.233.778-1.625a1.264 1.264 0 0 0-.575-1.68 1.234 1.234 0 0 0-1.659.583l-.778 1.625-.445-.219c-1.754-.862-3.874-.117-4.724 1.66-.851 1.777-.116 3.923 1.638 4.785l3.124 1.535c.522.256.742.896.488 1.426a1.05 1.05 0 0 1-1.408.495l-3.945-2.045.183 2.991-.203 3.305z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M34.96 63.79c0 1.344 7.743 2.091 6.415 2.091h-7.52c-1.328 0-2.404-1.09-2.404-2.435V19.411c0-1.345 1.076-2.435 2.404-2.435h1.244l-.14 46.813zM44.193 51.034H41.54a.502.502 0 0 1-.497-.504V34.32c0-.278.224-.504.497-.504h2.654c.274 0 .498.226.498.504V50.53a.502.502 0 0 1-.498.504M50.55 51.034h-2.927a.364.364 0 0 1-.361-.365v-8.337c0-.2.162-.365.36-.365h2.927c.199 0 .361.164.361.365v8.337a.364.364 0 0 1-.36.365M56.605 51.034h-2.6a.53.53 0 0 1-.524-.53V32.431a.53.53 0 0 1 .525-.531h2.6a.53.53 0 0 1 .524.531v18.071a.53.53 0 0 1-.525.531"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M60.734 64.945H37.438c-1.328 0-2.404-1.09-2.404-2.435V18.013c0-1.345 1.076-2.435 2.404-2.435h23.296c.323 0 .63.064.911.18a2.436 2.436 0 0 1 1.493 2.255V62.51c0 1.345-1.076 2.435-2.404 2.435zM41.183 19.569h16.235"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25",
    d: "M49.26 60.91h.082"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M59.032 67.626h-7.438"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M66.196 13.839c-.226-.927.36-1.87 1.306-2.106.947-.236 1.897.323 2.123 1.25.225.927-.36 1.87-1.307 2.106-.946.236-1.897-.323-2.122-1.25M64.26 15.907a.974.974 0 0 1 .722-1.166.96.96 0 0 1 1.175.693.974.974 0 0 1-.723 1.166.96.96 0 0 1-1.175-.693M67.244 20.275a.974.974 0 0 1 .723-1.166.96.96 0 0 1 1.175.692.974.974 0 0 1-.723 1.166.96.96 0 0 1-1.175-.692M26.96 22.558c-.225-.927.36-1.87 1.307-2.106.947-.237 1.897.323 2.122 1.25.226.927-.359 1.87-1.306 2.106-.946.237-1.897-.323-2.122-1.25M25.027 35.344a.974.974 0 0 1 .723-1.167.96.96 0 0 1 1.175.693.974.974 0 0 1-.723 1.166.96.96 0 0 1-1.175-.692M63.949 10.798h-1.291V9.491c0-.27-.218-.49-.484-.49a.489.489 0 0 0-.485.49v1.307H60.4a.489.489 0 0 0-.485.49c0 .27.218.491.484.491h1.291v1.308c0 .27.218.49.485.49.266 0 .484-.22.484-.49V11.78h1.291c.266 0 .484-.22.484-.49s-.218-.49-.484-.49"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.81 67.198)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M4.592 3.663L3.365 2.42l1.227-1.243a.667.667 0 0 0 0-.932.647.647 0 0 0-.92 0L2.445 1.488 1.217.245a.647.647 0 0 0-.92 0 .667.667 0 0 0 0 .932L1.524 2.42.297 3.663a.668.668 0 0 0 0 .933.647.647 0 0 0 .92 0l1.228-1.243 1.227 1.243a.647.647 0 0 0 .92 0 .667.667 0 0 0 0-.933",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M29.053 62.374H28.01v-1.056a.395.395 0 0 0-.391-.397.395.395 0 0 0-.391.397v1.056h-1.044a.395.395 0 0 0-.39.397c0 .218.175.396.39.396h1.044v1.057c0 .218.176.396.39.396a.395.395 0 0 0 .392-.396v-1.057h1.043a.395.395 0 0 0 .391-.396.395.395 0 0 0-.39-.397M25.72 28.283v-1.962a.22.22 0 0 1 .331-.193l1.678.981 1.677.981c.147.086.147.3 0 .387l-1.677.98-1.678.982a.22.22 0 0 1-.33-.194v-1.962zM65.275 63.082v-1.317c0-.115.124-.187.222-.13l1.126.659 1.125.658a.15.15 0 0 1 0 .26l-1.125.658-1.126.658a.148.148 0 0 1-.222-.13v-1.316z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M48.715 28.973H46.27a.53.53 0 0 0-.526.533.53.53 0 0 0 .526.533h1.182v.765a.53.53 0 0 0 .526.533.53.53 0 0 0 .526-.533v-.765h.21a1.51 1.51 0 0 0 1.499-1.518 1.51 1.51 0 0 0-1.5-1.518h-1.47a.45.45 0 0 1-.447-.453c0-.25.2-.452.447-.452h2.444a.53.53 0 0 0 .526-.533.53.53 0 0 0-.526-.533h-1.183v-.765a.53.53 0 0 0-.526-.532.53.53 0 0 0-.526.532v.765h-.21a1.51 1.51 0 0 0-1.498 1.518 1.51 1.51 0 0 0 1.499 1.518h1.47a.45.45 0 0 1 .447.453c0 .25-.2.452-.446.452"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.386",
    d: "M40.735 38.027c.699-.656 1.759-1.038 2.817-1.017l.278 2.33c.032.263.185.612.503.571.134-.017.236-.105.327-.188l1.223-1.12c.1-.092.212-.19.36-.212.389-.059.56.388.567.714l.057 2.722 1.763-2.385c.45-.609 1.19-1.31 2.003-1.066.827.249.823 1.19.797 1.914-.063 1.776.688 3.564 2.071 4.927.13.128.27.256.455.325.209.079.448.073.677.066l3.425-.103"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M43.888 52.63H40.974h1.458zM50.606 52.63h-2.914 1.457zM57.087 52.715h-2.914 1.457z"
  })));
};
var ImgAssurance = function ImgAssurance(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.215.084h4.029v4.56H.215z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M14.472.337L6.55 8.797l-3.7-3.95a.808.808 0 0 0-1.194 0L.46 6.123a.946.946 0 0 0 0 1.275l5.492 5.863a.808.808 0 0 0 1.194 0l9.716-10.373a.946.946 0 0 0 0-1.275L15.667.337a.816.816 0 0 0-.598-.264.816.816 0 0 0-.597.264z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M30.641 28.32c-.694.114-1.404.213-2.128.29 0 0-5.42 29.083 18.97 38.378h.991a33.116 33.116 0 0 0 3.1-1.363S27.336 59.995 30.64 28.32"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M45.05 16.966l1.969-7.093a.854.854 0 0 1 1.05-.593l22.549 6.203a.85.85 0 0 1 .595 1.045l-2.832 10.208"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M47.487 16.964l.64-2.307.56-2.02a.854.854 0 0 1 1.05-.593l18.242 5.018a.85.85 0 0 1 .595 1.045l-2.325 8.38"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M38.883 25.164v-7.225c0-.53.431-.96.963-.96h19.666l4.761 4.854v4.005M42 20.122h12.802M42 22.446h3.77"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M64.127 22.057l-2.12-.137-2.258-.16a.232.232 0 0 1-.211-.21l-.16-2.247-.138-2.112"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M49.835 16.87l2.002-1.794a.968.968 0 0 1 1.168-.093l3.46 2.226-6.63-.339z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M70.363 50.523c-.277-1.117.44-2.254 1.602-2.54 1.162-.284 2.327.39 2.604 1.508.277 1.118-.44 2.255-1.602 2.54-1.162.285-2.328-.39-2.604-1.508M33.626 61.457c-.132-.535.212-1.08.768-1.216.556-.137 1.114.186 1.247.722.132.535-.211 1.08-.767 1.216-.557.137-1.115-.187-1.248-.722M71.459 44.858c-.133-.535.21-1.08.767-1.217.556-.136 1.115.187 1.247.723.133.535-.211 1.08-.767 1.216-.557.137-1.115-.187-1.247-.722M32.73 20.805h-1.37V19.44a.515.515 0 0 0-1.027 0v1.365h-1.37a.514.514 0 0 0-.515.511c0 .282.232.512.514.512h1.37v1.365a.514.514 0 0 0 1.029 0v-1.365h1.37c.282 0 .514-.23.514-.512a.515.515 0 0 0-.514-.511"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.75 55.04)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M.215 2.364V.317c0-.18.195-.292.351-.202l1.78 1.024 1.78 1.023a.233.233 0 0 1 0 .404l-1.78 1.023-1.78 1.023a.234.234 0 0 1-.35-.201V2.364z",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M50.808 65.363c24.39-9.294 18.97-38.377 18.97-38.377-11.141-1.2-18.97-7.196-18.97-7.196h-.991s-7.829 5.997-18.97 7.196c0 0-5.42 29.083 18.97 38.377h.991zM57.378 65.907c3.656-2.105 6.438-4.748 8.55-7.639"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M50.69 59.914c18.557-7.072 14.433-29.2 14.433-29.2-8.477-.912-14.433-5.474-14.433-5.474h-.754s-5.957 4.562-14.434 5.475c0 0-4.124 22.127 14.434 29.199h.754z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M47.952 49.133L42.46 43.27a.945.945 0 0 1 0-1.275l1.195-1.276a.807.807 0 0 1 1.195 0l3.7 3.95 7.922-8.46a.807.807 0 0 1 1.195 0l1.195 1.276c.33.352.33.923 0 1.275l-9.716 10.373a.808.808 0 0 1-1.194 0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42 35.872)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M-5.419 19.133h28.16V-5.535h-28.16z",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.25",
    d: "M-5.419 19.133h28.16V-5.535h-28.16z",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M47.952 49.133L42.46 43.27a.945.945 0 0 1 0-1.275l1.195-1.276a.807.807 0 0 1 1.195 0l3.7 3.95 7.922-8.46a.807.807 0 0 1 1.195 0l1.195 1.276c.33.352.33.923 0 1.275l-9.716 10.373a.808.808 0 0 1-1.194 0z"
  })));
};
var ImgAtm = function ImgAtm(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M62.878 21.688a4.637 4.637 0 0 0-4.241-.103c-.9.435-1.601.996-2.057 1.812l-2.597-.203-1.094-2.31a.509.509 0 0 1 .236-.673l7.914-3.819a.5.5 0 0 1 .667.238l1.716 3.623M63.283 23.243a4.746 4.746 0 0 1 .34-2.667c1.045-2.39 3.81-3.47 6.176-2.415 2.366 1.055 3.437 3.846 2.392 6.235a4.694 4.694 0 0 1-1.738 2.058l-.022 2.472 5.092-11.64a.508.508 0 0 0-.255-.665l-8.025-3.578a.5.5 0 0 0-.66.258l-4.33 9.899 1.03.043z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M66.936 23.407c-.594-.36-.777-.8-.55-1.32.1-.228.245-.399.435-.513.19-.113.371-.131.545-.054.059.027.1.069.124.126a.207.207 0 0 1 0 .17c-.028.062-.063.1-.107.115a.575.575 0 0 1-.182.02.601.601 0 0 0-.252.039c-.066.028-.125.1-.176.218a.407.407 0 0 0 .004.372c.061.113.186.225.375.334l.257-.588c.01-.025.032-.03.063-.016a.293.293 0 0 1 .102.086c.034.042.048.072.04.089l-.239.546.176.083c.054.024.094.04.12.048l.263-.602c.01-.024.031-.03.061-.017.035.016.07.045.104.087.034.042.047.072.04.089l-.234.535c.451.15.73.107.833-.13a.528.528 0 0 0 .044-.273c-.01-.092-.079-.207-.204-.345a.592.592 0 0 1-.14-.198.178.178 0 0 1 .008-.118.247.247 0 0 1 .137-.143.26.26 0 0 1 .202.017c.177.079.302.24.376.482.073.242.055.488-.054.738a.924.924 0 0 1-.52.5l-1.651-.377z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M70.454 39.956a4.657 4.657 0 0 0 3.073 1.695c2.569.305 4.896-1.55 5.198-4.143.302-2.594-1.536-4.943-4.105-5.248a4.658 4.658 0 0 0-4.159 1.685l-.102-2.397 12.02 1.426c.273.033.47.285.438.56l-1.024 8.796a.502.502 0 0 1-.555.442l-10.92-1.295.136-1.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M73.346 37.18c-.01.48.113.735.368.766a.514.514 0 0 0 .271-.038c.084-.037.173-.137.267-.299a.588.588 0 0 1 .145-.193.176.176 0 0 1 .115-.027c.079.01.137.04.176.09.038.051.053.117.043.2-.022.194-.137.362-.345.504a1.012 1.012 0 0 1-.714.166.917.917 0 0 1-.627-.355c-.165-.207-.245-.5-.238-.878l-.25-.03c-.023-.002-.033-.02-.029-.055a.298.298 0 0 1 .052-.12c.03-.048.055-.07.072-.068l.169.02.008-.072c.007-.058.02-.142.037-.25l-.241-.03c-.024-.002-.034-.02-.03-.053a.3.3 0 0 1 .052-.123c.03-.047.055-.07.072-.068l.196.024c.166-.68.528-.985 1.087-.92.246.03.451.12.614.269.164.15.234.319.212.51a.232.232 0 0 1-.082.156.202.202 0 0 1-.161.05c-.067-.008-.114-.031-.14-.069a.58.58 0 0 1-.073-.17.613.613 0 0 0-.111-.231c-.046-.056-.133-.091-.259-.106a.396.396 0 0 0-.35.113c-.09.093-.159.246-.206.46l.633.075c.026.004.037.022.033.057a.287.287 0 0 1-.052.123c-.03.046-.054.067-.072.065l-.587-.07-.027.194c-.007.06-.01.103-.011.13l.649.077c.026.003.037.021.033.054a.298.298 0 0 1-.051.126c-.03.045-.055.067-.073.065l-.575-.069zM26.476 25.636c-.979 0-1.772.8-1.772 1.788V62.42a1.78 1.78 0 0 0 1.772 1.788h3.031l-2.687-2.433V25.589l-.344.047z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M68.748 63.576h-39.94a1.78 1.78 0 0 1-1.77-1.788V25.027a1.78 1.78 0 0 1 1.77-1.789h39.94c.978 0 1.771.801 1.771 1.789v36.76a1.78 1.78 0 0 1-1.771 1.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M36.975 49.017a1.78 1.78 0 0 1-1.771-1.788V29.047a1.78 1.78 0 0 1 1.771-1.789h23.833c.978 0 1.771.801 1.771 1.79v18.181a1.78 1.78 0 0 1-1.771 1.788H36.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M45.223 59.34H33.255a1.78 1.78 0 0 1-1.772-1.79v-3.145a1.78 1.78 0 0 1 1.772-1.788h11.968c.979 0 1.772.8 1.772 1.788v3.146a1.78 1.78 0 0 1-1.772 1.788"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M45.223 59.34H33.255a1.78 1.78 0 0 1-1.772-1.79v-3.145a1.78 1.78 0 0 1 1.772-1.788h11.968c.979 0 1.772.8 1.772 1.788v3.146a1.78 1.78 0 0 1-1.772 1.788z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M62.706 56.333H56.79a1.78 1.78 0 0 1-1.772-1.789v-.139a1.78 1.78 0 0 1 1.772-1.788h5.915c.978 0 1.771.8 1.771 1.788v.14a1.78 1.78 0 0 1-1.771 1.788z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E3B45",
    d: "M30.944 30.29c0-.558.448-1.01 1-1.01.553 0 1 .452 1 1.01 0 .557-.447 1.01-1 1.01-.552 0-1-.453-1-1.01M30.944 35.337c0-.557.448-1.01 1-1.01.553 0 1 .453 1 1.01 0 .558-.447 1.01-1 1.01-.552 0-1-.452-1-1.01M30.944 40.385c0-.558.448-1.01 1-1.01.553 0 1 .452 1 1.01 0 .557-.447 1.01-1 1.01-.552 0-1-.453-1-1.01M30.944 45.432c0-.557.448-1.01 1-1.01.553 0 1 .453 1 1.01 0 .558-.447 1.01-1 1.01-.552 0-1-.452-1-1.01M64.507 30.29c0-.558.448-1.01 1-1.01s1 .452 1 1.01c0 .557-.448 1.01-1 1.01s-1-.453-1-1.01M64.507 35.337c0-.557.448-1.01 1-1.01s1 .453 1 1.01c0 .558-.448 1.01-1 1.01s-1-.452-1-1.01M64.507 40.385c0-.558.448-1.01 1-1.01s1 .452 1 1.01c0 .557-.448 1.01-1 1.01s-1-.453-1-1.01M64.507 45.432c0-.557.448-1.01 1-1.01s1 .453 1 1.01c0 .558-.448 1.01-1 1.01s-1-.452-1-1.01"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M19.986 57.298a.981.981 0 0 1-.993.968.98.98 0 0 1-.993-.968c0-.872.444-.97.993-.97.548 0 .993.434.993.97M74.75 28.27a.981.981 0 0 1-.993.97.98.98 0 0 1-.993-.97c0-.871.444-.968.993-.968.548 0 .993.433.993.968M24.385 64.813a.998.998 0 0 1-1.01.986c-.557 0-1.01-.778-1.01-.986a.998.998 0 0 1 1.01-.985.998.998 0 0 1 1.01.985M77.133 25.493h-1.009v-1.018c0-.21-.17-.382-.378-.382a.381.381 0 0 0-.378.382v1.018h-1.009a.381.381 0 0 0 0 .764h1.009v1.018c0 .21.17.382.378.382a.38.38 0 0 0 .378-.382v-1.018h1.009a.381.381 0 0 0 0-.764M19.312 61.274l.114-1.81a.205.205 0 0 1 .318-.159l1.496 1.006 1.496 1.005a.208.208 0 0 1-.023.357l-1.61.805-1.61.805a.205.205 0 0 1-.296-.198l.115-1.81z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M35.24 56.032h8M55.748 58.65h8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E3B45",
    d: "M45.057 38.682h.748l-.377-1.044-.371 1.044zm1.005.702l-.12-.318h-1.018l-.12.325a1.15 1.15 0 0 1-.12.256c-.033.044-.087.066-.162.066a.237.237 0 0 1-.17-.07.218.218 0 0 1-.073-.16c0-.035.006-.07.017-.108a2.11 2.11 0 0 1 .057-.153l.64-1.643.066-.17a.869.869 0 0 1 .082-.164.334.334 0 0 1 .115-.106.346.346 0 0 1 .175-.041c.07 0 .13.013.177.04a.34.34 0 0 1 .115.105.735.735 0 0 1 .073.137l.076.196.655 1.632a.828.828 0 0 1 .077.27.225.225 0 0 1-.073.162.238.238 0 0 1-.175.073.225.225 0 0 1-.103-.021.217.217 0 0 1-.072-.059.54.54 0 0 1-.062-.114 5.235 5.235 0 0 1-.057-.135zM48.995 37.564h-.553V39.4c0 .106-.024.185-.07.236a.235.235 0 0 1-.182.077.237.237 0 0 1-.183-.078c-.048-.052-.071-.13-.071-.235v-1.837h-.554c-.086 0-.15-.02-.193-.058a.198.198 0 0 1-.063-.153c0-.065.022-.117.066-.155.043-.038.107-.057.19-.057h1.613c.088 0 .153.02.196.059.043.039.064.09.064.153a.194.194 0 0 1-.065.153c-.043.039-.108.058-.195.058M51.102 39.289l-.402-1.611v1.746c0 .096-.021.169-.064.217a.216.216 0 0 1-.17.072.215.215 0 0 1-.167-.071c-.044-.048-.065-.12-.065-.218v-2.002c0-.11.028-.185.085-.223a.406.406 0 0 1 .231-.058h.157a.59.59 0 0 1 .206.026.173.173 0 0 1 .095.093c.02.045.044.118.07.22l.364 1.384.364-1.385a1.46 1.46 0 0 1 .07-.219.173.173 0 0 1 .095-.093.59.59 0 0 1 .206-.026h.157c.097 0 .174.02.231.058.057.038.085.113.085.223v2.002c0 .096-.021.169-.064.217a.218.218 0 0 1-.172.072.213.213 0 0 1-.165-.072c-.044-.048-.065-.12-.065-.217v-1.746l-.402 1.611a3.307 3.307 0 0 1-.064.23.319.319 0 0 1-.091.134.265.265 0 0 1-.185.06.278.278 0 0 1-.15-.038.28.28 0 0 1-.096-.1.561.561 0 0 1-.054-.134l-.04-.152"
  })));
};
var ImgBridgeloan = function ImgBridgeloan(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M65.713 51.21l4.753-7.793a.636.636 0 01.872-.212l9.503 5.808a.638.638 0 01.211.873l-.63 1.033m-5.65 8.709l-.993 1.52c-2.08 3.182-3.853 5.867-3.899 5.839"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M66.32 50.979l6.384-6.526a.636.636 0 01.897-.01l7.954 7.797c.249.244.253.649.009.898l-13.835 14.14a.635.635 0 01-.898.01"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M66.169 51.322c2.312-1.812 5.898-1.737 8.052.374a5.953 5.953 0 01.086 8.414 5.94 5.94 0 01-5.902 1.553"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M70.002 57.022c.47.379.82.452 1.048.218a.662.662 0 00.172-.301c.029-.114-.001-.28-.09-.498-.058-.141-.084-.24-.078-.295a.224.224 0 01.062-.136.312.312 0 01.225-.108c.08 0 .158.037.232.11.176.172.254.417.234.736-.02.318-.15.6-.39.845-.224.23-.504.35-.838.357-.335.007-.687-.138-1.058-.436l-.224.228c-.02.022-.047.017-.078-.013a.37.37 0 01-.08-.145c-.023-.067-.027-.109-.011-.124l.15-.155-.064-.063a7.404 7.404 0 01-.22-.23l-.217.22c-.02.022-.046.018-.076-.011a.376.376 0 01-.082-.147c-.023-.067-.027-.109-.012-.124l.176-.18c-.547-.688-.57-1.288-.07-1.8.22-.225.468-.362.743-.41.276-.05.5.01.672.179.058.057.089.125.092.203a.26.26 0 01-.076.2c-.06.06-.119.09-.177.088a.741.741 0 01-.226-.057.76.76 0 00-.316-.067c-.091.004-.193.063-.306.178a.507.507 0 00-.16.44c.023.162.122.349.299.561l.565-.578c.024-.024.05-.02.082.01a.364.364 0 01.083.146c.022.065.025.106.009.123l-.526.537.172.176c.054.053.094.09.12.11l.58-.592c.024-.024.05-.022.08.008a.372.372 0 01.085.148c.022.065.025.106.009.123l-.515.526zM79.878 52.085a.578.578 0 11-.604.986.578.578 0 01.604-.986"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".575"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.863 63.11c3.997 0 7.916 1.283 11.218 3.704a19.964 19.964 0 012.992 2.7 1.14 1.14 0 01-.043 1.563 1.032 1.032 0 01-.727.302c-.281 0-.562-.116-.77-.347a17.78 17.78 0 00-2.67-2.408 16.843 16.843 0 00-9.987-3.28c-4.685 0-9.335 1.946-12.71 5.708-.21.232-.491.35-.774.35-.26 0-.52-.099-.724-.299a1.14 1.14 0 01-.049-1.563c3.186-3.55 7.506-5.793 12.163-6.314a18.662 18.662 0 012.08-.117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.75 69.5v-5.832a22.813 22.813 0 00-16.069-4.386 22.89 22.89 0 00-11.531 4.637v4.949M18.75 65.201V60.3M24.5 63.267V58M31.4 63.43V58M37.15 67.2v-6.9"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M63.876 53.415l2.907-4.22a.636.636 0 01.882-.163l1.048.723"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M68.032 39.427c-.15-.612.24-1.235.874-1.391.632-.156 1.268.213 1.418.826.151.612-.24 1.235-.873 1.391-.633.156-1.268-.214-1.419-.826M67.032 27.427c-.15-.612.24-1.235.874-1.391.632-.156 1.268.214 1.418.826.151.612-.24 1.235-.873 1.391-.633.156-1.268-.214-1.419-.826M17.032 56.427c-.15-.612.24-1.235.874-1.391.632-.156 1.268.214 1.418.826.151.612-.24 1.235-.873 1.391-.633.156-1.268-.214-1.419-.826M82.872 65.146h-1.559v-1.56A.587.587 0 0080.73 63a.587.587 0 00-.585.585v1.561h-1.56a.587.587 0 00-.584.585c0 .322.263.585.585.585h1.559v1.561c0 .322.263.585.585.585a.587.587 0 00.584-.585v-1.56h1.56a.587.587 0 00.584-.586.587.587 0 00-.585-.585M20.793 48.427l-.778-2.208a.266.266 0 01.3-.35l2.3.43 2.298.43c.202.038.287.28.154.436l-1.522 1.777-1.522 1.778a.266.266 0 01-.454-.085l-.776-2.208zM30.042 25.012l-1.38-1.381 1.38-1.381a.735.735 0 000-1.036.733.733 0 00-1.035 0l-1.38 1.38-1.379-1.38a.733.733 0 00-1.035 0 .736.736 0 000 1.036l1.38 1.38-1.38 1.382a.733.733 0 001.035 1.036l1.38-1.381 1.38 1.38a.733.733 0 001.034-1.035M70.054 34.4c-.253-1.03.404-2.077 1.469-2.34 1.064-.263 2.132.36 2.386 1.39.253 1.03-.404 2.077-1.469 2.34-1.064.262-2.132-.36-2.386-1.39M29.03 34.329c-.14-.57.224-1.15.813-1.296.59-.145 1.18.2 1.32.77.14.57-.223 1.15-.812 1.295-.59.146-1.18-.2-1.321-.77"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5 64h34a3.5 3.5 0 010 7h-34a3.5 3.5 0 010-7zm26 3v4m3-2v2M65.5 57h-34a3.5 3.5 0 000 7h34a3.5 3.5 0 000-7zm-25 3v4m-3-2v2M62.5 50h-34a3.5 3.5 0 000 7h34a3.5 3.5 0 000-7zm-26 3v4m-3-2v2M35.5 43h34a3.5 3.5 0 010 7h-34a3.5 3.5 0 010-7zm26 3v4m3-2v2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 10)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "17",
    cy: "16.5",
    r: "16.5",
    fill: "#AEEDFC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "18.5",
    cy: "16.5",
    r: "16.5",
    fill: "#00B3DB",
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M16.353 18.552c.225 2.66 1.05 4.018 2.475 4.072a2.806 2.806 0 001.466-.332c.444-.242.876-.832 1.296-1.768.269-.61.5-.988.692-1.133a.947.947 0 01.615-.202c.438.017.779.156 1.02.42s.36.625.355 1.083c-.012 1.085-.549 2.066-1.61 2.947-1.061.879-2.34 1.29-3.837 1.233-1.402-.053-2.622-.614-3.654-1.683-1.031-1.07-1.638-2.655-1.82-4.75l-1.391-.054c-.131-.004-.196-.103-.193-.295.001-.185.073-.416.215-.69.142-.275.26-.41.355-.407l.942.036.004-.399c.004-.326.025-.793.06-1.406l-1.347-.05c-.132-.005-.196-.1-.194-.285.002-.193.074-.426.216-.702.142-.273.26-.41.354-.406l1.096.04c.517-3.828 2.335-5.682 5.452-5.563 1.373.051 2.553.454 3.537 1.208.986.755 1.472 1.663 1.46 2.726a1.265 1.265 0 01-.36.905 1.093 1.093 0 01-.86.344c-.37-.015-.642-.12-.811-.318-.17-.2-.336-.501-.501-.905-.205-.532-.452-.943-.742-1.232-.288-.287-.783-.445-1.485-.471-.803-.03-1.424.23-1.865.783-.44.551-.731 1.43-.868 2.637l3.528.133c.144.006.216.105.215.296-.002.208-.072.444-.21.707-.14.265-.26.395-.36.391l-3.276-.124-.034 1.084c-.004.333 0 .573.013.721l3.616.138c.144.005.218.1.216.284-.003.214-.073.453-.211.717-.139.265-.26.396-.362.392l-3.207-.122z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M37.5 45h13a.5.5 0 110 1h-13a.5.5 0 110-1zM49.5 54h13a.5.5 0 110 1h-13a.5.5 0 110-1zM51.5 59h13a.5.5 0 110 1h-13a.5.5 0 110-1zM33.5 66h13a.5.5 0 110 1h-13a.5.5 0 110-1z"
  }))));
};
var ImgBrowserExchange = function ImgBrowserExchange(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.243.096H4.25V4.11H.243z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M49.177 47.458l-2.668 3.125a2.813 2.813 0 0 1-2.14.983h-3.85M61.76 40.075h-4.355c-1.182 0-2.315.504-3.07 1.411l-2.566 2.973"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M58.727 43.25l2.894-2.898a.591.591 0 0 0 .177-.428.657.657 0 0 0-.177-.429l-2.868-2.898M61.76 51.188h-4.355c-.83 0-1.61-.353-2.139-.983l-7.826-9.097a4.02 4.02 0 0 0-3.07-1.412h-3.85"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M58.753 54.741l2.894-2.898c.226-.227.226-.605 0-.857l-2.894-2.898M41.947 57.832c-2.091 5.592-7.104 8.464-13.735 8.464-8.413 0-15.232-13.671-15.232-21.623"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M15.604 30.964c-.265-1.078.423-2.174 1.536-2.448 1.113-.275 2.23.376 2.496 1.453.265 1.077-.423 2.173-1.536 2.448-1.113.274-2.23-.376-2.496-1.453"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M26.665 57.774c0 1.22-2.359.806-3.488.806-1.13 0-2.046-.989-2.046-2.208V27.21c0-1.22.916-2.208 2.046-2.208l.743 32.585 2.745.187z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M8 39.545a4.91 4.91 0 0 1 4.906-4.913 4.91 4.91 0 0 1 4.906 4.913 4.91 4.91 0 0 1-4.906 4.913A4.91 4.91 0 0 1 8 39.545z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M15.48 39.545c0 2.687-1.153 4.865-2.574 4.865-1.421 0-2.573-2.178-2.573-4.865 0-2.686 1.152-4.864 2.573-4.864s2.574 2.178 2.574 4.864zM8.367 37.844h8.898M8.367 41.022h8.898"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M47.793 60.956c-.11-.45.176-.908.641-1.022.465-.115.932.157 1.042.607.111.45-.176.907-.64 1.022-.466.115-.932-.157-1.043-.607M82.126 21.057c-.11-.45.177-.908.642-1.022.465-.115.932.157 1.042.607.111.45-.176.907-.641 1.022-.465.115-.932-.157-1.043-.607M51.478 64.445h-1.145v-1.148a.431.431 0 0 0-.43-.43.431.431 0 0 0-.43.43v1.148h-1.145a.431.431 0 0 0 0 .86h1.146v1.146c0 .237.193.43.43.43.235 0 .429-.193.429-.43v-1.146h1.145a.431.431 0 0 0 0-.86"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.45 14.156)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M3.822 1.673H2.676V.526a.43.43 0 0 0-.429-.43.431.431 0 0 0-.43.43v1.147H.672a.431.431 0 0 0 0 .86h1.145V3.68c0 .236.194.43.43.43s.43-.194.43-.43V2.533h1.145a.43.43 0 0 0 0-.86",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M43.255 61.925v-1.72c0-.152.163-.246.293-.17l1.488.86 1.488.86c.13.075.13.264 0 .34l-1.488.86-1.488.86a.195.195 0 0 1-.293-.17v-1.72zM71.44 17.236v-1.72c0-.15.163-.245.294-.17l1.487.86 1.488.86c.13.076.13.265 0 .34l-1.488.86-1.487.86a.196.196 0 0 1-.294-.17v-1.72z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M78.074 58.04H25.52c-.985 0-1.784-.8-1.784-1.787V23.765c0-.986.799-1.786 1.784-1.786h52.554c.985 0 1.783.8 1.783 1.786v32.488c0 .987-.798 1.786-1.783 1.786zM76.46 28.227H27.134"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M28.295 25.083a.873.873 0 1 1-1.745.001.873.873 0 0 1 1.745 0M31.101 25.083a.873.873 0 1 1-1.745.002.873.873 0 0 1 1.745-.002M77.17 25.083a.873.873 0 1 1-1.746.002.873.873 0 0 1 1.745-.002"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M83.178 53.9V41.22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M35.975 74.523c0 1.315-1.101 2.38-2.46 2.38s-2.46-1.065-2.46-2.38 1.101-2.38 2.46-2.38 2.46 1.065 2.46 2.38M31.047 68.517c0 .676-.566 1.224-1.265 1.224-.698 0-1.264-.548-1.264-1.224 0-.676.566-1.224 1.264-1.224.699 0 1.265.548 1.265 1.224"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00B3DB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M49.428 44.182l-2.668 3.125a2.813 2.813 0 0 1-2.139.983h-3.85M62.011 36.799h-4.354c-1.182 0-2.315.504-3.07 1.411l-2.567 2.973"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00B3DB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M59.979 39.974l2.894-2.898a.591.591 0 0 0 .176-.428.657.657 0 0 0-.176-.429l-2.869-2.898M62.011 49.046h-4.354c-.83 0-1.61-.353-2.139-.983l-7.826-9.097a4.02 4.02 0 0 0-3.07-1.412h-3.85"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00B3DB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M60.004 52.599l2.894-2.898c.227-.227.227-.605 0-.857l-2.894-2.898"
  })));
};
var ImgBuilding = function ImgBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M61.318 18.375l1.12-.487a.14.14 0 0 1 .195.142l-.134 1.205-.135 1.206a.14.14 0 0 1-.22.096l-.987-.718-.987-.719a.137.137 0 0 1 .027-.237l1.121-.488z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M62.731 26v-2.225a2.24 2.24 0 0 1 2.251-2.23h6.476a2.24 2.24 0 0 1 2.25 2.23v27.61"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M69.533 27.997h-2.33a.501.501 0 0 1-.502-.497V25.19c0-.273.226-.497.502-.497h2.33c.276 0 .502.224.502.497V27.5a.501.501 0 0 1-.502.497zM69.533 33.708h-2.33a.501.501 0 0 1-.502-.497v-2.309c0-.274.226-.497.502-.497h2.33c.276 0 .502.223.502.497v2.309a.501.501 0 0 1-.502.497zM69.533 39.56h-2.33a.501.501 0 0 1-.502-.497v-2.309c0-.273.226-.497.502-.497h2.33c.276 0 .502.224.502.497v2.309a.501.501 0 0 1-.502.497zM67.203 42.109h2.33c.276 0 .502.224.502.498v2.308a.501.501 0 0 1-.502.498h-2.33a.501.501 0 0 1-.502-.498v-2.308c0-.274.226-.498.502-.498z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M37.92 64.861c0 .519-.44.94-.981.94-.542 0-.981-.421-.981-.94 0-.519.44-.94.98-.94.543 0 .982.421.982.94M28.576 46.99c0 .518-.44.939-.982.939-.541 0-.98-.42-.98-.94 0-.518.439-.939.98-.939.542 0 .982.42.982.94M30.227 43.466c0 .519-.44.939-.981.939-.542 0-.981-.42-.981-.94 0-.518.439-.939.98-.939.543 0 .982.42.982.94M78.405 48.468h-.98v-.97a.367.367 0 0 0-.735 0v.97h-.98a.367.367 0 0 0-.367.365c0 .2.165.364.367.364h.98v.97a.367.367 0 0 0 .735 0v-.97h.98a.367.367 0 0 0 .367-.364c0-.201-.165-.365-.367-.365M27.87 52.221l-1.32 1.002-1.01-1.306a.629.629 0 0 0-.874-.114.615.615 0 0 0-.116.865l1.012 1.307-1.319 1.002a.616.616 0 0 0-.115.865c.209.27.602.321.874.114l1.318-1.002 1.012 1.307c.208.27.602.32.874.114a.615.615 0 0 0 .115-.866l-1.012-1.306 1.32-1.002a.616.616 0 0 0 .114-.866.629.629 0 0 0-.874-.114"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M34.789 58.957c0 1.232 2.803 2.23 1.56 2.23h-2.677a2.24 2.24 0 0 1-2.25-2.23V18.203a2.24 2.24 0 0 1 2.25-2.23h1.09l.027 42.984z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M69.531 60.566h-1.595a.709.709 0 0 1-.712-.705v-2.144c0-.39.32-.705.712-.705h1.595c.393 0 .712.315.712.705v2.144c0 .389-.319.705-.712.705z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M65.937 53.354c0-2.085 1.706-3.776 3.811-3.776s3.811 1.69 3.811 3.776c0 2.085-1.706 3.776-3.81 3.776-2.106 0-3.812-1.69-3.812-3.776"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M64.937 53.354c0-2.085 1.706-3.776 3.811-3.776s3.811 1.69 3.811 3.776c0 2.085-1.706 3.776-3.81 3.776-2.106 0-3.812-1.69-3.812-3.776zM55.901 60.566H36.276c-.983 0-1.78-.79-1.78-1.763V15.888c0-.974.797-1.764 1.78-1.764h17.946c.983 0 1.78.79 1.78 1.764v44.579a.1.1 0 0 1-.1.099z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M64.755 60.566H56.03V28.365a2.24 2.24 0 0 1 2.25-2.23h6.476a2.24 2.24 0 0 1 2.25 2.23V49.85"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M66.72 60.566h-1.595a.709.709 0 0 1-.712-.705v-2.448c0-.39.319-.705.712-.705h1.595c.393 0 .712.316.712.705v2.448c0 .389-.32.705-.712.705zM58.858 63.404H47.605"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M40.313 20.978h-2.33a.501.501 0 0 1-.502-.498v-2.308c0-.274.226-.498.502-.498h2.33c.276 0 .502.224.502.498v2.308a.501.501 0 0 1-.502.498M46.506 20.978h-2.33a.501.501 0 0 1-.502-.498v-2.308c0-.274.226-.498.502-.498h2.33c.276 0 .502.224.502.498v2.308a.501.501 0 0 1-.502.498M52.794 20.978h-2.33a.501.501 0 0 1-.502-.498v-2.308c0-.274.226-.498.502-.498h2.33c.277 0 .503.224.503.498v2.308a.501.501 0 0 1-.503.498M40.313 26.688h-2.33a.501.501 0 0 1-.502-.497v-2.309c0-.273.226-.497.502-.497h2.33c.276 0 .502.224.502.497v2.309a.501.501 0 0 1-.502.497M46.506 26.688h-2.33a.501.501 0 0 1-.502-.497v-2.309c0-.273.226-.497.502-.497h2.33c.276 0 .502.224.502.497v2.309a.501.501 0 0 1-.502.497M52.794 26.688h-2.33a.501.501 0 0 1-.502-.497v-2.309c0-.273.226-.497.502-.497h2.33c.277 0 .503.224.503.497v2.309a.501.501 0 0 1-.503.497M40.313 32.54h-2.33a.501.501 0 0 1-.502-.497v-2.308c0-.274.226-.498.502-.498h2.33c.276 0 .502.224.502.498v2.308a.501.501 0 0 1-.502.498M46.506 32.54h-2.33a.501.501 0 0 1-.502-.497v-2.308c0-.274.226-.498.502-.498h2.33c.276 0 .502.224.502.498v2.308a.501.501 0 0 1-.502.498M52.794 32.54h-2.33a.501.501 0 0 1-.502-.497v-2.308c0-.274.226-.498.502-.498h2.33c.277 0 .503.224.503.498v2.308a.501.501 0 0 1-.503.498M40.313 38.393h-2.33a.501.501 0 0 1-.502-.498v-2.308c0-.274.226-.498.502-.498h2.33c.276 0 .502.224.502.498v2.308a.501.501 0 0 1-.502.498M62.513 32.588h-2.33a.501.501 0 0 1-.502-.498v-2.308c0-.274.226-.498.502-.498h2.33c.276 0 .502.224.502.498v2.308a.501.501 0 0 1-.502.498M62.513 38.299h-2.33a.501.501 0 0 1-.502-.498v-2.309c0-.273.226-.497.502-.497h2.33c.276 0 .502.224.502.497v2.309a.501.501 0 0 1-.502.498M62.513 44.15h-2.33a.501.501 0 0 1-.502-.497v-2.308c0-.274.226-.498.502-.498h2.33c.276 0 .502.224.502.498v2.308a.501.501 0 0 1-.502.498M60.183 46.7h2.33c.276 0 .502.223.502.497v2.309a.501.501 0 0 1-.502.497h-2.33a.501.501 0 0 1-.502-.497v-2.309c0-.274.226-.498.502-.498M60.183 52.882h2.33c.276 0 .502.224.502.498v2.308a.501.501 0 0 1-.502.498h-2.33a.501.501 0 0 1-.502-.498V53.38c0-.274.226-.498.502-.498M46.506 38.393h-2.33a.501.501 0 0 1-.502-.498v-2.308c0-.274.226-.498.502-.498h2.33c.276 0 .502.224.502.498v2.308a.501.501 0 0 1-.502.498M52.794 38.393h-2.33a.501.501 0 0 1-.502-.498v-2.308c0-.274.226-.498.502-.498h2.33c.277 0 .503.224.503.498v2.308a.501.501 0 0 1-.503.498M40.313 44.245h-2.33a.501.501 0 0 1-.502-.497v-2.309c0-.274.226-.497.502-.497h2.33c.276 0 .502.223.502.497v2.309a.501.501 0 0 1-.502.497M46.506 44.245h-2.33a.501.501 0 0 1-.502-.497v-2.309c0-.274.226-.497.502-.497h2.33c.276 0 .502.223.502.497v2.309a.501.501 0 0 1-.502.497M52.794 44.245h-2.33a.501.501 0 0 1-.502-.497v-2.309c0-.274.226-.497.502-.497h2.33c.277 0 .503.223.503.497v2.309a.501.501 0 0 1-.503.497M52.794 50.05h-2.33a.501.501 0 0 1-.502-.497v-2.309c0-.274.226-.497.502-.497h2.33c.277 0 .503.223.503.497v2.309a.501.501 0 0 1-.503.497M52.794 55.855h-2.33a.501.501 0 0 1-.502-.497v-2.309c0-.274.226-.497.502-.497h2.33c.277 0 .503.223.503.497v2.309a.501.501 0 0 1-.503.497"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M45.462 60.364h-6.575a.501.501 0 0 1-.503-.498V48.094c0-.274.226-.498.503-.498h6.575c.276 0 .502.224.502.498v11.772a.501.501 0 0 1-.502.498"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M45.462 60.364h-6.575a.501.501 0 0 1-.503-.498V48.094c0-.274.226-.498.503-.498h6.575c.276 0 .502.224.502.498v11.772a.501.501 0 0 1-.502.498z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M62.126 53.354c0-2.085 1.706-3.776 3.811-3.776s3.811 1.69 3.811 3.776c0 2.085-1.706 3.776-3.811 3.776s-3.811-1.69-3.811-3.776"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M62.126 53.354c0-2.085 1.706-3.776 3.811-3.776s3.811 1.69 3.811 3.776c0 2.085-1.706 3.776-3.811 3.776s-3.811-1.69-3.811-3.776z"
  })));
};
var ImgCalendar = function ImgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .036h2.001v1.938H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M69.512 43.058a9.495 9.495 0 0 1 3.925-.842c5.274 0 9.55 4.285 9.55 9.571 0 5.287-4.276 9.572-9.55 9.572a9.512 9.512 0 0 1-6.875-2.927"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M69.642 45.111a7.615 7.615 0 0 1 3.794-1.006c4.234 0 7.665 3.44 7.665 7.682 0 4.243-3.431 7.683-7.665 7.683a7.624 7.624 0 0 1-4.822-1.711"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M73.474 46.293v5.382h2.792"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17 57.117)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M2.001 1.005c0 .536-.448.97-1 .97C.448 1.974 0 1.54 0 1.004 0 .133.448.036 1 .036c.553 0 1.001.434 1.001.97",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M26.877 64.968c0 .544-.456.986-1.018.986s-1.017-.778-1.017-.986c0-.544.455-.985 1.017-.985.562 0 1.018.441 1.018.985M27.769 17.363c-.25-1.014.397-2.045 1.443-2.304 1.047-.258 2.097.354 2.346 1.368.25 1.013-.397 2.045-1.443 2.303-1.047.258-2.097-.354-2.346-1.367M79.02 32.702h-1.017v-1.018a.383.383 0 0 0-.381-.382.383.383 0 0 0-.381.382v1.018h-1.017a.383.383 0 0 0 0 .764h1.017v1.019c0 .21.171.382.381.382s.38-.172.38-.382v-1.019h1.017a.383.383 0 0 0 0-.764M72.514 29.6v-1.814c0-.159.172-.258.31-.179l1.568.908 1.568.907a.207.207 0 0 1 0 .358l-1.568.907-1.568.908a.206.206 0 0 1-.31-.18v-1.814zM22.055 61.373v-1.815c0-.16.172-.259.31-.179l1.567.907 1.569.908a.207.207 0 0 1 0 .358l-1.569.907-1.568.908a.206.206 0 0 1-.309-.18v-1.814z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M32.662 59.204H26.47a2.804 2.804 0 0 1-2.801-2.807V26.238a2.804 2.804 0 0 1 2.8-2.807h.067c1.547 0-.245.833-.245 2.384v30.864c0 1.55 7.918 2.525 6.371 2.525"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M67.239 58.54H29.28a2.815 2.815 0 0 1-2.812-2.818V24.74a2.815 2.815 0 0 1 2.812-2.818h37.959a2.815 2.815 0 0 1 2.811 2.818v30.983a2.815 2.815 0 0 1-2.811 2.819zM26.53 29.846h43.39"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M34.527 37.523h-2.464a.506.506 0 0 1-.504-.505v-2.47c0-.277.227-.504.504-.504h2.464c.277 0 .504.227.504.505v2.47a.506.506 0 0 1-.504.504M41.768 37.523h-2.464a.506.506 0 0 1-.504-.505v-2.47c0-.277.227-.504.504-.504h2.464c.278 0 .504.227.504.505v2.47a.506.506 0 0 1-.504.504M49.109 37.523h-2.464a.506.506 0 0 1-.504-.505v-2.47c0-.277.226-.504.504-.504h2.464c.277 0 .504.227.504.505v2.47a.506.506 0 0 1-.504.504M56.35 37.523h-2.464a.506.506 0 0 1-.504-.505v-2.47c0-.277.227-.504.504-.504h2.464c.277 0 .504.227.504.505v2.47a.506.506 0 0 1-.504.504M63.64 37.523h-2.464a.506.506 0 0 1-.504-.505v-2.47c0-.277.227-.504.504-.504h2.464c.278 0 .504.227.504.505v2.47a.506.506 0 0 1-.504.504M34.527 45.08h-2.464a.506.506 0 0 1-.504-.506v-2.47c0-.277.227-.504.504-.504h2.464c.277 0 .504.227.504.505v2.47a.506.506 0 0 1-.504.504M41.768 45.08h-2.464a.506.506 0 0 1-.504-.506v-2.47c0-.277.227-.504.504-.504h2.464c.278 0 .504.227.504.505v2.47a.506.506 0 0 1-.504.504M49.109 45.08h-2.464a.506.506 0 0 1-.504-.506v-2.47c0-.277.226-.504.504-.504h2.464c.277 0 .504.227.504.505v2.47a.506.506 0 0 1-.504.504M56.35 45.08h-2.464a.506.506 0 0 1-.504-.506v-2.47c0-.277.227-.504.504-.504h2.464c.277 0 .504.227.504.505v2.47a.506.506 0 0 1-.504.504M63.64 45.08h-2.464a.506.506 0 0 1-.504-.506v-2.47c0-.277.227-.504.504-.504h2.464c.278 0 .504.227.504.505v2.47a.506.506 0 0 1-.504.504M34.527 52.635h-2.464a.506.506 0 0 1-.504-.505v-2.47c0-.278.227-.505.504-.505h2.464c.277 0 .504.227.504.505v2.47a.506.506 0 0 1-.504.505M41.768 52.635h-2.464a.506.506 0 0 1-.504-.505v-2.47c0-.278.227-.505.504-.505h2.464c.278 0 .504.227.504.505v2.47a.506.506 0 0 1-.504.505M49.109 52.635h-2.464a.506.506 0 0 1-.504-.505v-2.47c0-.278.226-.505.504-.505h2.464c.277 0 .504.227.504.505v2.47a.506.506 0 0 1-.504.505M56.35 52.635h-2.464a.506.506 0 0 1-.504-.505v-2.47c0-.278.227-.505.504-.505h2.464c.277 0 .504.227.504.505v2.47a.506.506 0 0 1-.504.505M63.64 52.635h-2.464a.506.506 0 0 1-.504-.505v-2.47c0-.278.227-.505.504-.505h2.464c.278 0 .504.227.504.505v2.47a.506.506 0 0 1-.504.505"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M36.453 24.102v-6.097M60.116 24.102v-6.097M50.173 61.714H31.61"
  })));
};
var ImgCentralisation = function ImgCentralisation(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .119h4.31v4.104H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.16.201h3.872v3.815H.16z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M43.194 42.062c0-3.24 2.688-5.865 6.003-5.865 3.316 0 6.004 2.626 6.004 5.865 0 3.24-2.688 5.865-6.004 5.865-3.315 0-6.003-2.626-6.003-5.865"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M68.17 61.915c0 1.133-.964 2.052-2.154 2.052s-2.155-.919-2.155-2.052.965-2.052 2.155-2.052 2.155.919 2.155 2.052"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 34.695)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M4.31 2.17c0 1.134-.965 2.053-2.155 2.053S0 3.303 0 2.17C0 1.037.965.119 2.155.119S4.31 1.037 4.31 2.17",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M61.925 21.036H60.82v-1.09a.413.413 0 0 0-.415-.409.413.413 0 0 0-.414.409v1.09h-1.107a.413.413 0 0 0-.415.409c0 .225.187.409.415.409h1.107v1.09c0 .224.186.408.414.408a.413.413 0 0 0 .415-.409v-1.09h1.106a.413.413 0 0 0 .415-.408.413.413 0 0 0-.415-.41"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.824 16.016)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M3.617 1.7H2.511V.61A.413.413 0 0 0 2.096.2a.413.413 0 0 0-.415.409V1.7H.575a.413.413 0 0 0-.415.409c0 .224.187.409.415.409h1.106v1.09c0 .224.187.408.415.408a.413.413 0 0 0 .415-.408v-1.09h1.106a.413.413 0 0 0 .415-.41.413.413 0 0 0-.415-.408",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M23.174 31.435v-1.942c0-.17.187-.277.337-.192l1.707.971 1.707.971a.22.22 0 0 1 0 .383l-1.707.971-1.707.971a.224.224 0 0 1-.337-.191v-1.942zM63.854 56.739c0 .582-.496 1.054-1.107 1.054-.612 0-1.108-.472-1.108-1.054 0-.583.496-1.055 1.108-1.055.611 0 1.107.472 1.107 1.055M29.591 44.457l-1.786 1.35-1.37-1.76a.855.855 0 0 0-1.184-.154.826.826 0 0 0-.156 1.166l1.37 1.76-1.786 1.35a.826.826 0 0 0-.156 1.167.855.855 0 0 0 1.184.154l1.786-1.35 1.37 1.76a.856.856 0 0 0 1.184.153.826.826 0 0 0 .156-1.166l-1.37-1.76 1.786-1.35a.826.826 0 0 0 .156-1.166.855.855 0 0 0-1.184-.154"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M44.296 40.718c0-3.022 2.486-5.472 5.553-5.472 3.066 0 5.553 2.45 5.553 5.472 0 3.022-2.487 5.472-5.553 5.472-3.067 0-5.553-2.45-5.553-5.472"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M44.296 40.718c0-3.022 2.486-5.472 5.553-5.472 3.066 0 5.553 2.45 5.553 5.472 0 3.022-2.487 5.472-5.553 5.472-3.067 0-5.553-2.45-5.553-5.472z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.4",
    d: "M50.386 17.305v12.493M55.944 25.322l-5.54 5.477-5.576-5.443M50.386 63.907V51.415M44.828 55.89l5.54-5.477 5.576 5.443M73.94 40.606H61.262M65.804 46.083l-5.558-5.46 5.523-5.494M26.647 40.606h12.678M34.783 35.13l5.558 5.458-5.523 5.495"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M65.381 25.464l-6.103 6.014M63.899 31.937l-5.078.008-.024-5.005M35.422 56.072l6.104-6.015M36.905 49.6l5.078-.009.024 5.005M66.44 56.03l-6.103-6.014M59.872 54.57l-.008-5.004 5.078-.024M35.38 25.422l6.103 6.014M41.948 26.883l.008 5.004-5.078.023"
  })));
};
var ImgCertification = function ImgCertification(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M14.283.34L6.36 8.88 5.07 7.49.27 6.18a.962.962 0 0 0 0 1.288l5.492 5.918a.802.802 0 0 0 1.195 0l9.715-10.47a.961.961 0 0 0 0-1.288L15.477.34a.812.812 0 0 0-.597-.267.813.813 0 0 0-.598.267z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M16.571.5L4.846 13.137 2.13 10.21.12 15.665l3.842 4.142c.488.526 1.28.526 1.768 0L20.108 4.31a1.423 1.423 0 0 0 0-1.905L18.339.5a1.201 1.201 0 0 0-.884-.395c-.32 0-.64.132-.884.395z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M.09.026H4.98v4.748H.091z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M14.408.424L6.485 8.963l-3.7-3.987a.803.803 0 0 0-1.195 0L.396 6.264a.962.962 0 0 0 0 1.287l5.491 5.919a.802.802 0 0 0 1.195 0L16.797 3a.961.961 0 0 0 0-1.289L15.602.424a.811.811 0 0 0-.597-.267.812.812 0 0 0-.598.267z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.75 38.254)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".74",
    d: "M-5.609 19.314h28.16V-5.588h-28.16z",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M71.82 45.744l1.29 1.39 7.923-8.54a.802.802 0 0 1 1.194 0l1.195 1.288c.33.355.33.932 0 1.287L73.707 51.64a.802.802 0 0 1-1.195 0l-5.491-5.918a.961.961 0 0 1 0-1.288"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M37.844 51.242l1.625-1.696-.691-3.175-4.622-.845-.687-1.131 1.313-5.073-3.688-4.35 3.688-3.848-1.563-5.01 5.625-1.822.285-4.477a1.793 1.793 0 0 0-1.304.123c-.408.246-.694.615-.775 1.066l-.897 4.14-4.119.901a1.487 1.487 0 0 0-1.06.778c-.244.41-.285.902-.122 1.312l1.305 4.057-3.14 2.87c-.326.327-.53.737-.53 1.229 0 .45.204.902.53 1.23l3.14 2.869-1.305 4.057c-.122.45-.082.902.122 1.312.245.41.612.696 1.06.778l4.119.902.897 4.14.794-.337z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65.5 26.444)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".74",
    d: "M-12.866 28.579h41.674V-8.272h-41.673z",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M67.63 36.654l2.716 2.927L82.07 26.944a1.187 1.187 0 0 1 1.768 0l1.768 1.906c.489.526.489 1.38 0 1.905L71.23 46.251a1.188 1.188 0 0 1-1.768 0l-3.843-4.142"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M70.558 28.983c0 .674-.562 1.22-1.256 1.22s-1.256-.546-1.256-1.22c0-.674.562-1.22 1.256-1.22s1.256.546 1.256 1.22M85.975 36.354c0 .674-.563 1.22-1.256 1.22-.694 0-1.257-.546-1.257-1.22 0-.674.563-1.22 1.257-1.22.693 0 1.256.546 1.256 1.22M82.979 21.683c0 1.311-1.094 2.374-2.444 2.374-1.35 0-2.444-1.063-2.444-2.374 0-1.312 1.094-2.374 2.444-2.374 1.35 0 2.444 1.062 2.444 2.374"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.5 60.116)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M4.979 2.4c0 1.311-1.094 2.374-2.444 2.374C1.185 4.774.091 3.711.091 2.4.09 1.09 1.185.026 2.535.026c1.35 0 2.444 1.063 2.444 2.374",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M69.833 23.16v-2.246c0-.197.213-.32.382-.222l1.936 1.123 1.936 1.124c.17.099.17.345 0 .443l-1.936 1.124-1.936 1.123a.254.254 0 0 1-.382-.222v-2.246zM23.29 32.56l-1.22-1.884a.256.256 0 0 1 .2-.395l2.233-.12 2.232-.119c.195-.01.33.196.24.371l-1.013 2.004-1.013 2.002a.254.254 0 0 1-.44.024l-1.22-1.883zM23.945 37.808l-2.026 1.562-1.554-2.037a.957.957 0 0 0-1.342-.178.969.969 0 0 0-.177 1.35L20.4 40.54l-2.026 1.562a.969.969 0 0 0-.177 1.35c.32.42.924.5 1.342.177l2.026-1.562 1.554 2.037c.32.42.925.5 1.342.178a.969.969 0 0 0 .177-1.35l-1.553-2.036 2.025-1.562a.968.968 0 0 0 .177-1.35.957.957 0 0 0-1.342-.177"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2E3B45",
    strokeWidth: "1.5",
    d: "M68.625 35.223c0-.45-.203-.902-.53-1.23l-3.14-2.869 1.305-4.057c.123-.45.082-.902-.122-1.312-.245-.41-.612-.696-1.06-.778l-4.118-.902-.898-4.14a1.493 1.493 0 0 0-.774-1.065 1.465 1.465 0 0 0-1.305-.123l-4.037 1.312-2.854-3.156c-.326-.328-.734-.533-1.223-.533-.449 0-.897.205-1.224.533l-2.854 3.156-4.037-1.312a1.793 1.793 0 0 0-1.304.123c-.408.246-.694.615-.775 1.066l-.897 4.14-4.119.901a1.486 1.486 0 0 0-1.06.778 1.5 1.5 0 0 0-.122 1.312l1.305 4.057-3.14 2.87c-.326.327-.53.737-.53 1.23 0 .45.204.9.53 1.229l3.14 2.869-1.305 4.057c-.122.45-.082.902.122 1.312.245.41.612.696 1.06.778l4.119.902.594 2.74.303 1.4c.081.45.367.86.775 1.065.407.246.856.287 1.304.123l4.037-1.312 2.854 3.156c.327.328.734.533 1.224.533.448 0 .897-.205 1.223-.533l2.854-3.156 4.037 1.312a1.79 1.79 0 0 0 1.305-.123c.407-.246.693-.615.774-1.066l.898-4.14 4.118-.9a1.487 1.487 0 0 0 1.06-.78c.204-.41.285-.901.122-1.311l-1.305-4.057 3.14-2.87c.327-.327.53-.778.53-1.229z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M46.887 42.175l-5.491-5.918a.962.962 0 0 1 0-1.288l1.194-1.287a.803.803 0 0 1 1.195 0l3.7 3.986 7.922-8.539a.802.802 0 0 1 1.195 0l1.195 1.288c.33.355.33.932 0 1.288l-9.715 10.47a.802.802 0 0 1-1.195 0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41 28.706)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M-5.484 19.397h28.16V-5.504h-28.16z",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.25",
    d: "M-5.484 19.397h28.16V-5.504h-28.16z",
    mask: "url(#h)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M46.887 42.175l-5.491-5.918a.962.962 0 0 1 0-1.288l1.194-1.287a.803.803 0 0 1 1.195 0l3.7 3.986 7.922-8.539a.802.802 0 0 1 1.195 0l1.195 1.288c.33.355.33.932 0 1.288l-9.715 10.47a.802.802 0 0 1-1.195 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M45.474 50.48L39.6 59.802l-.875-4.571-5 1.971 5.25-7.976.404-.13.303 1.398c.081.45.367.86.774 1.065.408.246.857.287 1.305.123l4.037-1.311-.323.11z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M45.474 50.48L39.6 59.802l-.875-4.571-5 1.971 5.25-7.976.404-.13.303 1.398c.081.45.367.86.774 1.065.408.246.857.287 1.305.123l4.037-1.311-.323.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M54.297 50.48l5.875 9.322.875-4.571 5 1.971-5.25-7.976-.403-.13-.303 1.398c-.082.45-.367.86-.775 1.065a1.468 1.468 0 0 1-1.305.123l-4.037-1.311.323.11z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M54.297 50.48l5.875 9.322.875-4.571 5 1.971-5.25-7.976-.403-.13-.303 1.398c-.082.45-.367.86-.775 1.065a1.468 1.468 0 0 1-1.305.123l-4.037-1.311.323.11z"
  }))));
};
var ImgChat = function ImgChat(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .08h4.132v3.995H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.136.035H1.86v1.668H.136z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M.15.135h3.357v3.802H.15z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M63.618 58.964l-2.68 1.961.004-5.907H46.045c-1.436 0-2.613-1.153-2.613-2.563V44.96h-9.744l.004 6.658-7.446-5.086-.33-.322h-3.307c-1.437 0-2.614-1.153-2.614-2.562V27.749c0-1.409 1.177-2.563 2.614-2.563h25.975c.742 0 1.414.308 1.89.798.449.46.723 1.083.723 1.765v17.102l-5.155.125v7.667l1.088 1.542 3.302.375 13.019-.183.167 4.587z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M62.437 26.545h-.294v2.045l-1.996-2.045h-6.384a.97.97 0 0 1-.97-.966V19.83a.97.97 0 0 1 .97-.967h8.674a.97.97 0 0 1 .97.967v5.748a.97.97 0 0 1-.97.966zM57.88 64.92h-.294v2.045L55.59 64.92h-6.384a.97.97 0 0 1-.97-.966v-5.748a.97.97 0 0 1 .97-.967h8.674a.97.97 0 0 1 .97.967v5.748a.97.97 0 0 1-.97.966zM66.306 29.295h.294v2.045l1.995-2.045h11.402a.97.97 0 0 0 .97-.966V22.58a.97.97 0 0 0-.97-.967H66.306a.97.97 0 0 0-.97.967v5.748a.97.97 0 0 0 .97.966z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M49.281 50.6V48.6a.43.43 0 0 1 .43-.428h15.298a.43.43 0 0 1 .43.428V50.6a.43.43 0 0 1-.43.429H49.71a.43.43 0 0 1-.43-.429M49.365 44.791v-1.798c0-.29.238-.528.53-.528H73.42c.292 0 .53.238.53.528v1.798a.53.53 0 0 1-.53.528H49.895a.53.53 0 0 1-.53-.528M49.448 39.25V37.45c0-.29.24-.528.53-.528h23.527c.291 0 .53.238.53.528v1.798a.53.53 0 0 1-.53.529H49.979a.53.53 0 0 1-.53-.529"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M59.579 54.377H48.554c-1.437 0-2.613-1.153-2.613-2.562V35.917c0-.682.275-1.305.723-1.765a2.633 2.633 0 0 1 1.89-.798H74.53c1.437 0 2.614 1.154 2.614 2.563v15.898c0 1.409-1.177 2.562-2.614 2.562h-3.306l-.33.322-7.446 5.086v-.892l.004-4.516h-3.872z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M40.068 45.069h11.025c1.437 0 2.613-1.154 2.613-2.563V26.609c0-.682-.275-1.305-.723-1.765a2.634 2.634 0 0 0-1.89-.799H25.118c-1.437 0-2.614 1.154-2.614 2.564v15.897c0 1.41 1.177 2.563 2.614 2.563h3.307l.329.32 7.446 5.087-.004-5.407h3.872z"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#2C3B45",
    fontFamily: "OpenSans-SemiBold, Open Sans",
    fontSize: "14",
    fontWeight: "500",
    transform: "translate(14 14)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "21",
    y: "26"
  }, "?")), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M40.068 45.069h11.025c1.437 0 2.613-1.154 2.613-2.563V26.609c0-.682-.275-1.305-.723-1.765a2.634 2.634 0 0 0-1.89-.799H25.118c-1.437 0-2.614 1.154-2.614 2.564v15.897c0 1.41 1.177 2.563 2.614 2.563h3.307l.329.32 7.446 5.087-.004-5.407h3.872z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 24.965)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M.057 2.571C-.208 1.502.477.415 1.587.142c1.11-.272 2.224.373 2.488 1.442.264 1.069-.42 2.156-1.53 2.429C1.434 4.285.32 3.64.056 2.57",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M42.883 56.79c-.11-.446.175-.9.639-1.014.463-.114.928.156 1.039.602.11.447-.176.9-.64 1.014-.463.114-.928-.155-1.038-.602"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.663 14.215)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M.16 1.075C.048.63.334.175.797.061c.464-.114.93.156 1.04.602.11.447-.176.9-.64 1.014C.735 1.791.27 1.522.16 1.075",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M81.14 35.819c-.111-.447.175-.9.638-1.015.464-.113.929.156 1.04.603.11.446-.177.9-.64 1.014-.463.114-.929-.156-1.039-.602M17.194 30.893c-.11-.446.176-.9.64-1.015.463-.113.928.156 1.038.603.11.446-.176.9-.64 1.014-.463.114-.928-.156-1.038-.602M42.333 58.918H41.19V57.78a.429.429 0 0 0-.856 0v1.138h-1.142a.429.429 0 0 0-.428.426c0 .235.193.427.428.427h1.142v1.138a.429.429 0 0 0 .856 0V59.77h1.142a.428.428 0 0 0 .428-.427.429.429 0 0 0-.428-.426M81.091 32.113H79.95v-1.138a.428.428 0 0 0-.856 0v1.138h-1.141a.429.429 0 0 0-.429.426c0 .235.193.427.429.427h1.141v1.138a.429.429 0 0 0 .856 0v-1.138h1.142a.429.429 0 0 0 .428-.427.429.429 0 0 0-.428-.426M37.982 54.418V52.71c0-.15.163-.243.293-.168l1.483.853 1.483.853c.13.075.13.262 0 .337l-1.483.853-1.483.854a.195.195 0 0 1-.293-.169v-1.706z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.488 25.215)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M.15 2.036V.329C.15.18.314.086.444.161l1.483.853 1.483.854c.13.075.13.261 0 .336l-1.483.854-1.483.853a.195.195 0 0 1-.292-.168V2.036z",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M79.48 44.52v6.543"
  })));
};
var ImgClock = function ImgClock(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M47.604 18a2.88 2.88 0 115.76 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M47.604 18a2.88 2.88 0 115.76 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M76.93 26.162a6 6 0 11-11.999 0 6 6 0 0112 0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M71.5 26.162a.63.63 0 11-1.26 0 .63.63 0 011.26 0zM70.841 20.994v.566M68.237 21.661l.283.49M66.322 23.537l.49.283M65.601 26.119h.566M66.268 28.716l.49-.284M68.144 30.631l.283-.49M70.726 31.352v-.566M73.323 30.685l-.283-.49M75.238 28.809l-.49-.283M75.959 26.227h-.566M75.292 23.63l-.49.283M73.416 21.715l-.283.49M70.841 25.391v-1.315M71.29 26.678l2.235 2.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M47.478 63.488c-12.49 0-22.616-9.915-22.616-22.145 0-12.231 10.125-22.146 22.616-22.146 0 0-19.356 1.768-19.888 21.888-.526 19.903 19.888 22.403 19.888 22.403"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M73.24 41.089c0 12.568-10.188 22.756-22.756 22.756S27.728 53.657 27.728 41.089s10.188-22.756 22.756-22.756S73.24 28.521 73.24 41.09"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M73.24 41.089c0 12.568-10.188 22.756-22.756 22.756S27.728 53.657 27.728 41.089s10.188-22.756 22.756-22.756S73.24 28.521 73.24 41.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M68.278 41.089c0 9.827-7.967 17.794-17.794 17.794-9.827 0-17.794-7.967-17.794-17.794 0-9.827 7.967-17.794 17.794-17.794 9.827 0 17.794 7.967 17.794 17.794"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M68.278 41.089c0 9.827-7.967 17.794-17.794 17.794-9.827 0-17.794-7.967-17.794-17.794 0-9.827 7.967-17.794 17.794-17.794 9.827 0 17.794 7.967 17.794 17.794z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M62.449 53.391c3.197-3.146 5.172-7.481 5.172-12.267 0-9.612-7.483-17.284-17.314-17.204v17.197l11.77 11.93.372.344z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M52.175 41.089a1.868 1.868 0 11-3.736 0 1.868 1.868 0 013.736 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.2",
    d: "M52.175 41.089a1.868 1.868 0 11-3.736 0 1.868 1.868 0 013.736 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M24.384 56.501c-.217-.883.347-1.78 1.26-2.005.914-.226 1.83.307 2.048 1.19.217.883-.347 1.78-1.26 2.006-.913.225-1.83-.308-2.048-1.19"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23 23.645)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .13h4.883v4.884H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M4.36 2.049H2.965V.654A.525.525 0 002.44.13a.525.525 0 00-.523.523v1.395H.523A.525.525 0 000 2.572c0 .288.235.523.523.523h1.395V4.49c0 .288.236.524.523.524a.525.525 0 00.524-.524V3.095H4.36a.525.525 0 00.523-.523.525.525 0 00-.523-.523",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M31.4 61.322h-1.395v-1.395a.525.525 0 00-.524-.523.525.525 0 00-.523.523v1.395h-1.395a.525.525 0 00-.523.523c0 .288.235.524.523.524h1.395v1.395c0 .287.236.523.523.523a.525.525 0 00.524-.523v-1.395H31.4a.525.525 0 00.523-.524.525.525 0 00-.523-.523M31.079 21.316v-1.868c0-.164.177-.267.32-.185l1.617.935 1.618.934a.213.213 0 010 .368l-1.618.934-1.618.935a.213.213 0 01-.319-.185v-1.868zM26.144 20.056c-.217-.883.347-1.78 1.26-2.006.914-.225 1.83.308 2.048 1.19.217.884-.347 1.782-1.26 2.007-.913.225-1.83-.308-2.048-1.191M23.158 60.254c-.12-.489.192-.986.698-1.11.505-.125 1.013.17 1.133.658.12.489-.191.987-.697 1.11-.506.126-1.013-.17-1.134-.658M69.88 57.921v-1.868c0-.164.176-.266.318-.185l1.618.935 1.618.934a.213.213 0 010 .368l-1.618.935-1.618.934a.213.213 0 01-.319-.184V57.92z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M74.917 48.09a20.876 20.876 0 01-2.81 6.103M50.218 25.76v1.678M42.496 27.738l.84 1.454M36.816 33.301l1.453.839M34.678 40.96h1.678M36.656 48.661l1.453-.839M42.219 54.342l.839-1.453M49.878 56.48v-1.678M57.579 54.502l-.839-1.454M63.26 48.938l-1.454-.839M65.398 41.28h-1.679M63.42 33.578l-1.454.84M57.856 27.898l-.839 1.453"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.2",
    d: "M50.218 38.8v-3.898M51.549 42.617l6.629 6.466"
  })));
};
var ImgComplain = function ImgComplain(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .08h4.132v3.995H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.136.035H1.86v1.668H.136z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M.15.135h3.357v3.802H.15z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M63.618 58.964l-2.68 1.961.004-5.907H46.045c-1.436 0-2.613-1.153-2.613-2.563V44.96h-9.744l.004 6.658-7.446-5.086-.33-.322h-3.307c-1.437 0-2.614-1.153-2.614-2.562V27.749c0-1.409 1.177-2.563 2.614-2.563h25.975c.742 0 1.414.308 1.89.798.449.46.723 1.083.723 1.765v17.102l-5.155.125v7.667l1.088 1.542 3.302.375 13.019-.183.167 4.587z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M62.437 26.545h-.294v2.045l-1.996-2.045h-6.384a.97.97 0 0 1-.97-.966V19.83a.97.97 0 0 1 .97-.967h8.674a.97.97 0 0 1 .97.967v5.748a.97.97 0 0 1-.97.966zM57.88 64.92h-.294v2.045L55.59 64.92h-6.384a.97.97 0 0 1-.97-.966v-5.748a.97.97 0 0 1 .97-.967h8.674a.97.97 0 0 1 .97.967v5.748a.97.97 0 0 1-.97.966zM66.306 29.295h.294v2.045l1.995-2.045h11.402a.97.97 0 0 0 .97-.966V22.58a.97.97 0 0 0-.97-.967H66.306a.97.97 0 0 0-.97.967v5.748a.97.97 0 0 0 .97.966z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M49.281 50.6V48.6a.43.43 0 0 1 .43-.428h15.298a.43.43 0 0 1 .43.428V50.6a.43.43 0 0 1-.43.429H49.71a.43.43 0 0 1-.43-.429M49.365 44.791v-1.798c0-.29.238-.528.53-.528H73.42c.292 0 .53.238.53.528v1.798a.53.53 0 0 1-.53.528H49.895a.53.53 0 0 1-.53-.528M49.448 39.25V37.45c0-.29.24-.528.53-.528h23.527c.291 0 .53.238.53.528v1.798a.53.53 0 0 1-.53.529H49.979a.53.53 0 0 1-.53-.529"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M59.579 54.377H48.554c-1.437 0-2.613-1.153-2.613-2.562V35.917c0-.682.275-1.305.723-1.765a2.633 2.633 0 0 1 1.89-.798H74.53c1.437 0 2.614 1.154 2.614 2.563v15.898c0 1.409-1.177 2.562-2.614 2.562h-3.306l-.33.322-7.446 5.086v-.892l.004-4.516h-3.872z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M40.068 45.069h11.025c1.437 0 2.613-1.154 2.613-2.563V26.609c0-.682-.275-1.305-.723-1.765a2.634 2.634 0 0 0-1.89-.799H25.118c-1.437 0-2.614 1.154-2.614 2.564v15.897c0 1.41 1.177 2.563 2.614 2.563h3.307l.329.32 7.446 5.087-.004-5.407h3.872z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M40.068 45.069h11.025c1.437 0 2.613-1.154 2.613-2.563V26.609c0-.682-.275-1.305-.723-1.765a2.634 2.634 0 0 0-1.89-.799H25.118c-1.437 0-2.614 1.154-2.614 2.564v15.897c0 1.41 1.177 2.563 2.614 2.563h3.307l.329.32 7.446 5.087-.004-5.407h3.872zM38.197 28.563v8.142M38.197 39.143v.649"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 24.965)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M.057 2.571C-.208 1.502.477.415 1.587.142c1.11-.272 2.224.373 2.488 1.442.264 1.069-.42 2.156-1.53 2.429C1.434 4.285.32 3.64.056 2.57",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M42.883 56.79c-.11-.446.175-.9.639-1.014.463-.114.928.156 1.039.602.11.447-.176.9-.64 1.014-.463.114-.928-.155-1.038-.602"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.663 14.215)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M.16 1.075C.048.63.334.175.797.061c.464-.114.93.156 1.04.602.11.447-.176.9-.64 1.014C.735 1.791.27 1.522.16 1.075",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M81.14 35.819c-.111-.447.175-.9.638-1.015.464-.113.929.156 1.04.603.11.446-.177.9-.64 1.014-.463.114-.929-.156-1.039-.602M17.194 30.893c-.11-.446.176-.9.64-1.015.463-.113.928.156 1.038.603.11.446-.176.9-.64 1.014-.463.114-.928-.156-1.038-.602M42.333 58.918H41.19V57.78a.429.429 0 0 0-.856 0v1.138h-1.142a.429.429 0 0 0-.428.426c0 .235.193.427.428.427h1.142v1.138a.429.429 0 0 0 .856 0V59.77h1.142a.428.428 0 0 0 .428-.427.429.429 0 0 0-.428-.426M81.091 32.113H79.95v-1.138a.428.428 0 0 0-.856 0v1.138h-1.141a.429.429 0 0 0-.429.426c0 .235.193.427.429.427h1.141v1.138a.429.429 0 0 0 .856 0v-1.138h1.142a.429.429 0 0 0 .428-.427.429.429 0 0 0-.428-.426M37.982 54.418V52.71c0-.15.163-.243.293-.168l1.483.853 1.483.853c.13.075.13.262 0 .337l-1.483.853-1.483.854a.195.195 0 0 1-.293-.169v-1.706z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.488 25.215)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M.15 2.036V.329C.15.18.314.086.444.161l1.483.853 1.483.854c.13.075.13.261 0 .336l-1.483.854-1.483.853a.195.195 0 0 1-.292-.168V2.036z",
    mask: "url(#f)"
  }))));
};
var ImgConfirmation = function ImgConfirmation(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M13.903.444L6.26 8.58 5.017 7.257.387 6.008a.908.908 0 0 0 0 1.227l5.297 5.64a.78.78 0 0 0 1.153 0l9.37-9.977a.907.907 0 0 0 0-1.227L15.055.444a.787.787 0 0 0-.576-.254.788.788 0 0 0-.576.254z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M14.422.597l-11.31 12.04-1.774-1.95L.12 16.602l2.14 2.39c.47.5 1.234.5 1.704 0L17.833 4.228c.471-.501.471-1.314 0-1.816L16.128.597a1.166 1.166 0 0 0-.853-.376c-.308 0-.617.125-.853.376z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.191 42.7)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".71",
    d: "M-5.283 18.522h27.162V-5.203H-5.283z",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M75.209 49.957l1.243 1.323 7.642-8.136a.78.78 0 0 1 1.153 0l1.152 1.227a.907.907 0 0 1 0 1.227l-9.37 9.976a.78.78 0 0 1-1.153 0l-5.297-5.638a.908.908 0 0 1 0-1.227"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.674 31.448)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".71",
    d: "M-13.97 27.35h40.195V-7.762H-13.97z",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M72.011 42.134l1.775 1.95 11.31-12.04a1.155 1.155 0 0 1 1.705 0l1.706 1.816c.47.501.47 1.315 0 1.816L74.639 50.439a1.154 1.154 0 0 1-1.705 0l-2.14-2.39"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M46.42 61.177c-12.55 0-22.723-9.891-22.723-22.092 0-12.2 10.173-22.092 22.723-22.092 0 0-19.448 1.764-19.982 21.836-.529 19.854 19.982 22.348 19.982 22.348"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M72.235 38.748c0 12.537-10.236 22.7-22.863 22.7-12.628 0-22.864-10.163-22.864-22.7 0-12.537 10.236-22.7 22.864-22.7 12.627 0 22.863 10.163 22.863 22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M44.612 50.066l-9.645-10.27a1.654 1.654 0 0 1 0-2.233l2.098-2.235a1.421 1.421 0 0 1 2.099 0l6.498 6.918L59.579 27.43a1.421 1.421 0 0 1 2.099 0l2.098 2.234c.58.617.58 1.617 0 2.234L46.711 50.066c-.58.617-1.52.617-2.099 0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M44.612 50.066l-9.645-10.27a1.654 1.654 0 0 1 0-2.233l2.098-2.235a1.421 1.421 0 0 1 2.099 0l6.498 6.918L59.579 27.43a1.421 1.421 0 0 1 2.099 0l2.098 2.234c.58.617.58 1.617 0 2.234L46.711 50.066c-.58.617-1.52.617-2.099 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M24.865 57.314c-.219-.88.348-1.777 1.266-2.001.918-.225 1.839.307 2.057 1.188.219.88-.348 1.776-1.266 2-.917.225-1.839-.306-2.057-1.187M25.604 22.872h-1.402V21.48a.525.525 0 0 0-1.051 0v1.392h-1.402a.525.525 0 0 0-.526.522c0 .287.237.522.526.522h1.402v1.391a.526.526 0 0 0 1.05 0v-1.391h1.403a.525.525 0 0 0 .525-.522.525.525 0 0 0-.525-.522M30.265 62.009h-1.401v-1.392a.525.525 0 0 0-1.052 0v1.392h-1.401a.525.525 0 0 0-.526.522c0 .287.237.521.526.521h1.401v1.392a.526.526 0 0 0 1.052 0v-1.392h1.401a.525.525 0 0 0 .526-.521.526.526 0 0 0-.526-.522M28.135 19.586v-1.864c0-.163.178-.266.32-.184l1.626.932 1.626.932a.212.212 0 0 1 0 .368l-1.626.932-1.625.932a.214.214 0 0 1-.32-.184v-1.864zM21.047 17.292c-.219-.881.348-1.777 1.266-2.001.917-.225 1.839.307 2.057 1.188.219.88-.348 1.776-1.266 2-.917.225-1.839-.307-2.057-1.187M29.684 58.574c-.121-.488.193-.984.7-1.108.509-.124 1.019.17 1.14.658.12.487-.193.983-.701 1.107-.508.125-1.018-.17-1.14-.657M71.66 57.618v-1.864c0-.163.178-.265.32-.183l1.626.932 1.626.932a.212.212 0 0 1 0 .367l-1.626.932-1.626.932a.214.214 0 0 1-.32-.184v-1.864z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.44",
    d: "M70.15 53.65a20.858 20.858 0 0 1-4.691 4.82"
  }))));
};
var ImgContact = function ImgContact(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.039.089h1.81v1.735H.039z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M58.727 44.833h-.24v1.653l-1.627-1.653h-5.205a.788.788 0 0 1-.79-.781v-4.646c0-.43.355-.781.79-.781h7.072c.435 0 .79.352.79.781v4.646c0 .43-.355.781-.79.781"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M58.727 44.833h-.24v1.653l-1.627-1.653h-5.205a.788.788 0 0 1-.79-.781v-4.646c0-.43.355-.781.79-.781h7.072c.435 0 .79.352.79.781v4.646c0 .43-.355.781-.79.781z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M46.211 29.344H57.77c.435 0 .79.35.79.78v4.647c0 .43-.355.78-.79.78H49.86l-1.631 1.654.004-1.653h-1.917l-.105-6.208z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M46.211 29.344H57.77c.435 0 .79.35.79.78v4.647c0 .43-.355.78-.79.78H49.86l-1.631 1.654.004-1.653h-1.917l-.105-6.208z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M35.84 24.507c-.496 0-1.02.188-1.463.405-.065.03-5.662 2.756-6.743 8.952-.87 4.685.796 8.973 6.85 17.658 3.552 5.12 9.702 11.107 18.777 10.625 1.814-.242 2.559-.564 6.911-3.704.3-.221.508-.645.575-1.166.087-.679-.082-1.393-.432-1.819l-2.994-3.1c-2.353-2.38-3.775-3.815-7.272-1.016-.212.152-.428.36-.657.579-1.075 1.031-3.078 2.95-6.286.28-2.37-1.995-8.647-8.725-7.933-12.788.303-2.136 2.226-3.1 3.375-3.677l.265-.133c1.05-.555 1.68-1.26 1.914-2.151.347-1.314-.18-3.1-1.523-5.167-.018-.028-1.592-2.47-2.17-3.189-.318-.433-.743-.59-1.195-.59m16.4 39.088c-9.17 0-15.333-6.062-18.942-11.266-6.31-9.05-8.03-13.598-7.08-18.713 1.208-6.931 7.273-9.863 7.53-9.983 1.867-.914 3.487-.695 4.434.605.604.751 2.17 3.178 2.235 3.28 1.587 2.442 2.162 4.56 1.705 6.294-.338 1.28-1.225 2.305-2.637 3.05l-.285.144c-1.014.509-2.402 1.204-2.604 2.627-.525 2.995 4.565 9.062 7.44 11.482 2.21 1.837 3.252.84 4.354-.215.267-.256.52-.498.785-.687 4.485-3.592 6.87-1.18 9.177 1.152l.437.44 2.61 2.716c.63.767.913 1.875.777 2.935-.118.917-.525 1.674-1.147 2.13l-.005.004c-4.37 3.154-5.37 3.673-7.628 3.972-.39.022-.775.033-1.155.033"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M64.667 12.735l.175-.735-10.804 3.853 9.017 2.043.907-2.903 1.357 1.555-.727.213M59.883 15.237l-5.845.616M62.666 14.958l-1.33.097"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M64.996 48.964c4.66-.048 9.23-3.193 11.757-8.092 2.528-4.899 2.94-11.403 1.057-16.738-.602-1.707-1.45-3.33-2.668-4.406-1.218-1.076-2.85-1.091-4.238-.41-1.714.843-2.72 2.575-2.207 4.788.512 2.213 2.45 3.302 4.271 2.954 1.82-.347 3.3-1.624 3.333-3.927.05-3.56-2.82-6.07-5.537-7.123a15.784 15.784 0 0 0-6.691-1.055"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M26.192 24.395h-1.341v-1.326a.502.502 0 0 0-.504-.497.502.502 0 0 0-.503.497v1.326h-1.34a.501.501 0 0 0-.504.497c0 .273.226.496.503.496h1.341v1.326c0 .273.227.497.503.497a.502.502 0 0 0 .504-.497v-1.326h1.341a.502.502 0 0 0 .503-.496.502.502 0 0 0-.503-.497"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M37.077 23.917c-.495 0-1.019.188-1.462.405-.065.03-5.662 2.756-6.743 8.953-.87 4.684.795 8.972 6.85 17.657 3.552 5.12 9.702 11.108 18.777 10.625 1.813-.242 2.559-.563 6.91-3.704.3-.22.509-.645.576-1.166.087-.678-.082-1.393-.432-1.819l-2.994-3.1c-2.353-2.38-3.775-3.815-7.272-1.016-.213.153-.429.36-.657.579-1.075 1.031-3.078 2.95-6.286.28-2.37-1.995-8.647-8.725-7.933-12.788.302-2.135 2.226-3.1 3.374-3.677l.265-.133c1.052-.554 1.68-1.26 1.915-2.151.347-1.314-.18-3.1-1.524-5.167-.017-.027-1.592-2.47-2.17-3.188-.317-.434-.742-.59-1.194-.59m16.4 39.087c-9.17 0-15.333-6.062-18.943-11.266-6.309-9.05-8.03-13.598-7.08-18.713 1.209-6.931 7.273-9.862 7.531-9.983 1.867-.914 3.486-.695 4.434.605.604.752 2.169 3.178 2.235 3.28 1.587 2.442 2.162 4.56 1.705 6.294-.338 1.28-1.225 2.306-2.638 3.05l-.284.144c-1.014.509-2.402 1.205-2.604 2.628-.525 2.994 4.565 9.061 7.44 11.48 2.209 1.838 3.252.842 4.354-.214.267-.256.52-.498.785-.687 4.485-3.592 6.87-1.18 9.177 1.152l.437.44 2.61 2.716c.629.767.913 1.875.777 2.935-.118.917-.525 1.674-1.147 2.13l-.005.004c-4.371 3.155-5.37 3.674-7.628 3.973-.39.022-.775.032-1.156.032"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M61.184 53.105C65.337 49.807 68 44.715 68 39c0-9.941-8.059-18-18-18a17.92 17.92 0 0 0-10.813 3.608"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M29.84 61.897a1.88 1.88 0 0 1 .602-.498c.406-.226.78-.295 1.124-.207.343.088.628.33.855.725.218.382.278.745.178 1.09-.099.344-.348.629-.748.852-.251.14-.49.22-.717.242l-1.293-2.204zm-1.165-1.153l-.306-.536c-.265-.463-.395-.922-.391-1.376.004-.454.162-1.023.473-1.706.306-.649.475-1.131.509-1.45a1.455 1.455 0 0 0-.19-.897c-.179-.313-.433-.486-.76-.52-.329-.033-.703.068-1.123.303-.732.409-1.432 1.112-2.1 2.108l-1.704-1.139a7.975 7.975 0 0 1 2.946-2.84c1.006-.561 1.942-.769 2.81-.623.865.146 1.526.617 1.982 1.413.304.53.444 1.057.42 1.58-.022.522-.238 1.215-.645 2.08-.273.604-.421 1.03-.443 1.278-.023.248.05.517.215.806l.248.434-1.94 1.085z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M68.149 55.536c-.21-.839.333-1.692 1.211-1.906.878-.214 1.76.293 1.969 1.132.21.838-.333 1.691-1.212 1.905-.878.214-1.76-.292-1.968-1.131M66.56 52.177c-.115-.464.185-.936.671-1.055.486-.118.975.162 1.09.627.116.464-.184.936-.67 1.054-.487.12-.975-.162-1.09-.626M66.56 59.013c-.115-.465.185-.937.671-1.055.486-.119.975.162 1.09.626.116.464-.184.936-.67 1.055-.487.118-.975-.162-1.09-.626M40.37 67.157c-.21-.839.333-1.692 1.211-1.906.879-.214 1.76.293 1.969 1.132.21.838-.333 1.691-1.212 1.905-.878.214-1.76-.293-1.968-1.131"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.385 67.127)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M.063 1.17C-.052.707.248.235.734.117c.486-.119.974.162 1.09.626.116.464-.184.937-.67 1.055-.487.118-.975-.162-1.09-.626",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M67.815 64.255h-1.197v-1.183a.448.448 0 0 0-.45-.444c-.246 0-.448.2-.448.444v1.183h-1.198c-.247 0-.45.2-.45.444s.203.444.45.444h1.198v1.183c0 .244.202.444.449.444s.449-.2.449-.444v-1.183h1.197c.247 0 .45-.2.45-.444a.448.448 0 0 0-.45-.444M39.106 15.853v-1.775c0-.156.17-.253.306-.175l1.556.887 1.556.888a.201.201 0 0 1 0 .35l-1.556.887-1.556.888a.204.204 0 0 1-.306-.175v-1.775z"
  })));
};
var ImgEmail = function ImgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.123.081h1.715v1.66H.123z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(83.542 60.188)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M.147 1.115C.037.671.32.22.782.107c.46-.113.923.155 1.032.599.11.443-.174.895-.635 1.008-.46.113-.923-.155-1.032-.599",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M32.141 59.48c-.11-.444.175-.895.636-1.009.46-.113.922.155 1.032.6.11.443-.175.895-.635 1.008-.46.113-.923-.155-1.033-.599"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M24.12 56.37c-.11-.444.174-.895.635-1.008.46-.113.923.155 1.032.599.11.444-.174.895-.635 1.008-.46.113-.923-.155-1.032-.599M27.356 55.288l-.566-1.6a.193.193 0 0 1 .219-.255l1.672.312 1.673.312a.193.193 0 0 1 .112.316l-1.108 1.288-1.107 1.289a.194.194 0 0 1-.33-.062l-.565-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M38.447 30.687c0-1.243 1.01-2.25 2.256-2.25h41.368a2.253 2.253 0 0 1 2.256 2.25v23.541c0 1.243-1.01 2.25-2.256 2.25M82.375 18.801l.188-.801-11.67 4.2 9.74 2.228.98-3.165 1.466 1.696-.785.232M77.207 21.53l-6.314.67M80.213 21.225l-1.437.106"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M82.73 58.302c5.034-.053 9.97-3.482 12.7-8.823 2.731-5.341 3.175-12.433 1.142-18.25-.65-1.86-1.566-3.63-2.882-4.804-1.315-1.172-3.08-1.189-4.578-.446-1.851.918-2.938 2.808-2.385 5.22.554 2.413 2.648 3.6 4.614 3.221 1.967-.379 3.566-1.77 3.601-4.282.055-3.88-3.046-6.617-5.981-7.765a16.906 16.906 0 0 0-7.229-1.151"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M31.356 27.517h-1.45v-1.445a.544.544 0 0 0-1.086 0v1.445h-1.45c-.298 0-.543.244-.543.542 0 .298.245.542.544.542h1.449v1.445a.544.544 0 0 0 1.086 0V28.6h1.45a.544.544 0 0 0 .543-.542.544.544 0 0 0-.543-.542"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M37.03 60.7c0 1.243-2.227.822-3.177.822-.95 0-1.72-1.007-1.72-2.25V33.939c0-1.243.77-2.25 1.72-2.25s.506 1.007.506 2.25V60.51l2.67.19"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M80.024 60.983H35.97a1.764 1.764 0 0 1-1.767-1.762V32.293c0-.972.79-1.761 1.767-1.761h44.055c.976 0 1.767.789 1.767 1.761v26.928c0 .973-.791 1.762-1.767 1.762z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M76.466 42.38h-4.848a.705.705 0 0 1-.706-.704V35.96c0-.39.316-.705.706-.705h4.848c.39 0 .707.316.707.705v5.717a.706.706 0 0 1-.707.705"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.25",
    d: "M76.466 42.38h-4.848a.705.705 0 0 1-.706-.704V35.96c0-.39.316-.705.706-.705h4.848c.39 0 .707.316.707.705v5.717a.706.706 0 0 1-.707.705z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M27.624 33.462h-16.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25",
    d: "M61.74 50.234H40.323M51.683 53.817h-11.36M58.57 53.817h-3.602M58.57 57.182H40.324"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M27.624 38.619h-10.57M27.502 43.862h-6.103M18.498 43.862h-2.55"
  })));
};
var ImgEmailConfirmation = function ImgEmailConfirmation(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.023.165H5.11v5.108H.023z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M30.205 35.253a1.422 1.422 0 0 0-.396-1.044l5.58-5.2-.08-3.753-7.84 8.241a1.431 1.431 0 0 0-.378 1.254h-.098v24.297c0 .86.678 1.557 1.514 1.557h4.637c.837 0-2.986-.697-2.986-1.557l-.25-18.773.297-5.022zM49.295 14.872c-.535-.55-3.027-.8-3.562-.251l-4.767 4.901 4.095.127 4.234-4.777z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.4",
    d: "M70.084 59.224L57.709 45.225"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M63.985 27.22s1.227-5.404 6.381-5.404c5.155 0 6.566 5.404 6.566 5.404M73.944 16.308a3.915 3.915 0 0 1-3.906 3.923 3.915 3.915 0 0 1-3.906-3.923 3.915 3.915 0 0 1 3.906-3.923 3.915 3.915 0 0 1 3.906 3.923z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25",
    d: "M73.347 39.959v10.144"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M32.736 23.744h-1.453v-1.46a.548.548 0 0 0-.545-.547c-.3 0-.545.246-.545.547v1.46H28.74a.548.548 0 0 0 0 1.094h1.453v1.46c0 .3.245.547.545.547.3 0 .545-.246.545-.547v-1.46h1.453a.548.548 0 0 0 0-1.094M22.049 59.943c-.227-.923.36-1.863 1.312-2.098.952-.236 1.906.322 2.133 1.245.227.924-.36 1.864-1.313 2.1-.95.235-1.906-.323-2.132-1.247"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.75 63.449)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M4.565 2.171H3.11V.712a.548.548 0 0 0-.545-.547c-.3 0-.545.246-.545.547v1.46H.568a.548.548 0 0 0 0 1.094h1.453v1.46c0 .3.246.547.545.547.3 0 .545-.246.545-.547v-1.46h1.454a.548.548 0 0 0 0-1.095",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M59.79 16.325l-.994-1.68a.223.223 0 0 1 .187-.337l1.947-.025 1.946-.024c.17-.002.28.182.196.331l-.952 1.706L61.168 18a.221.221 0 0 1-.384.004l-.994-1.68zM25.882 19.934c-.227-.923.36-1.863 1.312-2.098.952-.236 1.907.322 2.133 1.246.227.923-.36 1.863-1.312 2.098-.951.236-1.907-.322-2.133-1.246M22.438 64.204c-.125-.511.2-1.031.727-1.162.526-.13 1.055.179 1.18.69.126.511-.2 1.031-.726 1.162-.527.13-1.056-.179-1.18-.69M57.105 18.085c-.126-.511.2-1.031.726-1.162.527-.13 1.056.179 1.181.69.126.511-.2 1.032-.726 1.162-.527.13-1.056-.179-1.181-.69"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M70.659 35.271V58.52c0 .84-.678 1.52-1.515 1.52H31.383a1.517 1.517 0 0 1-1.515-1.52V35.27M44.466 19.902l4.767-4.788a1.366 1.366 0 0 1 1.937 0l4.89 4.912"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M64.514 28.557l5.67 5.695a1.38 1.38 0 0 1 0 1.945l-18.85 12.655a1.365 1.365 0 0 1-1.937 0l-19.054-12.86a1.38 1.38 0 0 1 0-1.946l4.841-4.862"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M35.412 39.076V20.061h28.953v19.943"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.207",
    d: "M40.604 25.285h15.609M40.604 30.244h18.837M40.604 35.364h7.259M40.604 40.512h9.673"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M58.263 49.263l-10.62-11.437a1.857 1.857 0 0 1 0-2.488l2.311-2.489a1.552 1.552 0 0 1 2.31 0l7.154 7.705 15.323-16.502a1.552 1.552 0 0 1 2.31 0l2.31 2.488a1.857 1.857 0 0 1 0 2.489L60.574 49.263a1.553 1.553 0 0 1-2.31 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M58.263 49.263l-10.62-11.437a1.857 1.857 0 0 1 0-2.488l2.311-2.489a1.552 1.552 0 0 1 2.31 0l7.154 7.705 15.323-16.502a1.552 1.552 0 0 1 2.31 0l2.31 2.488a1.857 1.857 0 0 1 0 2.489L60.574 49.263a1.553 1.553 0 0 1-2.31 0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.55",
    d: "M43.146 45.225L30.771 59.224"
  })));
};
var ImgError = function ImgError(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    id: "\uD83D\uDDBC\uFE0FAssets/Illustrations/img_error",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(20.000120, 14.622065)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.6321478,11.9145585 L49.9757517,9.68152486 L54.5780089,14.304273 C54.6753697,14.4019959 54.8352247,14.4025855 54.9331765,14.3054522 L56.8935421,12.362934 C56.9916417,12.2658007 56.9920849,12.1063194 56.8947241,12.0085965 L52.2926147,7.38570094 L56.926045,2.79434788 C57.0239968,2.6972146 57.0245878,2.53773325 56.9272269,2.44001039 L54.9801579,0.484226641 C54.8827971,0.386356386 54.7229421,0.385766806 54.6249903,0.482900086 L49.99156,5.07440054 L45.3891551,0.451652354 C45.291942,0.3537821 45.132087,0.353339915 45.0339875,0.450473195 L43.0737696,2.3929914 C42.97567,2.49012468 42.9752268,2.64960602 43.0725876,2.74747628 L47.674697,7.37007707 L45.8481841,8.93983341",
    id: "Stroke-1",
    stroke: "#FADBD8",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4946765,47.4673574 C12.9723306,47.4673574 2.8213532,37.5216352 2.8213532,25.2532463 C2.8213532,12.9848574 12.9723306,3.03913519 25.4946765,3.03913519 C25.4946765,3.03913519 6.08944343,4.81219074 5.5565111,24.9949315 C5.0293532,44.9595611 25.4946765,47.4673574 25.4946765,47.4673574",
    id: "Fill-3",
    fill: "#F6B7B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6256241,25.2037685 C51.6256241,37.8101574 41.4118496,48.0296019 28.8127519,48.0296019 C16.2134135,48.0296019 5.9998797,37.8101574 5.9998797,25.2037685 C5.9998797,12.5973796 16.2134135,2.37793519 28.8127519,2.37793519 C41.4118496,2.37793519 51.6256241,12.5973796 51.6256241,25.2037685 Z",
    id: "Stroke-5",
    stroke: "#2C3B45",
    strokeWidth: "1.44",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.38766917,40.4583833 C1.16968421,39.5729389 1.73509774,38.672087 2.65082707,38.446513 C3.56655639,38.2206981 4.48565414,38.7556241 4.7036391,39.6408278 C4.92162406,40.5262722 4.35621053,41.4271241 3.4404812,41.6529389 C2.52499248,41.8787537 1.60565414,41.3440685 1.38766917,40.4583833",
    id: "Fill-7",
    fill: "#FADBD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.37052632,9.55586667 L2.97190977,9.55586667 L2.97190977,8.15668148 C2.97190977,7.86779259 2.7358797,7.63186667 2.4473985,7.63186667 C2.15915789,7.63186667 1.92288722,7.86779259 1.92288722,8.15668148 L1.92288722,9.55586667 L0.524511278,9.55586667 C0.235789474,9.55586667 0,9.79179259 0,10.0806815 C0,10.3693296 0.235789474,10.6052556 0.524511278,10.6052556 L1.92288722,10.6052556 L1.92288722,12.0049222 C1.92288722,12.2933296 2.15915789,12.529737 2.4473985,12.529737 C2.7358797,12.529737 2.97190977,12.2933296 2.97190977,12.0049222 L2.97190977,10.6052556 L4.37052632,10.6052556 C4.65876692,10.6052556 4.89503759,10.3693296 4.89503759,10.0806815 C4.89503759,9.79179259 4.65876692,9.55586667 4.37052632,9.55586667",
    id: "Fill-9",
    fill: "#FADBD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42057143,45.2943593 L7.02219549,45.2943593 L7.02219549,43.8951741 C7.02219549,43.6062852 6.78592481,43.3701185 6.49744361,43.3701185 C6.20920301,43.3701185 5.97293233,43.6062852 5.97293233,43.8951741 L5.97293233,45.2943593 L4.57455639,45.2943593 C4.28583459,45.2943593 4.05004511,45.5302852 4.05004511,45.8191741 C4.05004511,46.1078222 4.28583459,46.3437481 4.57455639,46.3437481 L5.97293233,46.3437481 L5.97293233,47.7431741 C5.97293233,48.0318222 6.20920301,48.2682296 6.49744361,48.2682296 C6.78592481,48.2682296 7.02219549,48.0318222 7.02219549,47.7431741 L7.02219549,46.3437481 L8.42057143,46.3437481 C8.70881203,46.3437481 8.94508271,46.1078222 8.94508271,45.8191741 C8.94508271,45.5302852 8.70881203,45.2943593 8.42057143,45.2943593",
    id: "Fill-11",
    fill: "#FADBD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09936842,5.64618889 L8.09936842,3.77202222 C8.09936842,3.6075963 8.27693233,3.5048 8.41912782,3.58713333 L10.0412632,4.52433704 L11.6633985,5.4613 C11.805594,5.54339259 11.805594,5.74874444 11.6633985,5.83107778 L10.0412632,6.76804074 L8.41912782,7.70524444 C8.27693233,7.78733704 8.09936842,7.68478148 8.09936842,7.52035556 L8.09936842,5.64618889 Z",
    id: "Fill-13",
    fill: "#FADBD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1522406,3.90081852 C2.93425564,3.01537407 3.49942857,2.11452222 4.4153985,1.88894815 C5.33112782,1.66289259 6.24998496,2.19781852 6.46796992,3.08326296 C6.68619549,3.96870741 6.12078195,4.86931852 5.20481203,5.09537407 C4.28932331,5.32094815 3.37022556,4.78626296 3.1522406,3.90081852",
    id: "Fill-15",
    fill: "#FADBD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.158580451,44.2225333 C0.0377984962,43.7323852 0.350821053,43.2338111 0.857768421,43.1086259 C1.36471579,42.9836815 1.87358797,43.2797926 1.99412932,43.7699407 C2.11491128,44.2600889 1.80188872,44.7589037 1.29494135,44.8838481 C0.787993985,45.0087926 0.279121805,44.7126815 0.158580451,44.2225333",
    id: "Fill-17",
    fill: "#FADBD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3876692,32.4583833 C56.1696842,31.5729389 56.7350977,30.672087 57.6508271,30.446513 C58.5665564,30.2206981 59.4856541,30.7556241 59.7036391,31.6408278 C59.9216241,32.5262722 59.3562105,33.4271241 58.4404812,33.6529389 C57.5249925,33.8787537 56.6056541,33.3440685 56.3876692,32.4583833",
    id: "Fill-7",
    fill: "#FADBD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1585805,29.2225333 C55.0377985,28.7323852 55.3508211,28.2338111 55.8577684,28.1086259 C56.3647158,27.9836815 56.873588,28.2797926 56.9941293,28.7699407 C57.1149113,29.2600889 56.8018887,29.7589037 56.2949414,29.8838481 C55.787994,30.0087926 55.2791218,29.7126815 55.1585805,29.2225333",
    id: "Fill-17",
    fill: "#FADBD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9964511,44.7717352 L46.9964511,42.8975685 C46.9964511,42.7331426 47.1742556,42.6303463 47.3164511,42.7126796 L48.9385865,43.6498833 L50.5607218,44.5868463 C50.7029173,44.6689389 50.7029173,44.8745315 50.5607218,44.9566241 L48.9385865,45.893587 L47.3164511,46.8307907 C47.1742556,46.9131241 46.9964511,46.8103278 46.9964511,46.6459019 L46.9964511,44.7717352 Z",
    id: "Fill-19",
    fill: "#FADBD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5488602,2.2697037 C17.1996872,1.90955556 17.8764992,1.58094444 18.577612,1.28603704 C19.9942737,0.690925926 21.4400481,0.265296296 22.891597,0",
    id: "Stroke-21",
    stroke: "#2C3B45",
    strokeWidth: "1.44",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.034922, 16.377935)",
    fill: "#E84C3D",
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.19999993"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8690054,0.134193953 L8.95922346,6.00303453 L3.08920185,0.094251924 C2.96502143,-0.0308495253 2.76113188,-0.0314147427 2.63619771,0.0925562718 L0.135629932,2.57574468 C0.0106957616,2.6999041 0.00994201096,2.90357076 0.134310868,3.02867221 L6.00414404,8.93764323 L0.0941736459,14.8064838 C-0.0307605241,14.9306432 -0.0315142747,15.1344983 0.0926661446,15.2595998 L2.57608609,17.7595563 C2.70026651,17.8844693 2.90415606,17.8852229 3.02927867,17.7610635 L8.93906063,11.8920345 L14.8090822,17.801194 C14.9332627,17.926107 15.1371522,17.9268606 15.2620864,17.8025128 L17.7624657,15.3197012 C17.8875883,15.1953534 17.8881536,14.9914983 17.7639732,14.8665853 L11.89414,8.95761424 L17.803922,3.08877366 C17.9290446,2.96442584 17.9297984,2.76057076 17.8056179,2.63565772 L15.3220096,0.135889605 C15.1980176,0.0107881558 14.994128,0.0102229385 14.8690054,0.134193953 Z",
    id: "Stroke-25"
  })))));
};
var ImgFileBroken = function ImgFileBroken(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M6.126.291L4.42 3.912.776 2.218a.264.264 0 0 0-.35.126l-.296.629a.26.26 0 0 0 .127.347L3.9 5.014 2.815 7.32l1.264.187.931-1.977 3.645 1.694a.263.263 0 0 0 .35-.126l.296-.629a.26.26 0 0 0-.127-.347L5.53 4.428 7.235.808A.26.26 0 0 0 7.108.46L6.475.165a.263.263 0 0 0-.35.126z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.188 15.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".55",
    d: "M-3.499.903L8.56-3.44l4.37 11.978L.873 12.881z",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".55",
    d: "M41.268 22.642l.93-1.978 3.645 1.695a.263.263 0 0 0 .35-.126l.296-.63a.26.26 0 0 0-.127-.346l-3.644-1.695 1.705-3.62a.26.26 0 0 0-.126-.347l-.634-.295a.263.263 0 0 0-.35.126l-1.704 3.621-3.645-1.694a.264.264 0 0 0-.35.126l-.296.629a.26.26 0 0 0 .127.347l3.644 1.694-1.085 2.305 1.264.188zM65.48 39.971c.215.057.547.175.774.356.348.279.543.586.587.923.041.336-.076.675-.353 1.017-.267.33-.685.512-1.031.547l.023-2.843zm.517-1.285l.357-.477c.308-.413.665-.707 1.07-.882.406-.174.973-.26 1.702-.256.695.012 1.19-.03 1.486-.125a1.43 1.43 0 0 0 .724-.517c.208-.28.263-.57.165-.868-.099-.3-.334-.587-.707-.861-.65-.478-1.547-.813-2.693-1.004l.347-1.934a7.731 7.731 0 0 1 3.674 1.456c.892.657 1.442 1.392 1.65 2.206.208.813.047 1.574-.482 2.284-.353.473-.767.802-1.24.987-.473.185-1.173.269-2.1.252-.644 0-1.08.038-1.31.116-.23.078-.44.245-.633.504l-.288.387-1.722-1.268z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M31.759 45.964l-.038-21.91 1.664-1.321-1.338-.173c-1.568 0-2.839.953-2.839 2.128v21.276l-.003-.103c0 .801.442 1.537 1.154 1.917 0 0 3.525 1.06 4.024.757.499-.303-1.22-.716-1.22-.716l-1.404-1.855M31.583 50.937l.25 9.48 1.136 1.247 2.29.337c-.38 0-3.959-.048-4.29-.136-1.035-.27-1.764-.923-1.764-1.683v-1.238l.003-.28v-7.23s-.351-.366 2.375-.497"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M64.946 28.213v17.75l.005-.102c0 .801-.443 1.537-1.154 1.916a2.208 2.208 0 0 1-2.259-.098l-1.711-1.121a.504.504 0 0 0-.538.002l-1.37.895a3.813 3.813 0 0 1-2.097.627 3.81 3.81 0 0 1-2.096-.625l-1.37-.897a.503.503 0 0 0-.537.002l-1.371.895a3.818 3.818 0 0 1-4.19 0l-1.37-.897a.506.506 0 0 0-.54.002l-1.37.895a3.818 3.818 0 0 1-4.188 0l-1.371-.897a.506.506 0 0 0-.54.002l-1.71 1.117a2.223 2.223 0 0 1-2.26.1 2.173 2.173 0 0 1-1.153-1.918l.003.103V24.688c0-1.175 1.27-2.128 2.838-2.128h24.295l6.054 5.653z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M59.108 23v2.946c0 .89.729 1.653 1.763 1.97.332.103.695.159 1.076.159h2.518"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.65",
    d: "M59.108 23v2.946c0 .89.729 1.653 1.763 1.97.332.103.695.159 1.076.159h2.518L59.108 23z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M50.591 66.032H38.62M64.943 59.47v1.59c0 1.289-1.27 2.334-2.839 2.334h-27.51a3.37 3.37 0 0 1-1.076-.173c-1.034-.349-1.762-1.185-1.762-2.162V59.47l.003-.36v-8.07l-.003-.113c0 .88.44.472 1.153.89a2.056 2.056 0 0 0 2.26-.108l1.71-1.226a.468.468 0 0 1 .54-.002l1.37.983a3.54 3.54 0 0 0 4.19 0l1.37-.981a.468.468 0 0 1 .539-.002l1.37.983a3.54 3.54 0 0 0 4.19 0l1.37-.981a.465.465 0 0 1 .538-.002l1.37.983a3.571 3.571 0 0 0 2.096.686c.729 0 1.459-.228 2.096-.687l1.371-.982a.465.465 0 0 1 .538-.002l1.711 1.23c.68.486 1.546.53 2.26.106.71-.416 1.153-.009 1.153-.888l-.005.114v8.07l-.003.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M66.34 22.905c-.201-.81.32-1.635 1.164-1.841.844-.207 1.691.282 1.892 1.093.2.81-.32 1.634-1.164 1.84-.844.207-1.691-.282-1.892-1.092M64.613 24.713c-.111-.449.177-.905.645-1.02.467-.114.936.157 1.047.606.111.448-.177.905-.644 1.02-.468.113-.937-.158-1.048-.606M67.667 29.645c-.111-.449.177-.905.644-1.02.468-.114.937.157 1.048.606.11.448-.178.905-.645 1.019-.467.114-.936-.157-1.047-.605M23.235 31.738c-.2-.81.32-1.634 1.165-1.84.844-.207 1.69.282 1.892 1.092.2.81-.32 1.635-1.165 1.841-.844.207-1.69-.282-1.892-1.093M21.024 34.124c-.111-.448.177-.905.644-1.02.468-.113.937.157 1.048.606.11.449-.178.905-.645 1.02-.467.114-.936-.157-1.047-.606M64.337 20.247h-1.151v-1.143a.431.431 0 0 0-.863 0v1.143h-1.151a.432.432 0 0 0-.432.428c0 .236.194.43.432.43h1.15v1.143a.432.432 0 0 0 .864 0v-1.144h1.15a.432.432 0 0 0 .432-.429.431.431 0 0 0-.431-.428M71.334 60.157l-1.093-1.086 1.093-1.087a.575.575 0 0 0 0-.815.584.584 0 0 0-.82 0l-1.094 1.087-1.094-1.087a.584.584 0 0 0-.82 0 .575.575 0 0 0 0 .815L68.6 59.07l-1.094 1.086a.575.575 0 0 0 0 .815.584.584 0 0 0 .82 0l1.094-1.086 1.094 1.086a.584.584 0 0 0 .82 0 .575.575 0 0 0 0-.815M28.47 62.22h-.93v-.923a.349.349 0 0 0-.697 0v.924h-.93a.349.349 0 0 0-.349.346c0 .191.157.347.349.347h.93v.924a.349.349 0 0 0 .697 0v-.924h.93a.349.349 0 0 0 .349-.347.349.349 0 0 0-.349-.346M24.552 37.284v-1.715c0-.15.164-.244.295-.17l1.495.858 1.495.858a.195.195 0 0 1 0 .338l-1.495.857-1.495.858a.197.197 0 0 1-.295-.17v-1.714zM65.52 63.2v-1.152c0-.1.11-.164.197-.113l1.003.575 1.004.576a.13.13 0 0 1 0 .227l-1.004.575-1.003.576a.132.132 0 0 1-.198-.114V63.2z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#00B3DB",
    stroke: "#2C3B45",
    strokeWidth: "1.5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.204 36l3.225 3.225a1.097 1.097 0 0 1 0 1.551l-.653.652a1.096 1.096 0 0 1-1.551 0L49 38.205l-3.225 3.224c-.428.43-1.123.43-1.551 0l-.653-.652a1.097 1.097 0 0 1 0-1.551L46.796 36l-3.225-3.225a1.097 1.097 0 0 1 0-1.551l.653-.652a1.096 1.096 0 0 1 1.551 0L49 33.795l3.225-3.224a1.097 1.097 0 0 1 1.551 0l.653.652a1.097 1.097 0 0 1 0 1.551L51.204 36z"
  }))));
};
var ImgFileLost = function ImgFileLost(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M6.126.291L4.42 3.912.776 2.218a.264.264 0 0 0-.35.126l-.296.629a.26.26 0 0 0 .127.347L3.9 5.014 2.815 7.32l1.264.187.931-1.977 3.645 1.694a.263.263 0 0 0 .35-.126l.296-.63a.26.26 0 0 0-.127-.347L5.53 4.428 7.235.808A.26.26 0 0 0 7.108.46L6.475.165a.263.263 0 0 0-.35.126z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.168.08h2.27v2.564H.168z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.188 15.135)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".55",
    d: "M-3.499.903L8.56-3.44l4.37 11.978L.873 12.88z",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M46.268 22.642l.93-1.978 3.645 1.695a.264.264 0 0 0 .35-.126l.296-.63a.26.26 0 0 0-.127-.347l-3.644-1.693 1.705-3.621a.26.26 0 0 0-.126-.347l-.634-.295a.263.263 0 0 0-.35.126l-1.704 3.62-3.645-1.693a.264.264 0 0 0-.35.126l-.296.629a.26.26 0 0 0 .127.347l3.644 1.694-1.085 2.305 1.264.188zM70.48 39.971c.215.057.547.175.774.356.348.279.543.586.587.923.041.336-.076.675-.353 1.017-.267.33-.685.513-1.031.548l.023-2.844zm.517-1.285l.357-.477c.308-.413.665-.707 1.07-.882.406-.174.973-.26 1.702-.256.695.012 1.19-.03 1.486-.125a1.43 1.43 0 0 0 .724-.517c.208-.28.263-.57.165-.868-.099-.3-.334-.587-.707-.86-.65-.48-1.547-.814-2.693-1.005l.347-1.934a7.73 7.73 0 0 1 3.674 1.456c.892.657 1.442 1.392 1.65 2.206.208.813.047 1.574-.482 2.284-.353.473-.767.802-1.24.987-.473.184-1.173.269-2.1.252-.644 0-1.08.038-1.31.116-.23.078-.44.246-.633.504l-.288.387-1.722-1.268z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M36.759 45.964l-.038-21.91 1.664-1.321-1.338-.173c-1.568 0-2.839.953-2.839 2.128v21.276l-.003-.103c0 .801.442 1.536 1.154 1.917 0 0 3.525 1.06 4.024.757.499-.303-1.22-.716-1.22-.716l-1.404-1.855M36.583 50.734l.25 10.602 1.136 1.395 2.29.376c-.38 0-3.959-.054-4.29-.151-1.035-.304-1.764-1.032-1.764-1.883V59.69l.003-.313v-8.087s-.351-.408 2.375-.555"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M69.578 28.213v17.75l.004-.102c0 .801-.443 1.536-1.153 1.916a2.208 2.208 0 0 1-2.26-.098l-1.71-1.12a.503.503 0 0 0-.538 0l-1.37.896a3.815 3.815 0 0 1-2.097.627 3.81 3.81 0 0 1-2.096-.625l-1.37-.897a.503.503 0 0 0-.538.002l-1.37.895a3.82 3.82 0 0 1-4.19 0l-1.37-.897a.506.506 0 0 0-.54.002l-1.37.895a3.819 3.819 0 0 1-4.189 0l-1.37-.897a.506.506 0 0 0-.54.002l-1.71 1.117a2.223 2.223 0 0 1-2.26.1 2.174 2.174 0 0 1-1.154-1.918l.003.103V24.688c0-1.175 1.271-2.128 2.839-2.128h24.294l6.055 5.653z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M63.776 23.33v3.167c0 .89.728 1.653 1.763 1.97.331.102.695.159 1.075.159h2.63"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.1",
    d: "M63.776 23.33v3.167c0 .89.728 1.653 1.763 1.97.331.102.695.159 1.075.159h2.63"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.65",
    d: "M52.577 66.87H43.62"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M69.575 59.788v1.589c0 1.29-1.271 2.335-2.839 2.335h-27.51c-.38 0-.744-.062-1.076-.174-1.034-.348-1.763-1.185-1.763-2.161v-1.589l.003-.36v-8.07l-.003-.113c0 .879.442.472 1.154.89a2.056 2.056 0 0 0 2.26-.109l1.71-1.226a.468.468 0 0 1 .54-.002l1.37.984a3.54 3.54 0 0 0 4.19 0l1.369-.982a.468.468 0 0 1 .54-.002l1.37.984a3.54 3.54 0 0 0 4.19 0l1.37-.982a.465.465 0 0 1 .538-.002l1.37.984a3.573 3.573 0 0 0 2.096.685c.729 0 1.459-.227 2.096-.687l1.371-.982a.465.465 0 0 1 .538-.002l1.71 1.23c.681.487 1.546.53 2.26.107.71-.416 1.153-.01 1.153-.888l-.004.113v8.07l-.003.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M71.34 22.905c-.201-.81.32-1.635 1.164-1.841.844-.207 1.691.282 1.892 1.093.2.81-.32 1.634-1.164 1.84-.844.207-1.691-.282-1.892-1.092M69.613 24.713c-.111-.449.177-.905.645-1.02.467-.114.936.157 1.047.606.111.448-.177.905-.644 1.02-.468.113-.937-.157-1.048-.606M72.667 29.645c-.111-.449.177-.905.644-1.02.468-.114.937.157 1.048.606.11.448-.178.905-.645 1.019-.467.114-.936-.157-1.047-.605M28.235 31.738c-.2-.81.32-1.634 1.165-1.84.844-.207 1.69.282 1.892 1.092.2.81-.32 1.635-1.165 1.842-.844.206-1.69-.283-1.892-1.094M26.024 34.124c-.111-.448.177-.905.644-1.02.468-.113.937.158 1.048.606.11.449-.178.905-.645 1.02-.467.114-.936-.157-1.047-.606M69.337 20.247h-1.151v-1.144a.432.432 0 0 0-.863 0v1.144h-1.151a.432.432 0 0 0-.432.428c0 .236.194.43.432.43h1.15v1.143a.431.431 0 0 0 .864 0v-1.144h1.15a.432.432 0 0 0 .432-.429.431.431 0 0 0-.431-.428M76.334 60.157l-1.093-1.087 1.093-1.086a.575.575 0 0 0 0-.815.585.585 0 0 0-.82 0l-1.094 1.087-1.094-1.087a.585.585 0 0 0-.82 0 .576.576 0 0 0 0 .815L73.6 59.07l-1.094 1.087a.575.575 0 0 0 0 .815.584.584 0 0 0 .82 0l1.094-1.086 1.094 1.086a.584.584 0 0 0 .82 0 .575.575 0 0 0 0-.815M33.47 62.221h-.93v-.924a.349.349 0 0 0-.697 0v.924h-.93a.349.349 0 0 0-.349.346c0 .191.157.347.349.347h.93v.924a.349.349 0 0 0 .697 0v-.924h.93a.349.349 0 0 0 .349-.347.349.349 0 0 0-.349-.346M29.552 37.284v-1.715c0-.15.164-.245.295-.17l1.495.858 1.495.858a.195.195 0 0 1 0 .338l-1.495.857-1.495.858a.197.197 0 0 1-.295-.17v-1.714z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.351 61.838)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M.168 1.361V.211c0-.102.11-.165.198-.114l1.003.575 1.003.576a.13.13 0 0 1 0 .227L1.37 2.05l-1.003.576a.132.132 0 0 1-.198-.114v-1.15z",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M49.77 32.265c0 .67-.547 1.212-1.22 1.212-.674 0-1.22-.543-1.22-1.212 0-.669.546-1.211 1.22-1.211.673 0 1.22.542 1.22 1.211"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.65",
    d: "M49.77 32.265c0 .67-.547 1.212-1.22 1.212-.674 0-1.22-.543-1.22-1.212 0-.669.546-1.211 1.22-1.211.673 0 1.22.542 1.22 1.211z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M58.64 32.265c0 .67-.546 1.212-1.22 1.212-.674 0-1.22-.543-1.22-1.212 0-.669.546-1.211 1.22-1.211.674 0 1.22.542 1.22 1.211"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.65",
    d: "M58.64 32.265c0 .67-.546 1.212-1.22 1.212-.674 0-1.22-.543-1.22-1.212 0-.669.546-1.211 1.22-1.211.674 0 1.22.542 1.22 1.211z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeWidth: "1.65",
    d: "M47.682 41.934c0-1.752 2.374-3.172 5.303-3.172s5.303 1.42 5.303 3.172"
  })));
};
var ImgFiscality = function ImgFiscality(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M67.173 62.833c0 .891-.543 1.097-1.413 1.519a2.94 2.94 0 0 1-2.768-.109l-2.096-1.247a.67.67 0 0 0-.66.002l-1.679.996a5.015 5.015 0 0 1-2.568.697 5.013 5.013 0 0 1-2.569-.695l-1.677-.998a.669.669 0 0 0-.66.001l-1.679.997a5.077 5.077 0 0 1-5.133 0l-1.68-.998a.672.672 0 0 0-.66.001l-1.678.997a5.077 5.077 0 0 1-5.133 0l-1.68-.998a.672.672 0 0 0-.66.001l-2.095 1.244a2.96 2.96 0 0 1-2.77.11c-.872-.423-1.413-1.242-1.413-2.133v-39.1c0-.892.543-1.709 1.413-2.133a2.919 2.919 0 0 1 1.33-.294v40.059l1.155 1.839 1.766.429 1.766-.552 1.223-.735.747-.43 1.29.552 1.63.797s1.495.43 1.767.43c.271 0 2.517-.802 2.517-.802l2.338-.999 1.68.999 1.955.679 3.328-.43 1.53-1.246 3.361 1.43 3.26-.06 2.174-.798.358-.574 1.544.268 1.211.978 1.328.306z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M57.841 11.485c0-2.882 2.372-5.217 5.298-5.217 2.925 0 5.297 2.335 5.297 5.217 0 2.881-2.372 5.217-5.297 5.217-2.926 0-5.298-2.336-5.298-5.217z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M70.964 41.141c4.926-.043 7.99-2.814 10.663-7.132 2.672-4.318 3.106-10.05 1.117-14.752-.637-1.504-1.533-2.935-2.82-3.883-1.288-.948-3.014-.962-4.481-.36-1.812.741-2.875 2.268-2.334 4.219.542 1.95 2.592 2.91 4.516 2.603 1.924-.306 3.489-1.431 3.524-3.461.053-3.137-2.981-5.35-5.854-6.277a19.722 19.722 0 0 0-7.073-.93"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M62.337 11.91c.074.746.317 1.12.729 1.12a.838.838 0 0 0 .423-.11c.128-.072.25-.243.369-.511.076-.175.141-.284.196-.327a.284.284 0 0 1 .178-.064c.126 0 .225.037.296.108a.41.41 0 0 1 .106.302c0 .305-.152.587-.456.847a1.648 1.648 0 0 1-1.106.388c-.405 0-.76-.145-1.061-.435-.302-.29-.483-.73-.542-1.319h-.402c-.038 0-.057-.027-.057-.08a.46.46 0 0 1 .06-.197c.04-.08.074-.119.101-.119h.273v-.112c0-.092.004-.224.012-.397h-.39c-.037 0-.056-.026-.056-.078 0-.054.02-.12.06-.2.04-.078.074-.118.101-.118h.317c.137-1.084.657-1.626 1.559-1.626.397 0 .74.101 1.026.303.287.202.431.453.431.752a.362.362 0 0 1-.101.26.33.33 0 0 1-.247.105c-.108 0-.187-.027-.237-.081a.912.912 0 0 1-.147-.25.949.949 0 0 0-.218-.338c-.085-.078-.228-.117-.431-.117-.232 0-.411.08-.537.24-.126.16-.207.41-.243.752h1.02c.043 0 .064.027.064.081a.45.45 0 0 1-.059.201c-.039.077-.073.114-.103.114h-.947l-.006.306c0 .094.002.161.006.203h1.046c.042 0 .063.026.063.078 0 .06-.02.128-.059.204-.039.076-.073.114-.103.114h-.928z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M37.72 13.952c0 1.396-1.189 2.528-2.656 2.528s-2.656-1.132-2.656-2.528c0-1.397 1.19-2.528 2.656-2.528 1.467 0 2.656 1.131 2.656 2.528M76.258 44.879h-1.364v-1.343a.509.509 0 0 0-.51-.504.509.509 0 0 0-.512.504v1.343h-1.364a.51.51 0 0 0-.511.504c0 .277.23.503.511.503h1.364v1.343c0 .277.23.504.511.504a.51.51 0 0 0 .511-.504v-1.343h1.364a.51.51 0 0 0 .511-.503.51.51 0 0 0-.511-.504M74.356 63.473h-1.363V62.13a.509.509 0 0 0-.512-.504.509.509 0 0 0-.511.504v1.343h-1.364a.51.51 0 0 0-.511.503c0 .277.23.504.511.504h1.364v1.343c0 .277.23.504.511.504a.51.51 0 0 0 .512-.504V64.48h1.363a.51.51 0 0 0 .511-.504.51.51 0 0 0-.51-.503M71.906 26.139v-2.393c0-.21.23-.34.415-.236l2.104 1.196 2.104 1.197a.27.27 0 0 1 0 .472l-2.104 1.196-2.104 1.197a.277.277 0 0 1-.415-.236v-2.393zM18.66 36.697v-2.392c0-.21.231-.341.415-.236l2.104 1.196 2.105 1.196a.27.27 0 0 1 0 .472l-2.105 1.197-2.104 1.196a.277.277 0 0 1-.414-.236v-2.393zM72.43 69.475c0 .718-.612 1.3-1.366 1.3-.754 0-1.365-.582-1.365-1.3 0-.717.611-1.3 1.365-1.3s1.365.583 1.365 1.3M35.479 67.264c0 .718-.612 1.3-1.366 1.3-.754 0-1.365-.582-1.365-1.3 0-.718.611-1.3 1.365-1.3s1.366.582 1.366 1.3M65.695 65.672l-2.202 1.663-1.689-2.169a1.055 1.055 0 0 0-1.459-.19c-.454.344-.54.99-.192 1.438l1.689 2.169-2.202 1.663c-.454.343-.54.99-.192 1.437a1.055 1.055 0 0 0 1.459.19l2.202-1.664 1.688 2.169a1.055 1.055 0 0 0 1.46.19c.454-.344.54-.99.192-1.438l-1.69-2.168 2.203-1.664c.454-.343.54-.99.192-1.437a1.054 1.054 0 0 0-1.459-.19"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M58.841 62.771a5.017 5.017 0 0 1-2.568-.694l-1.678-.998a.67.67 0 0 0-.658.002l-1.68.996a5.081 5.081 0 0 1-5.133 0l-1.68-.998a.673.673 0 0 0-.66.002l-1.678.996a5.081 5.081 0 0 1-5.133 0l-1.68-.998a.673.673 0 0 0-.66.002l-2.095 1.243a2.963 2.963 0 0 1-2.77.11c-.872-.423-1.413-1.24-1.413-2.132V21.24c0-.89.543-1.707 1.413-2.13a2.937 2.937 0 0 1 2.768.108l2.097 1.245a.661.661 0 0 0 .658 0l1.68-.998a5.1 5.1 0 0 1 5.13 0l1.68.998a.662.662 0 0 0 .66 0l1.68-.998a5.1 5.1 0 0 1 5.13 0l1.68.998c.199.117.461.117.658 0l1.68-.998a5.097 5.097 0 0 1 5.13 0l1.68.996a.66.66 0 0 0 .66 0l2.096-1.245a2.949 2.949 0 0 1 2.768-.11c.88.427 1.423 1.243 1.423 2.134v39.062c0 .891-.543 1.709-1.413 2.13a2.943 2.943 0 0 1-2.768-.108l-2.097-1.247a.67.67 0 0 0-.659.002l-1.68.996a5.019 5.019 0 0 1-2.568.696z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M37.591 44.477l-1.675-1.77a.283.283 0 0 1 0-.385l.364-.385a.248.248 0 0 1 .365 0l1.129 1.192 2.418-2.553a.248.248 0 0 1 .364 0l.365.385c.1.106.1.278 0 .385l-2.965 3.131a.248.248 0 0 1-.365 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M62.18 42.63H43.84h9.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M37.591 50.477l-1.675-1.77a.283.283 0 0 1 0-.385l.364-.385a.248.248 0 0 1 .365 0l1.129 1.192 2.418-2.553a.248.248 0 0 1 .364 0l.365.385c.1.106.1.278 0 .385l-2.965 3.131a.248.248 0 0 1-.365 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M62.18 48.63H43.84h9.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M35.916 54.707a.283.283 0 0 1 0-.385l.364-.385a.248.248 0 0 1 .365 0l1.129 1.192 2.418-2.553a.248.248 0 0 1 .364 0l.365.385c.1.106.1.278 0 .385l-2.965 3.131a.248.248 0 0 1-.365 0l-1.675-1.77z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M62.18 54.63H43.84h9.17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M45.48 35.583l7.47-11.055"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M55.532 33.108c0 1.367-.973 2.475-2.174 2.475-1.2 0-2.173-1.108-2.173-2.475s.973-2.475 2.173-2.475c1.2 0 2.174 1.108 2.174 2.475"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M55.532 33.108c0 1.367-.973 2.475-2.174 2.475-1.2 0-2.173-1.108-2.173-2.475s.973-2.475 2.173-2.475c1.2 0 2.174 1.108 2.174 2.475z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M47.517 26.686c0 1.366-.973 2.475-2.174 2.475-1.2 0-2.173-1.109-2.173-2.475 0-1.367.973-2.476 2.173-2.476 1.2 0 2.174 1.109 2.174 2.476"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M47.517 26.686c0 1.366-.973 2.475-2.174 2.475-1.2 0-2.173-1.109-2.173-2.475 0-1.367.973-2.476 2.173-2.476 1.2 0 2.174 1.109 2.174 2.476z"
  }))));
};
var ImgGift = function ImgGift(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.169.038h1.753v1.708H.169z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0 61.962h49.919V.252H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(25 9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M16.258 53.112h-3.15c-1.333 0-2.413-.917-2.413-2.26v-22.88a2.422 2.422 0 0 1 2.412-2.431h.768l-.051 24.894 2.434 2.677z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M40.581 20.143l-.298-1.38c-.054-.201.089-.368.286-.333l4.688.627c.197.034.404.224.422.444l.055.568a.366.366 0 0 1-.367.398l-4.31.046c-.215.02-.421-.17-.476-.37zm-4.089-2.659l-1.057.965a.534.534 0 0 1-.602.015l-3.442-2.628c-.162-.145-.207-.373-.064-.54l.376-.425a.551.551 0 0 1 .602-.108l4.15 2.282c.18.09.199.31.037.44zm-5.76 6.65l6.893-6.002c.134-.139.448-.188.637-.126l.296.097c.189.062.387.28.441.481l1.345 4.99a.454.454 0 0 1-.26.526l-.574.207c-.206.085-.413-.014-.467-.214l-1.422-2.91c-.081-.21-.27-.273-.431-.143L32.5 24.64l-1.769-.506zm8.534-6.744l-1.212-.399c-.19-.062-.27-.272-.18-.456l.92-1.741c.117-.175.36-.279.548-.217l.297.098c.215.07.35.298.315.5l-.275 1.954c-.036.202-.224.323-.413.261z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.25 .214)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M1.922.892a.865.865 0 0 1-.877.854.865.865 0 0 1-.876-.854c0-.471.392-.854.876-.854s.877.383.877.854",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M2.428 31.763a.865.865 0 0 1-.877.854.865.865 0 0 1-.876-.854c0-.471.392-.854.876-.854s.877.383.877.854M24.327 3.16c-.22-.904.352-1.824 1.28-2.054.928-.23 1.859.315 2.08 1.219.22.904-.352 1.823-1.28 2.054-.928.23-1.859-.316-2.08-1.22M16.03 56.658c-.22-.904.353-1.823 1.28-2.054.928-.23 1.86.316 2.08 1.22.22.903-.352 1.823-1.28 2.053-.928.23-1.859-.315-2.08-1.219M39.8 2.729h-1.484V1.233a.56.56 0 0 0-.557-.562.56.56 0 0 0-.557.562v1.496h-1.484a.56.56 0 0 0 0 1.122h1.484v1.497c0 .308.25.56.557.56a.56.56 0 0 0 .557-.56V3.85H39.8a.56.56 0 0 0 0-1.122M7.527 31.428l-1.178.91-.903-1.187a.555.555 0 0 0-.78-.104.566.566 0 0 0-.104.787l.904 1.188-1.178.91a.566.566 0 0 0-.103.787.556.556 0 0 0 .78.104l1.179-.911.903 1.187a.555.555 0 0 0 .78.104.566.566 0 0 0 .103-.787l-.903-1.187 1.177-.91a.566.566 0 0 0 .103-.788.555.555 0 0 0-.78-.103M46.084 60.523l-.797 1.351a.177.177 0 0 1-.308-.004l-.762-1.371-.763-1.372a.179.179 0 0 1 .157-.266l1.56.02 1.56.02c.136.002.22.152.15.27l-.797 1.352z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M44.812 52.254H15.531c-.979 0-1.772-.8-1.772-1.786v-24.17c0-.987.793-1.787 1.772-1.787h29.281c.979 0 1.772.8 1.772 1.786v24.171c0 .986-.793 1.786-1.772 1.786z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M26.881 49.955h6.58V26.953h-6.58z",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M5.207 11.395c1.581-.906 3.015-.964 9.338 2.4l.27.147-6.183 3.543c-1.582.906-3.64.283-4.588-1.397-.94-1.684-.418-3.787 1.163-4.693",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M5.207 11.395c1.581-.906 3.015-.964 9.338 2.4l.27.147-6.183 3.543c-1.582.906-3.64.283-4.588-1.397-.94-1.684-.418-3.787 1.163-4.693z",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M17.56 4.317c-1.58.906-2.364 2.118-2.732 9.315l-.013.31L21 10.399c1.581-.906 2.103-3.009 1.156-4.689-.954-1.676-3.013-2.3-4.595-1.393",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M17.56 4.317c-1.58.906-2.364 2.118-2.732 9.315l-.013.31L21 10.399c1.581-.906 2.103-3.009 1.156-4.689-.954-1.676-3.013-2.3-4.595-1.393z",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M20.545 15.776l-5.741 3.242-1.01-1.816 5.743-3.241z",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M33.412 10.731L3.814 27.441a.706.706 0 0 1-.965-.273L.716 23.327a.718.718 0 0 1 .272-.973l29.597-16.71a.706.706 0 0 1 .965.273l2.134 3.842c.191.344.069.78-.272.972zM48.682 54.895h-7.571",
    mask: "url(#d)"
  })));
};
var ImgHardkey = function ImgHardkey(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.25.125h.125V.25H.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.25.125h.125V.25H.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M.25.125h.125V.25H.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M0 .071h1.961v1.903H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M.244.155h4.541v4.541H.244z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M31.449 20.258c-.978 0-1.772.793-1.772 1.772v38.414c0 .978.794 1.771 1.772 1.771h3.032l-2.688-2.41V20.211l-.344.047z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M65.993 61.61H33.844c-.787 0-1.426-.847-1.426-1.892v-38.9c0-1.046.639-1.893 1.426-1.893h32.149c.787 0 1.426.847 1.426 1.893v38.9c0 1.045-.639 1.892-1.426 1.892z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M62.643 28.558H37.195a.964.964 0 0 1-.964-.963v-4.453c0-.532.431-.964.964-.964h25.448c.532 0 .963.432.963.964v4.453a.964.964 0 0 1-.963.963"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2E3B45",
    strokeWidth: "1.5",
    d: "M37.248 33.136a1.685 1.685 0 1 1 3.371 0 1.685 1.685 0 0 1-3.37 0zM44.606 33.187a1.685 1.685 0 1 1 3.37 0 1.685 1.685 0 0 1-3.37 0zM51.912 33.187a1.685 1.685 0 1 1 3.37 0 1.685 1.685 0 0 1-3.37 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M59.218 33.187a1.685 1.685 0 1 1 3.37 0 1.685 1.685 0 0 1-3.37 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M59.218 33.187a1.685 1.685 0 1 1 3.37 0 1.685 1.685 0 0 1-3.37 0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2E3B45",
    strokeWidth: "1.5",
    d: "M37.248 40.593a1.685 1.685 0 1 1 3.37 0 1.685 1.685 0 0 1-3.37 0zM44.606 40.643a1.685 1.685 0 1 1 3.37 0 1.685 1.685 0 0 1-3.37 0zM51.912 40.643a1.685 1.685 0 1 1 3.37 0 1.685 1.685 0 0 1-3.37 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M59.218 40.643a1.685 1.685 0 1 1 3.37 0 1.685 1.685 0 0 1-3.37 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M59.218 40.643a1.685 1.685 0 1 1 3.37 0 1.685 1.685 0 0 1-3.37 0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2E3B45",
    strokeWidth: "1.5",
    d: "M37.248 48.093a1.685 1.685 0 1 1 3.37 0 1.685 1.685 0 0 1-3.37 0zM44.606 48.143a1.685 1.685 0 1 1 3.37 0 1.685 1.685 0 0 1-3.37 0zM51.912 48.143a1.685 1.685 0 1 1 3.37 0 1.685 1.685 0 0 1-3.37 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41BA84",
    d: "M59.218 48.143a1.685 1.685 0 1 1 3.37 0 1.685 1.685 0 0 1-3.37 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M59.218 48.143a1.685 1.685 0 1 1 3.37 0 1.685 1.685 0 0 1-3.37 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E84C3D",
    d: "M37.248 55.593a1.685 1.685 0 1 1 3.37 0 1.685 1.685 0 0 1-3.37 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2E3B45",
    strokeWidth: "1.5",
    d: "M37.248 55.593a1.685 1.685 0 1 1 3.37 0 1.685 1.685 0 0 1-3.37 0zM44.606 55.643a1.685 1.685 0 1 1 3.37 0 1.685 1.685 0 0 1-3.37 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E3B45",
    d: "M58.573 54.9h-.204a.027.027 0 0 0-.023.013l-.149.244-.314-.538a.027.027 0 0 0-.023-.014h-.242a.027.027 0 0 0-.023.014.026.026 0 0 0 0 .027l.44.752v.553c0 .015.012.027.026.027h.215a.027.027 0 0 0 .027-.027v-.535l.293-.475a.028.028 0 0 0 0-.027.027.027 0 0 0-.023-.014"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E3B45",
    d: "M59.603 54.605h-1.055a.027.027 0 0 0-.023.013l-.097.16a.028.028 0 0 0 0 .028.027.027 0 0 0 .023.013h.423v1.133c0 .014.012.026.027.026h.215a.027.027 0 0 0 .027-.026v-1.133h.392c.011 0 .021-.006.025-.016l.068-.16a.028.028 0 0 0-.002-.026.027.027 0 0 0-.023-.011M56.519 55.929l-.665-.666.6-.612a.028.028 0 0 0 .006-.03.027.027 0 0 0-.025-.016h-.27a.027.027 0 0 0-.02.009l-.58.636v-.618a.027.027 0 0 0-.027-.027h-.215a.027.027 0 0 0-.027.027v1.32c0 .014.012.026.027.026h.215a.027.027 0 0 0 .027-.027v-.618l.609.637a.027.027 0 0 0 .02.008h.31a.027.027 0 0 0 .027-.027.027.027 0 0 0-.012-.022M63.293 54.778a.69.69 0 0 0-.245-.143.981.981 0 0 0-.322-.05 2.158 2.158 0 0 0-.44.042.026.026 0 0 0-.023.026v1.272c0 .012.009.023.02.026a1.735 1.735 0 0 0 .44.054.942.942 0 0 0 .319-.05.661.661 0 0 0 .402-.369.722.722 0 0 0 .055-.288.79.79 0 0 0-.053-.295.62.62 0 0 0-.153-.225m-.111.71a.458.458 0 0 1-.248.271.498.498 0 0 1-.21.042.756.756 0 0 1-.119-.01l-.073-.013v-.99h.138c.088 0 .167.014.235.04a.447.447 0 0 1 .273.266.58.58 0 0 1 .004.394M57.512 55.766h-.586v-.381h.382c.011 0 .02-.007.025-.017l.066-.15a.027.027 0 0 0-.003-.025.026.026 0 0 0-.022-.012h-.448v-.372h.477c.01 0 .02-.006.025-.016l.067-.15a.027.027 0 0 0-.024-.038h-.787a.027.027 0 0 0-.027.027v1.32c0 .014.012.027.027.027h.737c.01 0 .019-.006.023-.014l.091-.158a.027.027 0 0 0 0-.027.028.028 0 0 0-.023-.014M61.595 54.62a.027.027 0 0 0-.025-.017h-.233a.028.028 0 0 0-.023.012.027.027 0 0 0-.001.026l.044.1-.497 1.2a.027.027 0 0 0 .025.038h.204a.027.027 0 0 0 .024-.018l.116-.293h.49l.117.293c.004.01.014.018.025.018h.236a.027.027 0 0 0 .027-.028.028.028 0 0 0-.005-.015l-.524-1.316zm-.288.844l.166-.421.166.421h-.332zM64.5 55.766h-.586v-.381h.382c.01 0 .02-.007.024-.017l.066-.15a.026.026 0 0 0-.002-.025.027.027 0 0 0-.023-.012h-.447v-.372h.477c.01 0 .02-.006.024-.016l.068-.15a.028.028 0 0 0-.002-.025.028.028 0 0 0-.023-.013h-.786a.027.027 0 0 0-.027.027v1.32c0 .014.012.027.027.027h.737c.01 0 .018-.006.023-.014l.09-.158a.028.028 0 0 0 0-.027.028.028 0 0 0-.023-.014"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E3B45",
    d: "M60.87 55.93l-.47-.563a.613.613 0 0 0 .162-.115.458.458 0 0 0 .08-.115.339.339 0 0 0 .033-.151.36.36 0 0 0-.043-.178.37.37 0 0 0-.117-.125.544.544 0 0 0-.171-.074.854.854 0 0 0-.211-.024 1.77 1.77 0 0 0-.408.041.027.027 0 0 0-.022.027v1.298c0 .015.012.027.027.027h.215a.027.027 0 0 0 .027-.027v-.507h.175l.414.524c.005.007.013.01.021.01h.273a.027.027 0 0 0 .026-.027.027.027 0 0 0-.01-.021m-.526-.77a.355.355 0 0 1-.111.086h-.262v-.457h.1c.117 0 .204.017.258.053.051.033.076.086.076.163 0 .032-.005.06-.017.086a.298.298 0 0 1-.044.07"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 65.845)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 65.845)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21 65.845)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M55.715 56.605l.018-.008a.228.228 0 0 0 .048-.033.171.171 0 0 0 .037-.047.134.134 0 0 0 .015-.064.121.121 0 0 0-.022-.069.183.183 0 0 0-.06-.053.354.354 0 0 0-.09-.033.53.53 0 0 0-.115-.012 1.517 1.517 0 0 0-.242.02.01.01 0 0 0-.008.01v.615a.01.01 0 0 0 .008.01l.043.008a.88.88 0 0 0 .133.016.981.981 0 0 0 .076.003.525.525 0 0 0 .12-.013.324.324 0 0 0 .097-.037.192.192 0 0 0 .065-.062.15.15 0 0 0 .024-.082.157.157 0 0 0-.047-.116.232.232 0 0 0-.1-.053zm-.076-.2c.03.018.044.04.044.068a.098.098 0 0 1-.022.066.156.156 0 0 1-.05.041h-.172v-.203h.07c.056 0 .1.01.13.028zm-.2.261h.093c.056 0 .1.009.132.025a.087.087 0 0 1 .034.03.084.084 0 0 1 .011.045.09.09 0 0 1-.044.08.227.227 0 0 1-.124.03.349.349 0 0 1-.074-.006l-.028-.008v-.196zM56.294 56.3a.01.01 0 0 0-.009-.005h-.133c-.004 0-.007.001-.009.004a.01.01 0 0 0 0 .01l.026.05-.285.581a.01.01 0 0 0 0 .01.01.01 0 0 0 .01.004h.115a.01.01 0 0 0 .01-.005l.067-.145h.289l.068.145a.01.01 0 0 0 .01.005h.134a.01.01 0 0 0 .008-.004.01.01 0 0 0 .001-.01l-.302-.64zm-.065.193l.102.218h-.203l.101-.218zM57.33 56.295h-.105l-.007.003-.003.008v.417l-.442-.425-.007-.003h-.155c-.004 0-.008.003-.01.007a.01.01 0 0 0 .003.01l.08.077v.555l.003.007.007.003h.103l.007-.003.003-.007v-.435l.458.442.007.003h.057l.008-.003.003-.007v-.638l-.003-.008-.008-.003M58.154 56.937l-.384-.326.346-.298a.01.01 0 0 0 .002-.011.01.01 0 0 0-.01-.006h-.155l-.006.002-.342.317v-.31l-.003-.007-.007-.002h-.123l-.007.002-.003.008v.638l.003.008.007.002h.123l.007-.002.003-.008v-.31l.359.318.007.002h.177a.01.01 0 0 0 .01-.006.01.01 0 0 0-.004-.011M52.91 54.503a.081.081 0 0 0 .083-.098l-.088-.497a.123.123 0 0 0-.117-.098h-.082a.123.123 0 0 0-.117.098l-.087.497a.081.081 0 0 0 .082.098h.326M52.94 54.816a.198.198 0 0 0-.152-.085h-.081a.198.198 0 0 0-.152.085l-1.229 2.018a.124.124 0 0 0 .023.152l.124.096a.093.093 0 0 0 .136-.018l1.08-1.505c.032-.045.085-.045.117 0l1.08 1.505a.092.092 0 0 0 .136.018l.124-.096a.125.125 0 0 0 .023-.152l-1.229-2.018M52.228 54.755c.028-.047.007-.093-.047-.103l-1.222-.222a.137.137 0 0 0-.14.072l-.057.135a.096.096 0 0 0 .06.126l1.07.36a.13.13 0 0 0 .146-.053l.19-.315M53.46 55.07a.13.13 0 0 0 .146.054l1.067-.36a.096.096 0 0 0 .06-.126l-.056-.136a.137.137 0 0 0-.14-.072l-1.22.222c-.054.01-.075.056-.047.103l.19.315"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M23.43 21.068c-.226-.92.361-1.855 1.313-2.09.951-.234 1.906.321 2.133 1.24.226.92-.361 1.856-1.313 2.09-.951.235-1.906-.32-2.133-1.24M68.7 65.378c-.126-.509.2-1.027.726-1.156.527-.13 1.055.177 1.18.686.126.51-.2 1.027-.726 1.157-.527.13-1.055-.178-1.18-.687"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.25 15.345)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M.027 1.258C-.1.748.227.23.753.1 1.28-.03 1.81.279 1.934.788c.126.509-.2 1.027-.726 1.156-.527.13-1.056-.177-1.181-.686",
    mask: "url(#h)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M73.2 24.712c-.126-.51.2-1.027.726-1.157.527-.13 1.055.178 1.18.687.126.509-.2 1.027-.726 1.156-.527.13-1.055-.177-1.18-.686"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.5 13.095)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M4.299 1.94H3V.641a.488.488 0 0 0-.486-.487.488.488 0 0 0-.487.487v1.297H.731a.488.488 0 0 0-.487.487c0 .267.219.486.487.486h1.297V4.21a.488.488 0 0 0 .973 0V2.912H4.3a.488.488 0 0 0 0-.973",
    mask: "url(#j)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M73.368 20.19H72.32v-1.048a.394.394 0 0 0-.394-.393.394.394 0 0 0-.393.393v1.048h-1.048a.394.394 0 0 0-.393.393c0 .217.177.394.393.394h1.048v1.048c0 .216.177.393.393.393a.394.394 0 0 0 .394-.393v-1.048h1.048a.394.394 0 0 0 .393-.394.394.394 0 0 0-.393-.393M70.962 54.867c-.226-.92.361-1.855 1.313-2.09.951-.234 1.906.321 2.133 1.24.226.92-.361 1.856-1.313 2.09-.95.234-1.906-.32-2.133-1.24M65.366 64.878c-.125-.509.2-1.027.727-1.156.527-.13 1.055.177 1.18.686.126.51-.2 1.027-.726 1.157-.527.13-1.055-.178-1.181-.687M69.716 60.547V58.6c0-.171.185-.278.333-.192l1.685.973 1.686.973a.222.222 0 0 1 0 .384l-1.686.973-1.685.973a.221.221 0 0 1-.333-.192v-1.946zM25.132 25.925V24.62c0-.114.124-.186.223-.129l1.131.653 1.131.653c.1.058.1.2 0 .258l-1.13.653-1.132.653a.149.149 0 0 1-.223-.128v-1.307z"
  })));
};
var ImgHelp = function ImgHelp(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M47.32 61.976c-11.928 0-21.598-9.584-21.598-21.407 0-11.822 9.67-21.407 21.599-21.407 0 0-18.486 1.709-18.993 21.158-.503 19.24 18.993 21.656 18.993 21.656"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M35.745 19.268h1.346c-.06-1.313-.043-3.27.825-4.082.58-.543 1.384-.586 2.117-.483.228.032.461.078.66.213.615.417.661 1.009.631 1.851.153-.824.82-1.517 1.524-1.43.703.086 1.25 1.09.932 1.843.418-.516 1.214-.287 1.559.302.344.588.333 1.235.198 1.934h1.765M65.41 11.802L65.6 11l-11.751 4.204 9.807 2.23.987-3.168 1.476 1.697-.79.232M60.207 14.532l-6.358.672M63.233 14.227l-1.446.107"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M69.205 50.784c3.79-1.173 7.23-4.158 9.351-8.28 2.75-5.346 3.197-12.443 1.15-18.264-.655-1.863-1.577-3.634-2.902-4.808-1.325-1.174-3.1-1.19-4.61-.446-1.864.918-2.959 2.81-2.401 5.224.557 2.414 2.666 3.602 4.646 3.223 1.98-.38 3.59-1.772 3.626-4.286.055-3.883-3.068-6.622-6.023-7.77a17.12 17.12 0 0 0-7.279-1.153"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M23.56 24.524H22.1v-1.446a.546.546 0 0 0-1.094 0v1.446h-1.459a.546.546 0 0 0-.547.543c0 .298.246.542.547.542h1.46v1.446a.547.547 0 0 0 1.094 0v-1.446h1.459c.3 0 .547-.244.547-.542a.546.546 0 0 0-.547-.543M44.961 41.133l-1.238-1.227 1.238-1.227a.648.648 0 0 0 0-.92.663.663 0 0 0-.929 0l-1.238 1.226-1.238-1.227a.663.663 0 0 0-.929 0 .649.649 0 0 0 0 .92l1.238 1.228-1.238 1.227a.649.649 0 0 0 0 .92.663.663 0 0 0 .929 0l1.238-1.227 1.238 1.227a.662.662 0 0 0 .929 0 .648.648 0 0 0 0-.92M24.312 19.617V17.68c0-.17.186-.276.334-.19l1.692.968 1.693.968a.22.22 0 0 1 0 .382l-1.693.969-1.692.968a.222.222 0 0 1-.334-.191v-1.937zM29.443 22.416c-.228-.915.362-1.846 1.317-2.08.956-.233 1.914.32 2.142 1.235.227.915-.362 1.846-1.318 2.08-.955.233-1.914-.32-2.141-1.235M23.167 51.896c-.227-.915.363-1.845 1.318-2.079.955-.233 1.914.32 2.142 1.235.227.915-.363 1.846-1.318 2.079-.955.233-1.914-.32-2.142-1.235M31.002 18.321c-.125-.506.201-1.021.73-1.15.529-.13 1.06.176 1.186.683.126.506-.201 1.022-.73 1.15-.529.13-1.06-.176-1.186-.683M70.943 54.26c-.227-.915.363-1.846 1.318-2.08.955-.233 1.914.32 2.142 1.235.227.915-.363 1.846-1.318 2.08-.955.232-1.914-.32-2.142-1.235M77.823 57.637c-.126-.506.201-1.022.73-1.151.529-.13 1.06.177 1.185.683.126.507-.2 1.022-.729 1.152-.53.129-1.06-.177-1.186-.684M68.992 59.054v-1.936c0-.17.186-.276.334-.192l1.692.969 1.693.968a.22.22 0 0 1 0 .382l-1.693.969-1.692.968a.222.222 0 0 1-.334-.191v-1.937z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M28.4 40.57c0-11.823 9.67-21.408 21.598-21.408 11.929 0 21.6 9.585 21.6 21.407 0 11.823-9.671 21.407-21.6 21.407-11.929 0-21.599-9.584-21.599-21.407z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25",
    d: "M73.688 38.241a21.475 21.475 0 0 1-.38 6.956"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M37.53 40.57c0-6.825 5.582-12.358 12.468-12.358s12.468 5.533 12.468 12.357c0 6.825-5.582 12.357-12.468 12.357S37.53 47.394 37.53 40.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M59.82 34.407a14.692 14.692 0 0 0-3.62-3.736l6.371-8.687a25.451 25.451 0 0 1 6.213 6.384l-8.963 6.039z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M59.82 34.407a14.692 14.692 0 0 0-3.62-3.736l6.371-8.687a25.451 25.451 0 0 1 6.213 6.384l-8.963 6.039z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M40.396 34.407a14.692 14.692 0 0 1 3.622-3.736l-6.372-8.687a25.451 25.451 0 0 0-6.213 6.384l8.963 6.039z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M40.396 34.407a14.692 14.692 0 0 1 3.622-3.736l-6.372-8.687a25.451 25.451 0 0 0-6.213 6.384l8.963 6.039z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M59.82 46.863a14.692 14.692 0 0 1-3.62 3.736l6.371 8.686a25.451 25.451 0 0 0 6.213-6.383l-8.963-6.04z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M59.82 46.863a14.692 14.692 0 0 1-3.62 3.736l6.371 8.686a25.451 25.451 0 0 0 6.213-6.383l-8.963-6.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M40.396 46.863a14.692 14.692 0 0 0 3.622 3.736l-6.372 8.686a25.451 25.451 0 0 1-6.213-6.383l8.963-6.04z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M40.396 46.863a14.692 14.692 0 0 0 3.622 3.736l-6.372 8.686a25.451 25.451 0 0 1-6.213-6.383l8.963-6.04z"
  })));
};
var ImgHome = function ImgHome(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M23.072 21.774c-.678 0-1.233.53-1.233 1.179v12.782c0 .648.555 1.179 1.233 1.179h.585l.011 1.43v18.912c0 1.628 1.381 2.947 3.084 2.947h3.355l-3.974-2.976V35.309l-1.595-.362-.073-13.173h-1.393z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M72.074 24.69h4.222c-.092-1.99-.065-4.955 1.255-6.184.882-.823 2.104-.889 3.218-.733.347.049.7.119 1.005.324.934.631 1.004 1.527.958 2.804.232-1.248 1.246-2.299 2.316-2.168 1.07.13 1.902 1.652 1.417 2.793.636-.782 1.846-.434 2.37.457.523.892.506 1.872.301 2.931h2.684M33.658 15.947h-4.222c.092-1.552.065-3.363-1.255-4.323-.882-.642-2.104-.693-3.218-.572-.347.038-.7.093-1.005.253-.934.493-1.004 1.695-.958 2.691-.232-.974-1.246-1.793-2.316-1.691-1.07.102-1.902 1.29-1.417 2.18-.636-.61-1.846-.34-2.37.357-.523.695-.506 1.46-.301 2.286H15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M18.041 39.603c-.191-.768.305-1.548 1.11-1.744.803-.196 1.61.268 1.802 1.035.191.768-.306 1.548-1.11 1.744-.803.196-1.61-.268-1.802-1.035M56.518 15.012c.205-.764 1.02-1.213 1.82-1.002.801.21 1.283 1 1.078 1.763-.206.764-1.022 1.213-1.822 1.003-.8-.21-1.282-1-1.076-1.764M80.58 36.67H78.6v-1.957a.74.74 0 0 0-.743-.733.74.74 0 0 0-.742.733v1.957h-1.981a.74.74 0 0 0-.743.733.74.74 0 0 0 .743.734h1.98v1.956a.74.74 0 0 0 .743.733.74.74 0 0 0 .743-.733v-1.956h1.98a.74.74 0 0 0 .743-.734.74.74 0 0 0-.743-.733M51.879 14.4l-1.344-1.454a.224.224 0 0 1 .12-.37l1.947-.422 1.947-.422a.225.225 0 0 1 .265.287l-.604 1.877-.604 1.876a.228.228 0 0 1-.384.083L51.879 14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M53.185 19.57h18.421c.679 0 1.234.551 1.234 1.225v13.288c0 .674-.555 1.226-1.234 1.226M25.624 35.308a1.233 1.233 0 0 1-1.234-1.225V20.795c0-.674.555-1.225 1.234-1.225h18.204"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25",
    d: "M48.183 62.818h14.662"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M70.045 59.519H29.304a3.074 3.074 0 0 1-3.084-3.064v-19.66l-.013-1.755 11.19-9.424 11.19-9.424 11.19 9.424 11.19 9.424-.014 1.755v6.689"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M52.096 56.414h-7.02a.711.711 0 0 1-.712-.71V43.659a.71.71 0 0 1 .713-.709h7.019a.71.71 0 0 1 .713.709v12.047c0 .391-.32.709-.713.709"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M52.096 56.414h-7.02a.711.711 0 0 1-.712-.71V43.659a.71.71 0 0 1 .713-.709h7.019a.71.71 0 0 1 .713.709v12.047c0 .391-.32.709-.713.709z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M64.928 41.35h-7.02a.71.71 0 0 1-.712-.709v-4.765a.71.71 0 0 1 .713-.709h7.02a.71.71 0 0 1 .712.709v4.765c0 .392-.319.71-.713.71zM39.47 41.35h-7.02a.71.71 0 0 1-.712-.709v-4.765a.71.71 0 0 1 .713-.709h7.02a.71.71 0 0 1 .712.709v4.765c0 .392-.319.71-.713.71zM45.618 26.986a3.037 3.037 0 0 1 3.047-3.027 3.036 3.036 0 0 1 3.046 3.027 3.036 3.036 0 0 1-3.046 3.026 3.036 3.036 0 0 1-3.047-3.026zM54.94 59.519H42.233a.711.711 0 0 1-.713-.71v-1.723a.71.71 0 0 1 .713-.708H54.94a.71.71 0 0 1 .713.708v1.724c0 .391-.32.709-.713.709zM75.641 59.538h-2.709a.711.711 0 0 1-.713-.709v-3.744c0-.392.32-.709.713-.709h2.71c.393 0 .713.317.713.709v3.744c0 .392-.32.709-.714.709z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M70.085 49.446c0-2.865 2.338-5.188 5.222-5.188 2.884 0 5.222 2.323 5.222 5.188 0 2.866-2.338 5.188-5.222 5.188-2.884 0-5.222-2.322-5.222-5.188"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M69.085 49.446c0-2.865 2.338-5.188 5.222-5.188 2.884 0 5.222 2.323 5.222 5.188 0 2.866-2.338 5.188-5.222 5.188-2.884 0-5.222-2.322-5.222-5.188z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M71.42 59.538h-2.71a.711.711 0 0 1-.713-.709v-4.186c0-.392.32-.709.713-.709h2.71c.393 0 .713.317.713.709v4.186c0 .392-.32.709-.714.709z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M64.863 49.446c0-2.865 2.337-5.188 5.222-5.188 2.884 0 5.222 2.323 5.222 5.188 0 2.866-2.338 5.188-5.222 5.188-2.885 0-5.222-2.322-5.222-5.188"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M64.863 49.446c0-2.865 2.337-5.188 5.222-5.188 2.884 0 5.222 2.323 5.222 5.188 0 2.866-2.338 5.188-5.222 5.188-2.885 0-5.222-2.322-5.222-5.188z"
  })));
};
var ImgHourglass = function ImgHourglass(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .22h2.966v2.876H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.131.109h2.966v2.877H.13z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M33.346 63.14h-1.47c-.244 0-.442-.234-.442-.518v-4.248c0-.285.198-.518.442-.518h1.47c.243 0 .442.233.442.518v4.248c0 .284-.199.517-.442.517"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M59.577 43.068a10.072 10.072 0 0 1 7.267-3.084c5.579 0 10.101 4.522 10.101 10.1 0 5.444-4.306 9.882-9.697 10.094M60.756 44.513a8.252 8.252 0 1 1 2.231 12.87"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M66.883 44.135v5.831h4.256"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M37.409 57.856h-1.532s-5.122-12.078 6.699-18.35v-.198c-9.387-5.537-8.09-13.851-7.158-17.04h-3.88c-.086 0-.157-.259-.157-.574v-4.711c0-.316.07-.575.157-.575h2.088l.075 4.271 3.674.535c.191 1.421-4.012 9.722 8.387 18.233 0 0-11.138 4.877-8.353 18.409"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M32.456 47.848c0 1.122-.941 2.032-2.102 2.032s-2.102-.91-2.102-2.032c0-1.122.94-2.031 2.102-2.031 1.16 0 2.102.909 2.102 2.031"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 50.476)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M.04 2.013C-.148 1.243.344.46 1.14.264c.796-.196 1.595.269 1.785 1.039.19.77-.302 1.552-1.099 1.749C1.03 3.248.23 2.783.041 2.013",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.812 64.907)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M.172 1.902C-.018 1.132.474.35 1.27.154c.797-.197 1.596.268 1.786 1.038.19.77-.302 1.552-1.099 1.749-.796.196-1.596-.269-1.785-1.039",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M34.714 39.253v-1.338c0-.118.127-.191.228-.132l1.16.669 1.16.67a.152.152 0 0 1 0 .264l-1.16.669-1.16.67a.152.152 0 0 1-.228-.133v-1.339z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M61.046 65.37H48.088M46.753 39.506c-12.775 5.556-8.89 18.35-8.89 18.35h25.065s3.885-12.794-8.89-18.35v-.198c12.775-5.556 8.89-18.35 8.89-18.35H37.863s-3.885 12.794 8.89 18.35v.198z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M47.573 51.018c-9.901 1.414-6.89 4.67-6.89 4.67h19.426s3.01-3.256-6.89-4.67h-5.646zM52.869 36.405c8.673-2.807 6.036-7.059 6.036-7.059H41.886s-2.637 4.252 6.037 7.06l2.52 3.771 2.426-3.772z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M66.656 20.643H34.135a.444.444 0 0 1-.442-.443v-3.633c0-.243.199-.443.442-.443h32.521c.243 0 .442.2.442.443V20.2a.443.443 0 0 1-.442.443z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M66.656 62.375H34.135a.444.444 0 0 1-.442-.443v-3.633c0-.244.199-.443.442-.443h32.521c.243 0 .442.2.442.443v3.633a.443.443 0 0 1-.442.443"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.25",
    d: "M66.656 62.375H34.135a.444.444 0 0 1-.442-.443v-3.633c0-.244.199-.443.442-.443h32.521c.243 0 .442.2.442.443v3.633a.443.443 0 0 1-.442.443z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M51.348 45.997a.877.877 0 1 1-1.753 0 .877.877 0 0 1 1.753 0"
  })));
};
var ImgIdea = function ImgIdea(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M42.02 47.285a14.521 14.521 0 0 1-5.588-6.533 14.227 14.227 0 0 1-1.151-5.623c0-7.964 6.535-14.42 14.597-14.42 4.296 0 8.159 1.833 10.83 4.752 0 0-12.18-6.894-17.997.333 0 0-8.978 9.187-.69 21.49"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M39.021 50.752c0 .704-.604 1.275-1.349 1.275s-1.349-.57-1.349-1.275c0-.704.604-1.275 1.35-1.275.744 0 1.348.57 1.348 1.275M37.103 23.296c0 .704-.604 1.275-1.35 1.275-.745 0-1.349-.57-1.349-1.275 0-.704.604-1.275 1.35-1.275.745 0 1.349.57 1.349 1.275M35.34 17.54c0 1.142-.98 2.068-2.187 2.068-1.208 0-2.188-.926-2.188-2.067 0-1.142.98-2.067 2.188-2.067 1.208 0 2.187.925 2.187 2.067M66.188 52.919h-1.123V51.82a.418.418 0 0 0-.421-.412.418.418 0 0 0-.421.412v1.098H63.1a.418.418 0 0 0-.421.412c0 .226.189.411.42.411h1.124v1.098c0 .227.19.412.42.412a.418.418 0 0 0 .422-.412v-1.098h1.123a.418.418 0 0 0 .421-.411.418.418 0 0 0-.421-.412M68.651 42.561v-1.956c0-.171.19-.279.342-.193l1.733.978 1.732.979a.22.22 0 0 1 0 .385l-1.732.979-1.733.978c-.152.086-.342-.021-.342-.193v-1.957zM65.559 48.279c0 .587-.503 1.063-1.124 1.063-.621 0-1.125-.476-1.125-1.063s.504-1.063 1.125-1.063c.62 0 1.124.476 1.124 1.063M34.516 54.958l-1.813 1.36-1.391-1.773a.872.872 0 0 0-1.202-.155.828.828 0 0 0-.158 1.175l1.391 1.773-1.813 1.36a.828.828 0 0 0-.158 1.175.872.872 0 0 0 1.201.155l1.813-1.36 1.39 1.773a.873.873 0 0 0 1.202.155.828.828 0 0 0 .159-1.175l-1.391-1.773 1.813-1.36a.828.828 0 0 0 .158-1.175.873.873 0 0 0-1.201-.155"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M57.872 48.451c4.56-2.562 7.63-7.372 7.63-12.883 0-8.2-6.8-14.85-15.186-14.85-8.387 0-15.186 6.65-15.186 14.85 0 5.21 2.743 9.793 6.895 12.443v4.634h15.884l-.037-4.194zM63.667 23.288c3.121 2.474 5.12 6.08 5.543 9.978"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M57.71 57.333H42.921c-1.153 0-2.097-.923-2.097-2.05v-.542c0-1.128.944-2.05 2.097-2.05h14.79c1.152 0 2.096.922 2.096 2.05v.542c0 1.127-.944 2.05-2.097 2.05"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M57.71 57.333H42.921c-1.153 0-2.097-.923-2.097-2.05v-.542c0-1.128.944-2.05 2.097-2.05h14.79c1.152 0 2.096.922 2.096 2.05v.542c0 1.127-.944 2.05-2.097 2.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M57.71 62.022H42.921c-1.153 0-2.097-.923-2.097-2.05v-.542c0-1.128.944-2.05 2.097-2.05h14.79c1.152 0 2.096.922 2.096 2.05v.542c0 1.127-.944 2.05-2.097 2.05"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M57.71 62.022H42.921c-1.153 0-2.097-.923-2.097-2.05v-.542c0-1.128.944-2.05 2.097-2.05h14.79c1.152 0 2.096.922 2.096 2.05v.542c0 1.127-.944 2.05-2.097 2.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M53.685 62.527c0 1.82-1.508 3.295-3.37 3.295-1.86 0-3.369-1.476-3.369-3.295"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M50.498 51.644v-8.5l4.106-8.268h-8.577l2.555 3.96"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M50.545 17.296V13M40.489 19.902l-2.196-3.72M33.113 27.075l-3.804-2.148M30.393 36.893H26M33.058 46.727l-3.804 2.147M67.867 46.82l3.804 2.147M70.587 37h4.393M60.586 19.955l2.196-3.72"
  })));
};
var ImgInfosessions = function ImgInfosessions(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M59.524 31.416a.314.314 0 0 1-.63 0v-.29a.314.314 0 0 1 .63 0v.29zm0 4.75a.314.314 0 0 1-.63 0v-3.655a.314.314 0 0 1 .63 0v3.656zm-.314-6.683a4.498 4.498 0 0 0-4.506 4.49c0 2.48 2.017 4.49 4.506 4.49a4.497 4.497 0 0 0 4.505-4.49c0-2.48-2.017-4.49-4.505-4.49zM63.424 40.217a.2.2 0 0 1-.401 0v-.186a.2.2 0 0 1 .4 0v.186zm0 3.03a.2.2 0 0 1-.401 0v-2.332a.2.2 0 0 1 .4 0v2.333zm-.2-4.264a2.87 2.87 0 0 0-2.876 2.865 2.87 2.87 0 0 0 2.875 2.865 2.87 2.87 0 0 0 2.875-2.865 2.87 2.87 0 0 0-2.875-2.865zM34.478 43.436a.358.358 0 0 1-.716 0v-.332a.358.358 0 0 1 .716 0v.332zm0 5.411a.357.357 0 1 1-.716 0v-4.165a.358.358 0 0 1 .716 0v4.165zm-.358-7.614c-2.835 0-5.132 2.29-5.132 5.115s2.297 5.115 5.132 5.115c2.835 0 5.132-2.29 5.132-5.115s-2.297-5.115-5.132-5.115zM43.562 57.885h-1.135a.76.76 0 0 1-.76-.758v-1.905c0-.168.136-.304.305-.304h.84c.42 0 .761.339.761.757v2.198a.012.012 0 0 1-.011.012M23.73 27.101c-.818 0-1.48.661-1.48 1.476v25.387c0 .815.662 1.475 1.48 1.475l4.41-.08-3.512-1.25-.313-4 .066-23.117-.651.11z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M27.834 22.965c.046-.248.162-.506.348-.776.288-.415.62-.66 1-.736.377-.076.772.028 1.184.31.397.273.63.603.698.99l-3.23.212zm-.984-2.4l-.251-.626c-.217-.542-.29-1.06-.218-1.552.072-.493.326-1.088.762-1.785.425-.66.68-1.16.763-1.5.084-.341.06-.676-.071-1.003-.147-.367-.395-.592-.743-.676-.35-.084-.767-.029-1.254.165-.85.338-1.707 1-2.573 1.985l-1.668-1.486a8.711 8.711 0 0 1 3.594-2.656c1.167-.464 2.206-.553 3.118-.268.911.285 1.554.893 1.927 1.824.248.62.321 1.213.219 1.778-.102.564-.437 1.286-1.004 2.165-.383.617-.605 1.059-.665 1.325-.062.266-.024.569.111.907l.204.508-2.251.895zM78.852 27.428a.45.45 0 0 1-.903 0v-.418a.45.45 0 0 1 .903 0v.418zm0 6.82a.45.45 0 0 1-.903 0v-5.25a.45.45 0 0 1 .903 0v5.25zm-4.29 2.039c1.073.79 1.9 1.257 3.336 1.257l.305-1.389 2.857.761c2.042-1.083 3.808-3.351 3.808-5.818 0-3.56-2.896-6.446-6.468-6.446a6.455 6.455 0 0 0-4.243 1.581l.405 10.054z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M74.803 45.418c.245.064.62.199.876.404.394.316.615.665.664 1.047.047.381-.085.766-.399 1.155a1.786 1.786 0 0 1-1.166.62l.025-3.226zm.586-1.458l.403-.542c.349-.469.752-.802 1.211-1 .46-.198 1.1-.296 1.925-.291.787.014 1.347-.034 1.682-.142.334-.108.607-.304.818-.587.236-.317.298-.646.187-.985-.112-.34-.378-.665-.8-.977-.734-.543-1.75-.922-3.046-1.139l.392-2.195a8.729 8.729 0 0 1 4.156 1.653c1.01.745 1.631 1.579 1.867 2.502.235.923.054 1.788-.546 2.593-.399.537-.866.91-1.402 1.12-.535.209-1.327.305-2.376.286-.728 0-1.222.043-1.481.131-.26.089-.498.279-.716.572l-.327.44-1.947-1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M21.557 19.941h-1.458v-1.453a.548.548 0 0 0-1.094 0v1.453h-1.458a.547.547 0 0 0-.547.545c0 .3.246.545.547.545h1.458v1.454a.548.548 0 0 0 1.094 0V21.03h1.458c.3 0 .547-.245.547-.545 0-.3-.247-.545-.547-.545M60.472 62.325c-.227-.92.362-1.855 1.317-2.09.955-.234 1.913.321 2.14 1.24.228.92-.362 1.856-1.317 2.09-.954.235-1.913-.32-2.14-1.24M58.746 58.642c-.126-.51.2-1.027.729-1.157.529-.13 1.059.178 1.185.687.126.509-.2 1.027-.73 1.157-.528.13-1.058-.178-1.184-.687M58.746 66.137c-.126-.51.2-1.027.729-1.157.529-.13 1.059.178 1.185.687.126.509-.2 1.027-.73 1.157-.528.13-1.058-.178-1.184-.687M78.589 47.843c-.126-.509.2-1.027.729-1.156.528-.13 1.059.177 1.185.686.126.51-.201 1.027-.73 1.157-.528.13-1.058-.178-1.184-.687M36.295 59.067c-.227-.92.363-1.855 1.317-2.09.955-.234 1.913.321 2.14 1.24.228.92-.362 1.856-1.316 2.09-.955.234-1.913-.32-2.14-1.24M56.738 60.635h-1.302v-1.297a.489.489 0 0 0-.976 0v1.297h-1.302a.489.489 0 0 0-.489.487c0 .267.22.486.489.486h1.302v1.298a.489.489 0 0 0 .976 0v-1.298h1.302a.489.489 0 0 0 .488-.486.489.489 0 0 0-.488-.487M86.097 36.48v-1.947c0-.17.185-.277.333-.192l1.691.973 1.692.973a.221.221 0 0 1 0 .384l-1.692.973-1.69.974a.223.223 0 0 1-.334-.192v-1.947z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M72.95 54.72H25.902c-.84 0-1.52-.679-1.52-1.516V26.992c0-.837.68-1.516 1.52-1.516H72.95c.84 0 1.52.68 1.52 1.516v26.212c0 .837-.68 1.516-1.52 1.516zM74.732 25.474H24.12a.455.455 0 0 1-.455-.454v-1.33c0-.252.204-.455.455-.455h50.612c.251 0 .455.203.455.454v1.331c0 .251-.204.454-.455.454zM55.332 57.26H43.52a.222.222 0 0 1-.222-.222v-1.796c0-.122.1-.221.222-.221h11.813c.123 0 .223.099.223.221v1.796c0 .123-.1.222-.223.222z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M44.757 68.314c-.11-.446.176-.9.64-1.014.463-.114.928.156 1.038.602.11.447-.176.9-.639 1.014-.464.114-.929-.155-1.039-.602M33.316 57.953h-1.142v-1.138a.429.429 0 0 0-.856 0v1.138h-1.142a.429.429 0 0 0-.428.427c0 .234.193.426.428.426h1.142v1.138a.429.429 0 0 0 .856 0v-1.138h1.142a.429.429 0 0 0 .428-.426.429.429 0 0 0-.428-.427"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M40.442 40.098c0-4.945 4.022-8.954 8.984-8.954s8.984 4.01 8.984 8.954c0 4.945-4.022 8.954-8.984 8.954s-8.984-4.009-8.984-8.954"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M40.442 40.098c0-4.945 4.022-8.954 8.984-8.954s8.984 4.01 8.984 8.954c0 4.945-4.022 8.954-8.984 8.954s-8.984-4.009-8.984-8.954z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M49.74 44.473v-7.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25",
    d: "M49.74 44.473v-7.29"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M49.74 35v-.581"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25",
    d: "M49.74 35v-.581"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M49.426 57.338v7.633M49.686 62.488l3.752 2.498M49.283 62.488l-3.752 2.498"
  })));
};
var ImgInterface = function ImgInterface(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.779.229a.57.57 0 0 0-.574.567v2.269a.57.57 0 0 0 .574.567h8.038a.57.57 0 0 0 .574-.567V.796a.57.57 0 0 0-.574-.567H.779z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.643.229a.57.57 0 0 0-.575.567v7.09a.57.57 0 0 0 .575.567h25.262a.57.57 0 0 0 .574-.567V.796a.57.57 0 0 0-.574-.567H.643z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M.779.076a.57.57 0 0 0-.574.568v2.268a.57.57 0 0 0 .574.567h5.454a.57.57 0 0 0 .575-.567V.644a.57.57 0 0 0-.575-.568H.78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M.779.173A.57.57 0 0 0 .205.74v2.269a.57.57 0 0 0 .574.567h7.177a.57.57 0 0 0 .574-.567V.739a.57.57 0 0 0-.574-.566H.779z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M.779.09C.462.09.205.272.205.497V5.18H39.82V.497c0-.225-.257-.407-.574-.407H.78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M.643.173A.57.57 0 0 0 .068.74v2.269a.57.57 0 0 0 .575.567h25.262a.57.57 0 0 0 .574-.567V.739a.57.57 0 0 0-.574-.566H.643z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M77.242 28.494h1.35c-.06-1.313-.043-3.27.828-4.08.582-.543 1.388-.587 2.123-.484.229.032.462.078.663.213.616.417.662 1.008.632 1.85.153-.823.822-1.516 1.527-1.43.706.086 1.255 1.09.935 1.843.42-.516 1.218-.286 1.564.302.345.588.334 1.234.198 1.933h1.77M29.361 20.317h-2.785c.06-1.313.043-2.844-.827-3.655-.583-.543-1.389-.587-2.123-.484-.23.032-.463.078-.663.214-.616.416-.663 1.433-.633 2.275-.153-.823-.822-1.516-1.527-1.43-.705.086-1.255 1.09-.935 1.843-.42-.516-1.218-.287-1.563.302-.346.588-.334 1.234-.199 1.933h-1.053"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M77.024 22.168c-.127-.507.2-1.022.731-1.151.53-.129 1.063.177 1.189.683.126.506-.201 1.022-.732 1.15-.53.13-1.062-.176-1.188-.682M73.005 19.899c-.127-.507.2-1.022.731-1.15.53-.13 1.063.176 1.189.682.126.507-.201 1.022-.731 1.151-.53.13-1.063-.177-1.19-.683M87.174 48.45h-1.306v-1.29a.489.489 0 0 0-.49-.485c-.27 0-.49.218-.49.484v1.291h-1.306c-.27 0-.49.218-.49.484s.22.484.49.484h1.306v1.29c0 .267.22.485.49.485s.49-.218.49-.484v-1.29h1.306c.27 0 .49-.219.49-.485a.488.488 0 0 0-.49-.484M16.012 26.613v-1.936c0-.17.185-.275.334-.19l1.697.967 1.698.968a.22.22 0 0 1 0 .382l-1.698.968-1.697.968a.223.223 0 0 1-.334-.19v-1.937zM80.516 52.751v-1.3a.15.15 0 0 1 .225-.127l1.139.65 1.139.65c.1.056.1.198 0 .255l-1.14.65-1.138.65a.15.15 0 0 1-.225-.128v-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M24.555 25.92h.192c-1.124 0-2.035.9-2.035 2.01v28.168c0 .899-1.411.1-.587.356l-2.051.142c-1.124 0-1.46 1.61-1.46 2.719 0 2.22 2.539 3.452 4.786 3.452h1.497l-.342-36.846z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M79.699 44.066V32.549M74.622 57.185H26.52c-.985 0-1.784-.79-1.784-1.763V26.193c0-.973.799-1.762 1.784-1.762h48.102c.985 0 1.784.789 1.784 1.762v29.23c0 .973-.799 1.762-1.784 1.762z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M77.511 62.554H23.127c-1.692 0-3.064-1.356-3.064-3.027v-.673c0-.973.799-1.762 1.784-1.762h57.951c.708 0 1.281.566 1.281 1.265v.672c0 1.947-1.597 3.525-3.568 3.525"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.25",
    d: "M77.511 62.554H23.127c-1.692 0-3.064-1.356-3.064-3.027v-.673c0-.973.799-1.762 1.784-1.762h57.951c.708 0 1.281.566 1.281 1.265v.672c0 1.947-1.597 3.525-3.568 3.525z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E3B45",
    d: "M49.824 28.106c0-.574.471-1.04 1.053-1.04.581 0 1.052.466 1.052 1.04 0 .575-.47 1.04-1.052 1.04a1.046 1.046 0 0 1-1.053-1.04"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M31.882 32.47h8.038a.57.57 0 0 1 .574.568v2.269a.57.57 0 0 1-.574.567h-8.038a.57.57 0 0 1-.574-.567v-2.269a.57.57 0 0 1 .574-.567"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.103 32.242)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M-189.548 123.593h388.405V-105.27h-388.405z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M-1.23 5.05h12.056v-6.24H-1.23z",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M45.088 32.47H70.35a.57.57 0 0 1 .574.568v7.09a.57.57 0 0 1-.574.567H45.088a.57.57 0 0 1-.575-.567v-7.09a.57.57 0 0 1 .575-.567"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.445 32.242)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M-202.89 123.593h388.406V-105.27H-202.89z",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M-1.367 9.871h29.281v-11.06h-29.28z",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M31.882 37.292h5.455a.57.57 0 0 1 .574.567v2.269a.57.57 0 0 1-.574.567h-5.455a.57.57 0 0 1-.574-.567v-2.269a.57.57 0 0 1 .574-.567"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.103 37.216)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M-189.548 118.619h388.405v-228.861h-388.405z",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M-1.23 4.897h9.472v-6.239H-1.23z",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M31.882 42.113h7.177a.57.57 0 0 1 .574.567v2.269a.57.57 0 0 1-.574.567h-7.177a.57.57 0 0 1-.574-.567V42.68a.57.57 0 0 1 .574-.567"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.103 41.94)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M-189.548 113.894h388.405v-228.861h-388.405z",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M-1.23 4.994H9.964v-6.24H-1.231z",
    mask: "url(#h)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.103 47.411)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M-189.548 108.423h388.405v-228.86h-388.405z",
    mask: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M-1.23 8.598h42.486v-9.926H-1.231z",
    mask: "url(#j)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M45.088 42.113H70.35a.57.57 0 0 1 .574.567v2.269a.57.57 0 0 1-.574.567H45.088a.57.57 0 0 1-.575-.567V42.68a.57.57 0 0 1 .575-.567"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.445 41.94)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M-202.89 113.894h388.406v-228.861H-202.89z",
    mask: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M-1.367 4.994h29.281v-6.24h-29.28z",
    mask: "url(#l)"
  }))));
};
var ImgInvest = function ImgInvest(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M1.321.443v-.24.24zm17.044 16.044s-1.54 1.796-6.09.532L1.321 13.024.096 15.422l1.225-.004c1.4.31 3.495.954 5.683 1.869 2.717 1.136 5.641 2.363 8.54 2.363 1.373 0 2.373-.606 3.238-1.139 0 0 12.791-7.654 12.857-7.712.659-.603 1.413-.613 1.413-1.858 0-.562-.123-1.1-.346-1.59l-14.341 9.136z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M3.184.619c-.157.055-.315.115-.474.179L1.527.819l8.025 1.36a92.663 92.663 0 0 1-.944-.727C8.062 1.027 6.887.228 5.234.228c-.705 0-1.374.153-2.05.39zM.25.842L1.527.82.25.603v.24zM13.501 5.14c1.143.728 1.73 1.852 2.037 2.904.117.402.169.795.228 1.183 0 0 9.678-3.554 9.842-3.61.504-.173 1.18-.377 1.996-.377L9.552 2.18c1.663 1.268 3.95 2.96 3.95 2.96zm14.103.1L.25 15.818c1.4.31 3.496.954 5.683 1.868 2.717 1.136 5.641 2.363 8.541 2.363 1.372 0 2.372-.606 3.237-1.139 0 0 12.792-7.654 12.857-7.712.659-.603 1.413-.613 1.413-1.858 0-2.248-1.976-4.1-4.377-4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M.245.227H5.48v5.027H.245z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".54",
    d: "M65.443 48.483c0-2.565 2.093-4.644 4.673-4.644s4.673 2.079 4.673 4.644c0 2.566-2.092 4.645-4.673 4.645-2.58 0-4.673-2.08-4.673-4.645z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M70.608 49.86h-.772V48.73h-1.145v-.78h1.145v-1.138h.772v1.139h1.15v.779h-1.15zM34.422 44.474v-.24.24zm0 14.975c1.4.31 3.495.954 5.683 1.868 2.717 1.136 5.64 2.363 8.54 2.363 1.373 0 2.373-.606 3.238-1.139 0 0 12.791-7.654 12.857-7.712.659-.603 1.413-.613 1.413-1.858 0-.562-.123-1.099-.346-1.589l-14.341 9.135s-1.54 1.796-6.09.532l-10.954-3.995-1.225 2.399 1.225-.004z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.101 44.03)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M-21.816 32.193h68.717v-46.631h-68.717z",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M24.31 59.99V47.668"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.172 40.838)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.35",
    d: "M-22.886 32.592H45.83v-46.631h-68.716z",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M61.776 46.077c-.817 0-1.492.204-1.996.377-.164.056-9.842 3.61-9.842 3.61-.06-.388-.112-.78-.229-1.182-.305-1.053-.893-2.176-2.036-2.904 0 0-3.356-2.484-4.893-3.688-.546-.426-1.722-1.224-3.375-1.224-.704 0-1.373.152-2.05.39-.156.056-.314.115-.473.18l-2.46.044v-.24m0 15.215c1.4.31 3.495.954 5.683 1.868 2.717 1.136 5.641 2.364 8.54 2.364 1.373 0 2.373-.607 3.238-1.14 0 0 12.791-7.654 12.857-7.712.659-.602 1.413-.613 1.413-1.857 0-2.249-1.977-4.1-4.377-4.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.35",
    d: "M49.56 50.005L39.142 47.48"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M57.182 47.44c1.938-2.074 3.125-5.251 3.125-8.323 0-6.401-5.153-11.59-11.51-11.59s-11.51 5.189-11.51 11.59c0 .442.024.879.072 1.308"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.35",
    d: "M68.588 35.62a20.637 20.637 0 0 1 .021 1.33"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeDasharray: "2.031479948587418,3.656609962871073",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M68.232 40.531a20.097 20.097 0 0 1-1.083 3.644"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.35",
    d: "M66.4 45.813c-.202.396-.417.785-.644 1.165M37.537 19.24c.38-.23.768-.448 1.164-.654"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeDasharray: "2.980799953651427,5.365169764487746",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M43.683 16.774c1.441-.32 2.94-.49 4.479-.49a20.455 20.455 0 0 1 15.54 7.113"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.35",
    d: "M65.296 25.511c.244.371.476.75.695 1.137M27.712 37.654c0-.447.012-.89.036-1.33"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeDasharray: "2.147579899163247,3.865319721822743",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M28.256 32.551c.29-1.33.689-2.614 1.188-3.84"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.35",
    d: "M30.235 26.979c.202-.397.415-.787.638-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M28.922 23.038c0-2.565 2.093-4.645 4.673-4.645 2.581 0 4.673 2.08 4.673 4.645 0 2.565-2.092 4.644-4.673 4.644-2.58 0-4.673-2.08-4.673-4.644"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M28.922 23.038c0-2.565 2.093-4.645 4.673-4.645 2.581 0 4.673 2.08 4.673 4.645 0 2.565-2.092 4.644-4.673 4.644-2.58 0-4.673-2.08-4.673-4.644z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M63.168 32.587c0-2.566 2.092-4.645 4.673-4.645 2.58 0 4.673 2.08 4.673 4.645 0 2.565-2.092 4.644-4.673 4.644-2.58 0-4.673-2.08-4.673-4.644"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M63.168 32.587c0-2.566 2.092-4.645 4.673-4.645 2.58 0 4.673 2.08 4.673 4.645 0 2.565-2.092 4.644-4.673 4.644-2.58 0-4.673-2.08-4.673-4.644z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M48.241 39.03c.128 1.3.548 1.951 1.259 1.951.266 0 .51-.063.73-.19.22-.127.433-.424.637-.892.132-.304.244-.494.34-.568a.487.487 0 0 1 .306-.111c.218 0 .389.062.511.187s.183.3.183.525c0 .533-.262 1.025-.787 1.476-.525.451-1.162.677-1.91.677-.7 0-1.31-.253-1.832-.759-.521-.505-.833-1.271-.935-2.297h-.695c-.066 0-.099-.047-.099-.141 0-.09.035-.205.104-.343.07-.137.128-.206.176-.206h.47v-.196c0-.16.007-.39.022-.69h-.673c-.066 0-.099-.046-.099-.136 0-.095.035-.21.104-.348.07-.138.128-.207.176-.207h.546c.238-1.889 1.135-2.833 2.692-2.833.685 0 1.276.176 1.772.528.496.351.744.788.744 1.31a.632.632 0 0 1-.175.451.566.566 0 0 1-.427.185c-.185 0-.321-.047-.407-.141a1.583 1.583 0 0 1-.254-.435c-.106-.258-.232-.454-.378-.59-.146-.136-.394-.204-.744-.204-.401 0-.71.14-.927.419-.217.279-.357.716-.419 1.31h1.762c.073 0 .11.047.11.141a.791.791 0 0 1-.102.35c-.067.133-.127.2-.178.2H48.21l-.011.532c0 .163.003.281.01.354h1.806c.073 0 .11.045.11.136a.799.799 0 0 1-.102.356c-.067.132-.127.198-.178.198h-1.603zM33.802 24.652h-.771V23.52h-1.146v-.779h1.146v-1.138h.771v1.138h1.151v.779h-1.15zM68.332 33.964h-.771v-1.132h-1.145v-.779h1.145v-1.138h.771v1.138h1.152v.779h-1.152z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M31.837 59.408H29.09a1.932 1.932 0 0 1-1.933-1.92V41.02c0-1.056.87-1.92 1.933-1.92h2.747c1.063 0 1.932.864 1.932 1.92v16.468c0 1.056-.87 1.92-1.932 1.92"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M31.837 59.408H29.09a1.932 1.932 0 0 1-1.933-1.92V41.02c0-1.056.87-1.92 1.933-1.92h2.747c1.063 0 1.932.864 1.932 1.92v16.468c0 1.056-.87 1.92-1.932 1.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M27.673 26.373c0 .856-.723 1.55-1.614 1.55-.891 0-1.614-.694-1.614-1.55 0-.856.723-1.55 1.614-1.55.891 0 1.614.694 1.614 1.55"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.833 11.04)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M5.479 2.74c0 1.389-1.172 2.514-2.617 2.514S.245 4.13.245 2.74C.245 1.352 1.417.227 2.862.227S5.48 1.352 5.48 2.74",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M70.837 56.748h-1.344v-1.336a.504.504 0 0 0-1.007 0v1.336h-1.344a.504.504 0 0 0-.503.5c0 .276.226.501.503.501h1.344v1.335a.504.504 0 0 0 1.007 0V57.75h1.344a.504.504 0 0 0 .504-.5.504.504 0 0 0-.504-.501M31.578 65.679h-1.344v-1.335a.504.504 0 0 0-1.007 0v1.335h-1.344a.504.504 0 0 0-.504.5c0 .276.227.502.504.502h1.344v1.335a.504.504 0 0 0 1.007 0V66.68h1.344a.504.504 0 0 0 .503-.501c0-.276-.226-.501-.503-.501M61.828 61.048V58.67c0-.209.227-.339.408-.235l2.073 1.19 2.073 1.19a.27.27 0 0 1 0 .469l-2.073 1.19-2.073 1.189a.272.272 0 0 1-.408-.235v-2.379zM35.211 62.956c0 .713-.602 1.292-1.345 1.292s-1.345-.579-1.345-1.292c0-.714.602-1.292 1.345-1.292s1.345.578 1.345 1.292M75.33 19.443l-2.168 1.654-1.664-2.156a1.033 1.033 0 0 0-1.438-.189 1.018 1.018 0 0 0-.189 1.43l1.664 2.155-2.17 1.654a1.018 1.018 0 0 0-.189 1.429c.343.444.99.53 1.438.188l2.169-1.654 1.664 2.156c.343.445.99.53 1.437.189.448-.342.533-.985.19-1.43l-1.664-2.155 2.169-1.654c.447-.341.533-.984.19-1.429a1.032 1.032 0 0 0-1.438-.188"
  }))));
};
var ImgLabtop = function ImgLabtop(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M76.802 20.157c-.126-.514.2-1.038.73-1.17a.969.969 0 0 1 1.184.695.977.977 0 0 1-.729 1.17.969.969 0 0 1-1.185-.695M72.797 17.851a.977.977 0 0 1 .73-1.17.97.97 0 0 1 1.184.695.977.977 0 0 1-.73 1.17.969.969 0 0 1-1.184-.695M70.11 17.804H68.81v-1.312c0-.27-.22-.492-.488-.492a.492.492 0 0 0-.489.492v1.312H66.53a.492.492 0 0 0 0 .984h1.302v1.311c0 .27.22.492.489.492a.492.492 0 0 0 .488-.492v-1.311h1.302a.492.492 0 0 0 0-.984M16 24.675v-1.967c0-.173.185-.28.333-.194l1.692.984 1.691.983a.225.225 0 0 1 0 .389l-1.691.983-1.692.984a.222.222 0 0 1-.333-.194v-1.968z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M25.01 23.972h-.807c-1.12 0-2.027.927-2.027 2.072v29.035c0 .927-1.407.104-.585.368l-2.045.146c-1.12 0-1.455 1.659-1.455 2.803 0 2.289 2.53 3.559 4.77 3.559h2.489l-.34-37.983z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M79.723 41.53v-8.706M74.434 55.747H26.497a1.785 1.785 0 0 1-1.778-1.79V24.248c0-.99.796-1.791 1.778-1.791h47.937c.982 0 1.778.801 1.778 1.79v29.708c0 .99-.796 1.791-1.778 1.791z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M77.288 61.204H23.091c-1.686 0-3.053-1.377-3.053-3.077v-.683c0-.99.796-1.791 1.777-1.791h57.753a1.28 1.28 0 0 1 1.276 1.285v.684c0 1.978-1.592 3.582-3.556 3.582"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M77.288 61.204H23.091c-1.686 0-3.053-1.377-3.053-3.077v-.683c0-.99.796-1.791 1.777-1.791h57.753a1.28 1.28 0 0 1 1.276 1.285v.684c0 1.978-1.592 3.582-3.556 3.582z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E3B45",
    d: "M49.416 26.193c0-.584.47-1.057 1.05-1.057.579 0 1.048.473 1.048 1.057s-.47 1.057-1.048 1.057c-.58 0-1.05-.473-1.05-1.057"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M17.024 30.129c-.182-.732.29-1.477 1.055-1.664.764-.187 1.531.255 1.713.988.182.732-.29 1.477-1.054 1.664-.764.187-1.532-.256-1.714-.988M18.04 52.707c-.183-.733.29-1.478 1.053-1.664.765-.187 1.532.255 1.714.988.182.732-.29 1.477-1.054 1.664-.765.186-1.532-.256-1.714-.988"
  })));
};
var ImgLetterBox = function ImgLetterBox(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .096h10.142v29.43H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.039.089h1.81v1.735H.039z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M48.396 23.883l-1.994-4.065M44.79 24.11L37.39 22a.47.47 0 0 1-.32-.578L39 14.516M51.056 17.952l-1.667 5.959"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M51 17.609a.427.427 0 0 1-.161.578l-6.623 2.171a.419.419 0 0 1-.572-.163L39.08 14.77a.427.427 0 0 1 .162-.578L51 17.609zM42.098 18.591l-4.82 3.116"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 24.16)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M10.142.096C4.54.096 0 4.716 0 10.413v17.66c0 .803.64 1.454 1.43 1.454h4.088l-2.75-1.195v-19.2l.833-3.773 2.084-2.713L8.06.951l2.082-.855",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M55.165 53.826V66.02c0 .368-.262.667-.587.667h-5.69c-.324 0-.587-.3-.587-.667V53.826"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M55.165 53.826V66.02c0 .368-.262.667-.587.667h-5.69c-.324 0-.587-.3-.587-.667V53.826M69.454 53.085H28.013c-.79 0-1.43-.646-1.43-1.443V34.116c0-5.654 4.54-10.238 10.142-10.238h27.13c3.882 0 7.028 3.177 7.028 7.095v20.67c0 .796-.64 1.442-1.429 1.442z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.55",
    d: "M52.685 55.675h2.375M52.11 58.23h2.95M51.827 60.848h3.233M52.685 63.404h2.375"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M54.06 33.055c0-1.533 1.231-2.776 2.75-2.776 1.518 0 2.75 1.243 2.75 2.776 0 1.533-1.232 2.776-2.75 2.776-1.519 0-2.75-1.243-2.75-2.776zM56.81 18.064v11.962"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M57.435 20.1l11.333.167-4.5-2.355 2.833-3.365-10.333-.168v6.225"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M57.435 20.1l11.333.167-4.5-2.355 2.833-3.365-10.333-.168v6.225M44.768 52.613v-20.29c0-4.64-3.75-8.436-8.333-8.436"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M39.31 37.091h-5.667v15.902h6.167V37.091"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.55",
    d: "M39.31 37.091h-5.667v15.902h6.167V37.091"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M44.185 34.68h-5.667v18.24h6.167V34.68"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M44.185 34.68h-5.667v18.24h6.167V34.68"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M38.872 35.038l5.625 6.609M33.872 37.266l4.625 5.688"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M32.192 20.52H30.85v-1.326a.502.502 0 0 0-.503-.497.502.502 0 0 0-.503.497v1.325h-1.34a.501.501 0 0 0-.504.497c0 .274.226.497.503.497h1.341v1.326c0 .273.227.497.503.497a.502.502 0 0 0 .503-.497v-1.326h1.342a.502.502 0 0 0 .503-.497.502.502 0 0 0-.503-.497M74.148 51.66c-.209-.838.334-1.691 1.212-1.905.878-.214 1.76.293 1.969 1.131.209.839-.333 1.692-1.212 1.906-.878.214-1.76-.293-1.969-1.131M72.56 48.302c-.115-.464.185-.937.671-1.055.486-.118.974.162 1.09.626.116.464-.184.937-.67 1.055-.487.119-.975-.162-1.09-.626M72.56 55.137c-.115-.464.185-.936.671-1.055.486-.118.974.162 1.09.627.116.464-.184.936-.67 1.055-.487.118-.975-.163-1.09-.627M40.045 56.955c-.21-.84.333-1.692 1.211-1.906.879-.214 1.76.293 1.97 1.131.208.839-.334 1.692-1.212 1.906-.879.214-1.76-.293-1.97-1.131"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26 23)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M.063 1.17C-.052.707.248.235.734.117c.486-.119.974.162 1.09.626.116.464-.184.937-.67 1.055-.487.118-.975-.162-1.09-.626",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M73.815 60.38h-1.197v-1.183a.448.448 0 0 0-.45-.444c-.246 0-.449.2-.449.444v1.183h-1.197c-.247 0-.45.2-.45.443 0 .245.203.444.45.444h1.197v1.184c0 .244.203.443.45.443s.449-.2.449-.443v-1.184h1.197c.247 0 .45-.2.45-.444a.448.448 0 0 0-.45-.443M20 25.978v-1.775c0-.156.17-.254.307-.176l1.556.888 1.556.887a.201.201 0 0 1 0 .35l-1.556.888-1.556.888a.204.204 0 0 1-.307-.175v-1.775z"
  })));
};
var ImgLimit = function ImgLimit(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .172h6.508v6.597H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M80.49 33.383c1.619.375 2.666.972 2.666 1.645 0 .989-2.256 1.814-5.263 2.01M83.156 37.995c0 1.134-2.974 2.054-6.642 2.054-.255 0-.316-.004-.563-.013M83.156 41.19c0 1.134-2.974 2.054-6.642 2.054-.833 0-1.63-.048-2.365-.134M83.156 44.27c0 1.135-2.974 2.055-6.642 2.055-1.937 0-3.68-.257-4.895-.666M83.156 35.142v9.328"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M67.297 26.226l6.147-9.1a.753.753 0 0 1 1.052-.2l10.956 7.605a.776.776 0 0 1 .197 1.067L72.328 45.316a.755.755 0 0 1-1.052.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M67.62 26.41a7.023 7.023 0 0 1 9.271-1.118c3.23 2.243 4.056 6.715 1.844 9.99a7.051 7.051 0 0 1-6.61 3.085"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M83.213 25.584a.703.703 0 0 1 .179.97.683.683 0 0 1-.957.181.703.703 0 0 1-.179-.97.682.682 0 0 1 .957-.18M72.672 32.368c.63.352 1.056.366 1.276.04a.803.803 0 0 0 .14-.394c.01-.141-.06-.332-.209-.573-.097-.156-.149-.268-.153-.335a.272.272 0 0 1 .044-.175.372.372 0 0 1 .243-.175.393.393 0 0 1 .295.081c.243.169.385.444.428.827.042.382-.052.745-.283 1.087a1.39 1.39 0 0 1-.911.6c-.392.08-.836-.02-1.334-.296l-.215.318c-.02.03-.052.03-.094 0a.45.45 0 0 1-.124-.156c-.041-.075-.054-.123-.04-.145l.146-.215-.089-.062a8.452 8.452 0 0 1-.307-.228l-.208.308c-.02.03-.051.031-.092.002a.456.456 0 0 1-.127-.157c-.04-.075-.054-.123-.039-.145l.17-.25c-.786-.705-.937-1.413-.456-2.126.212-.314.475-.53.788-.645.313-.116.588-.092.826.073.08.056.13.13.15.222a.316.316 0 0 1-.047.253c-.058.086-.122.133-.19.143a.87.87 0 0 1-.277-.02.89.89 0 0 0-.385-.014c-.107.024-.214.115-.323.276-.124.184-.156.369-.096.557.06.187.215.389.466.604l.545-.806c.022-.033.055-.035.098-.006a.441.441 0 0 1 .128.157c.039.073.05.121.035.144l-.506.75.239.172c.074.052.129.087.164.107l.558-.827c.023-.033.055-.036.096-.007a.44.44 0 0 1 .13.159c.04.072.051.12.036.144l-.496.733z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M72.457 50.885c-.18-.74.286-1.492 1.041-1.68.755-.189 1.513.258 1.692.997.18.74-.286 1.492-1.04 1.68-.756.19-1.513-.257-1.693-.997M19.983 35.042c-.18-.74.287-1.492 1.042-1.68.755-.19 1.512.258 1.692.997.18.74-.286 1.492-1.042 1.68-.754.189-1.512-.258-1.692-.997"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 38.195)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M5.811 2.763h-1.86V.88a.704.704 0 0 0-.697-.707.704.704 0 0 0-.697.707v1.884H.697A.704.704 0 0 0 0 3.47c0 .389.314.707.697.707h1.86v1.885c0 .389.314.707.697.707a.704.704 0 0 0 .697-.707V4.177h1.86a.704.704 0 0 0 .697-.707.704.704 0 0 0-.697-.707",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M76.63 48.871c-.18-.739.286-1.491 1.041-1.68.755-.188 1.512.258 1.692.998.18.74-.286 1.492-1.041 1.68-.755.189-1.513-.258-1.692-.998M64.009 18.096l-.927-2.667a.32.32 0 0 1 .358-.423l2.741.52 2.742.52c.24.045.342.337.183.525l-1.815 2.147-1.815 2.147a.316.316 0 0 1-.541-.102l-.926-2.667z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M45.484 18.691c-12.08-1.272-21.99 9.782-21.99 21.847 0 8.93 7.253 18.77 13.12 19.998 0 0-27.121-27.95 8.87-41.845"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M40.366 61.93c-7.895-3.532-13.405-11.537-13.405-20.846 0-12.578 10.06-22.774 22.468-22.774 12.409 0 22.468 10.196 22.468 22.774 0 9.386-5.602 17.446-13.601 20.932M37.192 64.836a22.614 22.614 0 0 1-9.478-7.813"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M45.782 41.889c0-2.042 1.633-3.697 3.647-3.697s3.647 1.655 3.647 3.697c0 2.041-1.633 3.696-3.647 3.696s-3.647-1.655-3.647-3.696"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M45.782 41.889c0-2.042 1.633-3.697 3.647-3.697s3.647 1.655 3.647 3.697c0 2.041-1.633 3.696-3.647 3.696s-3.647-1.655-3.647-3.696z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M48.16 38.26l-2.583-7.858"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25",
    d: "M41.256 59.024c-6.845-3.062-11.244-10.002-11.244-18.073 0-10.906 8.721-19.746 19.48-19.746s19.48 8.84 19.48 19.746c0 8.137-4.289 15.125-11.225 18.148"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25",
    d: "M49.67 19.236v3.176"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M35.468 24.39l2.014 2.433M27.858 37.591l3.085.552M30.4 52.663l2.713-1.588M40.6 61.989l1.072-2.984M58.28 62.04l-1.071-2.984M68.595 52.866l-2.714-1.588M71.292 37.822l-3.086.552M63.818 24.54l-2.014 2.433"
  })));
};
var ImgMaintenance = function ImgMaintenance(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M23.257.042c-.65 0-1.276.514-1.389 1.144l-1.04 5.787c-.112.63.328 1.144.98 1.144h3.875c.65 0 1.091-.514.978-1.144l-1.04-5.787C25.51.556 24.885.042 24.234.042M.837 8.107L.166 9.683a1.116 1.116 0 0 0 .708 1.46l12.712 4.206c.617.204 1.397-.076 1.733-.624L2.505 7.263a1.342 1.342 0 0 0-.235-.02c-.58 0-1.19.355-1.433.864m44.152.16L30.508 10.85c-.64.114-.89.656-.553 1.203l2.256 3.67c.336.546 1.116.826 1.733.622l12.677-4.194c.617-.204.936-.86.709-1.46l-.673-1.58c-.244-.51-.854-.864-1.433-.864-.08 0-.158.006-.235.02m-22.435 2.09c-.652 0-1.461.447-1.8.992L6.16 34.863c-.338.545-.218 1.339.27 1.764l1.477 1.122c.504.404 1.227.31 1.607-.209L22.35 20.003c.38-.52 1.001-.52 1.381 0l1.382-3.693.214-4.961c-.34-.545-1.149-.992-1.8-.992"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M23.398.181c-.65 0-1.276.516-1.389 1.146L20.97 7.126c-.113.63.327 1.145.978 1.145h3.876c.651 0 1.091-.515.978-1.145l-1.039-5.799c-.113-.63-.738-1.146-1.39-1.146M.979 8.261l-.671 1.58c-.227.599.091 1.257.708 1.461l12.712 4.215c.617.204 1.397-.076 1.733-.625l2.257-3.676c.336-.548.087-1.09-.554-1.205L2.646 7.416a1.34 1.34 0 0 0-.234-.02c-.58 0-1.19.356-1.434.866M45.13 7.42l-14.48 2.588c-.642.114-.89.657-.554 1.205l2.256 3.676c.336.548 1.116.829 1.733.624l12.677-4.201a1.12 1.12 0 0 0 .71-1.463l-.674-1.584c-.243-.51-.854-.866-1.433-.866-.079 0-.157.007-.235.02M23.4 10.935c-.65 0-1.46.447-1.799.993L7.007 35.486c-.338.546-.218 1.341.27 1.767l1.477 1.124c.504.405 1.227.31 1.608-.21l12.834-17.57c.38-.52 1.001-.52 1.381 0l7.126 9.755 2.726-5.097-8.256-13.328c-.34-.546-1.149-.993-1.8-.993"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28 13)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M-1.786 41.266V-.807h51.067v42.073",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M55.422 20.207h-3.85c-.647 0-1.084-.523-.972-1.163l1.033-5.881c.112-.64.733-1.163 1.38-1.163h.969c.647 0 1.268.523 1.38 1.163l1.032 5.881c.112.64-.325 1.163-.972 1.163m5.84 22.398l-7.078-9.895c-.378-.528-.995-.528-1.372 0l-12.75 17.823a1.092 1.092 0 0 1-1.598.212l-1.467-1.14c-.484-.432-.604-1.239-.268-1.793l14.498-23.897c.337-.554 1.141-1.008 1.788-1.008h.966c.647 0 1.45.454 1.787 1.008l8.203 13.52M47.368 23.193l-2.241 3.73c-.334.556-1.11.84-1.722.633l-12.628-4.275a1.141 1.141 0 0 1-.704-1.483l.667-1.601c.275-.588 1.02-.973 1.657-.858l14.422 2.632c.636.116.884.666.55 1.222m14.538 3.726l-2.241-3.728c-.334-.557-.087-1.107.55-1.223l14.386-2.626c.636-.116 1.382.27 1.656.858l.67 1.607a1.141 1.141 0 0 1-.705 1.483l-12.594 4.262c-.613.208-1.388-.076-1.722-.633"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29 12)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#2E3B45",
    strokeWidth: "1.5",
    d: "M-1.644 40.481V-1.67h51.066V40.48",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M55.128 20.314H51.29c-.645 0-1.08-.518-.969-1.152l1.03-5.828c.111-.634.73-1.152 1.375-1.152h.966c.645 0 1.264.518 1.376 1.152l1.03 5.828c.112.634-.324 1.152-.97 1.152zm5.823 22.194l-7.057-9.805c-.376-.523-.992-.523-1.368 0l-12.712 17.66a1.093 1.093 0 0 1-1.593.21l-1.463-1.13c-.482-.427-.602-1.226-.267-1.776l14.455-23.679c.336-.549 1.137-.998 1.782-.998h.963c.645 0 1.447.45 1.783.998l8.178 13.397-2.7 5.123zM47.1 23.274l-2.235 3.694c-.333.552-1.106.834-1.717.628l-12.59-4.235a1.13 1.13 0 0 1-.702-1.47l.665-1.587c.274-.582 1.017-.964 1.652-.85l14.379 2.609c.634.114.88.66.548 1.21zm14.495 3.691l-2.234-3.694c-.333-.552-.087-1.096.548-1.212l14.343-2.601c.635-.115 1.378.267 1.652.85l.666 1.592a1.129 1.129 0 0 1-.702 1.47l-12.556 4.223c-.611.205-1.384-.076-1.717-.628z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M25.297 17.791c-.253-1.03.404-2.078 1.468-2.34 1.065-.263 2.133.36 2.386 1.39.254 1.029-.403 2.077-1.468 2.34-1.064.262-2.133-.36-2.386-1.39M22.03 20.098c-.14-.57.224-1.15.813-1.295.59-.146 1.18.199 1.32.769.141.57-.223 1.15-.812 1.295-.59.146-1.18-.199-1.321-.769M75.792 35.917l-1.38-1.382 1.38-1.38a.735.735 0 0 0 0-1.037.733.733 0 0 0-1.035 0l-1.38 1.382-1.379-1.382a.733.733 0 0 0-1.035 0 .736.736 0 0 0 0 1.036l1.38 1.381-1.38 1.382a.733.733 0 0 0 1.035 1.036l1.38-1.381 1.38 1.38a.733.733 0 0 0 1.034-1.035M24.429 27.008v-2.18c0-.191.206-.31.372-.215l1.885 1.09 1.886 1.09a.249.249 0 0 1 0 .43l-1.886 1.09-1.885 1.09a.248.248 0 0 1-.372-.215v-2.18zM73.669 40.16v-1.463c0-.129.139-.209.25-.144l1.265.731 1.265.731a.167.167 0 0 1 0 .289l-1.265.731-1.265.732a.166.166 0 0 1-.25-.144V40.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M64.166 43.632L37.638 40.53a3.696 3.696 0 0 1-3.23-4.089l.334-2.857a3.694 3.694 0 0 1 4.084-3.233l26.528 3.102a3.696 3.696 0 0 1 3.23 4.09l-.334 2.857a3.694 3.694 0 0 1-4.084 3.233"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M64.166 43.632L37.638 40.53a3.696 3.696 0 0 1-3.23-4.089l.334-2.857a3.694 3.694 0 0 1 4.084-3.233l26.528 3.102a3.696 3.696 0 0 1 3.23 4.09l-.334 2.857a3.694 3.694 0 0 1-4.084 3.233z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M68.48 38.87l2.923.343-1.029 8.815-20.926-.214-.477 4.094M50.777 54.991l-1.256 10.761c-.188 1.614-1.296 2.233-2.545 2.087-1.249-.146-2.185-1.004-1.996-2.618l1.255-10.76 4.542.53zM49.713 54.82l-2.403-.28a.307.307 0 0 1-.268-.34l.2-1.718a.307.307 0 0 1 .34-.268l2.402.28c.167.02.288.173.268.34l-.2 1.719a.306.306 0 0 1-.34.268z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M38.27 52.875a1.31 1.31 0 0 1 1.306 1.307 1.31 1.31 0 0 1-1.305 1.307 1.31 1.31 0 0 1-1.305-1.307 1.31 1.31 0 0 1 1.305-1.307"
  })));
};
var ImgManage = function ImgManage(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M41.824 57.831c-2.084 5.572-7.078 8.434-13.685 8.434-8.382 0-15.177-13.623-15.177-21.546"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M15.577 31.059c-.264-1.074.42-2.166 1.53-2.44 1.109-.273 2.222.375 2.487 1.448.264 1.074-.421 2.166-1.53 2.44-1.11.273-2.223-.375-2.487-1.448"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M26.597 57.773c0 1.215-2.35.803-3.475.803-1.126 0-2.038-.985-2.038-2.2V27.319c0-1.216.912-2.2 2.038-2.2l.74 32.468 2.735.186z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M75.82 45.497c4.546-.046 7.374-3.025 9.84-7.668 2.467-4.642 2.867-10.805 1.03-15.86-.586-1.617-1.413-3.156-2.602-4.175-1.188-1.02-2.78-1.034-4.135-.388-1.672.798-2.653 2.44-2.153 4.537s2.391 3.128 4.167 2.8c1.776-.33 3.22-1.54 3.252-3.723.05-3.372-2.75-5.75-5.402-6.748a15.81 15.81 0 0 0-6.528-1M8 39.61a4.892 4.892 0 0 1 4.888-4.896c2.7 0 4.889 2.192 4.889 4.896a4.892 4.892 0 0 1-4.889 4.895A4.892 4.892 0 0 1 8 39.61z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M15.453 39.61c0 2.677-1.148 4.847-2.565 4.847-1.416 0-2.564-2.17-2.564-4.847 0-2.678 1.148-4.848 2.564-4.848 1.417 0 2.565 2.17 2.565 4.848zM8.365 37.914h8.866M8.365 41.081h8.866M70.411 12.92l-5.488-1.068s-1.555-.58-3.114.473l-1.059.802s-.984.956.421 1.23l9.108 1.216 3.078-.827-.241-1.264.841-2.723-1.92-.305-1.626 2.466z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M67.423 12.341l1.786-1.923-2.58-.418-1.835 1.73M67.304 15.235l1.4 3.44-2.584-.468-1.267-3.258"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M47.65 60.944a.85.85 0 0 1 .638-1.019c.464-.114.929.157 1.039.605.11.449-.176.905-.64 1.019-.462.114-.928-.156-1.038-.605M51.32 64.42h-1.14v-1.143a.43.43 0 0 0-.428-.428.43.43 0 0 0-.428.428v1.143h-1.141a.43.43 0 0 0 0 .857h1.14v1.143a.43.43 0 0 0 .429.428.43.43 0 0 0 .428-.428v-1.143h1.14a.43.43 0 0 0 0-.857M43.127 61.909v-1.714c0-.15.163-.244.293-.17l1.482.858 1.483.857c.13.075.13.263 0 .338l-1.483.857-1.482.857a.195.195 0 0 1-.293-.169V61.91z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M74.14 57.931H25.778A1.778 1.778 0 0 1 24 56.152V23.78c0-.983.796-1.78 1.777-1.78h48.364c.981 0 1.777.797 1.777 1.78v32.372c0 .983-.796 1.78-1.777 1.78zM72.093 27.96h-45M63.012 36.036H38.266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M28.222 25.199a.87.87 0 1 1-1.74.001.87.87 0 0 1 1.74-.001M31.018 25.199a.87.87 0 1 1-1.739.001.87.87 0 0 1 1.739-.001M72.92 25.199a.87.87 0 1 1-1.74.001.87.87 0 0 1 1.74-.001"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M55.168 35.723a2.487 2.487 0 0 1 2.485-2.489 2.487 2.487 0 0 1 2.485 2.49 2.487 2.487 0 0 1-2.485 2.488 2.487 2.487 0 0 1-2.485-2.489"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M55.168 35.723a2.487 2.487 0 0 1 2.485-2.489 2.487 2.487 0 0 1 2.485 2.49 2.487 2.487 0 0 1-2.485 2.488 2.487 2.487 0 0 1-2.485-2.489z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M63.012 43.962H38.266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M43.828 43.579a2.487 2.487 0 0 1 2.486-2.489 2.487 2.487 0 0 1 2.485 2.489 2.487 2.487 0 0 1-2.485 2.489 2.487 2.487 0 0 1-2.486-2.489"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M43.828 43.579a2.487 2.487 0 0 1 2.486-2.489 2.487 2.487 0 0 1 2.485 2.489 2.487 2.487 0 0 1-2.485 2.489 2.487 2.487 0 0 1-2.486-2.489z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M63.012 51.423H38.266"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25",
    d: "M63.012 51.423H38.266"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M50.042 51.201a2.487 2.487 0 0 1 2.485-2.489 2.487 2.487 0 0 1 2.485 2.49 2.487 2.487 0 0 1-2.485 2.488 2.487 2.487 0 0 1-2.485-2.489"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M50.042 51.201a2.487 2.487 0 0 1 2.485-2.489 2.487 2.487 0 0 1 2.485 2.49 2.487 2.487 0 0 1-2.485 2.488 2.487 2.487 0 0 1-2.485-2.489z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.45",
    d: "M78.913 53.913V41.279"
  })));
};
var ImgManageOneUser = function ImgManageOneUser(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M49.454 38.336c0 1.383-11.623.27-13.69 12.912-1.543-2.046-2.134-2.315-2.756-3.038 1.934-4.114 8.224-11.406 16.446-9.874"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeWidth: "1.08",
    d: "M57.448 27.025c0 4.818-4.068 8.724-9.085 8.724-5.018 0-9.085-3.906-9.085-8.724s4.067-8.724 9.085-8.724c5.017 0 9.085 3.906 9.085 8.724z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M57.313 27.226c0 4.726-3.821 8.557-8.535 8.557-4.715 0-8.536-3.831-8.536-8.557 0-4.725 3.821-8.556 8.536-8.556 4.714 0 8.535 3.831 8.535 8.556z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M33.032 17.463c0 .503-.42.91-.94.91-.519 0-.94-.407-.94-.91 0-.503.421-.91.94-.91.52 0 .94.407.94.91M39.88 57.514c0 .503-.42.911-.94.911-.519 0-.94-.408-.94-.91 0-.504.421-.912.94-.912.52 0 .94.408.94.911M33.88 38.91c0 .504-.42.912-.94.912-.519 0-.94-.408-.94-.911 0-.503.421-.911.94-.911.52 0 .94.408.94.91M34.05 20.247c-.236-.964.378-1.945 1.374-2.19.995-.247 1.994.336 2.23 1.3.237.964-.377 1.945-1.372 2.19-.995.246-1.994-.336-2.231-1.3M61.05 29.247c-.236-.964.378-1.945 1.374-2.19.995-.247 1.994.336 2.23 1.3.237.964-.377 1.945-1.372 2.19-.995.246-1.994-.336-2.231-1.3M40.412 55.247c-.237-.964.378-1.945 1.373-2.19.995-.247 1.994.336 2.231 1.3.237.964-.378 1.945-1.373 2.19-.995.246-1.994-.336-2.23-1.3M34.976 26.195h-1.592v-1.596a.6.6 0 0 0-.597-.599.6.6 0 0 0-.598.599v1.596h-1.592a.6.6 0 0 0 0 1.197h1.592v1.596a.6.6 0 0 0 .598.598.6.6 0 0 0 .597-.598v-1.596h1.592a.6.6 0 0 0 0-1.197M66.707 33.529l-1.263.97-.969-1.265a.598.598 0 0 0-.948.728l.97 1.267-1.264.971a.598.598 0 1 0 .727.95l1.263-.972.97 1.267a.597.597 0 1 0 .947-.729l-.97-1.266 1.264-.972a.598.598 0 1 0-.727-.95M68.707 54.529l-1.263.97-.97-1.266a.598.598 0 0 0-.947.73l.97 1.266-1.264.971a.598.598 0 1 0 .727.95l1.263-.972.97 1.267a.598.598 0 1 0 .947-.729l-.97-1.266 1.264-.972a.598.598 0 1 0-.727-.95"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00B3DB",
    strokeLinecap: "round",
    strokeWidth: "2.16",
    d: "M50.707 43.756h8.548"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M33.008 48.21l2.416 2.587S38.106 39.01 49.37 39.01c11.263 0 14.347 11.787 14.347 11.787"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M48.403 43.68c0-1.127.912-2.041 2.036-2.041s2.036.914 2.036 2.04c0 1.127-.912 2.04-2.036 2.04a2.038 2.038 0 0 1-2.036-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M48.403 43.68c0-1.127.912-2.041 2.036-2.041s2.036.914 2.036 2.04c0 1.127-.912 2.04-2.036 2.04a2.038 2.038 0 0 1-2.036-2.04z"
  })));
};
var ImgManageUser = function ImgManageUser(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M36.946 43.94c0 1.384-11.623.272-13.69 12.912-1.777.675-2.504.613-3.295-.577-.94-1.728 6.43-14.3 16.985-12.334M62.454 38.336c0 1.383-11.623.27-13.69 12.912-1.543-2.046-2.134-2.315-2.756-3.038 1.934-4.114 8.224-11.406 16.446-9.874"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M22.719 56.402S25.4 44.615 36.664 44.615s14.348 11.787 14.348 11.787"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeWidth: "1.08",
    d: "M44.749 32.425c0 4.818-4.068 8.724-9.085 8.724-5.018 0-9.085-3.906-9.085-8.724 0-4.819 4.067-8.724 9.085-8.724 5.017 0 9.085 3.905 9.085 8.724zM70.448 27.025c0 4.818-4.068 8.724-9.085 8.724-5.018 0-9.085-3.906-9.085-8.724s4.067-8.724 9.085-8.724c5.017 0 9.085 3.906 9.085 8.724z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M44.483 32.603c0 4.725-3.821 8.556-8.536 8.556-4.714 0-8.535-3.831-8.535-8.556 0-4.726 3.821-8.556 8.535-8.556 4.715 0 8.536 3.83 8.536 8.556zM70.313 27.226c0 4.726-3.821 8.557-8.535 8.557-4.715 0-8.536-3.831-8.536-8.557 0-4.725 3.821-8.556 8.536-8.556 4.714 0 8.535 3.831 8.535 8.556z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M37.032 17.463c0 .503-.42.91-.94.91-.519 0-.94-.407-.94-.91 0-.503.421-.91.94-.91.52 0 .94.407.94.91M69.295 59.461c0 .503-.42.911-.94.911s-.94-.408-.94-.91c0-.504.42-.912.94-.912s.94.408.94.911M19.88 40.275c0 .503-.42.911-.94.911-.519 0-.94-.408-.94-.91 0-.504.421-.911.94-.911.52 0 .94.407.94.91M38.702 17.247c-.237-.964.378-1.945 1.373-2.19.995-.247 1.994.336 2.23 1.3.238.964-.377 1.945-1.372 2.19-.995.246-1.994-.336-2.231-1.3M48.474 36.228c-.237-.964.378-1.945 1.373-2.19.995-.247 1.994.335 2.231 1.3.237.963-.378 1.944-1.373 2.19s-1.993-.336-2.23-1.3M69.827 57.194c-.237-.964.377-1.945 1.372-2.19.996-.247 1.995.336 2.232 1.3.236.964-.378 1.945-1.373 2.19-.996.246-1.994-.336-2.231-1.3M49.68 20.983h-1.593v-1.596a.6.6 0 0 0-.597-.599.6.6 0 0 0-.597.599v1.596H45.3a.6.6 0 0 0 0 1.197h1.593v1.596a.6.6 0 0 0 .597.598.6.6 0 0 0 .597-.598V22.18h1.592a.6.6 0 0 0 0-1.197M75.962 32.674l-1.263.971-.969-1.266a.598.598 0 0 0-.948.728l.97 1.267-1.264.971a.598.598 0 1 0 .727.95l1.263-.971.97 1.266a.597.597 0 1 0 .947-.729l-.97-1.266 1.264-.971a.598.598 0 1 0-.727-.95M25.35 40.804l-1.263.971-.969-1.266a.598.598 0 0 0-.948.729l.97 1.266-1.264.971a.598.598 0 1 0 .727.95l1.263-.971.97 1.266a.598.598 0 1 0 .947-.728l-.969-1.267 1.263-.971a.598.598 0 1 0-.727-.95"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00B3DB",
    strokeLinecap: "round",
    strokeWidth: "2.16",
    d: "M63.707 43.756h8.548M38.14 49.897h8.548"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M46.008 48.21l2.416 2.587S51.106 39.01 62.37 39.01c11.263 0 14.347 11.787 14.347 11.787"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M36.215 50.08c0-1.128.91-2.041 2.035-2.041 1.124 0 2.036.913 2.036 2.04s-.912 2.04-2.036 2.04a2.038 2.038 0 0 1-2.035-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M36.215 50.08c0-1.128.91-2.041 2.035-2.041 1.124 0 2.036.913 2.036 2.04s-.912 2.04-2.036 2.04a2.038 2.038 0 0 1-2.035-2.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M61.403 43.68c0-1.127.912-2.041 2.036-2.041s2.036.914 2.036 2.04c0 1.127-.912 2.04-2.036 2.04a2.038 2.038 0 0 1-2.036-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M61.403 43.68c0-1.127.912-2.041 2.036-2.041s2.036.914 2.036 2.04c0 1.127-.912 2.04-2.036 2.04a2.038 2.038 0 0 1-2.036-2.04z"
  })));
};
var ImgMissingFiles = function ImgMissingFiles(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M34.872 63.986h-3.194c-1.648 0-2.984-.917-2.984-2.05V23.887c0-1.131.751-2.05 2.399-2.05l-.295 39.5 1.049 1.861 1.559.16 1.466.628z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M41.801 14.664l1.841-6.825a.796.796 0 0 1 .982-.57l21.09 5.968a.82.82 0 0 1 .558 1.006l-3 10.899"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M44.08 14.662l.599-2.22.524-1.943a.796.796 0 0 1 .982-.57l17.062 4.827a.82.82 0 0 1 .557 1.006l-2.175 8.063"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M36.032 22.55V15.6c0-.51.404-.923.902-.923h18.394l4.452 4.67V23.2M38.948 17.7h11.974M38.948 19.936h3.525"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M59.643 19.562l-1.983-.132-2.111-.153a.22.22 0 0 1-.198-.202l-.15-2.163-.128-2.031"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M46.276 14.572l1.873-1.726a.885.885 0 0 1 1.092-.09l3.237 2.142-6.202-.326zM70.436 54.89c0 .189-.15.342-.334.342a.338.338 0 0 1-.334-.342v-.318c0-.189.15-.342.334-.342.184 0 .334.153.334.342v.318zm0 5.184c0 .19-.15.342-.334.342a.338.338 0 0 1-.334-.342v-3.99c0-.188.15-.342.334-.342.184 0 .334.154.334.342v3.99zm-.334-7.294c-2.642 0-4.784 2.194-4.784 4.9 0 2.706 2.142 4.9 4.784 4.9s4.784-2.194 4.784-4.9c0-2.706-2.142-4.9-4.784-4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.4",
    d: "M66.15 27.992v33.346c0 1.132-1.336 2.05-2.984 2.05H34.25c-1.648 0-2.984-.918-2.984-2.05v-37.45c0-1.132 1.336-2.05 2.984-2.05h25.89l6.01 6.154z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M44.805 28.063c0 4.737-3.75 8.577-8.375 8.577s-8.374-3.84-8.374-8.577c0-4.738 3.75-8.578 8.374-8.578 4.625 0 8.375 3.84 8.375 8.578"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.4",
    d: "M44.805 28.063c0 4.737-3.75 8.577-8.375 8.577s-8.374-3.84-8.374-8.577c0-4.738 3.75-8.578 8.374-8.578 4.625 0 8.375 3.84 8.375 8.578z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M36.71 23.872v6.984"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.187",
    d: "M36.71 23.872v6.984"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M36.71 32.965v.774"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.187",
    d: "M36.71 32.965v.774"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M59.907 22.67v3.442c0 .967.768 1.796 1.859 2.142.35.11.733.172 1.134.172h2.772"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.187",
    d: "M59.907 22.67v3.442c0 .967.768 1.796 1.859 2.142.35.11.733.172 1.134.172h2.772"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M68.98 39.994v9.675M37.672 40.847h21.743M43.585 33.263H55.77M37.672 47.972h21.84M37.672 55.25H59.69"
  })));
};
var ImgNoData = function ImgNoData(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.096.098h1.952v1.923H.096z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.096.14H2.05v1.923H.096z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M24.702 37.55H23.67c-.921 0-1.668.842-1.668 1.881v13.965s-.307 9.155 8.435 9.155c0 0-7.598-.768-5.863-24.88M28.604 36.45v-2.48c0-.92.79-1.665 1.763-1.665h2.703l-.789 3.976-3.677.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M53.713 25.426c-.226-.93.36-1.874 1.306-2.111.948-.237 1.899.324 2.124 1.253.226.93-.36 1.875-1.307 2.112-.947.236-1.898-.325-2.123-1.254M51.775 27.5a.977.977 0 0 1 .723-1.17.96.96 0 0 1 1.176.695.976.976 0 0 1-.723 1.168.96.96 0 0 1-1.176-.693M35.668 66.91c-.225-.929.36-1.874 1.307-2.111.947-.237 1.898.324 2.124 1.253.225.93-.36 1.875-1.307 2.112-.947.237-1.898-.325-2.124-1.254"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.671 67.78)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M.123 1.297A.977.977 0 0 1 .846.128a.96.96 0 0 1 1.176.694.977.977 0 0 1-.724 1.169.96.96 0 0 1-1.175-.694",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.76 49.116)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M.123 1.34A.977.977 0 0 1 .846.17a.96.96 0 0 1 1.176.694.977.977 0 0 1-.723 1.17.96.96 0 0 1-1.176-.695",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M51.465 22.378h-1.292v-1.311a.49.49 0 0 0-.484-.492.49.49 0 0 0-.485.492v1.311h-1.291a.49.49 0 0 0-.485.492c0 .27.218.492.485.492h1.291v1.31c0 .271.218.492.485.492a.49.49 0 0 0 .484-.492v-1.31h1.292a.49.49 0 0 0 .484-.492.49.49 0 0 0-.484-.492M30.208 67.316v-1.967a.22.22 0 0 1 .331-.194l1.678.983 1.678.984a.226.226 0 0 1 0 .388l-1.678.983-1.678.984a.22.22 0 0 1-.33-.194v-1.967z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M41.035 48.797a1.38 1.38 0 0 1-1.369 1.39 1.38 1.38 0 0 1-1.368-1.39c0-.767.612-1.39 1.368-1.39a1.38 1.38 0 0 1 1.37 1.39"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M41.035 48.797a1.38 1.38 0 0 1-1.369 1.39 1.38 1.38 0 0 1-1.368-1.39c0-.767.612-1.39 1.368-1.39a1.38 1.38 0 0 1 1.37 1.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M51.155 48.84a1.38 1.38 0 0 1-1.368 1.389 1.38 1.38 0 0 1-1.37-1.39c0-.767.613-1.39 1.37-1.39a1.38 1.38 0 0 1 1.368 1.39"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M51.155 48.84a1.38 1.38 0 0 1-1.368 1.389 1.38 1.38 0 0 1-1.37-1.39c0-.767.613-1.39 1.37-1.39a1.38 1.38 0 0 1 1.368 1.39z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M40.362 57.009c0-1.53 2.028-2.77 4.531-2.77 2.502 0 4.531 1.24 4.531 2.77"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M74.294 49.06v-7.617"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25",
    d: "M74.294 49.06v-7.617"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M32.42 36.552v-4.126c0-1.086.79-1.966 1.764-1.966h23.858v-.7c0-1.085.79-1.965 1.763-1.965h9.674c.974 0 1.764.88 1.764 1.966v14.66l.037 2.525v6.278s.254 9.57-8.994 9.57H34.252c-8.742 0-9.679-9.57-9.679-9.57v-14.6c0-1.086.747-1.966 1.668-1.966h38.242s-1.174 27.733 2.809 24.959M51.28 44.008l1.825 1.684M38.13 44.008l-1.825 1.684"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M33.5 33.304c-1.133.806-2.137.904-3.625.904-3.848 0-6.969-3.167-6.969-7.074s3.12-7.074 6.97-7.074c3.848 0 6.968 3.167 6.968 7.074A7.12 7.12 0 0 1 35.8 30.86s1.79 2.378 3.575 2.041c0 0-4.637 1.23-5.876.402"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M33.5 33.304c-1.133.806-2.137.904-3.625.904-3.848 0-6.969-3.167-6.969-7.074s3.12-7.074 6.97-7.074c3.848 0 6.968 3.167 6.968 7.074A7.12 7.12 0 0 1 35.8 30.86s1.79 2.378 3.575 2.041c0 0-4.637 1.23-5.876.402z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M28.03 27.608c0 .441-.354.8-.789.8a.794.794 0 0 1-.788-.8c0-.442.353-.8.788-.8.435 0 .788.358.788.8M30.746 27.608c0 .441-.352.8-.788.8a.794.794 0 0 1-.788-.8c0-.442.353-.8.788-.8.436 0 .788.358.788.8M33.36 27.608c0 .441-.353.8-.788.8a.794.794 0 0 1-.788-.8c0-.442.352-.8.788-.8.435 0 .788.358.788.8"
  })));
};
var ImgNoMessages = function ImgNoMessages(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M22.403 18.551l-.42 28.312c0 .937 3.022 1.696 2.085 1.696h-3.095c-.937 0-1.696-.76-1.696-1.696v-26.46A1.44 1.44 0 0 1 20.402 19l2.001-.448z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M55.29 33.199l-2.114-1.865"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M28.611 13.936h-1.453v-1.453c0-.3-.245-.546-.545-.546-.3 0-.545.246-.545.546v1.453h-1.453c-.3 0-.545.245-.545.545 0 .3.245.544.545.544h1.453v1.454c0 .3.245.545.545.545.3 0 .545-.246.545-.545v-1.454h1.453c.3 0 .545-.245.545-.544 0-.3-.245-.545-.545-.545M14.049 47.476c-.227-.92.36-1.855 1.312-2.089.952-.234 1.906.321 2.133 1.24.227.92-.36 1.855-1.313 2.09-.95.234-1.906-.32-2.132-1.24M25.815 54.379H24.36v-1.453c0-.3-.245-.545-.545-.545-.3 0-.545.245-.545.545v1.453h-1.453c-.3 0-.545.245-.545.545 0 .3.245.544.545.544h1.453v1.454c0 .3.246.545.545.545.3 0 .545-.246.545-.545v-1.454h1.454c.299 0 .545-.245.545-.544 0-.3-.246-.545-.545-.545M72.04 21.55l-.994-1.674a.222.222 0 0 1 .187-.335l1.947-.024 1.946-.024c.17-.002.28.18.196.33l-.952 1.697-.952 1.698a.222.222 0 0 1-.384.005l-.994-1.674zM21.757 10.143c-.227-.92.36-1.855 1.312-2.09.952-.234 1.907.322 2.133 1.241.227.92-.36 1.855-1.312 2.09-.951.234-1.907-.321-2.133-1.24M16.938 52.968c-.125-.509.2-1.026.727-1.156.526-.13 1.055.178 1.18.687.126.508-.2 1.026-.726 1.156-.527.13-1.056-.178-1.18-.687M69.355 23.302c-.126-.509.2-1.027.726-1.157.527-.13 1.056.178 1.181.687.126.509-.2 1.027-.726 1.156-.527.13-1.056-.177-1.181-.686"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M47.771 47.86h-24.09c-.937 0-1.696-.76-1.696-1.697V20.23"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25",
    d: "M67.684 20.231v13.28"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M67.222 19.396c.6.6.599 1.576-.005 2.18L45.97 35.806a1.542 1.542 0 0 1-2.18.006L22.384 21.454a1.54 1.54 0 0 1 .005-2.18l44.834.121zM36.86 31.334L22.997 46.95"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M47.82 44.926c0-7.18 5.82-13 13-13s13 5.82 13 13-5.82 13-13 13-13-5.82-13-13z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M51.423 44.926a9.396 9.396 0 0 1 9.397-9.396 9.397 9.397 0 1 1-9.396 9.397z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M83.09 70.714a2.75 2.75 0 0 1-3.88-.265l-8.574-9.826a.708.708 0 0 1 .068-1l3.076-2.684a.709.709 0 0 1 1 .068l8.574 9.826a2.75 2.75 0 0 1-.264 3.88"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M83.09 70.714a2.75 2.75 0 0 1-3.88-.265l-8.574-9.826a.708.708 0 0 1 .068-1l3.076-2.684a.709.709 0 0 1 1 .068l8.574 9.826a2.75 2.75 0 0 1-.264 3.88z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M70.277 54.033l2.959 3.391-1.978 1.726-2.959-3.39"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M67.602 50.41h-9.184a.709.709 0 0 1-.708-.708v-9.184c0-.391.317-.708.708-.708h9.184c.39 0 .708.317.708.708v9.184a.709.709 0 0 1-.708.708"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M67.602 50.41h-9.184a.709.709 0 0 1-.708-.708v-9.184c0-.391.317-.708.708-.708h9.184c.39 0 .708.317.708.708v9.184a.709.709 0 0 1-.708.708z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M61.838 47.32c0-.206.055-.36.165-.466.11-.105.27-.157.48-.157.203 0 .36.053.47.16.111.108.167.262.167.462 0 .193-.056.345-.168.456-.113.111-.269.167-.469.167-.205 0-.364-.055-.476-.163-.112-.109-.169-.262-.169-.46zm.118-1.253v-.271c0-.235.05-.439.15-.612.1-.173.283-.358.55-.553.255-.183.424-.332.506-.447a.647.647 0 0 0 .123-.384.416.416 0 0 0-.176-.363c-.117-.083-.28-.124-.49-.124-.367 0-.784.12-1.253.359l-.399-.802a3.487 3.487 0 0 1 1.732-.458c.503 0 .903.12 1.2.362.296.242.444.564.444.967 0 .269-.06.5-.183.696-.122.195-.354.415-.696.66-.234.173-.382.304-.444.395a.613.613 0 0 0-.094.355v.22h-.97z"
  })));
};
var ImgNoNews = function ImgNoNews(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.096.098h1.952v1.923H.096z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.096.14H2.05v1.923H.096z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M24.702 37.55H23.67c-.921 0-1.668.842-1.668 1.881v13.965s-.307 9.155 8.435 9.155c0 0-7.598-.768-5.863-24.88M28.604 36.45v-2.48c0-.92.79-1.665 1.763-1.665h2.703l-.789 3.976-3.677.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M53.713 25.426c-.226-.93.36-1.874 1.306-2.111.948-.237 1.899.324 2.124 1.253.226.93-.36 1.875-1.307 2.112-.947.236-1.898-.325-2.123-1.254M51.775 27.5a.977.977 0 0 1 .723-1.17.96.96 0 0 1 1.176.695.976.976 0 0 1-.723 1.168.96.96 0 0 1-1.176-.693M35.668 66.91c-.225-.929.36-1.874 1.307-2.111.947-.237 1.898.324 2.124 1.253.225.93-.36 1.875-1.307 2.112-.947.237-1.898-.325-2.124-1.254"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.671 67.78)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M.123 1.297A.977.977 0 0 1 .846.128a.96.96 0 0 1 1.176.694.977.977 0 0 1-.724 1.169.96.96 0 0 1-1.175-.694",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.76 49.116)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M.123 1.34A.977.977 0 0 1 .846.17a.96.96 0 0 1 1.176.694.977.977 0 0 1-.723 1.17.96.96 0 0 1-1.176-.695",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M51.465 22.378h-1.292v-1.311a.49.49 0 0 0-.484-.492.49.49 0 0 0-.485.492v1.311h-1.291a.49.49 0 0 0-.485.492c0 .27.218.492.485.492h1.291v1.31c0 .271.218.492.485.492a.49.49 0 0 0 .484-.492v-1.31h1.292a.49.49 0 0 0 .484-.492.49.49 0 0 0-.484-.492M30.208 67.316v-1.967a.22.22 0 0 1 .331-.194l1.678.983 1.678.984a.226.226 0 0 1 0 .388l-1.678.983-1.678.984a.22.22 0 0 1-.33-.194v-1.967z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M74.294 49.06v-7.617"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25",
    d: "M74.294 49.06v-7.617"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M32.42 36.552v-4.126c0-1.086.79-1.966 1.764-1.966h23.858v-.7c0-1.085.79-1.965 1.763-1.965h9.674c.974 0 1.764.88 1.764 1.966v14.66l.037 2.525v6.278s.254 9.57-8.994 9.57H34.252c-8.742 0-9.679-9.57-9.679-9.57v-14.6c0-1.086.747-1.966 1.668-1.966h38.242s-1.174 27.733 2.809 24.959"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M33.5 33.304c-1.133.806-2.137.904-3.625.904-3.848 0-6.969-3.167-6.969-7.074s3.12-7.074 6.97-7.074c3.848 0 6.968 3.167 6.968 7.074A7.12 7.12 0 0 1 35.8 30.86s1.79 2.378 3.575 2.041c0 0-4.637 1.23-5.876.402"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M33.5 33.304c-1.133.806-2.137.904-3.625.904-3.848 0-6.969-3.167-6.969-7.074s3.12-7.074 6.97-7.074c3.848 0 6.968 3.167 6.968 7.074A7.12 7.12 0 0 1 35.8 30.86s1.79 2.378 3.575 2.041c0 0-4.637 1.23-5.876.402z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M28.03 27.608c0 .441-.354.8-.789.8a.794.794 0 0 1-.788-.8c0-.442.353-.8.788-.8.435 0 .788.358.788.8M30.746 27.608c0 .441-.352.8-.788.8a.794.794 0 0 1-.788-.8c0-.442.353-.8.788-.8.436 0 .788.358.788.8M33.36 27.608c0 .441-.353.8-.788.8a.794.794 0 0 1-.788-.8c0-.442.352-.8.788-.8.435 0 .788.358.788.8"
  })));
};
var ImgNoResults = function ImgNoResults(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M60.301 31.212c.359-.16.794-.241 1.305-.241.787 0 1.396.21 1.829.629.43.419.646 1.02.646 1.8 0 .753-.217 1.347-.654 1.78-.436.433-1.043.65-1.821.65-.487 0-.907-.08-1.259-.238l-.046-4.38zm-.744-2.7v-1.057c0-.915.194-1.71.583-2.387.39-.676 1.1-1.395 2.135-2.158.996-.714 1.652-1.295 1.97-1.743.317-.448.477-.948.477-1.5 0-.62-.228-1.091-.683-1.415-.455-.324-1.09-.486-1.907-.486-1.422 0-3.044.467-4.866 1.4l-1.55-3.13c2.115-1.19 4.358-1.786 6.73-1.786 1.953 0 3.506.472 4.66 1.415 1.15.943 1.728 2.2 1.728 3.773 0 1.048-.238 1.953-.712 2.715-.474.762-1.375 1.62-2.703 2.573-.91.676-1.487 1.19-1.728 1.543-.243.352-.364.815-.364 1.386v.858h-3.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M41.326 17.377c-8.914 0-16.14 7.456-16.14 16.653 0 9.196 7.226 16.652 16.14 16.652 2.813 0 5.458-.742 7.76-2.048 0 0-20.448 2.362-20.758-14.005-.327-17.247 12.998-17.252 12.998-17.252"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M28.323 47.047a.788.788 0 0 1-.8.776.788.788 0 0 1-.798-.776c0-.428.358-.775.799-.775.441 0 .799.347.799.775M21.416 44.732c-.286-1.162.454-2.345 1.651-2.64 1.197-.297 2.399.405 2.684 1.567.285 1.162-.454 2.344-1.652 2.64-1.196.297-2.398-.405-2.683-1.567M65.946 36.134h-.798v-.802a.3.3 0 0 0-.3-.3.3.3 0 0 0-.298.3v.802h-.799a.301.301 0 0 0 0 .601h.799v.802a.3.3 0 0 0 .299.3.3.3 0 0 0 .299-.3v-.802h.798a.3.3 0 0 0 0-.601M50.595 53.027h-1.353v-1.36a.51.51 0 0 0-.508-.51.51.51 0 0 0-.508.51v1.36h-1.353a.51.51 0 0 0 0 1.02h1.353v1.359c0 .28.229.51.508.51a.51.51 0 0 0 .508-.51v-1.36h1.353a.51.51 0 0 0 0-1.019M17 41.852v-1.429c0-.125.135-.203.243-.14l1.231.713 1.232.715a.163.163 0 0 1 0 .281l-1.232.714-1.231.714a.162.162 0 0 1-.243-.14V41.85z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M28.086 32.882c0-8.86 7.15-16.043 15.971-16.043 8.82 0 15.972 7.183 15.972 16.043s-7.151 16.043-15.972 16.043c-8.82 0-15.971-7.183-15.971-16.043z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M32.513 32.882c0-6.404 5.168-11.596 11.544-11.596s11.544 5.192 11.544 11.596-5.168 11.596-11.544 11.596-11.544-5.192-11.544-11.596z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M71.9 64.282l-.966.846a2.73 2.73 0 0 1-3.862-.264L56.007 52.128a.711.711 0 0 1 .068-1l4.029-3.53a.704.704 0 0 1 .995.067l11.064 12.737a2.759 2.759 0 0 1-.263 3.88"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M71.9 64.282l-.966.846a2.73 2.73 0 0 1-3.862-.264L56.007 52.128a.711.711 0 0 1 .068-1l4.029-3.53a.704.704 0 0 1 .995.067l11.064 12.737a2.759 2.759 0 0 1-.263 3.88z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M55.676 44.121l3.635 4.184-2.43 2.13-3.635-4.184"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M70.545 53.72l-5.357-5.869"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M53.064 25.83s5.384 4.708.414 13.254h-12.27a.873.873 0 0 1-.87-.874V26.877c0-.483.39-.875.87-.875h11.963"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M53.064 25.83s5.384 4.708.414 13.254h-12.27a.873.873 0 0 1-.87-.874V26.877c0-.483.39-.875.87-.875h11.963"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M46.23 35.424c0-.253.067-.445.202-.574.135-.13.332-.195.59-.195.249 0 .441.067.578.2.136.132.204.322.204.569 0 .238-.068.425-.206.562-.139.137-.33.206-.576.206-.252 0-.447-.067-.585-.2-.138-.135-.207-.324-.207-.568zm.144-1.546v-.334c0-.29.061-.541.184-.755.123-.214.348-.441.675-.683.315-.225.523-.41.623-.55a.8.8 0 0 0 .151-.475.515.515 0 0 0-.216-.448c-.144-.102-.345-.153-.603-.153-.45 0-.963.147-1.539.443l-.49-.99a4.27 4.27 0 0 1 2.128-.565c.618 0 1.11.15 1.474.447.364.299.546.696.546 1.193 0 .332-.075.618-.225.859-.15.241-.435.512-.855.813-.288.214-.47.377-.546.488a.758.758 0 0 0-.115.439v.271h-1.192z"
  })));
};
var ImgPincode = function ImgPincode(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    id: "/imgPincode",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-57",
    transform: "translate(16.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.5867605,42.3782077 L60.4786436,40.144933 C60.2089701,40.0855374 60.0368808,39.8143396 60.0958326,39.542889 L61.7251625,32.0572736 C61.7843653,31.7858231 62.0532863,31.6121857 62.3227089,31.6718341 L72.4310766,33.9053615 C72.7004993,33.9647571 72.8725887,34.2357022 72.8133859,34.5071527 L71.1843069,41.9930209 C71.1251041,42.2644714 70.8561832,42.437856 70.5867605,42.3782077 Z",
    id: "Stroke-1",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1482584,33.6219055 L71.4568151,32.2371033 L71.4387533,32.3200044 L71.4613306,32.216378 C71.8872893,30.259356 70.6465402,28.3068835 68.7038873,27.8777187 L68.2112,27.7687846 C66.2685471,27.3398725 64.3309113,28.5897077 63.9049526,30.5469824 L63.6031691,31.9330484",
    id: "Stroke-3",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9604656,33.2432648 L70.1829777,32.2433967 L70.169933,32.3030451 L70.1862388,32.2284846 C70.4937921,30.8153747 69.6669605,29.4207154 68.348445,29.1295505 L68.0140498,29.0554956 C66.6957852,28.764078 65.3654794,29.682056 65.0579261,31.0954187 L64.8399296,32.0962978",
    id: "Stroke-5",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0559942,38.8570341 L66.0559942,38.8570341 C65.632544,38.7635176 65.3646265,38.3419352 65.4574443,37.9152978 L65.8598223,36.0672099 C65.9526402,35.6405725 66.3710732,35.3706385 66.7945234,35.4641549 C67.2177227,35.5576714 67.4858911,35.9792538 67.3930732,36.406144 L66.9906952,38.2539791 C66.8978773,38.6808692 66.4791935,38.9505505 66.0559942,38.8570341 Z",
    id: "Stroke-7",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.802277,4.15711099 C60.6763457,3.64251758 61.0027134,3.11907802 61.5312735,2.9879022 C62.0598337,2.85647363 62.5904007,3.16735275 62.716332,3.68194615 C62.8420124,4.19653956 62.5156447,4.72048462 61.9870845,4.85140769 C61.4585244,4.98283626 60.9282082,4.67195714 60.802277,4.15711099",
    id: "Fill-9",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7971107,1.85127253 C56.6714302,1.33667912 56.9975471,0.81323956 57.5261072,0.681810989 C58.0546674,0.550635165 58.5852344,0.861514286 58.7111656,1.37610769 C58.836846,1.8907011 58.5104784,2.41439341 57.9819182,2.54556923 C57.4533581,2.6769978 56.9230419,2.36586593 56.7971107,1.85127253",
    id: "Fill-11",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1107859,1.80388242 L52.8088271,1.80388242 L52.8088271,0.492124176 C52.8088271,0.221431868 52.5890746,2.52747253e-05 52.3206553,2.52747253e-05 C52.0519852,2.52747253e-05 51.8322326,0.221431868 51.8322326,0.492124176 L51.8322326,1.80388242 L50.5302739,1.80388242 C50.2618546,1.80388242 50.0421021,2.02528901 50.0421021,2.29572857 C50.0421021,2.56642088 50.2618546,2.78782747 50.5302739,2.78782747 L51.8322326,2.78782747 L51.8322326,4.09933297 C51.8322326,4.36977253 52.0519852,4.59117912 52.3206553,4.59117912 C52.5890746,4.59117912 52.8088271,4.36977253 52.8088271,4.09933297 L52.8088271,2.78782747 L54.1107859,2.78782747 C54.3792052,2.78782747 54.5989577,2.56642088 54.5989577,2.29572857 C54.5989577,2.02528901 54.3792052,1.80388242 54.1107859,1.80388242",
    id: "Fill-13",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01718213e-05,8.67544835 L5.01718213e-05,6.70781099 C5.01718213e-05,6.53518462 0.185184192,6.42751429 0.333441924,6.5137011 L2.02498488,7.49764615 L3.71627698,8.48133846 C3.86453471,8.56777802 3.86453471,8.78337143 3.71627698,8.86955824 L2.02498488,9.85325055 L0.333441924,10.8374484 C0.185184192,10.9236352 5.01718213e-05,10.8157121 5.01718213e-05,10.6433385 L5.01718213e-05,8.67544835 Z",
    id: "Fill-15",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00930378,7.97174945 L8.20304261,7.97174945 C7.08345842,7.97174945 6.17585017,8.89933187 6.17585017,10.0435187 L6.17585017,39.0793758 C6.17585017,40.0064527 4.76928316,39.1827495 5.59059588,39.4473758 L3.54634502,39.5934637 C2.42650997,39.5934637 2.09111134,41.2519912 2.09111134,42.396178 C2.09111134,44.6845516 4.62177801,45.9548593 6.86119725,45.9548593 L9.34997045,45.9548593 L9.00930378,7.97174945 Z",
    id: "Fill-17",
    fill: "#AEEDFC"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "63.7225533",
    y1: "25.5292923",
    x2: "63.7225533",
    y2: "16.8240613",
    id: "Stroke-19",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4339412,39.747311 L10.4970237,39.747311 C9.51516117,39.747311 8.71918522,38.945344 8.71918522,37.9560912 L8.71918522,8.24868462 C8.71918522,7.25943187 9.51516117,6.45771758 10.4970237,6.45771758 L58.4339412,6.45771758 C59.4158038,6.45771758 60.2117797,7.25943187 60.2117797,8.24868462 L60.2117797,37.9560912 C60.2117797,38.945344 59.4158038,39.747311 58.4339412,39.747311 Z",
    id: "Stroke-21",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2881911,45.2043516 L7.0913354,45.2043516 C5.40480962,45.2043516 4.03762749,43.8268791 4.03762749,42.1274066 L4.03762749,41.443978 C4.03762749,40.4547253 4.83360344,39.6527582 5.81546598,39.6527582 L63.5677478,39.6527582 C64.272411,39.6527582 64.8436172,40.2285165 64.8436172,40.9384835 L64.8436172,41.6219121 C64.8436172,43.6004176 63.2519162,45.2043516 61.2881911,45.2043516",
    id: "Fill-23",
    fill: "#00B3DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2881911,45.2043516 L7.0913354,45.2043516 C5.40480962,45.2043516 4.03762749,43.8268791 4.03762749,42.1274066 L4.03762749,41.443978 C4.03762749,40.4547253 4.83360344,39.6527582 5.81546598,39.6527582 L63.5677478,39.6527582 C64.272411,39.6527582 64.8436172,40.2285165 64.8436172,40.9384835 L64.8436172,41.6219121 C64.8436172,43.6004176 63.2519162,45.2043516 61.2881911,45.2043516 Z",
    id: "Stroke-25",
    stroke: "#2C3B45",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.41649,10.1931703 C33.41649,9.60932418 33.8860983,9.13618132 34.4655828,9.13618132 C35.0448165,9.13618132 35.5144247,9.60932418 35.5144247,10.1931703 C35.5144247,10.7770165 35.0448165,11.2501593 34.4655828,11.2501593 C33.8860983,11.2501593 33.41649,10.7770165 33.41649,10.1931703",
    id: "Fill-27",
    fill: "#2E3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2439773,25.1741066 C24.4032729,25.1000516 24.5550426,25.0259967 24.6995375,24.9519418 C24.8442832,24.8778868 24.9594275,24.8235462 25.0449704,24.7891725 C25.1307643,24.7545462 25.1994997,24.7371066 25.2509258,24.7371066 C25.3364687,24.7371066 25.410723,24.7664253 25.4731869,24.8243044 C25.5356509,24.8824363 25.5667574,24.9544692 25.5667574,25.0409088 C25.5667574,25.0901945 25.551455,25.1415022 25.5208502,25.1945791 C25.4902454,25.247656 25.4578845,25.2815242 25.4235168,25.2961835 C25.1074344,25.4220516 24.7597436,25.5135462 24.379943,25.5701615 C24.4484275,25.6343593 24.532967,25.7195352 24.6335615,25.825689 C24.7339052,25.9318429 24.7865856,25.988711 24.7916027,25.9960407 C24.8282282,26.0478538 24.8796543,26.1120516 24.9458811,26.1886341 C25.0121079,26.2649637 25.0580151,26.3251176 25.0836027,26.3680846 C25.1094412,26.4115571 25.1222351,26.4638758 25.1222351,26.5255462 C25.1222351,26.6044033 25.0928845,26.673656 25.0339326,26.7327989 C24.9752316,26.7919418 24.8992213,26.8217659 24.8061526,26.8217659 C24.7130838,26.8217659 24.6084756,26.748722 24.492077,26.6031396 C24.3756784,26.4575571 24.2256646,26.1959637 24.0417849,25.8183593 C23.8556474,26.1588099 23.7307196,26.3835022 23.6670014,26.4921835 C23.6032832,26.6008648 23.5420735,26.6830077 23.4833725,26.7381066 C23.4244206,26.7939637 23.3571904,26.8217659 23.2811801,26.8217659 C23.1906199,26.8217659 23.1151113,26.7901725 23.055156,26.7274912 C22.9952007,26.6643044 22.9650976,26.5970736 22.9650976,26.5255462 C22.9650976,26.4588209 22.9773897,26.4082714 23.0019739,26.3736451 C23.2272454,26.0650407 23.4625512,25.7973813 23.7073897,25.5701615 C23.5016852,25.5380626 23.3180564,25.5024253 23.1562522,25.4629967 C22.994699,25.4233154 22.8231113,25.3654363 22.6417402,25.2888538 C22.6123897,25.2741945 22.5835409,25.2403264 22.5554447,25.1872495 C22.5273485,25.1341725 22.5133003,25.0851396 22.5133003,25.0409088 C22.5133003,24.9544692 22.5444069,24.8824363 22.6068708,24.8243044 C22.6693347,24.7664253 22.7410804,24.7371066 22.821857,24.7371066 C22.8805581,24.7371066 22.9540598,24.7553044 23.0423622,24.790689 C23.1306646,24.8268319 23.2425478,24.8786451 23.3785134,24.9463813 C23.514479,25.0143703 23.66951,25.0901945 23.8433553,25.1741066 C23.8114962,25.018667 23.785156,24.8404802 23.7643347,24.6392934 C23.7435134,24.4381066 23.7332282,24.3003593 23.7332282,24.2263044 C23.7332282,24.1350626 23.762077,24.056711 23.8195237,23.9909967 C23.8772213,23.9260407 23.9512247,23.8931835 24.0417849,23.8931835 C24.1300873,23.8931835 24.2028364,23.9260407 24.260534,23.9909967 C24.3179808,24.056711 24.3468296,24.143656 24.3468296,24.2523374 C24.3468296,24.2819088 24.3425649,24.3405462 24.3340357,24.4279967 C24.3255065,24.5159527 24.3132144,24.6218538 24.2971595,24.7464582 C24.2813553,24.8713154 24.2635443,25.0136121 24.2439773,25.1741066",
    id: "Fill-29",
    fill: "#2E3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2439773,25.1741066 C24.4032729,25.1000516 24.5550426,25.0259967 24.6995375,24.9519418 C24.8442832,24.8778868 24.9594275,24.8235462 25.0449704,24.7891725 C25.1307643,24.7545462 25.1994997,24.7371066 25.2509258,24.7371066 C25.3364687,24.7371066 25.410723,24.7664253 25.4731869,24.8243044 C25.5356509,24.8824363 25.5667574,24.9544692 25.5667574,25.0409088 C25.5667574,25.0901945 25.551455,25.1415022 25.5208502,25.1945791 C25.4902454,25.247656 25.4578845,25.2815242 25.4235168,25.2961835 C25.1074344,25.4220516 24.7597436,25.5135462 24.379943,25.5701615 C24.4484275,25.6343593 24.532967,25.7195352 24.6335615,25.825689 C24.7339052,25.9318429 24.7865856,25.988711 24.7916027,25.9960407 C24.8282282,26.0478538 24.8796543,26.1120516 24.9458811,26.1886341 C25.0121079,26.2649637 25.0580151,26.3251176 25.0836027,26.3680846 C25.1094412,26.4115571 25.1222351,26.4638758 25.1222351,26.5255462 C25.1222351,26.6044033 25.0928845,26.673656 25.0339326,26.7327989 C24.9752316,26.7919418 24.8992213,26.8217659 24.8061526,26.8217659 C24.7130838,26.8217659 24.6084756,26.748722 24.492077,26.6031396 C24.3756784,26.4575571 24.2256646,26.1959637 24.0417849,25.8183593 C23.8556474,26.1588099 23.7307196,26.3835022 23.6670014,26.4921835 C23.6032832,26.6008648 23.5420735,26.6830077 23.4833725,26.7381066 C23.4244206,26.7939637 23.3571904,26.8217659 23.2811801,26.8217659 C23.1906199,26.8217659 23.1151113,26.7901725 23.055156,26.7274912 C22.9952007,26.6643044 22.9650976,26.5970736 22.9650976,26.5255462 C22.9650976,26.4588209 22.9773897,26.4082714 23.0019739,26.3736451 C23.2272454,26.0650407 23.4625512,25.7973813 23.7073897,25.5701615 C23.5016852,25.5380626 23.3180564,25.5024253 23.1562522,25.4629967 C22.994699,25.4233154 22.8231113,25.3654363 22.6417402,25.2888538 C22.6123897,25.2741945 22.5835409,25.2403264 22.5554447,25.1872495 C22.5273485,25.1341725 22.5133003,25.0851396 22.5133003,25.0409088 C22.5133003,24.9544692 22.5444069,24.8824363 22.6068708,24.8243044 C22.6693347,24.7664253 22.7410804,24.7371066 22.821857,24.7371066 C22.8805581,24.7371066 22.9540598,24.7553044 23.0423622,24.790689 C23.1306646,24.8268319 23.2425478,24.8786451 23.3785134,24.9463813 C23.514479,25.0143703 23.66951,25.0901945 23.8433553,25.1741066 C23.8114962,25.018667 23.785156,24.8404802 23.7643347,24.6392934 C23.7435134,24.4381066 23.7332282,24.3003593 23.7332282,24.2263044 C23.7332282,24.1350626 23.762077,24.056711 23.8195237,23.9909967 C23.8772213,23.9260407 23.9512247,23.8931835 24.0417849,23.8931835 C24.1300873,23.8931835 24.2028364,23.9260407 24.260534,23.9909967 C24.3179808,24.056711 24.3468296,24.143656 24.3468296,24.2523374 C24.3468296,24.2819088 24.3425649,24.3405462 24.3340357,24.4279967 C24.3255065,24.5159527 24.3132144,24.6218538 24.2971595,24.7464582 C24.2813553,24.8713154 24.2635443,25.0136121 24.2439773,25.1741066 Z",
    id: "Stroke-31",
    stroke: "#2C3B45",
    strokeWidth: "0.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0773041,25.1741066 C31.2365997,25.1000516 31.3883694,25.0259967 31.5328643,24.9519418 C31.67761,24.8778868 31.7927543,24.8235462 31.8782973,24.7891725 C31.9640911,24.7545462 32.0328265,24.7371066 32.0842526,24.7371066 C32.1697955,24.7371066 32.2440498,24.7664253 32.3065137,24.8243044 C32.3689777,24.8824363 32.4000842,24.9544692 32.4000842,25.0409088 C32.4000842,25.0901945 32.3847818,25.1415022 32.354177,25.1945791 C32.3235722,25.247656 32.2912113,25.2815242 32.2568436,25.2961835 C31.9407612,25.4220516 31.5930704,25.5135462 31.2132698,25.5701615 C31.2817543,25.6343593 31.3662938,25.7195352 31.4668883,25.825689 C31.567232,25.9318429 31.6199124,25.988711 31.6249296,25.9960407 C31.661555,26.0478538 31.7129811,26.1120516 31.7792079,26.1886341 C31.8454347,26.2649637 31.8913419,26.3251176 31.9169296,26.3680846 C31.942768,26.4115571 31.9555619,26.4638758 31.9555619,26.5255462 C31.9555619,26.6044033 31.9262113,26.673656 31.8672595,26.7327989 C31.8085584,26.7919418 31.7325481,26.8217659 31.6394794,26.8217659 C31.5464107,26.8217659 31.4418024,26.748722 31.3254038,26.6031396 C31.2090052,26.4575571 31.0589914,26.1959637 30.8751117,25.8183593 C30.6889742,26.1588099 30.5640464,26.3835022 30.5003282,26.4921835 C30.43661,26.6008648 30.3754003,26.6830077 30.3166993,26.7381066 C30.2577474,26.7939637 30.1905172,26.8217659 30.1145069,26.8217659 C30.0239467,26.8217659 29.9484381,26.7901725 29.8884828,26.7274912 C29.8285275,26.6643044 29.7984244,26.5970736 29.7984244,26.5255462 C29.7984244,26.4588209 29.8107165,26.4082714 29.8353007,26.3736451 C30.0605722,26.0650407 30.295878,25.7973813 30.5407165,25.5701615 C30.335012,25.5380626 30.1513832,25.5024253 29.989579,25.4629967 C29.8280258,25.4233154 29.6564381,25.3654363 29.475067,25.2888538 C29.4457165,25.2741945 29.4168677,25.2403264 29.3887715,25.1872495 C29.3606753,25.1341725 29.3466271,25.0851396 29.3466271,25.0409088 C29.3466271,24.9544692 29.3777337,24.8824363 29.4401976,24.8243044 C29.5026615,24.7664253 29.5744072,24.7371066 29.6551838,24.7371066 C29.7138849,24.7371066 29.7873866,24.7553044 29.875689,24.790689 C29.9639914,24.8268319 30.0758746,24.8786451 30.2118402,24.9463813 C30.3478058,25.0143703 30.5028368,25.0901945 30.6766821,25.1741066 C30.644823,25.018667 30.6184828,24.8404802 30.5976615,24.6392934 C30.5768402,24.4381066 30.566555,24.3003593 30.566555,24.2263044 C30.566555,24.1350626 30.5954038,24.056711 30.6528505,23.9909967 C30.7105481,23.9260407 30.7845515,23.8931835 30.8751117,23.8931835 C30.9634141,23.8931835 31.0361632,23.9260407 31.0938608,23.9909967 C31.1513076,24.056711 31.1801564,24.143656 31.1801564,24.2523374 C31.1801564,24.2819088 31.1758918,24.3405462 31.1673625,24.4279967 C31.1588333,24.5159527 31.1465412,24.6218538 31.1304863,24.7464582 C31.1146821,24.8713154 31.0968711,25.0136121 31.0773041,25.1741066",
    id: "Fill-33",
    fill: "#2E3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0773041,25.1741066 C31.2365997,25.1000516 31.3883694,25.0259967 31.5328643,24.9519418 C31.67761,24.8778868 31.7927543,24.8235462 31.8782973,24.7891725 C31.9640911,24.7545462 32.0328265,24.7371066 32.0842526,24.7371066 C32.1697955,24.7371066 32.2440498,24.7664253 32.3065137,24.8243044 C32.3689777,24.8824363 32.4000842,24.9544692 32.4000842,25.0409088 C32.4000842,25.0901945 32.3847818,25.1415022 32.354177,25.1945791 C32.3235722,25.247656 32.2912113,25.2815242 32.2568436,25.2961835 C31.9407612,25.4220516 31.5930704,25.5135462 31.2132698,25.5701615 C31.2817543,25.6343593 31.3662938,25.7195352 31.4668883,25.825689 C31.567232,25.9318429 31.6199124,25.988711 31.6249296,25.9960407 C31.661555,26.0478538 31.7129811,26.1120516 31.7792079,26.1886341 C31.8454347,26.2649637 31.8913419,26.3251176 31.9169296,26.3680846 C31.942768,26.4115571 31.9555619,26.4638758 31.9555619,26.5255462 C31.9555619,26.6044033 31.9262113,26.673656 31.8672595,26.7327989 C31.8085584,26.7919418 31.7325481,26.8217659 31.6394794,26.8217659 C31.5464107,26.8217659 31.4418024,26.748722 31.3254038,26.6031396 C31.2090052,26.4575571 31.0589914,26.1959637 30.8751117,25.8183593 C30.6889742,26.1588099 30.5640464,26.3835022 30.5003282,26.4921835 C30.43661,26.6008648 30.3754003,26.6830077 30.3166993,26.7381066 C30.2577474,26.7939637 30.1905172,26.8217659 30.1145069,26.8217659 C30.0239467,26.8217659 29.9484381,26.7901725 29.8884828,26.7274912 C29.8285275,26.6643044 29.7984244,26.5970736 29.7984244,26.5255462 C29.7984244,26.4588209 29.8107165,26.4082714 29.8353007,26.3736451 C30.0605722,26.0650407 30.295878,25.7973813 30.5407165,25.5701615 C30.335012,25.5380626 30.1513832,25.5024253 29.989579,25.4629967 C29.8280258,25.4233154 29.6564381,25.3654363 29.475067,25.2888538 C29.4457165,25.2741945 29.4168677,25.2403264 29.3887715,25.1872495 C29.3606753,25.1341725 29.3466271,25.0851396 29.3466271,25.0409088 C29.3466271,24.9544692 29.3777337,24.8824363 29.4401976,24.8243044 C29.5026615,24.7664253 29.5744072,24.7371066 29.6551838,24.7371066 C29.7138849,24.7371066 29.7873866,24.7553044 29.875689,24.790689 C29.9639914,24.8268319 30.0758746,24.8786451 30.2118402,24.9463813 C30.3478058,25.0143703 30.5028368,25.0901945 30.6766821,25.1741066 C30.644823,25.018667 30.6184828,24.8404802 30.5976615,24.6392934 C30.5768402,24.4381066 30.566555,24.3003593 30.566555,24.2263044 C30.566555,24.1350626 30.5954038,24.056711 30.6528505,23.9909967 C30.7105481,23.9260407 30.7845515,23.8931835 30.8751117,23.8931835 C30.9634141,23.8931835 31.0361632,23.9260407 31.0938608,23.9909967 C31.1513076,24.056711 31.1801564,24.143656 31.1801564,24.2523374 C31.1801564,24.2819088 31.1758918,24.3405462 31.1673625,24.4279967 C31.1588333,24.5159527 31.1465412,24.6218538 31.1304863,24.7464582 C31.1146821,24.8713154 31.0968711,25.0136121 31.0773041,25.1741066 Z",
    id: "Stroke-35",
    stroke: "#2C3B45",
    strokeWidth: "0.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.910656,25.1741066 C38.0699515,25.1000516 38.2217213,25.0259967 38.3662162,24.9519418 C38.5109619,24.8778868 38.6261062,24.8235462 38.7116491,24.7891725 C38.797443,24.7545462 38.8661784,24.7371066 38.9176045,24.7371066 C39.0031474,24.7371066 39.0774017,24.7664253 39.1398656,24.8243044 C39.2023296,24.8824363 39.2334361,24.9544692 39.2334361,25.0409088 C39.2334361,25.0901945 39.2181337,25.1415022 39.1875289,25.1945791 C39.1569241,25.247656 39.1245632,25.2815242 39.0901955,25.2961835 C38.7741131,25.4220516 38.4264223,25.5135462 38.0466216,25.5701615 C38.1151062,25.6343593 38.1996457,25.7195352 38.3002402,25.825689 C38.4005838,25.9318429 38.4532643,25.988711 38.4582814,25.9960407 C38.4949069,26.0478538 38.546333,26.1120516 38.6125598,26.1886341 C38.6787866,26.2649637 38.7246938,26.3251176 38.7502814,26.3680846 C38.7761199,26.4115571 38.7889137,26.4638758 38.7889137,26.5255462 C38.7889137,26.6044033 38.7595632,26.673656 38.7006113,26.7327989 C38.6419103,26.7919418 38.5659,26.8217659 38.4728313,26.8217659 C38.3797625,26.8217659 38.2751543,26.748722 38.1587557,26.6031396 C38.042357,26.4575571 37.8923433,26.1959637 37.7084636,25.8183593 C37.5223261,26.1588099 37.3973983,26.3835022 37.3336801,26.4921835 C37.2699619,26.6008648 37.2087522,26.6830077 37.1500512,26.7381066 C37.0910993,26.7939637 37.0238691,26.8217659 36.9478588,26.8217659 C36.8572986,26.8217659 36.78179,26.7901725 36.7218347,26.7274912 C36.6618794,26.6643044 36.6317763,26.5970736 36.6317763,26.5255462 C36.6317763,26.4588209 36.6440684,26.4082714 36.6686526,26.3736451 C36.8939241,26.0650407 37.1292299,25.7973813 37.3740684,25.5701615 C37.1683639,25.5380626 36.9847351,25.5024253 36.8229309,25.4629967 C36.6613777,25.4233154 36.48979,25.3654363 36.3084189,25.2888538 C36.2790684,25.2741945 36.2502196,25.2403264 36.2221234,25.1872495 C36.1940271,25.1341725 36.179979,25.0851396 36.179979,25.0409088 C36.179979,24.9544692 36.2110856,24.8824363 36.2735495,24.8243044 C36.3360134,24.7664253 36.4077591,24.7371066 36.4885357,24.7371066 C36.5472368,24.7371066 36.6207385,24.7553044 36.7090409,24.790689 C36.7973433,24.8268319 36.9092265,24.8786451 37.0451921,24.9463813 C37.1811577,25.0143703 37.3361887,25.0901945 37.510034,25.1741066 C37.4781749,25.018667 37.4518347,24.8404802 37.4310134,24.6392934 C37.4101921,24.4381066 37.3999069,24.3003593 37.3999069,24.2263044 C37.3999069,24.1350626 37.4287557,24.056711 37.4862024,23.9909967 C37.5439,23.9260407 37.6179034,23.8931835 37.7084636,23.8931835 C37.796766,23.8931835 37.8695151,23.9260407 37.9272127,23.9909967 C37.9846595,24.056711 38.0135082,24.143656 38.0135082,24.2523374 C38.0135082,24.2819088 38.0092436,24.3405462 38.0007144,24.4279967 C37.9921852,24.5159527 37.9798931,24.6218538 37.9638381,24.7464582 C37.948034,24.8713154 37.930223,25.0136121 37.910656,25.1741066",
    id: "Fill-37",
    fill: "#2E3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.910656,25.1741066 C38.0699515,25.1000516 38.2217213,25.0259967 38.3662162,24.9519418 C38.5109619,24.8778868 38.6261062,24.8235462 38.7116491,24.7891725 C38.797443,24.7545462 38.8661784,24.7371066 38.9176045,24.7371066 C39.0031474,24.7371066 39.0774017,24.7664253 39.1398656,24.8243044 C39.2023296,24.8824363 39.2334361,24.9544692 39.2334361,25.0409088 C39.2334361,25.0901945 39.2181337,25.1415022 39.1875289,25.1945791 C39.1569241,25.247656 39.1245632,25.2815242 39.0901955,25.2961835 C38.7741131,25.4220516 38.4264223,25.5135462 38.0466216,25.5701615 C38.1151062,25.6343593 38.1996457,25.7195352 38.3002402,25.825689 C38.4005838,25.9318429 38.4532643,25.988711 38.4582814,25.9960407 C38.4949069,26.0478538 38.546333,26.1120516 38.6125598,26.1886341 C38.6787866,26.2649637 38.7246938,26.3251176 38.7502814,26.3680846 C38.7761199,26.4115571 38.7889137,26.4638758 38.7889137,26.5255462 C38.7889137,26.6044033 38.7595632,26.673656 38.7006113,26.7327989 C38.6419103,26.7919418 38.5659,26.8217659 38.4728313,26.8217659 C38.3797625,26.8217659 38.2751543,26.748722 38.1587557,26.6031396 C38.042357,26.4575571 37.8923433,26.1959637 37.7084636,25.8183593 C37.5223261,26.1588099 37.3973983,26.3835022 37.3336801,26.4921835 C37.2699619,26.6008648 37.2087522,26.6830077 37.1500512,26.7381066 C37.0910993,26.7939637 37.0238691,26.8217659 36.9478588,26.8217659 C36.8572986,26.8217659 36.78179,26.7901725 36.7218347,26.7274912 C36.6618794,26.6643044 36.6317763,26.5970736 36.6317763,26.5255462 C36.6317763,26.4588209 36.6440684,26.4082714 36.6686526,26.3736451 C36.8939241,26.0650407 37.1292299,25.7973813 37.3740684,25.5701615 C37.1683639,25.5380626 36.9847351,25.5024253 36.8229309,25.4629967 C36.6613777,25.4233154 36.48979,25.3654363 36.3084189,25.2888538 C36.2790684,25.2741945 36.2502196,25.2403264 36.2221234,25.1872495 C36.1940271,25.1341725 36.179979,25.0851396 36.179979,25.0409088 C36.179979,24.9544692 36.2110856,24.8824363 36.2735495,24.8243044 C36.3360134,24.7664253 36.4077591,24.7371066 36.4885357,24.7371066 C36.5472368,24.7371066 36.6207385,24.7553044 36.7090409,24.790689 C36.7973433,24.8268319 36.9092265,24.8786451 37.0451921,24.9463813 C37.1811577,25.0143703 37.3361887,25.0901945 37.510034,25.1741066 C37.4781749,25.018667 37.4518347,24.8404802 37.4310134,24.6392934 C37.4101921,24.4381066 37.3999069,24.3003593 37.3999069,24.2263044 C37.3999069,24.1350626 37.4287557,24.056711 37.4862024,23.9909967 C37.5439,23.9260407 37.6179034,23.8931835 37.7084636,23.8931835 C37.796766,23.8931835 37.8695151,23.9260407 37.9272127,23.9909967 C37.9846595,24.056711 38.0135082,24.143656 38.0135082,24.2523374 C38.0135082,24.2819088 38.0092436,24.3405462 38.0007144,24.4279967 C37.9921852,24.5159527 37.9798931,24.6218538 37.9638381,24.7464582 C37.948034,24.8713154 37.930223,25.0136121 37.910656,25.1741066 Z",
    id: "Stroke-39",
    stroke: "#2C3B45",
    strokeWidth: "0.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7438574,25.1741066 C44.9031529,25.1000516 45.0549227,25.0259967 45.1994175,24.9519418 C45.3441632,24.8778868 45.4593076,24.8235462 45.5448505,24.7891725 C45.6306443,24.7545462 45.6993797,24.7371066 45.7508058,24.7371066 C45.8363488,24.7371066 45.9106031,24.7664253 45.973067,24.8243044 C46.0355309,24.8824363 46.0666375,24.9544692 46.0666375,25.0409088 C46.0666375,25.0901945 46.0513351,25.1415022 46.0207302,25.1945791 C45.9901254,25.247656 45.9577646,25.2815242 45.9233969,25.2961835 C45.6073144,25.4220516 45.2596237,25.5135462 44.879823,25.5701615 C44.9483076,25.6343593 45.0328471,25.7195352 45.1334416,25.825689 C45.2337852,25.9318429 45.2864656,25.988711 45.2914828,25.9960407 C45.3281082,26.0478538 45.3795344,26.1120516 45.4457612,26.1886341 C45.511988,26.2649637 45.5578952,26.3251176 45.5834828,26.3680846 C45.6093213,26.4115571 45.6221151,26.4638758 45.6221151,26.5255462 C45.6221151,26.6044033 45.5927646,26.673656 45.5338127,26.7327989 C45.4751117,26.7919418 45.3991014,26.8217659 45.3060326,26.8217659 C45.2129639,26.8217659 45.1083557,26.748722 44.991957,26.6031396 C44.8755584,26.4575571 44.7255447,26.1959637 44.5416649,25.8183593 C44.3555275,26.1588099 44.2305997,26.3835022 44.1668814,26.4921835 C44.1031632,26.6008648 44.0419536,26.6830077 43.9832526,26.7381066 C43.9243007,26.7939637 43.8570704,26.8217659 43.7810601,26.8217659 C43.6905,26.8217659 43.6149914,26.7901725 43.5550361,26.7274912 C43.4950808,26.6643044 43.4649777,26.5970736 43.4649777,26.5255462 C43.4649777,26.4588209 43.4772698,26.4082714 43.501854,26.3736451 C43.7271254,26.0650407 43.9624313,25.7973813 44.2072698,25.5701615 C44.0015653,25.5380626 43.8179364,25.5024253 43.6561323,25.4629967 C43.494579,25.4233154 43.3229914,25.3654363 43.1416203,25.2888538 C43.1122698,25.2741945 43.083421,25.2403264 43.0553247,25.1872495 C43.0272285,25.1341725 43.0131804,25.0851396 43.0131804,25.0409088 C43.0131804,24.9544692 43.0442869,24.8824363 43.1067509,24.8243044 C43.1692148,24.7664253 43.2409605,24.7371066 43.3217371,24.7371066 C43.3804381,24.7371066 43.4539399,24.7553044 43.5422423,24.790689 C43.6305447,24.8268319 43.7424278,24.8786451 43.8783935,24.9463813 C44.0143591,25.0143703 44.16939,25.0901945 44.3432354,25.1741066 C44.3113763,25.018667 44.2850361,24.8404802 44.2642148,24.6392934 C44.2433935,24.4381066 44.2331082,24.3003593 44.2331082,24.2263044 C44.2331082,24.1350626 44.261957,24.056711 44.3194038,23.9909967 C44.3771014,23.9260407 44.4511048,23.8931835 44.5416649,23.8931835 C44.6299674,23.8931835 44.7027165,23.9260407 44.7604141,23.9909967 C44.8178608,24.056711 44.8467096,24.143656 44.8467096,24.2523374 C44.8467096,24.2819088 44.842445,24.3405462 44.8339158,24.4279967 C44.8253866,24.5159527 44.8130945,24.6218538 44.7970395,24.7464582 C44.7812354,24.8713154 44.7634244,25.0136121 44.7438574,25.1741066",
    id: "Fill-41",
    fill: "#2E3B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7438574,25.1741066 C44.9031529,25.1000516 45.0549227,25.0259967 45.1994175,24.9519418 C45.3441632,24.8778868 45.4593076,24.8235462 45.5448505,24.7891725 C45.6306443,24.7545462 45.6993797,24.7371066 45.7508058,24.7371066 C45.8363488,24.7371066 45.9106031,24.7664253 45.973067,24.8243044 C46.0355309,24.8824363 46.0666375,24.9544692 46.0666375,25.0409088 C46.0666375,25.0901945 46.0513351,25.1415022 46.0207302,25.1945791 C45.9901254,25.247656 45.9577646,25.2815242 45.9233969,25.2961835 C45.6073144,25.4220516 45.2596237,25.5135462 44.879823,25.5701615 C44.9483076,25.6343593 45.0328471,25.7195352 45.1334416,25.825689 C45.2337852,25.9318429 45.2864656,25.988711 45.2914828,25.9960407 C45.3281082,26.0478538 45.3795344,26.1120516 45.4457612,26.1886341 C45.511988,26.2649637 45.5578952,26.3251176 45.5834828,26.3680846 C45.6093213,26.4115571 45.6221151,26.4638758 45.6221151,26.5255462 C45.6221151,26.6044033 45.5927646,26.673656 45.5338127,26.7327989 C45.4751117,26.7919418 45.3991014,26.8217659 45.3060326,26.8217659 C45.2129639,26.8217659 45.1083557,26.748722 44.991957,26.6031396 C44.8755584,26.4575571 44.7255447,26.1959637 44.5416649,25.8183593 C44.3555275,26.1588099 44.2305997,26.3835022 44.1668814,26.4921835 C44.1031632,26.6008648 44.0419536,26.6830077 43.9832526,26.7381066 C43.9243007,26.7939637 43.8570704,26.8217659 43.7810601,26.8217659 C43.6905,26.8217659 43.6149914,26.7901725 43.5550361,26.7274912 C43.4950808,26.6643044 43.4649777,26.5970736 43.4649777,26.5255462 C43.4649777,26.4588209 43.4772698,26.4082714 43.501854,26.3736451 C43.7271254,26.0650407 43.9624313,25.7973813 44.2072698,25.5701615 C44.0015653,25.5380626 43.8179364,25.5024253 43.6561323,25.4629967 C43.494579,25.4233154 43.3229914,25.3654363 43.1416203,25.2888538 C43.1122698,25.2741945 43.083421,25.2403264 43.0553247,25.1872495 C43.0272285,25.1341725 43.0131804,25.0851396 43.0131804,25.0409088 C43.0131804,24.9544692 43.0442869,24.8824363 43.1067509,24.8243044 C43.1692148,24.7664253 43.2409605,24.7371066 43.3217371,24.7371066 C43.3804381,24.7371066 43.4539399,24.7553044 43.5422423,24.790689 C43.6305447,24.8268319 43.7424278,24.8786451 43.8783935,24.9463813 C44.0143591,25.0143703 44.16939,25.0901945 44.3432354,25.1741066 C44.3113763,25.018667 44.2850361,24.8404802 44.2642148,24.6392934 C44.2433935,24.4381066 44.2331082,24.3003593 44.2331082,24.2263044 C44.2331082,24.1350626 44.261957,24.056711 44.3194038,23.9909967 C44.3771014,23.9260407 44.4511048,23.8931835 44.5416649,23.8931835 C44.6299674,23.8931835 44.7027165,23.9260407 44.7604141,23.9909967 C44.8178608,24.056711 44.8467096,24.143656 44.8467096,24.2523374 C44.8467096,24.2819088 44.842445,24.3405462 44.8339158,24.4279967 C44.8253866,24.5159527 44.8130945,24.6218538 44.7970395,24.7464582 C44.7812354,24.8713154 44.7634244,25.0136121 44.7438574,25.1741066 Z",
    id: "Stroke-43",
    stroke: "#2C3B45",
    strokeWidth: "0.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "23.1725581",
    y1: "28.4312099",
    x2: "25.7581629",
    y2: "28.4312099",
    id: "Stroke-45",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "29.7785564",
    y1: "28.4312099",
    x2: "32.3641612",
    y2: "28.4312099",
    id: "Stroke-47",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "36.5935203",
    y1: "28.4312099",
    x2: "39.1791251",
    y2: "28.4312099",
    id: "Stroke-49",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "43.3249481",
    y1: "28.4312099",
    x2: "45.9105529",
    y2: "28.4312099",
    id: "Stroke-51",
    stroke: "#AEEDFC",
    strokeWidth: "0.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6986766,20.3075088 L21.2322883,20.3075088 C20.9553399,20.3075088 20.7305701,20.0810473 20.7305701,19.8020143 L20.7305701,18.8294429 C20.7305701,18.5504099 20.9553399,18.3239484 21.2322883,18.3239484 L47.6986766,18.3239484 C47.9756251,18.3239484 48.2003948,18.5504099 48.2003948,18.8294429 L48.2003948,19.8020143 C48.2003948,20.0810473 47.9756251,20.3075088 47.6986766,20.3075088",
    id: "Fill-53",
    fill: "#AEEDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5297017,17.4428714 L21.2323134,17.4428714 C20.9553649,17.4428714 20.7305952,17.2164099 20.7305952,16.9373769 L20.7305952,15.9648055 C20.7305952,15.6857725 20.9553649,15.459311 21.2323134,15.459311 L36.5297017,15.459311 C36.8066502,15.459311 37.0314199,15.6857725 37.0314199,15.9648055 L37.0314199,16.9373769 C37.0314199,17.2164099 36.8066502,17.4428714 36.5297017,17.4428714",
    id: "Fill-55",
    fill: "#E2F8FE"
  }))));
};
var ImgPrefMobile = function ImgPrefMobile(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M37.773 61.171c0 1.335 7.847 2.075 6.501 2.075h-7.62a2.426 2.426 0 0 1-2.436-2.415V17.145a2.426 2.426 0 0 1 2.436-2.416h1.261l-.142 46.442z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M64.358 13.883h1.334c-.06-1.32-.042-3.287.818-4.102.576-.546 1.373-.59 2.1-.487.226.033.457.079.655.215.609.42.655 1.014.625 1.86.15-.828.812-1.524 1.51-1.438.697.087 1.24 1.096.925 1.853.414-.519 1.203-.288 1.545.303.341.592.33 1.241.196 1.944h1.75M54.571 62.37c-2.068 5.547-7.025 8.396-13.583 8.396-8.32 0-15.063-13.563-15.063-21.452M21 44.227c0-2.691 2.172-4.873 4.852-4.873s4.852 2.181 4.852 4.873-2.172 4.874-4.852 4.874S21 46.92 21 44.227z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M28.397 44.227c0 2.666-1.14 4.827-2.545 4.827-1.406 0-2.545-2.161-2.545-4.827 0-2.665 1.14-4.826 2.545-4.826s2.545 2.161 2.545 4.826zM21.362 42.539h8.8M21.362 45.693h8.8M35.394 20.643h-2.753c.059-1.32.041-2.859-.819-3.674-.575-.546-1.372-.59-2.099-.486-.226.032-.457.078-.655.214-.61.42-.655 1.441-.625 2.288-.151-.828-.813-1.524-1.51-1.438-.698.087-1.241 1.096-.925 1.852-.414-.518-1.204-.287-1.545.304-.342.591-.33 1.241-.197 1.944h-1.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M62.78 62.416H39.477A2.41 2.41 0 0 1 37.071 60V15.856a2.41 2.41 0 0 1 2.405-2.416h23.305c.322 0 .63.064.911.18a2.417 2.417 0 0 1 1.493 2.236V60a2.41 2.41 0 0 1-2.404 2.416zM43.008 17.4h16.24M68.088 42.832v11.485M60.735 38.652h-18.34M60.735 46.294h-18.34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M44.915 46.13a2.472 2.472 0 0 1 2.467-2.479 2.472 2.472 0 0 1 2.467 2.478 2.472 2.472 0 0 1-2.467 2.478 2.472 2.472 0 0 1-2.467-2.478"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M44.915 46.13a2.472 2.472 0 0 1 2.467-2.479 2.472 2.472 0 0 1 2.467 2.478 2.472 2.472 0 0 1-2.467 2.478 2.472 2.472 0 0 1-2.467-2.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M53.676 38.334a2.472 2.472 0 0 1 2.467-2.478 2.472 2.472 0 0 1 2.466 2.478 2.472 2.472 0 0 1-2.466 2.478 2.472 2.472 0 0 1-2.467-2.478"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M53.676 38.334a2.472 2.472 0 0 1 2.467-2.478 2.472 2.472 0 0 1 2.466 2.478 2.472 2.472 0 0 1-2.466 2.478 2.472 2.472 0 0 1-2.467-2.478z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M60.735 53.972h-18.34"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M48.262 53.718a2.472 2.472 0 0 1 2.467-2.478 2.472 2.472 0 0 1 2.467 2.478 2.472 2.472 0 0 1-2.467 2.478 2.472 2.472 0 0 1-2.467-2.478"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M48.262 53.718a2.472 2.472 0 0 1 2.467-2.478 2.472 2.472 0 0 1 2.467 2.478 2.472 2.472 0 0 1-2.467 2.478 2.472 2.472 0 0 1-2.467-2.478z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".75",
    d: "M55.58 26.173c0 2.324-1.875 4.208-4.189 4.208-2.313 0-4.189-1.884-4.189-4.208 0-2.325 1.876-4.209 4.19-4.209 2.313 0 4.189 1.884 4.189 4.209z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".75",
    d: "M52.366 25.457a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM49.1 29.466s.455-2.005 2.367-2.005c1.91 0 2.434 2.005 2.434 2.005-1.782 1.166-3.382 1.166-4.8 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M70.85 24.882c-.225-.92.36-1.855 1.307-2.09.947-.234 1.898.322 2.123 1.241.226.92-.36 1.855-1.306 2.09-.947.234-1.898-.321-2.124-1.241M69.138 21.2c-.125-.51.199-1.028.723-1.158.524-.13 1.05.178 1.176.687.124.51-.2 1.027-.724 1.157-.524.13-1.05-.178-1.175-.687M69.138 28.694c-.125-.509.199-1.027.723-1.157.524-.13 1.05.178 1.176.687.124.509-.2 1.027-.724 1.157-.524.13-1.05-.178-1.175-.687M29.322 34.517c-.226-.92.36-1.855 1.307-2.09.947-.234 1.897.321 2.123 1.24.225.92-.36 1.856-1.307 2.09-.947.235-1.897-.32-2.123-1.24M25.846 33.05c-.125-.51.199-1.027.723-1.157.525-.13 1.051.177 1.176.686.125.51-.2 1.027-.723 1.157-.525.13-1.05-.178-1.176-.687M75.332 35.787h-1.291v-1.298a.487.487 0 0 0-.485-.487.487.487 0 0 0-.484.487v1.298H71.78a.487.487 0 0 0 0 .973h1.292v1.297c0 .268.218.487.484.487a.487.487 0 0 0 .485-.487V36.76h1.291a.487.487 0 0 0 0-.973M70.237 68.286l-1.228-1.234 1.228-1.233a.658.658 0 0 0 0-.925.65.65 0 0 0-.921 0l-1.228 1.233-1.227-1.233a.65.65 0 0 0-.921 0 .658.658 0 0 0 0 .925l1.227 1.233-1.227 1.234a.658.658 0 0 0 0 .924.65.65 0 0 0 .92 0l1.228-1.233 1.228 1.233a.65.65 0 0 0 .92 0 .658.658 0 0 0 0-.924M31.482 55.218H30.44V54.17a.393.393 0 0 0-.392-.394.393.393 0 0 0-.391.394v1.048h-1.043a.393.393 0 0 0 0 .786h1.043v1.049c0 .216.176.393.391.393a.394.394 0 0 0 .392-.393v-1.049h1.043a.394.394 0 0 0 0-.786M27.54 26.045V24.1a.22.22 0 0 1 .331-.192l1.678.973 1.678.973a.222.222 0 0 1 0 .384l-1.678.973-1.678.973a.22.22 0 0 1-.33-.192v-1.946zM73.268 54.318V53.01c0-.114.124-.186.223-.128l1.126.653 1.125.653a.15.15 0 0 1 0 .258l-1.125.653-1.126.653a.148.148 0 0 1-.223-.13v-1.305z"
  })));
};
var ImgProducts = function ImgProducts(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .122h3.22v3.173H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M63.803 45.69l-.386-1.982a.549.549 0 0 1 .227-.559.529.529 0 0 1 .593-.002L81.593 54.88a.551.551 0 0 1 .003.91l-4.435 3.03 2.675 4.071c.077.12.106.267.08.409a.538.538 0 0 1-.227.345l-3.545 2.427a.522.522 0 0 1-.74-.15l-2.677-4.069-4.435 3.034a.532.532 0 0 1-.822-.346l-2.675-13.753"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M33.642 44.982l-6.976 3.736 18.527 9.92 3.338-1.787-15-8.324 3.718-2.098z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M45.193 43.67l-11.551-6.185-6.976 3.736 9.73 5.21.58.31M47.846 25.223l-2.653-1.42-18.527 9.92 9.369 5.017 2.929-1.761-5.67-3.531z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M68.89 48.343l-18.527 9.92-18.527-9.92 6.976-3.735 11.551 6.185 11.572-6.273 1.626.894z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M68.89 40.846l-18.527 9.92-18.527-9.92 6.976-3.736 11.551 6.185 11.572-6.272z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M68.89 40.846l-18.527 9.92-18.527-9.92 6.976-3.736 11.551 6.185 11.572-6.272z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23 43.643)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M3.22 1.709c0 .876-.721 1.586-1.61 1.586C.72 3.295 0 2.585 0 1.71 0 .832.72.122 1.61.122c.889 0 1.61.71 1.61 1.587",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M55.5 64.853c0 1.42-1.168 2.573-2.61 2.573-1.441 0-2.61-1.152-2.61-2.573s1.169-2.573 2.61-2.573c1.442 0 2.61 1.152 2.61 2.573M63.131 62.597h-1.34V61.23a.51.51 0 0 0-.502-.512.509.509 0 0 0-.502.512v1.367h-1.34a.51.51 0 0 0-.503.512.51.51 0 0 0 .503.513h1.34v1.367c0 .281.225.512.502.512a.51.51 0 0 0 .502-.512v-1.367h1.34a.51.51 0 0 0 .503-.513.51.51 0 0 0-.503-.512M42.352 19.256V16.82c0-.214.227-.347.408-.24l2.067 1.217 2.068 1.218a.28.28 0 0 1 0 .48l-2.068 1.217-2.067 1.218a.272.272 0 0 1-.408-.24v-2.435zM59.748 68.462c0 .73-.6 1.322-1.341 1.322a1.332 1.332 0 0 1-1.342-1.322c0-.73.6-1.322 1.342-1.322.74 0 1.341.591 1.341 1.322M78.067 36.036l-2.163 1.692-1.66-2.206a1.012 1.012 0 0 0-1.433-.193 1.06 1.06 0 0 0-.19 1.462l1.66 2.207-2.163 1.692a1.06 1.06 0 0 0-.189 1.463c.342.455.987.541 1.433.192l2.164-1.692 1.66 2.206c.342.455.987.542 1.433.193a1.06 1.06 0 0 0 .189-1.462l-1.66-2.207 2.164-1.693a1.06 1.06 0 0 0 .189-1.462 1.012 1.012 0 0 0-1.434-.192"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M62.281 55.613l-6.615 3.724"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M68.89 33.348l-7.18 3.846-11.347 6.076-18.527-9.922 18.527-9.92z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M52.872 20.663h-1.1a1.048 1.048 0 0 1-1.034-1.056v-6.55c0-.282.11-.538.286-.728.189-.203.454-.329.747-.329h7.01c.57 0 1.034.475 1.034 1.056v6.551c0 .581-.465 1.056-1.033 1.056h-1.307l-.13.133-2.944 2.096.002-2.229h-1.531z"
  })));
};
var ImgRenovation1 = function ImgRenovation1(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.22.127h4.562V4.71H.22z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".543",
    d: "M49.03 21.346a1.775 1.775 0 0 1 .76-2.379l1.966-1.016a1.759 1.759 0 0 1 2.367.763l.942 1.84"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M67.813 33.74a4.651 4.651 0 0 1-3.968 2.248h-32.85c-2.555 0-4.646-2.101-4.646-4.669v-3.908c0-1.284.522-2.45 1.365-3.297l.209 7.716 2.93 2.607 3.264.253 30.983-.216 2.713-.733"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M27.64 30.006c-.283 3.927.369 11.418.946 15.312.122.827.408 1.816 1.216 2.016.331.082.685 0 .988-.158 1.279-.67 1.495-2.37 1.723-3.8.227-1.432.977-3.139 2.42-3.164.837-.014 1.708.582 2.458.207.645-.323.823-1.21 1.434-1.595.952-.599 2.078.345 3.117.773 1.695.699 3.874-.259 4.514-1.984.241-.652.293-1.389.697-1.953.514-.719 1.457-.964 2.329-1.093"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M70.18 15.854c-.227-.928.363-1.872 1.319-2.108.955-.237 1.915.323 2.142 1.251.228.928-.362 1.872-1.318 2.109-.956.236-1.915-.324-2.143-1.252M67.558 18.585c-.126-.514.2-1.036.73-1.168.53-.13 1.06.18 1.186.693.126.514-.2 1.037-.73 1.168-.529.13-1.06-.18-1.186-.693M71.683 23.573c-.126-.514.2-1.036.73-1.167s1.06.179 1.186.693c.126.513-.2 1.036-.73 1.167-.529.131-1.06-.18-1.186-.693M20.96 29.273c-.227-.928.363-1.872 1.319-2.108.956-.237 1.915.324 2.143 1.251.227.928-.363 1.872-1.319 2.109-.956.237-1.915-.324-2.142-1.252M18.027 30.217c-.126-.514.2-1.037.73-1.167.53-.131 1.06.179 1.186.692.126.514-.2 1.037-.73 1.168-.529.13-1.06-.18-1.186-.693"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.7 13.125)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M4.293 1.928H2.99V.618c0-.27-.22-.491-.489-.491a.491.491 0 0 0-.489.491v1.31H.71a.491.491 0 0 0 0 .982h1.303v1.31c0 .27.22.49.49.49a.491.491 0 0 0 .488-.49V2.91h1.303a.491.491 0 0 0 0-.982",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M57.764 50.441l-1.239-1.245 1.24-1.244a.664.664 0 0 0 0-.934.657.657 0 0 0-.93 0l-1.239 1.245-1.239-1.245a.657.657 0 0 0-.929 0 .664.664 0 0 0 0 .934l1.24 1.244-1.24 1.245a.664.664 0 0 0 0 .933.657.657 0 0 0 .93 0l1.238-1.244 1.239 1.244a.657.657 0 0 0 .93 0 .664.664 0 0 0 0-.933M20.18 35.181v-1.964c0-.172.186-.28.335-.194l1.693.982 1.693.982a.224.224 0 0 1 0 .388l-1.693.982-1.693.982a.223.223 0 0 1-.334-.194v-1.964zM55.858 54.264v-1.318a.15.15 0 0 1 .224-.13l1.136.659 1.136.659c.1.058.1.202 0 .26l-1.136.66-1.136.658a.15.15 0 0 1-.224-.13v-1.318z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.477 34.348h-32.85c-2.555 0-4.646-2.1-4.646-4.669v-3.908c0-2.567 2.091-4.668 4.647-4.668h32.849c2.556 0 4.646 2.1 4.646 4.668v3.908c0 2.568-2.09 4.669-4.646 4.669"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M65.477 34.348h-32.85c-2.555 0-4.646-2.1-4.646-4.669v-3.908c0-2.567 2.091-4.668 4.647-4.668h32.849c2.556 0 4.646 2.1 4.646 4.668v3.908c0 2.568-2.09 4.669-4.646 4.669zM53.616 59.648V64.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M70.186 27.588h3.64v11.47l-25.738 2.867v5.326"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M50.75 50.937v14c0 2.1-1.273 3.062-2.829 3.062-1.555 0-2.827-.961-2.827-3.061v-14h5.655z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M49.41 50.878h-2.977a.387.387 0 0 1-.385-.387V48.24c0-.213.173-.387.385-.387h2.977c.212 0 .385.174.385.387v2.252a.387.387 0 0 1-.385.387z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M36.21 44.613a1.178 1.178 0 0 1 0 2.355 1.178 1.178 0 0 1 0-2.355z"
  })));
};
var ImgRenovation2 = function ImgRenovation2(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M55.827 61.26h1.148c.331 0 .601-.271.601-.604V38.134a.604.604 0 0 0-.6-.605h-1.15a.605.605 0 0 0-.6.605v22.522c0 .333.27.605.6.605M52.081 61.34h-.998a.605.605 0 0 0-.6.604v2.244c0 .333.27.605.6.605h3.51c.33 0-1.91-.272-1.91-.605v-2.244a.605.605 0 0 0-.602-.605"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M68.92 36.067c-.126-.514.2-1.038.73-1.169.528-.13 1.06.18 1.185.694.126.514-.2 1.038-.73 1.168-.528.132-1.06-.179-1.186-.693"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M45.623 64.696H36.57a.44.44 0 0 1-.437-.44v-4.165a.44.44 0 0 1 .437-.44h9.052a.44.44 0 0 1 .436.44v4.165a.44.44 0 0 1-.436.44z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M38.264 63.764a.543.543 0 0 1-.54-.543v-2.097c0-.299.243-.543.54-.543.298 0 .54.244.54.543v2.097a.544.544 0 0 1-.54.543zM41.094 63.764a.544.544 0 0 1-.54-.543v-2.097c0-.299.243-.543.54-.543.297 0 .54.244.54.543v2.097a.543.543 0 0 1-.54.543zM43.95 63.764a.544.544 0 0 1-.54-.543v-2.097c0-.299.243-.543.54-.543.297 0 .54.244.54.543v2.097a.543.543 0 0 1-.54.543zM34.198 64.696h-9.051a.44.44 0 0 1-.437-.44v-4.165a.44.44 0 0 1 .437-.44h9.051a.44.44 0 0 1 .437.44v4.165a.44.44 0 0 1-.437.44z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M26.84 63.764a.543.543 0 0 1-.54-.543v-2.097c0-.299.243-.543.54-.543.297 0 .54.244.54.543v2.097a.544.544 0 0 1-.54.543zM29.67 63.764a.544.544 0 0 1-.54-.543v-2.097c0-.299.243-.543.54-.543.297 0 .54.244.54.543v2.097a.543.543 0 0 1-.54.543zM32.526 63.764a.544.544 0 0 1-.54-.543v-2.097c0-.299.242-.543.54-.543.297 0 .54.244.54.543v2.097a.543.543 0 0 1-.54.543zM42.508 59.57h-9.051a.44.44 0 0 1-.437-.44v-4.166a.44.44 0 0 1 .437-.44h9.051a.44.44 0 0 1 .437.44v4.166a.44.44 0 0 1-.437.44z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M35.15 58.637a.544.544 0 0 1-.54-.543v-2.096c0-.3.243-.544.54-.544.297 0 .54.245.54.544v2.096a.544.544 0 0 1-.54.543zM37.98 58.637a.544.544 0 0 1-.54-.543v-2.096c0-.3.243-.544.54-.544.297 0 .54.245.54.544v2.096a.544.544 0 0 1-.54.543zM40.836 58.637a.544.544 0 0 1-.54-.543v-2.096c0-.3.242-.544.54-.544.297 0 .54.245.54.544v2.096a.544.544 0 0 1-.54.543zM44.266 54.518h-9.052a.44.44 0 0 1-.437-.44v-4.166a.44.44 0 0 1 .437-.44h9.052a.44.44 0 0 1 .437.44v4.166a.44.44 0 0 1-.437.44z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M36.908 53.586a.544.544 0 0 1-.54-.544v-2.096c0-.299.243-.544.54-.544.297 0 .54.245.54.544v2.096a.544.544 0 0 1-.54.544zM39.738 53.586a.544.544 0 0 1-.54-.544v-2.096c0-.299.242-.544.54-.544.297 0 .54.245.54.544v2.096a.544.544 0 0 1-.54.544zM42.593 53.586a.544.544 0 0 1-.54-.544v-2.096c0-.299.243-.544.54-.544.297 0 .54.245.54.544v2.096a.544.544 0 0 1-.54.544z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M25.44 34.004c-.126-.514.201-1.037.73-1.169.53-.13 1.06.18 1.186.694.126.514-.2 1.038-.73 1.169-.529.131-1.06-.18-1.186-.694M50.564 58.132H49.26V56.82c0-.27-.22-.492-.488-.492a.492.492 0 0 0-.49.492v1.31H46.98a.491.491 0 0 0 0 .984h1.303v1.31c0 .271.22.492.489.492a.492.492 0 0 0 .488-.491v-1.311h1.304a.491.491 0 0 0 0-.983M21 35.619v-1.967c0-.172.185-.28.334-.194l1.693.984 1.693.983a.225.225 0 0 1 0 .388l-1.693.983-1.693.983a.222.222 0 0 1-.334-.194V35.62zM69.905 45.014c-.228-.929.362-1.874 1.318-2.11.955-.238 1.915.324 2.142 1.252.228.93-.362 1.874-1.318 2.111-.956.237-1.915-.324-2.142-1.253M67.95 47.087c-.126-.514.2-1.037.73-1.168.529-.132 1.06.18 1.185.693.127.515-.2 1.038-.73 1.17-.528.13-1.06-.18-1.185-.695M67.637 41.967h-1.303v-1.311c0-.27-.22-.492-.489-.492a.492.492 0 0 0-.488.492v1.31h-1.303a.491.491 0 0 0 0 .984h1.303v1.31c0 .271.22.492.488.492a.492.492 0 0 0 .489-.491V42.95h1.303a.491.491 0 0 0 0-.983"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M66.144 37.378H51.931a.56.56 0 0 1-.557-.56v-9.814c0-1.789 1.455-3.253 3.234-3.253h11.536a.56.56 0 0 1 .557.56v12.507a.56.56 0 0 1-.557.56"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M66.144 37.378H51.931a.56.56 0 0 1-.557-.56v-9.814c0-1.789 1.455-3.253 3.234-3.253h11.536a.56.56 0 0 1 .557.56v12.507a.56.56 0 0 1-.557.56zM77.183 32.692h-4.576a.196.196 0 0 1-.195-.196v-4.75c0-.109.088-.196.195-.196h4.576c.107 0 .195.087.195.195v4.751a.196.196 0 0 1-.195.196zM60.24 61.26h-2.405a.605.605 0 0 1-.6-.604V38.134c0-.333.27-.605.6-.605h2.404c.331 0 .602.272.602.605v22.522c0 .333-.27.605-.602.605zM24.701 30.197v-2.419c0-.332.27-.604.601-.604h25.395c.33 0 .6.272.6.604v2.419c0 .332-.27.605-.6.605H25.302a.605.605 0 0 1-.6-.605zM51.639 32.719h27.35"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M28.196 27.139c2.405-.216 31.557-11.013 31.557-11.013l17.43 11.64"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25",
    d: "M59.904 23.649v-7.265"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M65.263 64.161H52.841a.605.605 0 0 1-.601-.605v-1.612c0-.333.27-.605.6-.605h12.423c.33 0 .601.272.601.605v1.612c0 .333-.27.605-.6.605zM34.808 38.765a2.01 2.01 0 0 1-2.003 2.016 2.01 2.01 0 0 1-2.004-2.016c0-.835.505-1.551 1.224-1.857v-5.53M63.616 49.648v6.738"
  })));
};
var ImgRenovation3 = function ImgRenovation3(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M21.157 53.53H20.4a.503.503 0 0 0-.504.5v6.458c0 .275.227.5.504.5h1.511M24.935 38.03h-.756a.503.503 0 0 0-.503.5v5.958c0 .275.226.5.503.5h.756a.503.503 0 0 0 .504-.5v-5.959c0-.275-.227-.5-.504-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M21.408 53.238c0 .05.353.5.126.5h-4.03a.503.503 0 0 1-.504-.5v-6.834c0-.275.227-.5.504-.5h.882l.296 6.374s1.731.187 1.889.187c.157 0 1.039.063 1.039.063l-.202.71z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".675",
    d: "M77.091 44.434l-6.505-10.306a.586.586 0 0 1 .187-.809l4.75-2.953a.596.596 0 0 1 .816.185l6.505 10.306a.586.586 0 0 1-.187.81l-4.751 2.953a.596.596 0 0 1-.815-.186z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".675",
    d: "M72.865 35.396a.725.725 0 0 1 .231-1l2.391-1.487a.737.737 0 0 1 1.008.23.725.725 0 0 1-.231 1l-2.39 1.487a.737.737 0 0 1-1.009-.23zM74.899 38.618a.724.724 0 0 1 .231-1l2.391-1.487a.737.737 0 0 1 1.008.23.724.724 0 0 1-.231 1l-2.39 1.487a.737.737 0 0 1-1.01-.23zM76.951 41.87a.725.725 0 0 1 .232-1.001l2.39-1.486a.737.737 0 0 1 1.009.23.724.724 0 0 1-.232 1l-2.39 1.486a.737.737 0 0 1-1.009-.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M73.153 26.004c-.228-.92.363-1.855 1.322-2.089.96-.235 1.921.32 2.15 1.24.228.92-.364 1.855-1.323 2.09-.959.234-1.921-.321-2.15-1.24M70.767 56.685c-.229-.92.363-1.855 1.322-2.09.96-.234 1.921.322 2.15 1.241.228.92-.364 1.855-1.323 2.09-.959.234-1.921-.321-2.15-1.24M31.833 30.913h-1.307v-1.297a.49.49 0 0 0-.98 0v1.297h-1.308a.49.49 0 0 0-.49.487c0 .267.22.486.49.486h1.307v1.298a.49.49 0 0 0 .98 0v-1.298h1.308a.49.49 0 0 0 .49-.486.49.49 0 0 0-.49-.487M71.283 29.148c-.127-.509.2-1.027.732-1.157.53-.13 1.063.178 1.19.687.126.51-.202 1.027-.733 1.157-.53.13-1.063-.178-1.19-.687M23.294 31.482c-.126-.51.201-1.027.732-1.157.53-.13 1.064.177 1.19.686.126.51-.201 1.028-.732 1.157-.53.13-1.064-.177-1.19-.686M22.393 27.349v-1.947c0-.17.186-.277.335-.192l1.699.974 1.698.973a.22.22 0 0 1 0 .384l-1.698.973-1.699.973a.223.223 0 0 1-.335-.192v-1.946z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M36.817 60.363H22.206a.503.503 0 0 1-.504-.5v-6.834c0-.275.227-.5.504-.5h14.61c.278 0 .505.225.505.5v6.834c0 .275-.227.5-.504.5zM52.435 60.363h-14.61a.503.503 0 0 1-.504-.5v-6.834c0-.275.226-.5.503-.5h14.611c.277 0 .504.225.504.5v6.834c0 .275-.227.5-.504.5zM68.053 60.363h-14.61a.503.503 0 0 1-.504-.5v-6.834c0-.275.227-.5.504-.5h14.61c.278 0 .504.225.504.5v6.834c0 .275-.226.5-.504.5zM40.595 44.613h-14.61a.503.503 0 0 1-.504-.5v-6.834c0-.275.227-.5.504-.5h14.61c.278 0 .504.225.504.5v6.834c0 .275-.226.5-.504.5zM56.214 44.613H41.603a.503.503 0 0 1-.504-.5v-6.834c0-.275.227-.5.504-.5h14.61c.278 0 .504.225.504.5v6.834c0 .275-.226.5-.503.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M71.832 44.613h-14.61a.503.503 0 0 1-.505-.5v-6.834c0-.275.227-.5.504-.5h14.611c.277 0 .504.225.504.5v6.834c0 .275-.227.5-.504.5zM49.412 52.488h-14.61a.503.503 0 0 1-.504-.5v-6.834c0-.275.226-.5.503-.5h14.611c.277 0 .504.225.504.5v6.834c0 .275-.227.5-.504.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M33.92 52.488H19.31a.503.503 0 0 1-.505-.5v-6.834c0-.275.227-.5.504-.5h14.61c.278 0 .505.225.505.5v6.834c0 .275-.227.5-.504.5zM65.03 52.488H50.42a.503.503 0 0 1-.504-.5v-6.834c0-.275.227-.5.504-.5h14.61c.278 0 .504.225.504.5v6.834c0 .275-.226.5-.504.5zM80.775 52.488h-14.61a.503.503 0 0 1-.505-.5v-6.834c0-.275.227-.5.504-.5h14.61c.278 0 .505.225.505.5v6.834c0 .275-.227.5-.504.5z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".675",
    d: "M34.68 25.766c-.172 1.394.478 6.554.83 7.937.075.294.249.645.742.716.202.029.419 0 .603-.056.781-.238.914-.842 1.053-1.35.138-.508.596-1.114 1.477-1.123.511-.005 1.043.207 1.5.073.395-.114.503-.43.877-.566.58-.213 1.268.123 1.902.274 1.036.249 2.366-.091 2.757-.704.147-.231.178-.243.425-.443.314-.256.89-.343 1.422-.389"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M64.259 24.853l-.001.73c0 .862-.705 1.56-1.574 1.56l-9.666-.007a.404.404 0 0 1-.405-.403l.002-3.047c0-.223.182-.402.406-.402l9.666.007c.869 0 1.572.7 1.572 1.562"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M64.259 24.853l-.001.73c0 .862-.705 1.56-1.574 1.56l-9.666-.007a.404.404 0 0 1-.405-.403l.002-3.047c0-.223.182-.402.406-.402l9.666.007c.869 0 1.572.7 1.572 1.562z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M49.445 24.288l3.175.002-.001 1.839-3.176-.003"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M49.04 25.292c0 1.167-1.009 5-1.009 5-5.71.498-13.098-4.337-13.098-4.337v-1.463s7.39-4.832 13.1-4.33c0 0 1.007 3.833 1.007 5v.13z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".675",
    d: "M48.186 34.038c0-.552.451-1 1.008-1 .556 0 1.008.448 1.008 1s-.452 1-1.008 1a1.004 1.004 0 0 1-1.008-1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M33.577 62.87H24.62"
  })));
};
var ImgRenovation4 = function ImgRenovation4(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.038.166h5.086v5.143H.038z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M42.36 37.052h-1.507a.375.375 0 0 0-.379.368l-.71 4.652 2.225.16.75-4.812a.375.375 0 0 0-.379-.368M43.777 22.448h-1.191c-.227 0-.414.1-.414.22l-.827 2.413c0 .12.186.219.414.219h3.386c-.135.018-.117.174-.117.364l-1.212 11.007c0 .202.12.368.268.368h.55l.807-.62 1.337-12.145-3.576-.35.625-1.264-.05-.212"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".675",
    d: "M29.038 54.384a.586.586 0 0 1-.779-.289L23.141 42.94a.598.598 0 0 1 .286-.788l5.047-2.368a.586.586 0 0 1 .78.29l3.742 8.627"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".675",
    d: "M25.228 44.497a.74.74 0 0 1 .353-.975l2.54-1.191a.725.725 0 0 1 .963.357.74.74 0 0 1-.353.974l-2.54 1.192a.725.725 0 0 1-.963-.357zM26.828 47.985a.74.74 0 0 1 .353-.975l2.54-1.191a.725.725 0 0 1 .964.357.74.74 0 0 1-.353.974l-2.54 1.192a.725.725 0 0 1-.964-.357zM28.442 51.504a.74.74 0 0 1 .353-.975l2.54-1.19a.724.724 0 0 1 .964.356.74.74 0 0 1-.353.975l-2.54 1.19a.724.724 0 0 1-.964-.356z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M66.439 22.937h1.34c-.06-1.334-.042-3.323.822-4.148.578-.551 1.38-.596 2.109-.491.227.032.459.08.658.217.612.424.658 1.025.628 1.88.152-.837.816-1.54 1.517-1.453.7.087 1.246 1.108.929 1.873.416-.525 1.21-.291 1.552.307.343.598.332 1.255.198 1.966h1.758"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M51.73 54.669c-.227-.93.36-1.876 1.312-2.113.952-.237 1.906.325 2.133 1.254.227.93-.36 1.876-1.313 2.113-.95.238-1.906-.324-2.132-1.254M33.746 28.413h-1.454v-1.47a.55.55 0 0 0-.545-.551.55.55 0 0 0-.545.551v1.47H29.75a.55.55 0 0 0-.545.55c0 .304.245.552.545.552h1.453v1.47a.55.55 0 0 0 .545.55.55.55 0 0 0 .545-.55v-1.47h1.454a.55.55 0 0 0 .545-.551.55.55 0 0 0-.545-.551"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.75 57.44)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M4.579 2.186H3.126V.716a.55.55 0 0 0-.545-.55.55.55 0 0 0-.545.55v1.47H.583a.55.55 0 0 0-.545.551c0 .303.245.551.545.551h1.453v1.47a.55.55 0 0 0 .545.551.55.55 0 0 0 .545-.551v-1.47h1.453a.55.55 0 0 0 .545-.55.55.55 0 0 0-.545-.552",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M34.037 33.37v-1.968c0-.173.184-.28.332-.194l1.686.984 1.685.984a.226.226 0 0 1 0 .388l-1.685.984-1.686.984a.222.222 0 0 1-.332-.194V33.37zM37.96 31.038c-.163-.67.26-1.352.946-1.523.686-.171 1.375.233 1.539.904.163.67-.26 1.352-.947 1.524-.686.17-1.375-.235-1.538-.905M56.726 56a.978.978 0 0 1 .726-1.17.966.966 0 0 1 1.181.694.978.978 0 0 1-.726 1.17.965.965 0 0 1-1.181-.695M67.995 32.685v-1.969c0-.172.185-.28.332-.194l1.686.984 1.685.984a.226.226 0 0 1 0 .389l-1.685.984-1.686.984a.222.222 0 0 1-.332-.194v-1.968z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M50.836 49.453c0 3.319-2.66 6.009-5.942 6.009s-5.942-2.69-5.942-6.009c0-3.318 2.66-6.008 5.942-6.008 3.281 0 5.942 2.69 5.942 6.008"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M50.836 49.453c0 3.319-2.66 6.009-5.942 6.009s-5.942-2.69-5.942-6.009c0-3.318 2.66-6.008 5.942-6.008 3.281 0 5.942 2.69 5.942 6.008zM60.786 49.68h-9.834"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeWidth: "1.5",
    d: "M41.013 44.727l1.448-7.56c0-.202.185-.368.41-.368h28.732c.226 0 .41.166.41.368V48.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M72.67 49.453c0 3.319-2.661 6.009-5.943 6.009-3.281 0-5.941-2.69-5.941-6.009 0-3.318 2.66-6.008 5.941-6.008 3.282 0 5.942 2.69 5.942 6.008"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M72.67 49.453c0 3.319-2.661 6.009-5.943 6.009-3.281 0-5.941-2.69-5.941-6.009 0-3.318 2.66-6.008 5.941-6.008 3.282 0 5.942 2.69 5.942 6.008zM65.759 36.786h-20.05c-.147 0-.268-.165-.268-.368l1.337-12.144c0-.202.12-.368.267-.368h17.501c.147 0 .267.166.267.368l1.213 12.144c0 .203-.12.368-.267.368z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M55.202 33.467h-5.25a.504.504 0 0 1-.5-.505v-5.31c0-.277.225-.505.5-.505h5.25c.275 0 .5.228.5.506v5.309a.504.504 0 0 1-.5.505zM65.98 23.91H43.633c-.227 0-.413-.1-.413-.22l.827-2.412c0-.121.186-.22.414-.22h20.69c.229 0 .415.099.415.22l.827 2.412c0 .12-.186.22-.413.22z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M37.585 42.706l3.492-.896"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeWidth: "1.5",
    d: "M37.765 44.907l3.062-.506"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M32.923 42.306v9.464l-6.14 3.248h8.382l2.095-6.003-.35-9.181-7.682-5.297zM74.48 35.52v8.96"
  })));
};
var ImgSavings = function ImgSavings(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M55.204 62.087S11.6 67.742 39.243 31.655h-2.831s-24.408 32.517 9.104 32.517h2.073c3.8 0 6.227-.775 7.615-2.085"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M75.41 44.928c1.356.31 2.234.805 2.234 1.363 0 .818-1.892 1.5-4.412 1.663M77.644 48.747c0 .94-2.493 1.701-5.569 1.701-.213 0-.265-.004-.472-.01M77.644 51.393c0 .939-2.493 1.7-5.569 1.7-.699 0-1.367-.039-1.983-.11M77.644 53.944c0 .939-2.493 1.7-5.569 1.7-1.624 0-3.086-.212-4.104-.55M77.644 46.385v7.724M63.299 37.073l2.907-4.221a.636.636 0 0 1 .882-.162l1.048.722"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M64.346 39.002l5.155-7.535a.636.636 0 0 1 .882-.165l9.187 6.297a.638.638 0 0 1 .165.883l-11.17 16.327a.635.635 0 0 1-.882.165"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M64.617 39.154a5.941 5.941 0 0 1 7.774-.925 5.953 5.953 0 0 1 1.546 8.27 5.94 5.94 0 0 1-5.542 2.556"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M77.692 38.47a.578.578 0 1 1-.654.954.578.578 0 0 1 .654-.953M68.854 44.088c.528.292.885.303 1.07.033.068-.1.107-.21.116-.327.01-.116-.049-.274-.174-.474-.082-.13-.125-.222-.129-.277a.224.224 0 0 1 .037-.145.312.312 0 0 1 .204-.145.333.333 0 0 1 .248.068c.203.139.322.367.358.684.036.316-.043.617-.237.9a1.167 1.167 0 0 1-.764.497c-.328.065-.701-.017-1.118-.246l-.18.264c-.017.025-.044.025-.08 0a.37.37 0 0 1-.103-.129c-.035-.062-.046-.102-.034-.12l.122-.178-.074-.051a7.404 7.404 0 0 1-.258-.19l-.174.256c-.017.025-.043.025-.077.002a.376.376 0 0 1-.106-.13c-.034-.063-.046-.103-.033-.12l.141-.208c-.658-.583-.785-1.17-.38-1.76.177-.26.397-.438.66-.534.262-.097.493-.076.692.06.068.046.11.108.126.184a.26.26 0 0 1-.04.21c-.048.07-.101.11-.16.118a.741.741 0 0 1-.231-.017.76.76 0 0 0-.323-.012c-.09.02-.18.096-.27.23a.507.507 0 0 0-.081.46c.05.155.18.322.39.5l.457-.667c.02-.027.046-.029.082-.004.04.026.075.07.108.13s.042.1.03.119l-.425.62.2.143c.062.043.108.072.138.089l.468-.685c.019-.028.046-.03.08-.006.04.027.077.071.11.131.032.06.042.1.029.12l-.415.607zM35.022 19.847l-1.14-.026c-2.056 0-1.142 2.444-1.142 2.444l2.74 3.84h3.35l-3.808-6.258z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M65.593 25.005c-.15-.612.24-1.235.874-1.39.632-.157 1.268.213 1.418.825.15.612-.24 1.236-.873 1.392-.633.156-1.268-.214-1.419-.827M85.623 43.26c-.151-.612.24-1.235.873-1.39.633-.157 1.268.213 1.419.825.15.613-.24 1.236-.873 1.392-.633.156-1.268-.214-1.42-.826M26.032 61.896c-.15-.613.24-1.235.874-1.392.632-.156 1.268.214 1.418.826.151.613-.24 1.236-.873 1.392-.633.156-1.268-.214-1.419-.826M26.467 21.084c-.15-.612.24-1.235.874-1.391.632-.156 1.268.214 1.418.826.151.612-.24 1.235-.873 1.392-.633.156-1.268-.214-1.419-.827M83.653 43.475h-1.559v-1.561a.587.587 0 0 0-.585-.585.587.587 0 0 0-.584.585v1.56h-1.56a.587.587 0 0 0-.584.586c0 .322.263.585.585.585h1.559v1.56c0 .323.263.586.584.586a.587.587 0 0 0 .585-.585v-1.56h1.56a.587.587 0 0 0 .584-.586.587.587 0 0 0-.585-.585M27.216 28.084l-.778-2.208a.266.266 0 0 1 .3-.35l2.3.43 2.298.43c.202.039.287.28.154.436L29.968 28.6l-1.522 1.777a.266.266 0 0 1-.454-.084l-.776-2.209z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M59.914 31.526s24.92 31-9.296 31H48.5c-34.216 0-9.295-31-9.295-31M69.206 59.074c-1.9 3.045-6.584 5.36-12.269 5.724"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M62.631 31.14H36.488a1.899 1.899 0 0 1-1.892-1.894V27.86c0-1.041.851-1.894 1.892-1.894h26.143c1.04 0 1.892.853 1.892 1.894v1.386a1.899 1.899 0 0 1-1.892 1.895z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M61.03 25.192l2.742-3.775s.914-2.402-1.143-2.402l-5.028.114-6.403-3.867a.947.947 0 0 0-.49-.136H48.41a.948.948 0 0 0-.49.136l-6.402 3.867-5.028-.114c-2.057 0-1.143 2.402-1.143 2.402l2.743 3.775"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M44.531 28.338a5.03 5.03 0 0 1 5.028-5.033 5.03 5.03 0 0 1 5.029 5.033 5.03 5.03 0 0 1-5.029 5.033 5.03 5.03 0 0 1-5.028-5.033"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M44.531 28.338a5.03 5.03 0 0 1 5.028-5.033 5.03 5.03 0 0 1 5.029 5.033 5.03 5.03 0 0 1-5.029 5.033 5.03 5.03 0 0 1-5.028-5.033z"
  })));
};
var ImgSearch = function ImgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13 13)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.751 8.97L14.811.7c.036-.276.314-.475.62-.443l33.513 3.506c.306.032.526.283.491.56l-.264 2.499M18.142 3.961l27.79 2.902M17.584 6.863l21.384 2.233",
    stroke: "#AEEDFC",
    strokeWidth: ".5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.144 48.782c-.23-.941.366-1.898 1.33-2.138.965-.24 1.933.328 2.162 1.27.23.94-.366 1.897-1.33 2.137-.964.24-1.932-.329-2.162-1.27",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 15.868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.024 1.103A.855.855 0 01.66.079a.846.846 0 011.035.608.855.855 0 01-.637 1.024.847.847 0 01-1.035-.608",
    fill: "#E2F8FE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.51 3.12h-.644v-.648a.243.243 0 00-.24-.244.243.243 0 00-.242.244v.648h-.643a.243.243 0 000 .487h.643v.649c0 .134.109.243.241.243.133 0 .241-.11.241-.243v-.649h.643a.243.243 0 000-.487M5.04 12.921H3.904v-1.148a.43.43 0 00-.426-.43.43.43 0 00-.427.43v1.148H1.912a.43.43 0 000 .862H3.05v1.148c0 .237.192.43.427.43a.43.43 0 00.426-.43v-1.148h1.138a.43.43 0 000-.862M44.373 43.999v-1.723c0-.15.162-.245.291-.17l1.478.862 1.478.861c.13.076.13.264 0 .34l-1.478.86-1.478.862a.194.194 0 01-.291-.17V44z",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M8.187 14.686h2.708V10.73H8.187zM15.729 38.13s-7.438-2.141-8.25-8.899l-.036-12.905-2.128-.028.125 14.412s1.497 6.64 10.91 8.2l-.622-.78z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.26 41.249h10.397M10.33 14.395V10.64a1.78 1.78 0 011.77-1.788h26.465v-.636a1.78 1.78 0 011.772-1.789h10.967c.978 0 1.772.801 1.772 1.789v13.336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.001 14.491H9.223c-.979 0-1.772.8-1.772 1.788V29.56s.995 8.707 10.285 8.707h17.127",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.032 26.627c0-7.247 5.82-13.122 13-13.122s13 5.875 13 13.122-5.82 13.121-13 13.121-13-5.874-13-13.121z",
    stroke: "#2C3B45",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.635 26.627c0-5.238 4.207-9.485 9.397-9.485s9.396 4.247 9.396 9.485c0 5.238-4.207 9.484-9.396 9.484-5.19 0-9.397-4.246-9.397-9.484z",
    stroke: "#2C3B45",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.302 52.655a2.733 2.733 0 01-3.88-.266l-8.574-9.918a.72.72 0 01.068-1.01l3.076-2.71a.704.704 0 011 .07l8.574 9.918a2.794 2.794 0 01-.264 3.916",
    fill: "#00B3DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.302 52.655h0a2.733 2.733 0 01-3.88-.266l-8.574-9.918a.72.72 0 01.068-1.01l3.076-2.71a.704.704 0 011 .07l8.574 9.918a2.794 2.794 0 01-.264 3.916z",
    stroke: "#2C3B45",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M50.49 35.82l2.958 3.422-1.978 1.741-2.959-3.422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.814 32.162H38.63a.712.712 0 01-.708-.715v-9.27c0-.394.317-.714.708-.714h9.184c.391 0 .708.32.708.715v9.27a.712.712 0 01-.708.714",
    fill: "#AEEDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.814 32.162H38.63a.712.712 0 01-.708-.715v-9.27c0-.394.317-.714.708-.714h9.184c.391 0 .708.32.708.715v9.27a.712.712 0 01-.708.714z",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3 28.916c0-.207.056-.363.165-.47.11-.105.27-.158.48-.158.203 0 .36.054.47.162.112.109.167.264.167.466 0 .195-.056.348-.168.46-.112.112-.269.168-.469.168-.205 0-.364-.055-.476-.164-.112-.11-.168-.264-.168-.464zm.118-1.264v-.274c0-.236.05-.442.15-.617.1-.175.283-.361.55-.558.256-.185.425-.335.506-.451a.658.658 0 00.123-.388.421.421 0 00-.176-.366c-.117-.084-.28-.126-.49-.126-.367 0-.784.12-1.253.362l-.399-.81a3.462 3.462 0 011.732-.461c.503 0 .903.122 1.2.366.296.244.445.57.445.976 0 .27-.062.505-.184.702-.122.197-.354.419-.695.665-.235.175-.383.308-.445.4a.623.623 0 00-.094.358v.222h-.97z",
    fill: "#2C3B45",
    mask: "url(#d)"
  })));
};
var ImgSearchInput = function ImgSearchInput(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M40.946 39.595H15.42a.42.42 0 0 1-.42-.42v-9.631a.42.42 0 0 1 .42-.419h.926l.125 8.683.934.436 22.793-.249.748 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M34.407 27.155c.046-.246.162-.503.347-.772.285-.413.616-.657.992-.733.375-.075.768.028 1.176.31.394.27.625.6.693.984l-3.208.211zm-.976-2.388l-.25-.623c-.215-.54-.287-1.054-.216-1.545.071-.49.324-1.082.757-1.776.422-.657.675-1.154.758-1.493.082-.34.059-.672-.071-.998-.146-.365-.392-.589-.738-.672-.346-.083-.761-.029-1.245.164-.843.336-1.695.995-2.555 1.975l-1.657-1.478a8.654 8.654 0 0 1 3.57-2.644c1.158-.461 2.19-.55 3.096-.267.905.285 1.543.89 1.913 1.816.247.618.32 1.207.218 1.769-.102.561-.434 1.28-.997 2.155-.38.614-.601 1.053-.661 1.318-.061.266-.024.566.11.903l.203.505-2.235.891z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M38.497 27.209a1.59 1.59 0 0 1 .272-.605c.223-.324.483-.516.777-.575.295-.059.602.022.923.242.309.213.49.47.543.772m-4.071-9.007c.707-.204 1.35-.217 1.926-.036.71.223 1.21.697 1.5 1.424.194.484.25.946.171 1.386-.08.44-.34 1.004-.782 1.69-.298.482-.47.826-.518 1.034-.048.208-.018.444.087.708l.159.396-1.753.699-.195-.49c-.17-.422-.226-.826-.17-1.21.056-.385.254-.85.594-1.393.33-.515.528-.905.594-1.17a1.255 1.255 0 0 0-.056-.783c-.114-.286-.307-.462-.579-.527-.271-.066-.597-.023-.976.128a3.52 3.52 0 0 0-.317.146"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M70.574 22.805c-.125-.507.199-1.022.724-1.151.524-.13 1.051.176 1.176.683.125.506-.199 1.022-.724 1.15-.525.13-1.051-.176-1.176-.682M78.395 22.944h-1.293v-1.291a.486.486 0 0 0-.97 0v1.29H74.84a.486.486 0 0 0-.485.485c0 .266.218.484.485.484h1.292v1.292a.486.486 0 0 0 .97 0v-1.292h1.293a.486.486 0 0 0 .485-.484.486.486 0 0 0-.485-.484M32.75 46.19c-.125-.506.2-1.022.724-1.151.525-.13 1.052.177 1.177.683.125.507-.2 1.022-.724 1.151-.525.13-1.052-.176-1.177-.683M34.475 43.061c-.226-.915.36-1.846 1.308-2.079.948-.233 1.9.32 2.125 1.234.226.915-.36 1.846-1.307 2.08-.949.233-1.9-.32-2.126-1.235M39.54 46.182v-1.937c0-.17.185-.276.332-.191l1.68.969 1.679.968a.22.22 0 0 1 0 .382l-1.68.968-1.68.969a.22.22 0 0 1-.33-.191v-1.937z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M71.275 27.632h5.414c.23 0 .42.189.42.42v9.631a.42.42 0 0 1-.42.42h-4.978M40.821 38.102H16.914a.42.42 0 0 1-.42-.419v-9.632a.42.42 0 0 1 .42-.419h23.72M20.083 30.2v5.473"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M40.144 33.203c0-8.817 7.156-15.965 15.985-15.965s15.986 7.148 15.986 15.965c0 8.816-7.157 15.964-15.986 15.964S40.144 42.02 40.144 33.203z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M44.575 33.203c0-6.373 5.173-11.54 11.554-11.54 6.382 0 11.555 5.167 11.555 11.54 0 6.372-5.173 11.539-11.555 11.539-6.381 0-11.554-5.167-11.554-11.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M83.997 64.45l-.966.842a2.743 2.743 0 0 1-3.867-.263L68.09 52.355a.704.704 0 0 1 .068-.995l4.032-3.513a.707.707 0 0 1 .997.067L84.26 60.588a2.734 2.734 0 0 1-.263 3.862"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M83.997 64.45l-.966.842a2.743 2.743 0 0 1-3.867-.263L68.09 52.355a.704.704 0 0 1 .068-.995l4.032-3.513a.707.707 0 0 1 .997.067L84.26 60.588a2.734 2.734 0 0 1-.263 3.862z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M67.759 44.387l3.638 4.163-2.433 2.12-3.638-4.164"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M82.64 53.939l-5.36-5.84"
  })));
};
var ImgSms = function ImgSms(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M1.321.136C.611.136.035.637.035 1.256v4.48c0 .619.576 1.12 1.286 1.12h18.007c.71 0 1.286-.502 1.286-1.12v-4.48c0-.619-.576-1.12-1.286-1.12H1.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M1.442.156h12.219c.71 0 1.286.502 1.286 1.12v4.48c0 .62-.576 1.12-1.286 1.12H1.442c-.71 0-1.286-.5-1.286-1.12v-4.48c0-.618.576-1.12 1.286-1.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M1.442.156h12.219c.71 0 1.286.502 1.286 1.12v4.48c0 .62-.576 1.12-1.286 1.12H1.442c-.71 0-1.286-.5-1.286-1.12v-4.48c0-.618.576-1.12 1.286-1.12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M1.53.177C.82.177.244.678.244 1.297v4.48c0 .619.575 1.12 1.286 1.12h16.076c.711 0 1.287-.501 1.287-1.12v-4.48c0-.619-.576-1.12-1.287-1.12H1.53z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M62.462 13.818v-2.623c0-.532.438-.967.974-.967h18.342c.536 0 .974.435.974.967v5.748a.973.973 0 0 1-.974.966h-.296v2.045l-2.005-2.045H64.295M78.111 37.908h-.295v2.045l-2.006-2.045h-6.416a.973.973 0 0 1-.974-.967v-5.748c0-.531.438-.966.974-.966h8.717c.536 0 .975.435.975.966v5.748a.973.973 0 0 1-.975.967zM63.808 20.171h14.246c.536 0 .974.435.974.966v5.748a.973.973 0 0 1-.974.966h-9.749l-2.01 2.046.005-2.045h-2.363l-.13-7.681z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M40.46 67.589c0 .658-.556 1.19-1.242 1.19-.686 0-1.242-.532-1.242-1.19 0-.658.556-1.191 1.242-1.191.686 0 1.243.533 1.243 1.19M73.642 56.798h-1.034v-1.026a.387.387 0 0 0-.776 0v1.026h-1.034a.387.387 0 0 0-.388.384c0 .212.175.385.388.385h1.034v1.025a.387.387 0 0 0 .776 0v-1.025h1.034a.387.387 0 0 0 .388-.385.387.387 0 0 0-.388-.384M67.748 64.273v-1.828c0-.16.175-.26.315-.18l1.596.914 1.595.913c.14.08.14.28 0 .361l-1.595.913-1.596.914a.21.21 0 0 1-.315-.18v-1.827z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M35.773 61.171c0 1.335 7.847 2.075 6.501 2.075h-7.62a2.426 2.426 0 0 1-2.436-2.415V17.145a2.426 2.426 0 0 1 2.436-2.416h1.261l-.142 46.442z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M67.944 58.505c0 .548-.464.992-1.035.992-.572 0-1.036-.444-1.036-.992s.464-.993 1.036-.993c.571 0 1.035.445 1.035.993M27.908 53.35l-1.67 1.27-1.28-1.655a.796.796 0 0 0-1.107-.145.78.78 0 0 0-.146 1.097l1.281 1.656-1.67 1.27a.78.78 0 0 0-.146 1.098.796.796 0 0 0 1.107.144l1.67-1.27 1.28 1.656a.796.796 0 0 0 1.107.145.781.781 0 0 0 .146-1.098l-1.281-1.655 1.67-1.27a.78.78 0 0 0 .146-1.098.796.796 0 0 0-1.107-.145"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M61.515 62.624H37.908a2.426 2.426 0 0 1-2.436-2.416V16.065a2.426 2.426 0 0 1 2.436-2.415h23.607c.327 0 .638.063.923.18a2.416 2.416 0 0 1 1.513 2.235V60.21a2.426 2.426 0 0 1-2.436 2.415zM41.485 17.608h16.452"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M49.67 58.622h.083"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M66.891 43.041v11.485"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M40.708 25.583h18.006c.71 0 1.286.502 1.286 1.12v4.48c0 .619-.575 1.12-1.286 1.12H40.708c-.71 0-1.286-.501-1.286-1.12v-4.48c0-.618.576-1.12 1.286-1.12"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.387 25.447)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M-425.042 243.75h870.09v-451.947h-870.09z",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M-3.18 9.656h27.01v-12.32H-3.18z",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M43.602 35.104H55.82c.71 0 1.286.501 1.286 1.12v4.48c0 .619-.575 1.12-1.286 1.12H43.602c-.71 0-1.286-.501-1.286-1.12v-4.48c0-.619.575-1.12 1.286-1.12"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.16 34.948)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M-424.921 234.25h870.09v-451.947h-870.09z",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.16 34.948)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M-3.06 9.677h21.222V-2.644H-3.059z",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M41.673 44.624H57.75c.71 0 1.286.502 1.286 1.12v4.48c0 .62-.576 1.12-1.286 1.12H41.673c-.71 0-1.287-.5-1.287-1.12v-4.48c0-.618.576-1.12 1.287-1.12"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.143 44.447)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M-424.834 224.75h870.09v-451.947h-870.09z",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M-2.972 9.697h25.08v-12.32h-25.08z",
    mask: "url(#h)"
  }))));
};
var ImgSoftkey = function ImgSoftkey(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M.25.125h.125V.25H.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.25.125h.125V.25H.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M.25.125h.125V.25H.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M.133.052h4.698V4.75H.133z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M0 .226h3.814v4.336H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2E3B45",
    d: "M44.648 48.525h-.203a.027.027 0 0 0-.024.013l-.148.244-.314-.538a.027.027 0 0 0-.024-.013h-.241a.027.027 0 0 0-.024.013.026.026 0 0 0 0 .027l.44.752v.554c0 .015.012.027.027.027h.214a.027.027 0 0 0 .027-.027v-.535l.293-.476a.028.028 0 0 0 0-.027.027.027 0 0 0-.023-.014"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E3B45",
    d: "M45.678 48.23h-1.055a.027.027 0 0 0-.023.013l-.097.16a.028.028 0 0 0 0 .028.027.027 0 0 0 .023.013h.423v1.133c0 .014.013.027.027.027h.215a.027.027 0 0 0 .027-.027v-1.133h.393c.01 0 .02-.006.024-.016l.068-.16a.028.028 0 0 0-.002-.025.027.027 0 0 0-.023-.012M42.594 49.554l-.665-.666.6-.612a.028.028 0 0 0 .006-.03.027.027 0 0 0-.025-.015h-.27a.027.027 0 0 0-.02.008l-.58.636v-.618a.027.027 0 0 0-.027-.026H41.4a.027.027 0 0 0-.028.026v1.32c0 .014.013.027.028.027h.214a.027.027 0 0 0 .027-.027v-.62l.61.638a.027.027 0 0 0 .018.009h.311a.027.027 0 0 0 .027-.027.027.027 0 0 0-.012-.023M49.368 48.403a.69.69 0 0 0-.245-.143.981.981 0 0 0-.321-.05 2.158 2.158 0 0 0-.441.042.026.026 0 0 0-.022.026v1.272c0 .012.008.023.02.026a1.735 1.735 0 0 0 .44.054.942.942 0 0 0 .318-.05.661.661 0 0 0 .402-.369.722.722 0 0 0 .055-.288.79.79 0 0 0-.052-.295.62.62 0 0 0-.154-.225m-.111.71a.458.458 0 0 1-.248.272.498.498 0 0 1-.21.041.756.756 0 0 1-.118-.01l-.074-.013v-.99h.138c.088 0 .167.014.235.04a.447.447 0 0 1 .274.266.58.58 0 0 1 .003.394M43.587 49.392h-.586v-.382h.383c.01 0 .02-.007.024-.016l.066-.15a.027.027 0 0 0-.003-.026.026.026 0 0 0-.022-.012H43v-.372h.477c.01 0 .02-.006.025-.016l.068-.15a.027.027 0 0 0-.025-.037h-.787a.027.027 0 0 0-.027.027v1.319c0 .015.013.027.027.027h.738c.01 0 .018-.005.023-.014l.09-.158a.027.027 0 0 0 0-.027.028.028 0 0 0-.023-.013M47.67 48.246a.027.027 0 0 0-.025-.017h-.233a.028.028 0 0 0-.022.012.027.027 0 0 0-.002.026l.045.1-.497 1.199a.027.027 0 0 0 .024.038h.204a.027.027 0 0 0 .025-.017l.115-.294h.49l.118.294c.004.01.014.017.024.017h.237a.027.027 0 0 0 .026-.027.028.028 0 0 0-.005-.016l-.524-1.315zm-.288.843l.166-.421.166.421h-.332zM50.574 49.392h-.585v-.382h.382c.01 0 .02-.007.025-.016l.065-.15a.026.026 0 0 0-.002-.026.027.027 0 0 0-.022-.012h-.448v-.372h.477c.01 0 .02-.006.024-.016l.068-.15a.028.028 0 0 0-.001-.025.028.028 0 0 0-.023-.012h-.787a.027.027 0 0 0-.027.027v1.319c0 .015.012.027.027.027h.737c.01 0 .019-.005.023-.014l.09-.158a.028.028 0 0 0 0-.027.028.028 0 0 0-.023-.013"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E3B45",
    d: "M46.946 49.555l-.47-.563a.613.613 0 0 0 .162-.115.458.458 0 0 0 .079-.115.339.339 0 0 0 .033-.151.36.36 0 0 0-.043-.178.37.37 0 0 0-.117-.125.544.544 0 0 0-.171-.074.854.854 0 0 0-.211-.024 1.77 1.77 0 0 0-.407.042.027.027 0 0 0-.022.026v1.299c0 .015.012.027.027.027h.215a.027.027 0 0 0 .026-.027v-.508h.175l.415.524c.005.007.013.01.02.01h.273a.027.027 0 0 0 .027-.026.027.027 0 0 0-.011-.022m-.526-.77a.355.355 0 0 1-.11.087h-.263v-.458h.1c.117 0 .204.018.258.053.052.033.077.086.077.164 0 .032-.006.06-.017.085a.298.298 0 0 1-.045.07"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 69.237)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 69.237)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 69.237)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M41.79 50.23c.007-.002.012-.005.018-.008a.228.228 0 0 0 .049-.033.171.171 0 0 0 .037-.047.134.134 0 0 0 .014-.063.121.121 0 0 0-.021-.07.183.183 0 0 0-.06-.052.354.354 0 0 0-.092-.034.53.53 0 0 0-.114-.011 1.517 1.517 0 0 0-.241.019.01.01 0 0 0-.009.01v.616a.01.01 0 0 0 .009.01l.042.007a.88.88 0 0 0 .133.016.981.981 0 0 0 .076.003.525.525 0 0 0 .12-.012.324.324 0 0 0 .098-.038.192.192 0 0 0 .064-.061.15.15 0 0 0 .024-.083.157.157 0 0 0-.046-.116.232.232 0 0 0-.1-.053zm-.075-.2c.03.018.043.04.044.068a.098.098 0 0 1-.023.066.156.156 0 0 1-.049.041h-.172v-.203h.069c.056 0 .1.01.13.028zm-.2.261h.092c.056 0 .1.009.132.025a.087.087 0 0 1 .035.03.084.084 0 0 1 .01.045.09.09 0 0 1-.043.08.227.227 0 0 1-.125.03.349.349 0 0 1-.073-.006l-.028-.008v-.196zM42.37 49.925a.01.01 0 0 0-.01-.005h-.133c-.003 0-.007.001-.008.004a.01.01 0 0 0 0 .01l.025.05-.285.581a.01.01 0 0 0 0 .01.01.01 0 0 0 .01.004h.116a.01.01 0 0 0 .01-.005l.066-.145h.29l.068.145a.01.01 0 0 0 .009.005h.134a.01.01 0 0 0 .009-.004.01.01 0 0 0 0-.01l-.301-.64zm-.065.193l.102.218h-.204l.102-.218zM43.405 49.92H43.3l-.007.004-.003.007v.417l-.442-.424-.006-.003h-.156c-.004 0-.007.002-.009.006a.01.01 0 0 0 .002.011l.08.077v.555l.003.007.007.003h.104l.007-.003.003-.007v-.436l.458.443.007.003h.057l.007-.003.003-.007v-.64l-.003-.006-.007-.003M44.23 50.562l-.385-.326.346-.298a.01.01 0 0 0 .003-.01.01.01 0 0 0-.01-.007h-.155l-.007.002-.342.317v-.31l-.003-.007-.007-.002h-.123l-.007.002-.003.008v.638l.003.008.007.002h.123l.007-.002.003-.008v-.31l.359.318.007.002h.177a.01.01 0 0 0 .01-.006.01.01 0 0 0-.003-.011M38.986 48.128a.081.081 0 0 0 .082-.098l-.087-.497a.123.123 0 0 0-.117-.098h-.082a.123.123 0 0 0-.117.098l-.088.497a.081.081 0 0 0 .083.098h.326M39.015 48.441a.198.198 0 0 0-.151-.085h-.082a.198.198 0 0 0-.152.085l-1.228 2.019a.124.124 0 0 0 .022.151l.125.096a.093.093 0 0 0 .135-.018l1.08-1.505c.033-.044.085-.044.117 0l1.08 1.505a.092.092 0 0 0 .136.018l.124-.096a.125.125 0 0 0 .023-.151l-1.229-2.019M38.303 48.38c.028-.046.007-.093-.047-.103l-1.222-.222a.137.137 0 0 0-.14.072l-.057.136a.096.096 0 0 0 .06.125l1.07.361a.13.13 0 0 0 .146-.053l.19-.315M39.536 48.695a.13.13 0 0 0 .145.054l1.068-.36a.096.096 0 0 0 .06-.126l-.057-.136a.137.137 0 0 0-.14-.072l-1.22.222c-.054.01-.075.056-.046.103l.19.315"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M29.909 61.23c0 1.334 8.656 1.825 7.322 1.825h-7.557a2.416 2.416 0 0 1-2.416-2.416V16.953a2.416 2.416 0 0 1 2.416-2.416l.25 1.75-.015 44.943z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25",
    d: "M35.788 17.485h16.315M53.725 65.16h-7.474"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M58.977 13.852c-.125-.509.2-1.026.727-1.156.527-.13 1.055.177 1.18.686.126.51-.2 1.027-.726 1.157-.527.13-1.055-.178-1.18-.687M21.496 20.45c-.226-.92.361-1.855 1.313-2.09.951-.234 1.906.322 2.133 1.241.226.92-.361 1.855-1.313 2.09-.951.234-1.906-.321-2.133-1.24M22.983 29.129c-.125-.51.2-1.027.727-1.157.526-.13 1.055.177 1.18.686.126.51-.2 1.028-.726 1.157-.527.13-1.056-.177-1.18-.686M58.666 8.784h-1.297V7.487A.488.488 0 0 0 56.881 7a.488.488 0 0 0-.487.487v1.297h-1.297a.488.488 0 0 0-.487.487c0 .267.219.486.487.486h1.297v1.298a.488.488 0 0 0 .973 0V9.757h1.298a.488.488 0 0 0 .486-.486.488.488 0 0 0-.486-.487"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.5 64.737)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M4.64 3.634L3.408 2.401l1.234-1.233a.655.655 0 0 0 0-.925.655.655 0 0 0-.925 0L2.482 1.476 1.25.243a.656.656 0 0 0-.925 0 .656.656 0 0 0 0 .925L1.558 2.4.324 3.634a.656.656 0 0 0 0 .925c.255.255.67.255.925 0l1.233-1.233 1.234 1.233c.254.255.67.255.925 0a.656.656 0 0 0 0-.925",
    mask: "url(#h)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M24.974 60.576h-1.048v-1.048a.394.394 0 0 0-.394-.394.394.394 0 0 0-.393.394v1.048h-1.048a.394.394 0 0 0-.393.393c0 .216.177.393.393.393h1.048v1.049a.394.394 0 0 0 .787 0v-1.049h1.048a.394.394 0 0 0 .393-.393.394.394 0 0 0-.393-.393"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.25 23.736)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M0 2.394V.448C0 .277.184.17.332.256l1.686.973 1.685.973a.222.222 0 0 1 0 .384l-1.685.973-1.686.973A.222.222 0 0 1 0 4.34V2.394z",
    mask: "url(#j)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M59.998 60.653v-1.306c0-.115.125-.187.224-.129l1.13.653 1.132.653c.1.057.1.2 0 .258l-1.131.653-1.131.653a.149.149 0 0 1-.224-.129v-1.306z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M50.892 45.954H36.774a.377.377 0 0 1-.376-.376V32.227c0-.207.17-.376.376-.376h14.118c.207 0 .376.17.376.376v13.351c0 .207-.169.376-.376.376"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25",
    d: "M50.892 45.954H36.774a.377.377 0 0 1-.376-.376V32.227c0-.207.17-.376.376-.376h14.118c.207 0 .376.17.376.376v13.351c0 .207-.169.376-.376.376z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M38.28 33.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853M40.78 33.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M42.415 33.922a.427.427 0 1 1-.77-.37.427.427 0 0 1 .77.37"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M43.28 33.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M44.53 33.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E84C3D",
    d: "M47.03 33.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853M48.28 33.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M49.53 33.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M38.28 34.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M39.53 34.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E84C3D",
    d: "M40.78 34.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M42.03 34.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M43.28 34.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M44.53 34.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M45.78 34.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853M48.28 34.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M49.53 34.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M38.28 36.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E84C3D",
    d: "M42.03 36.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M45.78 36.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M47.03 36.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M48.28 36.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M49.53 36.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853M38.28 37.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E84C3D",
    d: "M39.53 37.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M40.78 37.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853M43.28 37.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E84C3D",
    d: "M47.03 37.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853M48.28 37.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853M38.28 39.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M40.78 39.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853M42.03 39.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M43.28 39.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853M45.78 39.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E84C3D",
    d: "M47.03 39.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M48.28 39.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M49.53 39.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E84C3D",
    d: "M38.28 40.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M39.53 40.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M40.78 40.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E84C3D",
    d: "M42.03 40.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853M43.28 40.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M44.53 40.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853M48.28 40.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853M39.53 42.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M40.78 42.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E84C3D",
    d: "M43.28 42.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M44.53 42.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M45.78 42.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E84C3D",
    d: "M49.53 42.31a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M39.53 43.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M40.78 43.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M42.03 43.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M43.28 43.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E84C3D",
    d: "M44.53 43.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853M45.78 43.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853M47.03 43.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M49.53 43.81a.427.427 0 1 1 0 .853.427.427 0 0 1 0-.853M71.779 49.65H58.513a.575.575 0 0 1-.573-.574V28.73c0-.315.258-.574.573-.574h13.266c.315 0 .573.259.573.574v20.347a.575.575 0 0 1-.573.574"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25",
    d: "M71.779 49.65H58.513a.575.575 0 0 1-.573-.574V28.73c0-.315.258-.574.573-.574h13.266c.315 0 .573.259.573.574v20.347a.575.575 0 0 1-.573.574z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M58.859 31.311a.65.65 0 1 1-1.173-.563.65.65 0 0 1 1.173.563"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M60.178 30.38a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M62.083 30.38a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E84C3D",
    d: "M65.893 30.38a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3M67.798 30.38a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M69.703 30.38a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M58.273 32.666a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M60.178 32.666a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M62.083 32.666a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M63.988 32.666a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3M67.798 32.666a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M69.703 32.666a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E84C3D",
    d: "M58.273 34.952a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M63.988 34.952a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M65.893 34.952a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M67.798 34.952a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M69.703 34.952a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M60.178 37.238a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E84C3D",
    d: "M65.893 37.238a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3M67.798 37.238a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M58.273 39.524a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M60.178 39.524a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3M63.988 39.524a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E84C3D",
    d: "M65.893 39.524a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M67.798 39.524a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M69.703 39.524a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E84C3D",
    d: "M58.273 41.81a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3M60.178 41.81a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M62.083 41.81a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3M67.798 41.81a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E84C3D",
    d: "M60.178 44.096a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M62.083 44.096a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M63.988 44.096a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E84C3D",
    d: "M69.703 44.096a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M58.273 46.382a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M60.178 46.382a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E84C3D",
    d: "M62.083 46.382a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3M63.988 46.382a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3M65.893 46.382a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M69.703 46.382a.65.65 0 1 1 0 1.3.65.65 0 0 1 0-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.25",
    d: "M55.539 62.5h-23.41a2.416 2.416 0 0 1-2.417-2.415V15.941a2.416 2.416 0 0 1 2.416-2.416h23.41a2.413 2.413 0 0 1 2.416 2.416v44.144a2.416 2.416 0 0 1-2.415 2.416z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "44",
    cy: "58",
    r: "1",
    fill: "#2C3B45",
    stroke: "#2C3B45"
  })));
};
var ImgWallet = function ImgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M26.238 29.145h-1.742c-.769 0-1.398.612-1.398 1.36v28.822c0 .748.629 1.36 1.398 1.36h3.093l-1.48-1.77.13-29.772z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M84.106 52.056c0 .974-2.614 1.765-5.838 1.765-3.225 0-5.84-.79-5.84-1.765 0-.61 1.022-1.147 2.575-1.464.932-.19 2.055-.302 3.265-.302 3.224 0 5.838.791 5.838 1.766zM84.106 54.605c0 .975-2.614 1.765-5.838 1.765-3.225 0-5.84-.79-5.84-1.765M84.106 57.35c0 .976-2.614 1.766-5.838 1.766-3.225 0-5.84-.79-5.84-1.765M84.106 59.998c0 .975-2.614 1.765-5.838 1.765-3.225 0-5.84-.79-5.84-1.765M84.141 52.154v8.015"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".54",
    d: "M72.466 52.154v8.015"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M77.27 50.26c-1.434-.321-2.363-.837-2.363-1.418 0-.975 2.614-1.765 5.839-1.765 3.224 0 5.838.79 5.838 1.765 0 .788-2.039 1.62-4.398 1.847M86.584 51.391c0 .61-1.02 1.147-2.574 1.464M86.584 54.137c0 .59-.954 1.11-2.422 1.431M86.584 56.785c0 .586-.946 1.106-2.402 1.427M86.62 48.94v8.016"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".54",
    d: "M74.944 48.94V50.538"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M65.863 64.44c0 .868-.729 1.57-1.628 1.57-.9 0-1.629-.702-1.629-1.57 0-.867.73-1.57 1.629-1.57.9 0 1.628.703 1.628 1.57M26.51 64.408c0 .867-.73 1.57-1.63 1.57-.899 0-1.628-.703-1.628-1.57 0-.867.73-1.57 1.629-1.57.9 0 1.628.703 1.628 1.57M83.196 17.546c0 1.405-1.182 2.545-2.64 2.545-1.458 0-2.64-1.14-2.64-2.545 0-1.406 1.182-2.546 2.64-2.546 1.458 0 2.64 1.14 2.64 2.546M79.933 25.731h-1.356V24.38a.509.509 0 0 0-1.016 0v1.352h-1.356a.51.51 0 0 0-.508.507.51.51 0 0 0 .508.508h1.356v1.352a.509.509 0 0 0 1.016 0v-1.352h1.356a.51.51 0 0 0 .508-.508.51.51 0 0 0-.508-.507M72.819 64.036h-1.356v-1.352a.51.51 0 0 0-1.016 0v1.352H69.09a.51.51 0 0 0-.508.507.51.51 0 0 0 .508.508h1.356v1.352a.509.509 0 0 0 1.016 0V65.05h1.356a.51.51 0 0 0 .508-.508.51.51 0 0 0-.508-.507M68.995 19.13v-2.409c0-.211.23-.343.413-.238l2.091 1.205 2.091 1.205a.274.274 0 0 1 0 .475L71.5 20.573l-2.091 1.204a.275.275 0 0 1-.413-.237v-2.41zM18.714 29.208l-1.317-2.02a.274.274 0 0 1 .216-.423l2.412-.128 2.411-.129a.275.275 0 0 1 .26.399L21.6 29.055l-1.094 2.147a.275.275 0 0 1-.476.025l-1.317-2.02zM65.888 21.117c0 .722-.608 1.308-1.357 1.308-.75 0-1.357-.586-1.357-1.308 0-.723.607-1.309 1.357-1.309s1.357.586 1.357 1.309M19.422 34.835l-2.188 1.675-1.679-2.184a1.033 1.033 0 1 0-1.642 1.256l1.68 2.184-2.19 1.675a1.033 1.033 0 0 0-.19 1.447c.346.45.998.536 1.45.19l2.188-1.674 1.679 2.183a1.034 1.034 0 1 0 1.642-1.256l-1.68-2.183 2.19-1.675c.45-.346.537-.997.19-1.447a1.039 1.039 0 0 0-1.45-.19"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M54.944 25.265a6.195 6.195 0 0 0-5.606-.134c-1.19.567-2.116 1.3-2.719 2.366l-3.432-.266-1.446-3.015a.66.66 0 0 1 .312-.88l10.46-4.988a.664.664 0 0 1 .882.31l2.267 4.733M53.981 19.787l3.709-1.768a.663.663 0 0 1 .881.31l2.268 4.732"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M45.629 63.693h-15.18M72.13 51.497v7.054a1.4 1.4 0 0 1-1.397 1.394H27.129a1.4 1.4 0 0 1-1.398-1.394V28.994a1.4 1.4 0 0 1 1.398-1.395h43.604a1.4 1.4 0 0 1 1.397 1.395v13.191M71.8 35.18H34.793"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M75.104 51.003H64.2c-2.362 0-4.295-1.928-4.295-4.285s1.933-4.285 4.295-4.285h10.904v8.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M38.732 35.27l21.163-13.487 8.627 13.473z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.35",
    d: "M38.732 35.27l21.163-13.487 8.627 13.473z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M63.21 46.718c0-.91.739-1.648 1.651-1.648a1.65 1.65 0 0 1 1.652 1.648c0 .91-.74 1.648-1.652 1.648a1.65 1.65 0 0 1-1.652-1.648"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.35",
    d: "M26.533 56.442h1.982"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeDasharray: "3.768659777941707,3.768659777941707",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M32.285 56.442h35.813"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.35",
    d: "M69.983 56.442h1.982"
  })));
};
var ImgWelcome = function ImgWelcome(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.354 21.565h1.222c-.055-1.228-.04-3.06.748-3.818.527-.508 1.256-.549 1.921-.453.207.03.419.074.6.2.558.39.6.943.572 1.731.138-.77.744-1.418 1.382-1.338.638.081 1.136 1.02.846 1.724.38-.482 1.102-.267 1.414.283.313.55.303 1.155.18 1.81h1.602M28.364 46.941h-2.52c.055-1.228.038-2.661-.749-3.42-.527-.508-1.256-.549-1.92-.453-.208.03-.42.074-.6.2-.558.39-.6 1.341-.573 2.13-.138-.77-.743-1.419-1.382-1.338-.638.08-1.135 1.02-.846 1.724-.379-.483-1.101-.268-1.414.282-.312.55-.302 1.156-.18 1.81h-.952",
    stroke: "#AEEDFC",
    strokeWidth: ".5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.322 34.287c-.206-.856.329-1.727 1.196-1.945a1.587 1.587 0 011.943 1.154c.207.856-.329 1.727-1.196 1.946a1.587 1.587 0 01-1.943-1.155M22.746 56.671a.9.9 0 01.662-1.077.879.879 0 011.076.64.9.9 0 01-.662 1.076.879.879 0 01-1.076-.639M71.942 36.192a.9.9 0 01.662-1.077.878.878 0 011.075.639.9.9 0 01-.662 1.077.878.878 0 01-1.075-.64M22.807 52.41c-.206-.857.329-1.728 1.196-1.946a1.587 1.587 0 011.943 1.155c.206.856-.329 1.727-1.196 1.945a1.587 1.587 0 01-1.943-1.155M36.025 39.407a.9.9 0 01.662-1.077.879.879 0 011.075.64.9.9 0 01-.662 1.077.879.879 0 01-1.075-.64M76.246 39.411h-1.182v-1.208a.45.45 0 00-.444-.453.45.45 0 00-.443.453v1.208h-1.182a.45.45 0 00-.443.453c0 .25.199.453.443.453h1.182v1.208c0 .249.2.453.443.453a.45.45 0 00.444-.453v-1.208h1.182a.45.45 0 00.443-.453.45.45 0 00-.443-.453M22.235 60.27V58.46c0-.159.168-.258.303-.179l1.536.906 1.535.906a.209.209 0 010 .357l-1.535.906-1.536.906a.202.202 0 01-.303-.179v-1.811z",
    fill: "#E2F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.656 21.02l-.114 37.83c0 .902 2.701 1.633 1.818 1.633h-2.656c-.883 0-1.599-.731-1.599-1.633V21.02c0-.902 1.285-1.866 2.168-1.866l.383 1.866z",
    fill: "#AEEDFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.555 18.047l-8.595 4.189c-.603.326-1.162.532-1.162 1.187V54.06c0 .656.474.822 1.162 1.188l8.595 4.189",
    fill: "#00B3DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.555 18.047l-8.595 4.189c-.603.326-1.162.532-1.162 1.187V54.06c0 .656.474.822 1.162 1.188l8.595 4.189",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.19 18.047l8.595 4.189c.602.326 1.162.532 1.162 1.187V54.06c0 .656-.475.822-1.162 1.188l-8.596 4.189",
    fill: "#00B3DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.19 18.047l8.595 4.189c.602.326 1.162.532 1.162 1.187V54.06c0 .656-.475.822-1.162 1.188l-8.596 4.189",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.348 59.901H31.233c-.896 0-1.622-.742-1.622-1.657V19.239c0-.915.726-1.657 1.622-1.657h37.115c.895 0 1.621.742 1.621 1.657v39.005c0 .915-.726 1.657-1.621 1.657z",
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.368",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M65.978 62.615h-9.201M37.66 36.439v3.723M62.03 36.439v3.723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.538 34.344a.415.415 0 00-.39.334l-.293 1.689c-.032.183.092.333.275.333h1.09c.183 0 .307-.15.275-.333l-.292-1.69a.415.415 0 00-.39-.333h-.275zM43.233 36.697l-.189.46a.329.329 0 00.2.426l3.574 1.227a.43.43 0 00.488-.182l.634-1.07c.095-.16.025-.318-.155-.351l-4.083-.756a.46.46 0 00-.47.246zM55.65 36.452l-4.073.754c-.18.033-.25.191-.155.35l.634 1.072c.095.16.314.241.488.182l3.565-1.224a.33.33 0 00.2-.426l-.19-.462a.461.461 0 00-.403-.252.347.347 0 00-.066.006zM49.539 37.476a.657.657 0 00-.506.29l-4.105 6.86a.428.428 0 00.076.515l.416.328c.141.118.345.09.452-.06l3.61-5.119c.106-.151.281-.151.388 0l3.61 5.118c.106.151.31.179.451.061l.416-.328a.428.428 0 00.076-.514l-4.105-6.862a.658.658 0 00-.506-.29h-.273z",
    fill: "#00B3DB"
  })), " ");
};
var ImgWirelessCard = function ImgWirelessCard(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .163h3.83v4.315H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M62.762 35.856h1.913c.82 0 1.485.659 1.485 1.472v22.51a1.48 1.48 0 0 1-1.485 1.472H27.623c-.821 0-1.486-.659-1.486-1.472v-2.339M40.738 22.261c2.675-1.138 5.909-.865 8.474.992 2.27 1.645 3.507 4.16 3.567 6.708"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M40.837 24.856a6.707 6.707 0 0 1 6.55.767c1.755 1.27 2.71 3.215 2.756 5.184M40.292 27.781a5.645 5.645 0 0 1 5.513.646 5.58 5.58 0 0 1 2.217 3.429M40.083 30.228a4.093 4.093 0 0 1 3.996.469c.484.35.869.785 1.148 1.267"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M60.722 57.848a1.48 1.48 0 0 1-1.485 1.472H22.184a1.48 1.48 0 0 1-1.485-1.472v-22.51a1.48 1.48 0 0 1 1.485-1.473l.286 22.888 1.555.826 35.927.003.77.266z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M55.378 20.605c-.227-.916.363-1.846 1.318-2.08.955-.233 1.914.32 2.141 1.235.228.915-.362 1.845-1.317 2.079-.956.233-1.914-.32-2.142-1.234M53.424 22.647c-.126-.507.2-1.022.73-1.152.528-.129 1.06.177 1.185.684.126.506-.2 1.022-.73 1.15-.528.13-1.06-.176-1.185-.682M53.111 17.603H51.81v-1.291a.488.488 0 0 0-.977 0v1.29h-1.303a.488.488 0 0 0-.489.485c0 .267.22.484.49.484h1.302v1.291a.488.488 0 0 0 .977 0v-1.29h1.302a.488.488 0 0 0 .489-.485.488.488 0 0 0-.489-.484M80.498 35.855h-1.303v-1.29a.488.488 0 0 0-.977 0v1.29h-1.302a.488.488 0 0 0-.489.484c0 .267.22.485.489.485h1.302v1.29a.488.488 0 0 0 .977 0v-1.29h1.303a.488.488 0 0 0 .489-.485.488.488 0 0 0-.489-.484"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M61.077 57.579H24.025a1.48 1.48 0 0 1-1.486-1.473v-22.51a1.48 1.48 0 0 1 1.486-1.472h37.052c.82 0 1.486.66 1.486 1.473v22.51a1.48 1.48 0 0 1-1.486 1.472z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M62.317 45.204H22.815a.22.22 0 0 1-.222-.22v-5.517c0-.122.1-.22.222-.22h39.502a.22.22 0 0 1 .221.22v5.518c0 .12-.099.22-.221.22"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M62.317 45.204H22.815a.22.22 0 0 1-.222-.22v-5.517c0-.122.1-.22.222-.22h39.502a.22.22 0 0 1 .221.22v5.518c0 .12-.099.22-.221.22z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeWidth: "1.5",
    d: "M26.863 53.519h5.522M35.648 53.519h5.522M44.433 53.519h5.521"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M63.402 15.442c4.602-1.01 9.664.394 13.179 4.118 3.111 3.297 4.311 7.67 3.629 11.74"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M62.768 19.6c3.557-.78 7.47.305 10.186 3.183 2.404 2.548 3.332 5.928 2.805 9.074M61.008 24.09c2.994-.656 6.288.257 8.575 2.68 2.024 2.145 2.804 4.99 2.36 7.639M59.928 27.922a6.616 6.616 0 0 1 6.216 1.942 6.5 6.5 0 0 1 1.712 5.537"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M22.439 62.004c-.126-.507.2-1.022.73-1.151.528-.13 1.059.176 1.185.683.126.506-.2 1.022-.73 1.151-.528.13-1.06-.177-1.185-.683"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18 61.274)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M0 2.32V.384C0 .214.185.107.334.193l1.692.968 1.692.968a.22.22 0 0 1 0 .382l-1.692.969-1.692.968A.222.222 0 0 1 0 4.258V2.32z",
    mask: "url(#b)"
  }))));
};
var ImgWithdrawal = function ImgWithdrawal(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .08h3.685v4.057H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M20.482 52.204c0 .547-.46.99-1.025.99-.567 0-1.026-.782-1.026-.99 0-.547.46-.991 1.026-.991.566 0 1.025.444 1.025.99"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".508",
    d: "M61.584 15.99a4.748 4.748 0 0 0-4.306-.103c-.915.437-1.626 1.002-2.088 1.822l-2.637-.204-1.11-2.322a.51.51 0 0 1 .239-.677l8.035-3.841a.509.509 0 0 1 .677.239l1.742 3.644M61.995 17.554a4.755 4.755 0 1 1 7.28 3.23l-.024 2.485 5.17-11.705a.51.51 0 0 0-.26-.669l-8.146-3.598a.51.51 0 0 0-.67.259L60.95 17.51l1.046.043z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M65.703 17.72c-.603-.362-.789-.804-.558-1.327.102-.23.249-.402.441-.517.193-.114.377-.132.553-.054.06.027.102.069.127.126a.207.207 0 0 1-.001.171c-.028.062-.064.101-.108.116a.588.588 0 0 1-.185.02.614.614 0 0 0-.255.04c-.068.028-.127.1-.18.218a.405.405 0 0 0 .004.375c.063.114.19.226.381.336l.262-.592c.01-.025.032-.03.063-.016a.297.297 0 0 1 .104.086c.034.043.048.073.04.09l-.242.55.178.082c.056.025.096.041.121.05l.268-.607c.01-.024.032-.03.062-.016.036.015.071.044.106.087.034.042.048.072.04.09l-.237.537c.458.152.74.108.846-.13.04-.09.054-.181.044-.274-.01-.093-.08-.209-.207-.347a.59.59 0 0 1-.142-.2.178.178 0 0 1 .008-.119.25.25 0 0 1 .14-.144.267.267 0 0 1 .204.017c.18.08.307.241.382.485.074.244.056.491-.055.742a.933.933 0 0 1-.528.503l-1.676-.379z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".508",
    d: "M69.275 34.362a4.755 4.755 0 1 0 .007-6.045l-.104-2.41L81.38 27.34a.509.509 0 0 1 .445.564l-1.04 8.844a.508.508 0 0 1-.562.445l-11.087-1.302.139-1.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M72.21 31.57c-.01.483.115.74.375.77a.527.527 0 0 0 .274-.039c.086-.037.176-.137.27-.3.062-.106.111-.17.15-.194a.18.18 0 0 1 .116-.027c.08.01.139.04.178.09.039.052.054.118.044.2-.023.196-.14.365-.35.508-.211.144-.453.2-.726.167a.933.933 0 0 1-.636-.357c-.168-.207-.248-.502-.242-.882l-.253-.03c-.024-.003-.034-.022-.03-.056a.3.3 0 0 1 .053-.121c.031-.048.055-.07.073-.069l.171.02.009-.071c.007-.059.02-.143.038-.253l-.246-.028c-.024-.003-.034-.021-.03-.055a.301.301 0 0 1 .053-.123c.031-.047.055-.07.073-.068l.2.023c.167-.682.535-.99 1.103-.924.25.03.457.12.623.27.166.15.238.32.215.512a.235.235 0 0 1-.083.158.207.207 0 0 1-.164.05c-.068-.008-.115-.031-.142-.07a.574.574 0 0 1-.074-.17.615.615 0 0 0-.113-.233c-.047-.056-.134-.091-.262-.106a.404.404 0 0 0-.356.114c-.091.093-.161.247-.21.463l.643.075c.026.003.038.022.034.056a.287.287 0 0 1-.052.125c-.03.045-.055.067-.074.065l-.596-.07-.027.195c-.007.06-.01.103-.011.13l.658.077c.027.004.038.022.034.055a.297.297 0 0 1-.052.126c-.03.046-.055.068-.074.066l-.584-.07zM24.628 19.96c-.994 0-1.799.806-1.799 1.8v35.19c0 .993.805 1.799 1.799 1.799h3.077l-2.728-2.447V19.913l-.35.048zM59.202 43.474H35.008a1.798 1.798 0 0 1-1.799-1.799V23.391c0-.993.806-1.799 1.799-1.799h24.194c.994 0 1.8.806 1.8 1.799v18.284c0 .994-.806 1.799-1.8 1.799"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E3B45",
    d: "M28.53 24.64a1.015 1.015 0 1 1 2.03 0 1.015 1.015 0 0 1-2.03 0M28.53 29.716a1.015 1.015 0 1 1 2.03 0 1.015 1.015 0 0 1-2.03 0M28.53 34.792a1.015 1.015 0 1 1 2.03 0 1.015 1.015 0 0 1-2.03 0M28.53 39.868a1.015 1.015 0 1 1 2.03 0 1.015 1.015 0 0 1-2.03 0M63.618 24.64a1.015 1.015 0 1 1 2.03 0 1.015 1.015 0 0 1-2.03 0M63.618 29.716a1.015 1.015 0 1 1 2.03 0 1.015 1.015 0 0 1-2.03 0M63.618 34.792a1.015 1.015 0 1 1 2.03 0 1.015 1.015 0 0 1-2.03 0M63.618 39.868a1.015 1.015 0 1 1 2.03 0 1.015 1.015 0 0 1-2.03 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M73.636 22.61c0 .538-.451.974-1.008.974-.557 0-1.008-.436-1.008-.974 0-.876.451-.974 1.008-.974.557 0 1.008.436 1.008.974M25.558 61.214c0 .547-.46.99-1.025.99-.567 0-1.026-.782-1.026-.99 0-.548.46-.991 1.026-.991.566 0 1.025.443 1.025.99M76.055 19.817h-1.024v-1.024a.385.385 0 0 0-.384-.384.385.385 0 0 0-.384.384v1.024h-1.024a.385.385 0 0 0 0 .768h1.024v1.024a.385.385 0 0 0 .768 0v-1.024h1.024a.385.385 0 0 0 .384-.384.385.385 0 0 0-.384-.384"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18 54.085)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M.117 2.095L.233.275c.01-.16.19-.249.322-.16l1.519 1.01 1.518 1.011a.208.208 0 0 1-.022.36l-1.635.81-1.635.81a.208.208 0 0 1-.3-.2l.117-1.82z",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#2E3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M45.848 33.237l-1.122 1.312c-.222.265-.56.413-.899.413h-1.619M51.137 30.138h-1.83c-.497 0-.973.211-1.29.592l-1.08 1.248"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2E3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M50.703 31.47l1.217-1.216a.249.249 0 0 0 .074-.18.276.276 0 0 0-.074-.18l-1.206-1.216M51.137 35.279h-1.83c-.349 0-.677-.148-.9-.413l-3.29-3.819a1.692 1.692 0 0 0-1.29-.592h-1.619"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2E3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M50.714 36.77l1.217-1.216a.262.262 0 0 0 0-.36l-1.217-1.216"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M67.267 58.114H26.72a1.799 1.799 0 0 1-1.799-1.798V19.348c0-.993.805-1.798 1.799-1.798h40.546c.993 0 1.798.805 1.798 1.798v36.968c0 .993-.805 1.798-1.798 1.798z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M33.658 62.826h11.798V48.89H33.658z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M33.658 62.826h11.798V48.89H33.658z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M42.671 47.982c.565.727.904 1.422.904 2.434 0 2.335-1.802 4.227-4.024 4.227s-4.024-1.892-4.024-4.227c0-.876.254-1.689.688-2.364"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: "1.5",
    d: "M42.671 47.982c.565.727.904 1.422.904 2.434 0 2.335-1.802 4.227-4.024 4.227s-4.024-1.892-4.024-4.227c0-.876.254-1.689.688-2.364"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C3B45",
    d: "M39.762 51.4c.414-.047.62-.182.617-.408a.458.458 0 0 0-.065-.23c-.04-.07-.137-.136-.287-.198a.511.511 0 0 1-.183-.105.155.155 0 0 1-.037-.097.215.215 0 0 1 .058-.162.23.23 0 0 1 .166-.06c.17-.004.328.078.475.242a.893.893 0 0 1 .224.601.805.805 0 0 1-.233.585c-.158.167-.401.27-.728.307l.004.22c0 .021-.015.032-.045.032a.256.256 0 0 1-.11-.031c-.044-.021-.066-.04-.067-.055l-.002-.149-.062.001c-.051 0-.125 0-.22-.003l.003.213c0 .02-.014.031-.043.032a.263.263 0 0 1-.112-.032c-.044-.02-.066-.04-.066-.054l-.003-.174c-.603-.066-.908-.346-.916-.84a.944.944 0 0 1 .16-.563c.11-.159.248-.24.415-.242.056 0 .104.017.144.053.04.037.06.081.06.135.002.058-.013.102-.042.13a.53.53 0 0 1-.138.082.527.527 0 0 0-.186.123c-.042.046-.063.125-.061.236a.349.349 0 0 0 .138.292c.09.067.23.11.42.126l-.009-.558c0-.023.014-.035.044-.035.033 0 .07.01.113.03.042.021.064.04.064.056l.008.518.17.001c.051 0 .089-.003.112-.005l-.008-.572c0-.023.013-.035.042-.036.034 0 .072.01.114.03.043.022.064.04.065.056l.007.508z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeWidth: ".25",
    d: "M39.762 51.4c.414-.047.62-.182.617-.408a.458.458 0 0 0-.065-.23c-.04-.07-.137-.136-.287-.198a.511.511 0 0 1-.183-.105.155.155 0 0 1-.037-.097.215.215 0 0 1 .058-.162.23.23 0 0 1 .166-.06c.17-.004.328.078.475.242a.893.893 0 0 1 .224.601.805.805 0 0 1-.233.585c-.158.167-.401.27-.728.307l.004.22c0 .021-.015.032-.045.032a.256.256 0 0 1-.11-.031c-.044-.021-.066-.04-.067-.055l-.002-.149-.062.001c-.051 0-.125 0-.22-.003l.003.213c0 .02-.014.031-.043.032a.263.263 0 0 1-.112-.032c-.044-.02-.066-.04-.066-.054l-.003-.174c-.603-.066-.908-.346-.916-.84a.944.944 0 0 1 .16-.563c.11-.159.248-.24.415-.242.056 0 .104.017.144.053.04.037.06.081.06.135.002.058-.013.102-.042.13a.53.53 0 0 1-.138.082.527.527 0 0 0-.186.123c-.042.046-.063.125-.061.236a.349.349 0 0 0 .138.292c.09.067.23.11.42.126l-.009-.558c0-.023.014-.035.044-.035.033 0 .07.01.113.03.042.021.064.04.064.056l.008.518.17.001c.051 0 .089-.003.112-.005l-.008-.572c0-.023.013-.035.042-.036.034 0 .072.01.114.03.043.022.064.04.065.056l.007.508z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M31.263 48h16.589M61.181 51.561h-6.004a1.799 1.799 0 0 1-1.799-1.799v-.14c0-.993.805-1.798 1.799-1.798h6.004c.994 0 1.799.805 1.799 1.799v.14c0 .993-.805 1.798-1.799 1.798zM54.118 53.892h8.122"
  })));
};
var ImgZoomit = function ImgZoomit(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 100 80"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M71.513 40.593a8.752 8.752 0 0 1 3.603-.77c4.843 0 8.769 3.917 8.769 8.749 0 4.831-3.926 8.748-8.769 8.748a8.753 8.753 0 0 1-6.312-2.675"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M71.632 42.47a7.018 7.018 0 0 1 3.484-.92c3.887 0 7.038 3.144 7.038 7.022s-3.15 7.021-7.038 7.021a7.018 7.018 0 0 1-4.428-1.563"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M75.15 43.55v4.92h2.564M63.83 19.232c1.248-.29 2.175-.236 2.4.225.33.675-.961 2.001-2.984 3.15M67.22 21.485c.33.675-.96 2.001-2.983 3.151M68.288 23.669c.284.581-.634 1.646-2.187 2.665M69.317 25.775c.247.505-.414 1.375-1.61 2.262M66.268 19.534l3.115 6.377M50.63 17.624l.706-4.655a.586.586 0 0 1 .665-.49l1.159.175"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M52.276 18.795l1.23-8.297a.587.587 0 0 1 .665-.492l10.148 1.499c.319.046.54.345.493.662l-1.688 11.384"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#AEEDFC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: ".5",
    d: "M52.562 18.812a5.479 5.479 0 0 1 6.066-3.896 5.467 5.467 0 0 1 3.836 8.317"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M63.116 12.981a.53.53 0 1 1-.154 1.05.53.53 0 0 1 .154-1.05M58.06 19.772c.556.027.856-.107.9-.404a.605.605 0 0 0-.035-.317c-.04-.1-.151-.207-.336-.321-.12-.074-.192-.133-.218-.177a.206.206 0 0 1-.028-.135.286.286 0 0 1 .11-.202.307.307 0 0 1 .233-.044c.224.033.415.174.573.42.157.248.213.528.166.84a1.072 1.072 0 0 1-.432.718c-.245.186-.587.269-1.025.248l-.043.29c-.004.027-.026.037-.066.031a.344.344 0 0 1-.138-.064c-.053-.038-.079-.066-.076-.086l.03-.196-.083-.012a6.365 6.365 0 0 1-.289-.053l-.042.282c-.004.027-.025.038-.063.032a.351.351 0 0 1-.14-.065c-.054-.037-.08-.066-.076-.086l.033-.228c-.78-.217-1.122-.65-1.025-1.3.042-.286.153-.522.331-.707.18-.185.378-.261.598-.229.075.011.134.045.179.101.045.057.062.12.052.19-.012.077-.04.132-.085.161a.685.685 0 0 1-.199.08.698.698 0 0 0-.272.12c-.066.053-.11.152-.132.298a.465.465 0 0 0 .12.413c.103.108.278.194.525.256l.109-.735c.005-.03.027-.043.066-.037.043.006.09.028.141.064.052.037.076.065.073.087l-.101.682.223.038c.07.01.12.016.15.018l.112-.754c.004-.03.025-.043.064-.037a.343.343 0 0 1 .143.064c.052.037.076.065.073.087l-.1.669z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M26.948 20.12c-.372-.445-.3-1.117.162-1.5.461-.385 1.136-.335 1.508.11.372.444.3 1.116-.162 1.5-.461.384-1.137.335-1.508-.11M70.882 21.525c-.372-.445-.3-1.116.162-1.5.461-.384 1.137-.335 1.509.11.371.445.299 1.117-.163 1.5-.46.385-1.136.335-1.508-.11M19.086 42.621c-.304-.493-.136-1.148.376-1.461.512-.314 1.173-.169 1.477.325.304.493.135 1.148-.376 1.461-.512.314-1.173.169-1.477-.325M20.854 53.4l-1.291.628-.63-1.289a.539.539 0 0 0-.969.471l.63 1.289-1.292.627a.54.54 0 0 0-.248.72c.13.265.454.376.72.247l1.292-.628.63 1.288a.539.539 0 0 0 .969-.471l-.63-1.288 1.29-.628a.538.538 0 1 0-.471-.966"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEEDFC",
    d: "M56.497 64.36a22.842 22.842 0 0 1-10.087 2.336c-12.929 0-23.41-10.745-23.41-24 0-13.254 10.481-24 23.41-24C32.83 23.037 26.042 30.285 26.042 40.44c0 6.717 3.653 20.154 12.79 22.705.754.21 3.666 1.463 8.735 1.757 1.644.095 4.62-.086 8.93-.542z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M72.412 42.053c0 12.9-10.481 23.357-23.41 23.357s-23.41-10.458-23.41-23.357c0-12.9 10.481-23.357 23.41-23.357s23.41 10.458 23.41 23.357z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    d: "M50.467 28.929H37.836v5.587h9.755s-6.413 9.49-9.755 14.419c-4.584 6.758 3.629 6.308 3.629 6.308h26.358l3.432-6.308H45.717s6.39-9.192 8.016-11.535c0 0 6.972-8.471-3.266-8.471"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2C3B45",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M50.467 28.929H37.836v5.587h9.755s-6.413 9.49-9.755 14.419c-4.584 6.758 3.629 6.308 3.629 6.308h26.358l3.432-6.308H45.717s6.39-9.192 8.016-11.535c0 0 6.972-8.471-3.266-8.471z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2F8FE",
    d: "M32.193 68.98c0 .49-.41.886-.918.886s-.919-.397-.919-.886c0-.797.411-.886.919-.886.507 0 .918.397.918.886M72.42 62.714c0 .497-.418.9-.934.9s-.934-.71-.934-.9c0-.498.418-.901.934-.901s.935.403.935.9M34.88 12.491c-.23-.926.364-1.869 1.325-2.105.96-.236 1.925.323 2.154 1.25.229.926-.365 1.869-1.325 2.105-.961.236-1.926-.323-2.154-1.25M76.643 32.591h-.934v-.93a.35.35 0 0 0-.7 0v.93h-.933a.35.35 0 0 0-.35.35c0 .192.158.349.35.349h.933v.93a.35.35 0 0 0 .7 0v-.93h.934a.35.35 0 0 0 .35-.35.35.35 0 0 0-.35-.349M21.256 26.61V24.95a.19.19 0 0 1 .284-.164l1.44.83 1.44.83a.188.188 0 0 1 0 .326l-1.44.83-1.44.829a.19.19 0 0 1-.284-.164V26.61zM63.672 67.132v-1.659a.19.19 0 0 1 .284-.163l1.44.829 1.44.83a.188.188 0 0 1 0 .326l-1.44.83-1.44.83a.19.19 0 0 1-.284-.164v-1.659z"
  })));
};
var UtilsKeytrade = function UtilsKeytrade(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 34 28"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("path", {
    fill: "#03B3D9",
    fillRule: "nonzero",
    d: "M22.8 10.764l-1.532-2.613c-.245-.373-.062-.809.367-.871l10.052-1.867c.43-.062.98.187 1.165.623l.49 1.12a.788.788 0 0 1-.49 1.057L24.026 11.2c-.43.187-.98-.062-1.226-.436zM12.626 8.09l-1.532 2.675c-.246.374-.797.56-1.226.436L1.042 8.151c-.43-.187-.674-.622-.49-1.058l.49-1.12c.184-.373.674-.684 1.164-.622l10.052 1.867c.43.062.613.498.368.87zm5.884.56L28.623 25.51a.972.972 0 0 1-.184 1.245l-1.042.808c-.368.312-.858.25-1.103-.124l-8.888-12.569c-.306-.373-.735-.373-.98 0L7.539 27.44c-.245.373-.736.436-1.104.124l-1.041-.808c-.307-.312-.43-.872-.184-1.245L15.384 8.65c.184-.373.797-.685 1.226-.685h.674c.429 0 .98.312 1.226.685zm-.245-2.613h-2.759c-.429 0-.735-.374-.674-.81l.736-4.168c.122-.436.551-.81.98-.81h.675c.49 0 .919.374.98.81l.736 4.169c.061.435-.245.809-.674.809z"
  }));
};
var UtilsLoadingCircle = function UtilsLoadingCircle(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size,
    viewBox: "0 0 20 20"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-17)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "19",
    r: "18",
    fill: "#FFF",
    fillOpacity: "0",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeOpacity: "0",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B3DB",
    fillRule: "nonzero",
    d: "M37 19a1 1 0 0 1-2 0c0-9.388-7.612-17-17-17a1 1 0 0 1 0-2c10.492 0 19 8.508 19 19z"
  })));
};
var UtilsSpinner = function UtilsSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    width: props.size,
    height: props.size,
    viewBox: "0 0 104 104",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, props.accessibilityText && /*#__PURE__*/React.createElement("title", null, props.accessibilityText), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Spinner_KTB",
    fill: "#A7BDCC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(48.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "8",
    height: "24",
    rx: "4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(72.000000, 17.358984) rotate(30.000000) translate(-72.000000, -17.358984) translate(68.000000, 5.358984)",
    fillOpacity: "0.9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "8",
    height: "24",
    rx: "4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(86.641016, 32.000000) rotate(60.000000) translate(-86.641016, -32.000000) translate(82.641016, 20.000000)",
    fillOpacity: "0.84"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "8",
    height: "24",
    rx: "4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(92.000000, 52.000000) rotate(90.000000) translate(-92.000000, -52.000000) translate(88.000000, 40.000000)",
    fillOpacity: "0.76"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "8",
    height: "24",
    rx: "4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(86.641016, 72.000000) rotate(120.000000) translate(-86.641016, -72.000000) translate(82.641016, 60.000000)",
    fillOpacity: "0.68"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "8",
    height: "24",
    rx: "4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(72.000000, 86.641016) rotate(150.000000) translate(-72.000000, -86.641016) translate(68.000000, 74.641016)",
    fillOpacity: "0.6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "8",
    height: "24",
    rx: "4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(52.000000, 92.000000) rotate(180.000000) translate(-52.000000, -92.000000) translate(48.000000, 80.000000)",
    fillOpacity: "0.52"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "8",
    height: "24",
    rx: "4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(32.000000, 86.641016) rotate(-150.000000) translate(-32.000000, -86.641016) translate(28.000000, 74.641016)",
    fillOpacity: "0.44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "8",
    height: "24",
    rx: "4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(17.358984, 72.000000) rotate(-120.000000) translate(-17.358984, -72.000000) translate(13.358984, 60.000000)",
    fillOpacity: "0.36"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "8",
    height: "24",
    rx: "4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(12.000000, 52.000000) rotate(-90.000000) translate(-12.000000, -52.000000) translate(8.000000, 40.000000)",
    fillOpacity: "0.28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "8",
    height: "24",
    rx: "4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(17.358984, 32.000000) rotate(-60.000000) translate(-17.358984, -32.000000) translate(13.358984, 20.000000)",
    fillOpacity: "0.2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "8",
    height: "24",
    rx: "4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(32.000000, 17.358984) rotate(-30.000000) translate(-32.000000, -17.358984) translate(28.000000, 5.358984)",
    fillOpacity: "0.12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: "0",
    y: "0",
    width: "8",
    height: "24",
    rx: "4"
  })))));
};
var allIcons = {
  'icn_academy': IcnAcademy,
  'icn_accounts': IcnAccounts,
  'icn_activate': IcnActivate,
  'icn_addInstrumentLight': IcnAddInstrumentLight,
  'icn_addUserLIght': IcnAddUserLIght,
  'icn_addUserRegular': IcnAddUserRegular,
  'icn_userProDefRegular': IcnUserProDefRegular,
  'icn_addWatchlist': IcnAddWatchlist,
  'icn_alarm': IcnAlarm,
  'icn_arrowDown': IcnArrowDown,
  'icn_arrowLeft': IcnArrowLeft,
  'icn_arrowRight': IcnArrowRight,
  'icn_arrowUp': IcnArrowUp,
  'icn_balance': IcnBalance,
  'icn_basket': IcnBasket,
  'icn_basketLight': IcnBasketLight,
  'icn_bell': IcnBell,
  'icn_bellLight': IcnBellLight,
  'icn_block': IcnBlock,
  'icn_blockcard': IcnBlockcard,
  'icn_blockcardlight': IcnBlockcardlight,
  'icn_blockLight': IcnBlockLight,
  'icn_blocks': IcnBlocks,
  'icn_browser': IcnBrowser,
  'icn_buy': IcnBuy,
  'icn_buySell': IcnBuysell,
  'icn_calendar': IcnCalendar,
  'icn_calendarLight': IcnCalendarLight,
  'icn_card': IcnCard,
  'icn_cardLight': IcnCardLight,
  'icn_caret': IcnCaret,
  'icn_cashTefth': IcnCashTefth,
  'icn_change': IcnChange,
  'icn_chartArea': IcnChartArea,
  'icn_chartBar': IcnChartBar,
  'icn_chartLine': IcnChartLine,
  'icn_chartPie': IcnChartPie,
  'icn_chat': IcnChat,
  'icn_chatting': IcnChatting,
  'icn_check': IcnCheck,
  'icn_checkBold': IcnCheckBold,
  'icn_checkCircle': IcnCheckCircle,
  'icn_checkCirclePlein': IcnCheckCirclePlein,
  'icn_checkLight': IcnCheckLight,
  'icn_child': IcnChild,
  'icn_clock': IcnClock,
  'icn_clockLight': IcnClockLight,
  'icn_cloud': IcnCloud,
  'icn_code': IcnCode,
  'icn_codeLight': IcnCodeLight,
  'icn_compliance': IcnCompliance,
  'icn_concierge': IcnConcierge,
  'icn_config': IcnConfig,
  'icn_contactLess': IcnContactLess,
  'icn_contract': IcnContract,
  'icn_countryChoice': IcnCountryChoice,
  'icn_cross': IcnCross,
  'icn_crossLight': IcnCrossLight,
  'icn_csv': IcnCsv,
  'icn_csvLight': IcnCsvLight,
  'icn_dashboard': IcnDashboard,
  'icn_debit': IcnDebit,
  'icn_deleteUserLIght': IcnDeleteUserLIght,
  'icn_deleteUserRegular': IcnDeleteUserRegular,
  'icn_deleteWatchlist': IcnDeleteWatchlist,
  'icn_desktop': IcnDesktop,
  'icn_diamant': IcnDiamant,
  'icn_download': IcnDownload,
  'icn_downloadLight': IcnDownloadLight,
  'icn_dragDrop': IcnDragDrop,
  'icn_duplicate': IcnDuplicate,
  'icn_email': IcnEmail,
  'icn_emailVerified': IcnEmailVerified,
  'icn_errorCircle': IcnErrorCircle,
  'icn_euro': IcnEuro,
  'icn_excel': IcnExcel,
  'icn_excelLight': IcnExcelLight,
  'icn_exclamationCircle': IcnExclamationCircle,
  'icn_exclamationMark': IcnExclamationMark,
  'icn_eyeClosed': IcnEyeClosed,
  'icn_facebookCircle': IcnFacebookCircle,
  'icn_facebookSquare': IcnFacebookSquare,
  'icn_file': IcnFile,
  'icn_fileEmpty': IcnFileEmpty,
  'icn_fileEmptyLight': IcnFileEmptyLight,
  'icn_fileLight': IcnFileLight,
  'icn_food': IcnFood,
  'icn_fortuneoLeft': IcnFortuneoLeft,
  'icn_googleCircle': IcnGoogleCircle,
  'icn_guarantee': IcnGuarantee,
  'icn_hardKeyLeft': IcnHardKeyLeft,
  'icn_hardKeyOk': IcnHardKeyOk,
  'icn_hardKeyRight': IcnHardKeyRight,
  'icn_help': IcnHelp,
  'icn_history': IcnHistory,
  'icn_holder': IcnHolder,
  'icn_home': IcnHome,
  'icn_idcard': IcnIdcard,
  'icn_idea': IcnIdea,
  'icn_info': IcnInfo,
  'icn_inputfieldErase': IcnInputfieldErase,
  'icn_instagramCircle': IcnInstagramCircle,
  'icn_insurances': IcnInsurances,
  'icn_KeyEvent': IcnKeyEvent,
  'icn_keysPapers': IcnKeysPapers,
  'icn_keytrade': IcnKeytrade,
  'icn_linkedinCircle': IcnLinkedinCircle,
  'icn_list': IcnList,
  'icn_listsimple': IcnListsimple,
  'icn_locker': IcnLocker,
  'icn_lockerLight': IcnLockerLight,
  'icn_longArrowDown': IcnLongArrowDown,
  'icn_longArrowDownLight': IcnLongArrowDownLight,
  'icn_longArrowLeft': IcnLongArrowLeft,
  'icn_longArrowRight': IcnLongArrowRight,
  'icn_longArrowFall': IcnLongArrowFall,
  'icn_longArrowRise': IcnLongArrowRise,
  'icn_markets': IcnMarkets,
  'icn_minus': IcnMinus,
  'icn_minusCircle': IcnMinusCircle,
  'icn_minusLight': IcnMinusLight,
  'icn_moon': IcnMoon,
  'icn_mortgage': IcnMortgage,
  'icn_noImage': IcnNoImage,
  'icn_noPincode': IcnNoPincode,
  'icn_onlinePayment': IcnOnlinePayment,
  'icn_options': IcnOptions,
  'icn_paperclip': IcnPaperclip,
  'icn_paperclipLight': IcnPaperclipLight,
  'icn_parent': IcnParent,
  'icn_payments': IcnPayments,
  'icn_PDF': IcnPDF,
  'icn_PDFLight': IcnPDFLight,
  'icn_pen': IcnPen,
  'icn_penLight': IcnPenLight,
  'icn_perchaseInsurance': IcnPerchaseInsurance,
  'icn_phone': IcnPhone,
  'icn_pincode': IcnPincode,
  'icn_play': IcnPlay,
  'icn_playLight': IcnPlayLight,
  'icn_plus': IcnPlus,
  'icn_plusCircle': IcnPlusCircle,
  'icn_plusLight': IcnPlusLight,
  'icn_post': IcnPost,
  'icn_pourcentage': IcnPourcentage,
  'icn_products': IcnProducts,
  'icn_printLight': IcnPrintLight,
  'icn_Promo': IcnPromo,
  'icn_questionCircle': IcnQuestionCircle,
  'icn_questionCircleLight': IcnQuestionCircleLight,
  'icn_receiving': IcnReceiving,
  'icn_redo': IcnRedo,
  'icn_redoLight': IcnRedoLight,
  'icn_reorderLight': IcnReorderLight,
  'icn_replacementCards': IcnReplacementCards,
  'icn_savings': IcnSavings,
  'icn_search': IcnSearch,
  'icn_searchLight': IcnSearchLight,
  'icn_select1AccountOff': IcnSelect1AccountOff,
  'icn_select1AccountOn': IcnSelect1AccountOn,
  'icn_select2AccountOff': IcnSelect2AccountOff,
  'icn_select2AccountOn': IcnSelect2AccountOn,
  'icn_selectMinirOff': IcnSelectMinirOff,
  'icn_selectMinirOn': IcnSelectMinirOn,
  'icn_sell': IcnSell,
  'icn_sendDoc': IcnSendDoc,
  'icn_settings': IcnSettings,
  'icn_settingsLight': IcnSettingsLight,
  'icn_shoppingBag': IcnShoppingBag,
  'icn_signCircle': IcnSignCircle,
  'icn_signout': IcnSignout,
  'icn_signoutLight': IcnSignoutLight,
  'icn_skype': IcnSkype,
  'icn_sport': IcnSport,
  'icn_star': IcnStar,
  'icn_starLight': IcnStarLight,
  'icn_stop': IcnStop,
  'icn_stopLight': IcnStopLight,
  'icn_threeDots': IcnThreeDots,
  'icn_ticket': IcnTicket,
  'icn_transfer': IcnTransfer,
  'icn_transferLight': IcnTransferLight,
  'icn_trash': IcnTrash,
  'icn_trashLight': IcnTrashLight,
  'icn_travel': IcnTravel,
  'icn_travelAccident': IcnTravelAccident,
  'icn_travelAssistance': IcnTravelAssistance,
  'icn_TravelCancel': IcnTravelCancel,
  'icn_travelTrubbles': IcnTravelTrubbles,
  'icn_twitter': IcnTwitter,
  'icn_XCircle': IcnXCircle,
  'icn_userLight': IcnUserLight,
  'icn_userRegular': IcnUserRegular,
  'icn_visa': IcnVisa,
  'icn_wait': IcnWait,
  'icn_wallet': IcnWallet,
  'icn_watchlist': IcnWatchlist,
  'icn_widthdraw': IcnWidthdraw,
  'icn_xml': IcnXml,
  'icn_xmlLight': IcnXmlLight,
  'icn_youtubeCircle': IcnYoutubeCircle,
  'icn_zeroEuro': IcnZeroEuro,
  'img_alerts': ImgAlerts,
  'img_analysts': ImgAnalysts,
  'img_appTrading': ImgAppTrading,
  'img_assurance': ImgAssurance,
  'img_atm': ImgAtm,
  'img_bridgeloan': ImgBridgeloan,
  'img_browserExchange': ImgBrowserExchange,
  'img_building': ImgBuilding,
  'img_calendar': ImgCalendar,
  'img_cardBlocked': ImgCardBlocked,
  'img_cardLockTemporary': ImgCardLockTemporary,
  'img_cardPending': ImgCardPending,
  'img_cardPinPaper': ImgCardPinPaper,
  'img_cardPinSms': ImgCardPinSms,
  'img_cardRefused': ImgCardRefused,
  'img_cardReplace': ImgCardReplace,
  'img_cardSending': ImgCardSending,
  'img_centralisation': ImgCentralisation,
  'img_certification': ImgCertification,
  'img_chat': ImgChat,
  'img_clock': ImgClock,
  'img_complain': ImgComplain,
  'img_confirmation': ImgConfirmation,
  'img_contact': ImgContact,
  'img_email': ImgEmail,
  'img_emailConfirmation': ImgEmailConfirmation,
  'img_environment': ImgEnvironment,
  'img_error': ImgError,
  'img_fileBroken': ImgFileBroken,
  'img_fileLost': ImgFileLost,
  'img_fiscality': ImgFiscality,
  'img_gift': ImgGift,
  'img_hardkey': ImgHardkey,
  'img_help': ImgHelp,
  'img_home': ImgHome,
  'img_hourglass': ImgHourglass,
  'img_idea': ImgIdea,
  'img_infosessions': ImgInfosessions,
  'img_interface': ImgInterface,
  'img_invest': ImgInvest,
  'img_labtop': ImgLabtop,
  'img_letterBox': ImgLetterBox,
  'img_limit': ImgLimit,
  'img_lock': ImgLock,
  'img_login': ImgLogin,
  'img_maintenance': ImgMaintenance,
  'img_manage': ImgManage,
  'img_manageOneUser': ImgManageOneUser,
  'img_manageUser': ImgManageUser,
  'img_missingFiles': ImgMissingFiles,
  'img_noData': ImgNoData,
  'img_noMessages': ImgNoMessages,
  'img_noNews': ImgNoNews,
  'img_noResults': ImgNoResults,
  'img_pincode': ImgPincode,
  'img_pincodePhone': ImgPincodePhone,
  'img_prefMobile': ImgPrefMobile,
  'img_products': ImgProducts,
  'img_renovation1': ImgRenovation1,
  'img_renovation2': ImgRenovation2,
  'img_renovation3': ImgRenovation3,
  'img_renovation4': ImgRenovation4,
  'img_savings': ImgSavings,
  'img_search': ImgSearch,
  'img_searchInput': ImgSearchInput,
  'img_sms': ImgSms,
  'img_softkey': ImgSoftkey,
  'img_wallet': ImgWallet,
  'img_welcome': ImgWelcome,
  'img_wirelessCard': ImgWirelessCard,
  'img_withdrawal': ImgWithdrawal,
  'img_zoomit': ImgZoomit,
  'utils_Keytrade': UtilsKeytrade,
  'utils_loadingCircle': UtilsLoadingCircle,
  'utils_spinner': UtilsSpinner
};
var iconsList = Object.keys(allIcons);
var COLORS = functions.config.colors.list;
var deprecatedIconsMapping = {
  icn_abroad: {
    name: 'icn_countryChoice'
  },
  icn_account_picture: {
    name: 'icn_noImage'
  },
  icn_alert: {
    name: 'icn_exclamationCircle'
  },
  icn_alertCircle: {
    name: 'icn_exclamationCircle'
  },
  icn_alertTriangle: {
    name: 'icn_exclamationCircle'
  },
  icn_attention: {
    name: 'icn_exclamationCircle'
  },
  icn_attentionCircle: {
    name: 'icn_exclamationCircle'
  },
  icn_blockTemp: {
    name: 'icn_clock'
  },
  icn_cancel: {
    name: 'icn_blockLight'
  },
  icn_cashWithdraw: {
    name: 'icn_widthdraw'
  },
  icn_checkBlueDark: {
    name: 'icn_checkBold',
    color: COLORS.BlueDark
  },
  icn_checkBlueSky: {
    name: 'icn_checkBold'
  },
  icn_checkCircleGreen: {
    name: 'icn_checkCircle',
    color: COLORS.GreenSeafoam
  },
  icn_checkGreen: {
    name: 'icn_checkBold',
    color: COLORS.GreenSeafoam
  },
  icn_checkGreenSeafoam: {
    name: 'icn_checkBold',
    color: COLORS.GreenSeafoam
  },
  icn_checkLIght: {
    name: 'icn_checkLight'
  },
  icn_checkWhite: {
    name: 'icn_checkBold',
    color: COLORS.White
  },
  icn_clearElement: {
    name: 'icn_inputfieldErase',
    color: COLORS.GreyWarm
  },
  icn_client: {
    name: 'icn_select1AccountOn'
  },
  icn_close: {
    name: 'icn_cross'
  },
  icn_closeWhite: {
    name: 'icn_cross',
    color: COLORS.White
  },
  icn_configure: {
    name: 'icn_config'
  },
  icn_contactLessPayment: {
    name: 'icn_contactLess'
  },
  icn_contactlessPayment: {
    name: 'icn_contactLess'
  },
  icn_crossCircledRed: {
    name: 'icn_errorCircle',
    color: COLORS.Tomato
  },
  icn_deleteUser: {
    name: 'icn_deleteUserRegular'
  },
  icn_doPayment: {
    name: 'icn_payments'
  },
  icn_dragDropBig: {
    name: 'icn_dragDrop',
    color: COLORS.GreyWarm
  },
  icn_dragDropVertical: {
    name: 'icn_reorderLight'
  },
  icn_dropdownArrowDownBlue: {
    name: 'icn_longArrowDown'
  },
  icn_dropdownArrowLeftBlue: {
    name: 'icn_longArrowLeft'
  },
  icn_dropdownArrowRightBlue: {
    name: 'icn_longArrowRight'
  },
  icn_dropdownChevronDownBlue: {
    name: 'icn_arrowDown'
  },
  icn_dropdownChevronLeftBlue: {
    name: 'icn_arrowLeft'
  },
  icn_dropdownChevronRightBlue: {
    name: 'icn_arrowRight'
  },
  icn_dropdownChevronUpBlue: {
    name: 'icn_arrowUp'
  },
  icn_edit: {
    name: 'icn_pen'
  },
  icn_editSmall: {
    name: 'icn_penLight'
  },
  icn_emailCheckGreen: {
    name: 'img_emailConfirmation'
  },
  icn_emailReceive: {
    name: 'icn_email'
  },
  icn_exclamation: {
    name: 'icn_exclamationMark'
  },
  icn_eyeOpen: {
    name: 'icn_watchlist'
  },
  icn_facebook: {
    name: 'icn_facebookCircle'
  },
  icn_familyActive: {
    name: 'icn_selectMinirOn'
  },
  icn_familyInactive: {
    name: 'icn_selectMinirOff'
  },
  icn_fileCsv: {
    name: 'icn_csv'
  },
  icn_fileDark: {
    name: 'icn_fileEmptyLight'
  },
  icn_fileExcel: {
    name: 'icn_excelLight'
  },
  icn_fileGrey: {
    name: 'icn_fileEmptyLight',
    color: COLORS.GreyWarm
  },
  icn_filePdf: {
    name: 'icn_PDFLight'
  },
  icn_fileXml: {
    name: 'icn_xmlLight'
  },
  icn_foreignCountries: {
    name: 'icn_countryChoice'
  },
  icn_id: {
    name: 'icn_idcard'
  },
  icn_invoice: {
    name: 'icn_file'
  },
  icn_locked: {
    name: 'icn_locker'
  },
  icn_lockedWhite: {
    name: 'icn_locker',
    color: COLORS.White
  },
  icn_logout: {
    name: 'icn_signout'
  },
  icn_mobile_app: {
    name: 'utils_Keytrade'
  },
  icn_newUser: {
    name: 'icn_addUserLIght'
  },
  icn_office: {
    name: 'img_building'
  },
  icn_pinless: {
    name: 'icn_noPincode'
  },
  icn_pinLess: {
    name: 'icn_noPincode'
  },
  icn_planet: {
    name: 'icn_onlinePayment'
  },
  icn_postal: {
    name: 'icn_post'
  },
  icn_print: {
    name: 'icn_printLight'
  },
  icn_redo: {
    name: 'icn_transfer'
  },
  icn_refresh: {
    name: 'icn_change'
  },
  icn_sablier: {
    name: 'icn_wait'
  },
  icn_searchActive: {
    name: 'icn_search'
  },
  icn_sendDocument: {
    name: 'img_email'
  },
  icn_settingWheel: {
    name: 'icn_settingsLight'
  },
  icn_sign: {
    name: 'icn_signCircle'
  },
  icn_titulaire: {
    name: 'icn_holder'
  },
  icn_tooltip: {
    name: 'icn_info'
  },
  icn_transfer: {
    name: 'icn_transferLight'
  },
  icn_upload: {
    name: 'icn_dragDrop',
    color: COLORS.GreyWarm
  },
  icn_uploadBig: {
    name: 'icn_dragDrop',
    color: COLORS.GreyWarm
  },
  icn_userActive: {
    name: 'icn_select1AccountOn'
  },
  icn_userInactive: {
    name: 'icn_select1AccountOff'
  },
  icn_usersActive: {
    name: 'icn_select2AccountOn'
  },
  icn_usersInactive: {
    name: 'icn_select2AccountOff'
  },
  icn_webPayment: {
    name: 'icn_onlinePayment'
  },
  icn_xml: {
    name: 'icn_xmlLight'
  },
  loader_keytradeLogo: {
    name: 'utils_Keytrade'
  },
  loader_quarterCircle: {
    name: 'utils_loadingCircle'
  },
  face_fillAtLeastOne: {
    name: 'icn_errorCircle'
  },
  face_resultsNone: {
    name: 'img_noResults'
  }
};
var colors = functions.config.colors.list;
var checkIcon = function checkIcon(props) {
  var icon = props.icon;
  if (!allIcons[icon]) {
    var mappingObject = deprecatedIconsMapping[icon];
    if (!mappingObject) {
      props.icon = 'icn_keytrade';
      props.color = 'Tomato';
      console.warn("Icon ".concat(icon, " not found!"));
    } else {
      props.icon = mappingObject.name;
      if (mappingObject.color) {
        props.color = mappingObject.color;
      }
      console.warn("Icon ".concat(icon, " is deprecated, it should be replaced by ").concat(mappingObject.name, "!"));
    }
  }
};
var setIconSize = function setIconSize(props) {
  switch (props.size) {
    case 'sm':
      props.size = '4rem';
      break;
    case 'md':
      props.size = '6rem';
      break;
    case 'lg':
      props.size = '8rem';
  }
};
var Icon = function Icon(props) {
  var iconProps = _objectSpread2({}, props);
  checkIcon(iconProps);
  setIconSize(iconProps);

  // This addresses a bug in older versions of FF which ignores the 'height' and 'width' attributes on SVG elements when set in rems, see https://bugzilla.mozilla.org/show_bug.cgi?id=1231147
  iconProps.style = {
    width: iconProps.size,
    height: iconProps.size,
    margin: iconProps.margin
  };
  return allIcons[iconProps.icon](iconProps);
};
Icon.propTypes = {
  /** Choose from the icon list. This includes deprecated icons, make sure you check your console for any warnings. */
  icon: PropTypes.oneOf(iconsList).isRequired,
  /** Custom icon color, if this is set the icon will be render using '<svg>...</svg>' instead of the default '<img src="..."/>' */
  color: PropTypes.string,
  /** ['sm', 'md', 'lg'] or a custom size including the unit (if the unit is ommitted, defaults to pixels) */
  size: PropTypes.string,
  /** this will add a margin shortcut css rule */
  margin: PropTypes.string,
  /** this will add title accesibility text to the svg */
  accessibilityText: PropTypes.string
};
Icon.defaultProps = {
  color: colors.BlueSky,
  size: '2.4rem'
};
exports.default = Icon;
exports.Icon = Icon;
exports.iconsList = iconsList;